
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("k2vBO", function(module, exports) {

$parcel$export(module.exports, "sendFileToS3", function () { return $e96c836b92e000d3$export$a66317a466bfa2d8; });
$parcel$export(module.exports, "initRequest", function () { return $e96c836b92e000d3$export$af0c4af558fd76ef; });

var $eD8Qa = parcelRequire("eD8Qa");
function $e96c836b92e000d3$var$recallAfterOffline(XMLHttpRequest1, fn) {
    if (XMLHttpRequest1.readyState === 0 || XMLHttpRequest1.readyState === 4) // Network error (i.e. connection refused, access denied due to CORS, etc.)
    window.addEventListener('online', ()=>{
        fn();
    }, {
        once: true
    });
}
async function $e96c836b92e000d3$export$a66317a466bfa2d8(file, { s3key: s3key, s3bucketUrl: s3bucketUrl, s3fields: s3fields, defaultImgPath: defaultImgPath, defaultFileType: defaultFileType = 'image/jpeg' }, { retryIfOffline: retryIfOffline = false } = {}) {
    return new Promise(function exec(resolve) {
        const xhr = new XMLHttpRequest();
        xhr.addEventListener('load', ()=>resolve(finalPath()), false);
        xhr.addEventListener('error', (err)=>{
            if (retryIfOffline) $e96c836b92e000d3$var$recallAfterOffline(err.currentTarget, ()=>exec(resolve));
        }, false);
        xhr.open('POST', s3bucketUrl, true); // MUST BE LAST LINE BEFORE YOU SEND
        xhr.send(prepareFormData());
    });
    function prepareFormData() {
        const fd = new FormData();
        fd.append('key', s3key);
        fd.append('acl', 'public-read');
        fd.append('success_action_status', '201');
        fd.append('Content-Type', getFileType());
        fd.append('X-Amz-Credential', s3fields['X-Amz-Credential']);
        fd.append('X-Amz-Algorithm', s3fields['X-Amz-Algorithm']);
        fd.append('X-Amz-Date', s3fields['X-Amz-Date']);
        fd.append('X-Amz-Security-Token', s3fields['X-Amz-Security-Token']);
        fd.append('Policy', s3fields.Policy);
        fd.append('X-Amz-Signature', s3fields['X-Amz-Signature']);
        fd.append('file', file);
        return fd;
    }
    function finalPath() {
        if (s3fields.bucket) return `https://${s3fields.bucket}/${s3key}`;
        return `${defaultImgPath}/${s3key}`;
    }
    function getFileType() {
        return file.type && file.type !== '' ? file.type : defaultFileType;
    }
}
const $e96c836b92e000d3$export$af0c4af558fd76ef = (serverUrl)=>({
        post: async (path, body = {}, { addAuth: addAuth = false, retryIfOffline: retryIfOffline = false, extraHeaders: extraHeaders = null } = {})=>{
            let auth = null;
            if (addAuth) auth = await $e96c836b92e000d3$var$getAuthToken();
            return new Promise(function exec(resolve, reject) {
                const xhr = new XMLHttpRequest();
                xhr.responseType = 'json';
                xhr.addEventListener('load', (event)=>{
                    resolve(event.currentTarget.response);
                }, false);
                xhr.addEventListener('error', (err)=>{
                    if (retryIfOffline) $e96c836b92e000d3$var$recallAfterOffline(err.currentTarget, ()=>exec(resolve));
                    else reject(err.currentTarget);
                }, false);
                xhr.open('POST', `${serverUrl}${path}`, true); // MUST BE LAST LINE BEFORE YOU SEND
                if (auth) xhr.setRequestHeader('Authorization', auth);
                if (extraHeaders) Object.entries(extraHeaders).forEach(([name, value])=>{
                    if (value != null) xhr.setRequestHeader(name, value);
                });
                xhr.send(JSON.stringify(body));
            });
        }
    });
const $e96c836b92e000d3$export$4b615ee88617c876 = $e96c836b92e000d3$export$af0c4af558fd76ef("https://api-new.occo.io/v1");
async function $e96c836b92e000d3$var$getAuthToken() {
    const { idToken: idToken } = (0, $eD8Qa.getStoredTokens)();
    if (idToken) return (0, $eD8Qa.getIdToken)();
    // SDK fallback is only for non-SSO projects (webapp) that still load
    // the AmazonCognitoIdentity script. SSO projects (occo-portal, photo-album,
    // occo-admin) don't load it — with no stored SSO token the user is simply
    // unauthenticated, so reject cleanly instead of throwing "SDK not included".
    if (typeof AmazonCognitoIdentity !== 'undefined') return $e96c836b92e000d3$var$getAuthTokenFromSdk();
    throw new Error('unauthorized_user');
}
function $e96c836b92e000d3$var$getAuthTokenFromSdk() {
    return new Promise((resolve, reject)=>{
        const cognitoUser = getCurrentUser();
        if (cognitoUser == null) {
            reject(new Error('unauthorized_user'));
            return;
        }
        cognitoUser.getSession((err, session)=>{
            if (err || !session.isValid()) {
                const error = {
                    type: 'unauthorized_user'
                };
                if (err) error.innerError = err;
                reject(error);
            } else resolve(session.getIdToken().getJwtToken());
        });
        function getCurrentUser() {
            if (!AmazonCognitoIdentity) throw new Error('AmazonCognitoIdentity should be included');
            const userPool = new AmazonCognitoIdentity.CognitoUserPool({
                UserPoolId: "us-west-2_TIXPqIBIl",
                ClientId: "1o5s7hu2bvnd5q6g1a120vrirq"
            });
            return userPool.getCurrentUser();
        }
    });
}
function $e96c836b92e000d3$export$60955a2a33777029(input) {
    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/;
    const seen = new WeakMap();
    function transform(value) {
        // string -> Date if matches ISO pattern
        if (typeof value === 'string') return isoRegex.test(value) ? new Date(value) : value;
        // keep Date instances as-is
        if (value instanceof Date) return value;
        // primitives and null
        if (value === null || typeof value !== 'object') return value;
        // handle circular references
        if (seen.has(value)) return seen.get(value);
        // arrays
        if (Array.isArray(value)) {
            const outArr = value.map((el)=>transform(el));
            seen.set(value, outArr);
            return outArr;
        }
        // plain or custom objects: preserve prototype
        const proto = Object.getPrototypeOf(value);
        const outObj = Object.create(proto);
        seen.set(value, outObj);
        for (const [k, v] of Object.entries(value))outObj[k] = transform(v);
        return outObj;
    }
    return transform(input);
}

});
parcelRegister("eD8Qa", function(module, exports) {

$parcel$export(module.exports, "getStoredTokens", function () { return $aa6b90b7716035e0$export$8bdfd37227c61428; });
$parcel$export(module.exports, "getIdToken", function () { return $aa6b90b7716035e0$export$393ade1005606e67; });
const $aa6b90b7716035e0$var$TOKEN_KEYS = {
    idToken: 'occo_cognito_sso.id_token',
    accessToken: 'occo_cognito_sso.access_token',
    refreshToken: 'occo_cognito_sso.refresh_token',
    expiresAt: 'occo_cognito_sso.expires_at'
};
const $aa6b90b7716035e0$var$PKCE_VERIFIER_KEY = 'occo_cognito_sso.pkce_verifier';
const $aa6b90b7716035e0$var$OAUTH_STATE_KEY = 'occo_cognito_sso.oauth_state';
const $aa6b90b7716035e0$var$OAUTH_RETURN_TO_KEY = 'occo_cognito_sso.return_to';
const $aa6b90b7716035e0$var$OAUTH_FLOW_STARTED_KEY = 'occo_cognito_sso.oauth_flow_started_at';
const $aa6b90b7716035e0$var$OAUTH_FLOW_KEYS = [
    $aa6b90b7716035e0$var$PKCE_VERIFIER_KEY,
    $aa6b90b7716035e0$var$OAUTH_STATE_KEY,
    $aa6b90b7716035e0$var$OAUTH_RETURN_TO_KEY
];
// Abandoned login attempts should not leave reusable state indefinitely.
const $aa6b90b7716035e0$var$OAUTH_FLOW_MAX_AGE_MS = 900000;
const $aa6b90b7716035e0$var$STALE_OAUTH_CALLBACK = 'STALE_OAUTH_CALLBACK';
const $aa6b90b7716035e0$var$EXPIRY_BUFFER_MS = 60000;
function $aa6b90b7716035e0$var$staleOAuthError(message) {
    const err = new Error(message);
    err.code = $aa6b90b7716035e0$var$STALE_OAUTH_CALLBACK;
    return err;
}
function $aa6b90b7716035e0$var$isStaleOAuthCallback(err) {
    return err?.code === $aa6b90b7716035e0$var$STALE_OAUTH_CALLBACK;
}
// OAuth state/PKCE live in localStorage (not sessionStorage) so they survive tab discard
// after long idle. sessionStorage is still read once for in-flight logins from older builds.
function $aa6b90b7716035e0$var$clearOAuthFlow() {
    $aa6b90b7716035e0$var$OAUTH_FLOW_KEYS.forEach((key)=>{
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
    });
    localStorage.removeItem($aa6b90b7716035e0$var$OAUTH_FLOW_STARTED_KEY);
}
function $aa6b90b7716035e0$var$isOAuthFlowExpired() {
    const startedAt = Number(localStorage.getItem($aa6b90b7716035e0$var$OAUTH_FLOW_STARTED_KEY) || 0);
    return !startedAt || Date.now() - startedAt > $aa6b90b7716035e0$var$OAUTH_FLOW_MAX_AGE_MS;
}
function $aa6b90b7716035e0$var$readOAuthFlowKey(key) {
    if ($aa6b90b7716035e0$var$isOAuthFlowExpired()) {
        $aa6b90b7716035e0$var$clearOAuthFlow();
        return null;
    }
    return localStorage.getItem(key) ?? sessionStorage.getItem(key);
}
function $aa6b90b7716035e0$var$writeOAuthFlowKey(key, value) {
    localStorage.setItem(key, value);
    sessionStorage.removeItem(key);
}
function $aa6b90b7716035e0$var$finishOAuthFlow() {
    $aa6b90b7716035e0$var$clearOAuthFlow();
}
const $aa6b90b7716035e0$var$FORCE_LOGIN_KEY = 'occo_cognito_sso.force_login';
const $aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS = 'redirecting_to_auth';
function $aa6b90b7716035e0$export$cec2144b6a46d4aa() {
    sessionStorage.setItem($aa6b90b7716035e0$var$FORCE_LOGIN_KEY, '1');
}
function $aa6b90b7716035e0$var$consumeLoginRequired() {
    if (sessionStorage.getItem($aa6b90b7716035e0$var$FORCE_LOGIN_KEY) !== '1') return false;
    sessionStorage.removeItem($aa6b90b7716035e0$var$FORCE_LOGIN_KEY);
    return true;
}
function $aa6b90b7716035e0$export$7a8cdd7c482119af(err) {
    return err?.message === $aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS || err?.innerError?.message === $aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS;
}
const $aa6b90b7716035e0$var$OAUTH_ERROR_HINTS = {
    redirect_mismatch: 'Register the redirect_uri in Cognito app client Allowed callback URLs (exact match, including trailing slash).',
    unauthorized_client: 'Use a public SPA app client with Authorization code grant, PKCE, openid/email/profile scopes, and Cognito user pool identity provider enabled.',
    access_denied: 'Sign-in was cancelled or access was denied.'
};
function $aa6b90b7716035e0$var$readEnv(key) {
    if (typeof window !== 'undefined' && window[key] !== undefined) return window[key];
    // Parcel only inlines static process.env.* access (not process.env[key])
    const env = {
        COGNITO_DOMAIN: "auth.occo.io",
        POOL_DATA_CLIENT_ID: "1o5s7hu2bvnd5q6g1a120vrirq",
        COGNITO_REDIRECT_URI: "https://photo.occo.io/index.html",
        COGNITO_LOGOUT_REDIRECT_URI: "https://photo.occo.io/index.html"
    };
    return env[key];
}
function $aa6b90b7716035e0$var$safeParseUrl(uri) {
    try {
        return new URL(uri);
    } catch  {
        return null;
    }
}
function $aa6b90b7716035e0$var$normalizeRedirectUri(uri) {
    // Cognito callback/sign-out URLs must match exactly. Strip any trailing slash so
    // both branches below (configured value vs. origin fallback) produce the same form.
    return uri.trim().replace(/\/+$/, '');
}
function $aa6b90b7716035e0$var$ensureStaticHostCallbackPath(uri) {
    // S3/CloudFront sub-path deploys (e.g. /armen-1) have no directory index — only
    // /armen-1/index.html exists. Bare /armen-1 returns NoSuchKey after OAuth.
    const url = $aa6b90b7716035e0$var$safeParseUrl(uri);
    if (!url) return uri;
    const path = url.pathname.replace(/\/+$/, '') || '/';
    if (path === '/' || /\.[a-zA-Z0-9]+$/.test(path)) return uri;
    return `${url.origin}${path}/index.html`;
}
function $aa6b90b7716035e0$var$resolveRedirectUri(envKey, fallbackKey) {
    const configured = $aa6b90b7716035e0$var$readEnv(envKey) || (fallbackKey ? $aa6b90b7716035e0$var$readEnv(fallbackKey) : null);
    if (typeof window !== 'undefined' && window.location?.origin) {
        const currentOrigin = window.location.origin;
        const configuredUrl = configured ? $aa6b90b7716035e0$var$safeParseUrl(configured) : null;
        if (configuredUrl) // Always return to the origin the app is actually running on, but keep the
        // configured callback PATH (e.g. /index.html). This lets a single dev/prod
        // COGNITO_REDIRECT_URI work on localhost without dropping the path — otherwise
        // a sub-path callback page would lose its path and the code would land on the
        return $aa6b90b7716035e0$var$ensureStaticHostCallbackPath($aa6b90b7716035e0$var$normalizeRedirectUri(`${currentOrigin}${configuredUrl.pathname}${configuredUrl.search}`));
        return $aa6b90b7716035e0$var$normalizeRedirectUri(currentOrigin);
    }
    if (!configured) throw new Error(`${envKey} is required`);
    return $aa6b90b7716035e0$var$ensureStaticHostCallbackPath($aa6b90b7716035e0$var$normalizeRedirectUri(configured));
}
function $aa6b90b7716035e0$var$getConfig() {
    const domain = ($aa6b90b7716035e0$var$readEnv('COGNITO_DOMAIN') || '').replace(/^https?:\/\//, '').replace(/\/$/, '');
    const clientId = $aa6b90b7716035e0$var$readEnv('POOL_DATA_CLIENT_ID');
    const redirectUri = $aa6b90b7716035e0$var$resolveRedirectUri('COGNITO_REDIRECT_URI');
    const logoutRedirectUri = $aa6b90b7716035e0$var$resolveRedirectUri('COGNITO_LOGOUT_REDIRECT_URI', 'COGNITO_REDIRECT_URI');
    if (!domain) throw new Error('COGNITO_DOMAIN is required');
    if (!clientId) throw new Error('POOL_DATA_CLIENT_ID is required');
    return {
        domain: domain,
        clientId: clientId,
        redirectUri: redirectUri,
        logoutRedirectUri: logoutRedirectUri,
        scopes: 'openid email profile'
    };
}
function $aa6b90b7716035e0$var$base64UrlEncode(buffer) {
    const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
    let binary = '';
    bytes.forEach((byte)=>{
        binary += String.fromCharCode(byte);
    });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function $aa6b90b7716035e0$var$resolveExpiresAtMs({ expiresIn: expiresIn, idToken: idToken }) {
    if (expiresIn != null && Number.isFinite(Number(expiresIn))) return Date.now() + Number(expiresIn) * 1000;
    if (idToken) try {
        const payload = JSON.parse(atob(idToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (payload.exp) return payload.exp * 1000;
    } catch  {
    /* malformed JWT — fall through */ }
    return Date.now() + 3600000;
}
function $aa6b90b7716035e0$var$saveTokens({ idToken: idToken, accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn }) {
    localStorage.setItem($aa6b90b7716035e0$var$TOKEN_KEYS.idToken, idToken);
    localStorage.setItem($aa6b90b7716035e0$var$TOKEN_KEYS.accessToken, accessToken);
    if (refreshToken) localStorage.setItem($aa6b90b7716035e0$var$TOKEN_KEYS.refreshToken, refreshToken);
    localStorage.setItem($aa6b90b7716035e0$var$TOKEN_KEYS.expiresAt, String($aa6b90b7716035e0$var$resolveExpiresAtMs({
        expiresIn: expiresIn,
        idToken: idToken
    })));
}
function $aa6b90b7716035e0$export$7809a8af6f3e4c63() {
    Object.values($aa6b90b7716035e0$var$TOKEN_KEYS).forEach((key)=>localStorage.removeItem(key));
    $aa6b90b7716035e0$var$clearOAuthFlow();
}
function $aa6b90b7716035e0$export$8bdfd37227c61428() {
    return {
        idToken: localStorage.getItem($aa6b90b7716035e0$var$TOKEN_KEYS.idToken),
        accessToken: localStorage.getItem($aa6b90b7716035e0$var$TOKEN_KEYS.accessToken),
        refreshToken: localStorage.getItem($aa6b90b7716035e0$var$TOKEN_KEYS.refreshToken),
        expiresAt: Number(localStorage.getItem($aa6b90b7716035e0$var$TOKEN_KEYS.expiresAt) || 0)
    };
}
function $aa6b90b7716035e0$var$isTokenExpired(expiresAt) {
    return !expiresAt || Date.now() >= expiresAt - $aa6b90b7716035e0$var$EXPIRY_BUFFER_MS;
}
function $aa6b90b7716035e0$export$2d1683f878dc8696() {
    const { idToken: idToken, expiresAt: expiresAt, refreshToken: refreshToken } = $aa6b90b7716035e0$export$8bdfd37227c61428();
    // Unexpired ID token, or expired ID + refresh (Cognito "keep logged in" window).
    // Without this, login pages skip getIdToken() refresh and force Hosted UI.
    if (!idToken) return false;
    if (!$aa6b90b7716035e0$var$isTokenExpired(expiresAt)) return true;
    return Boolean(refreshToken);
}
function $aa6b90b7716035e0$var$formatOAuthError(error, errorDescription) {
    const hint = $aa6b90b7716035e0$var$OAUTH_ERROR_HINTS[error];
    const detail = errorDescription || error || 'unknown_error';
    return hint ? `${detail}. ${hint}` : detail;
}
async function $aa6b90b7716035e0$var$requestTokens(body) {
    const { domain: domain } = $aa6b90b7716035e0$var$getConfig();
    const response = await fetch(`https://${domain}/oauth2/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: body
    });
    const data = await response.json().catch(()=>({}));
    if (!response.ok) throw new Error($aa6b90b7716035e0$var$formatOAuthError(data.error, data.error_description || `Token request failed (${response.status})`));
    return data;
}
async function $aa6b90b7716035e0$var$exchangeAuthorizationCode(code) {
    const { clientId: clientId, redirectUri: redirectUri } = $aa6b90b7716035e0$var$getConfig();
    const codeVerifier = $aa6b90b7716035e0$var$readOAuthFlowKey($aa6b90b7716035e0$var$PKCE_VERIFIER_KEY);
    localStorage.removeItem($aa6b90b7716035e0$var$PKCE_VERIFIER_KEY);
    sessionStorage.removeItem($aa6b90b7716035e0$var$PKCE_VERIFIER_KEY);
    if (!codeVerifier) throw $aa6b90b7716035e0$var$staleOAuthError('Missing PKCE verifier. Restart sign-in.');
    const tokens = await $aa6b90b7716035e0$var$requestTokens(new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: clientId,
        code: code,
        redirect_uri: redirectUri,
        code_verifier: codeVerifier
    }));
    $aa6b90b7716035e0$var$saveTokens({
        idToken: tokens.id_token,
        accessToken: tokens.access_token,
        refreshToken: tokens.refresh_token,
        expiresIn: tokens.expires_in
    });
}
let $aa6b90b7716035e0$var$refreshInFlight = null;
async function $aa6b90b7716035e0$var$refreshIdToken() {
    if ($aa6b90b7716035e0$var$refreshInFlight) return $aa6b90b7716035e0$var$refreshInFlight;
    $aa6b90b7716035e0$var$refreshInFlight = (async ()=>{
        const { clientId: clientId } = $aa6b90b7716035e0$var$getConfig();
        const { refreshToken: refreshToken } = $aa6b90b7716035e0$export$8bdfd37227c61428();
        if (!refreshToken) throw new Error('No refresh token available');
        const tokens = await $aa6b90b7716035e0$var$requestTokens(new URLSearchParams({
            grant_type: 'refresh_token',
            client_id: clientId,
            refresh_token: refreshToken
        }));
        const { idToken: previousIdToken } = $aa6b90b7716035e0$export$8bdfd37227c61428();
        $aa6b90b7716035e0$var$saveTokens({
            idToken: tokens.id_token || previousIdToken,
            accessToken: tokens.access_token,
            refreshToken: tokens.refresh_token || refreshToken,
            expiresIn: tokens.expires_in
        });
        return tokens.id_token || previousIdToken;
    })();
    try {
        return await $aa6b90b7716035e0$var$refreshInFlight;
    } finally{
        $aa6b90b7716035e0$var$refreshInFlight = null;
    }
}
async function $aa6b90b7716035e0$export$393ade1005606e67() {
    const { idToken: idToken, expiresAt: expiresAt } = $aa6b90b7716035e0$export$8bdfd37227c61428();
    if (!idToken) throw new Error('unauthorized_user');
    if ($aa6b90b7716035e0$var$isTokenExpired(expiresAt)) try {
        // Seamless background refresh — no page reload (mirrors the SDK's getSession).
        return await $aa6b90b7716035e0$var$refreshIdToken();
    } catch  {
        // A concurrent refresh may have succeeded while this one failed (rotated token).
        const retry = $aa6b90b7716035e0$export$8bdfd37227c61428();
        if (retry.idToken && !$aa6b90b7716035e0$var$isTokenExpired(retry.expiresAt)) return retry.idToken;
        $aa6b90b7716035e0$var$beginSilentReauth();
    }
    return idToken;
}
const $aa6b90b7716035e0$var$COGNITO_SESSION_REVOKED = 'cognito_session_revoked';
const $aa6b90b7716035e0$var$COGNITO_USERINFO_TRANSIENT = 'COGNITO_USERINFO_TRANSIENT';
/**
 * Ask Cognito whether the access token is still accepted.
 * After AdminUserGlobalSignOut / token revocation, /oauth2/userInfo returns 401 even
 * while the local JWT has not reached exp — that is how we force immediate logout.
 * Network / 5xx failures are marked transient so a Cognito blip does not sign users out.
 */ async function $aa6b90b7716035e0$var$assertCognitoSessionActive() {
    const { accessToken: accessToken } = $aa6b90b7716035e0$export$8bdfd37227c61428();
    if (!accessToken) {
        const err = new Error('No access token available');
        err.code = $aa6b90b7716035e0$var$COGNITO_SESSION_REVOKED;
        throw err;
    }
    const { domain: domain } = $aa6b90b7716035e0$var$getConfig();
    let response;
    try {
        response = await fetch(`https://${domain}/oauth2/userInfo`, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
    } catch (networkErr) {
        const err = new Error(networkErr?.message || 'userInfo network error');
        err.code = $aa6b90b7716035e0$var$COGNITO_USERINFO_TRANSIENT;
        throw err;
    }
    if (response.ok) return;
    if (response.status === 401 || response.status === 403) {
        const err = new Error($aa6b90b7716035e0$var$COGNITO_SESSION_REVOKED);
        err.code = $aa6b90b7716035e0$var$COGNITO_SESSION_REVOKED;
        throw err;
    }
    const err = new Error(`userInfo failed (${response.status})`);
    err.code = $aa6b90b7716035e0$var$COGNITO_USERINFO_TRANSIENT;
    throw err;
}
function $aa6b90b7716035e0$var$beginForcedLogout() {
    // Clear app tokens and the Hosted UI cookie so Cognito console "Sign out user" sticks
    // (authorize alone can silently re-issue tokens via the managed-login cookie).
    $aa6b90b7716035e0$export$b0ac3a1c242cb1ea();
    throw new Error($aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS);
}
async function $aa6b90b7716035e0$export$7b962f1e4c5494f() {
    const idToken = await $aa6b90b7716035e0$export$393ade1005606e67();
    try {
        await $aa6b90b7716035e0$var$assertCognitoSessionActive();
        return idToken;
    } catch (err) {
        if (err?.code === $aa6b90b7716035e0$var$COGNITO_USERINFO_TRANSIENT) return idToken;
        try {
            await $aa6b90b7716035e0$var$refreshIdToken();
            await $aa6b90b7716035e0$var$assertCognitoSessionActive();
            return $aa6b90b7716035e0$export$8bdfd37227c61428().idToken;
        } catch (retryErr) {
            if (retryErr?.code === $aa6b90b7716035e0$var$COGNITO_USERINFO_TRANSIENT) return $aa6b90b7716035e0$export$8bdfd37227c61428().idToken || idToken;
            if (retryErr?.message === $aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS) throw retryErr;
            $aa6b90b7716035e0$var$beginForcedLogout();
        }
    }
}
function $aa6b90b7716035e0$var$beginSilentReauth() {
    $aa6b90b7716035e0$export$7809a8af6f3e4c63();
    $aa6b90b7716035e0$var$redirectToAuthorize(globalThis.location.href);
    // Fail fast so callers (guardPage / occoAPI) don't hang; navigation is already queued.
    throw new Error($aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS);
}
function $aa6b90b7716035e0$var$parseOAuthCallback() {
    const url = new URL(globalThis.location.href);
    return {
        code: url.searchParams.get('code'),
        state: url.searchParams.get('state'),
        error: url.searchParams.get('error'),
        errorDescription: url.searchParams.get('error_description')
    };
}
function $aa6b90b7716035e0$var$cleanOAuthUrl() {
    const url = new URL(globalThis.location.href);
    url.searchParams.delete('code');
    url.searchParams.delete('state');
    url.searchParams.delete('error');
    url.searchParams.delete('error_description');
    globalThis.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
}
async function $aa6b90b7716035e0$var$completeAuthorizationCallback(code, state) {
    const expectedState = $aa6b90b7716035e0$var$readOAuthFlowKey($aa6b90b7716035e0$var$OAUTH_STATE_KEY);
    localStorage.removeItem($aa6b90b7716035e0$var$OAUTH_STATE_KEY);
    sessionStorage.removeItem($aa6b90b7716035e0$var$OAUTH_STATE_KEY);
    if (!expectedState || state !== expectedState) throw $aa6b90b7716035e0$var$staleOAuthError('Invalid OAuth state. Restart sign-in.');
    await $aa6b90b7716035e0$var$exchangeAuthorizationCode(code);
    $aa6b90b7716035e0$var$finishOAuthFlow();
    $aa6b90b7716035e0$var$cleanOAuthUrl();
}
function $aa6b90b7716035e0$var$consumeReturnTo() {
    const returnTo = $aa6b90b7716035e0$var$readOAuthFlowKey($aa6b90b7716035e0$var$OAUTH_RETURN_TO_KEY);
    localStorage.removeItem($aa6b90b7716035e0$var$OAUTH_RETURN_TO_KEY);
    sessionStorage.removeItem($aa6b90b7716035e0$var$OAUTH_RETURN_TO_KEY);
    if (!returnTo) return null;
    // Only honor same-origin targets to avoid being used as an open redirect.
    try {
        if (new URL(returnTo, window.location.origin).origin === window.location.origin) return returnTo;
    } catch  {
    /* malformed return target — ignore */ }
    return null;
}
async function $aa6b90b7716035e0$var$redirectToAuthorize(returnTo) {
    const { domain: domain, clientId: clientId, redirectUri: redirectUri, scopes: scopes } = $aa6b90b7716035e0$var$getConfig();
    $aa6b90b7716035e0$var$clearOAuthFlow();
    const verifierBytes = new Uint8Array(32);
    crypto.getRandomValues(verifierBytes);
    const codeVerifier = $aa6b90b7716035e0$var$base64UrlEncode(verifierBytes);
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
    const codeChallenge = $aa6b90b7716035e0$var$base64UrlEncode(digest);
    const stateBytes = new Uint8Array(16);
    crypto.getRandomValues(stateBytes);
    const oauthState = $aa6b90b7716035e0$var$base64UrlEncode(stateBytes);
    localStorage.setItem($aa6b90b7716035e0$var$OAUTH_FLOW_STARTED_KEY, String(Date.now()));
    $aa6b90b7716035e0$var$writeOAuthFlowKey($aa6b90b7716035e0$var$PKCE_VERIFIER_KEY, codeVerifier);
    $aa6b90b7716035e0$var$writeOAuthFlowKey($aa6b90b7716035e0$var$OAUTH_STATE_KEY, oauthState);
    if (returnTo) $aa6b90b7716035e0$var$writeOAuthFlowKey($aa6b90b7716035e0$var$OAUTH_RETURN_TO_KEY, returnTo);
    const params = new URLSearchParams({
        response_type: 'code',
        client_id: clientId,
        redirect_uri: redirectUri,
        scope: scopes,
        code_challenge_method: 'S256',
        code_challenge: codeChallenge,
        state: oauthState
    });
    window.location.assign(`https://${domain}/oauth2/authorize?${params}`);
}
function $aa6b90b7716035e0$export$b0ac3a1c242cb1ea({ logoutRedirectUri: logoutRedirectUri } = {}) {
    const { domain: domain, clientId: clientId, logoutRedirectUri: defaultLogoutUri } = $aa6b90b7716035e0$var$getConfig();
    $aa6b90b7716035e0$export$7809a8af6f3e4c63();
    const params = new URLSearchParams({
        client_id: clientId,
        logout_uri: logoutRedirectUri || defaultLogoutUri
    });
    window.location.assign(`https://${domain}/logout?${params}`);
}
async function $aa6b90b7716035e0$export$1635fd45e10df58b({ redirectAfterLogin: redirectAfterLogin, onSuccess: onSuccess, onError: onError }) {
    const { error: error, errorDescription: errorDescription, code: code, state: state } = $aa6b90b7716035e0$var$parseOAuthCallback();
    if (error) {
        $aa6b90b7716035e0$var$cleanOAuthUrl();
        onError?.(new Error($aa6b90b7716035e0$var$formatOAuthError(error, errorDescription)));
        return;
    }
    if (code) {
        try {
            await $aa6b90b7716035e0$var$completeAuthorizationCallback(code, state);
            if (onSuccess) await onSuccess();
            window.location.href = $aa6b90b7716035e0$var$consumeReturnTo() || redirectAfterLogin;
        } catch (err) {
            $aa6b90b7716035e0$var$cleanOAuthUrl();
            if ($aa6b90b7716035e0$var$isStaleOAuthCallback(err)) {
                $aa6b90b7716035e0$var$redirectToAuthorize($aa6b90b7716035e0$var$consumeReturnTo() ?? undefined).catch((redirectErr)=>onError?.(redirectErr));
                return;
            }
            onError?.(err);
        }
        return;
    }
    if ($aa6b90b7716035e0$var$consumeLoginRequired()) $aa6b90b7716035e0$export$7809a8af6f3e4c63();
    else if ($aa6b90b7716035e0$export$2d1683f878dc8696()) try {
        await $aa6b90b7716035e0$export$7b962f1e4c5494f();
        // Re-sync role/username even when reusing a valid session, otherwise a session
        // restored without onSuccess leaves the portal showing the generic 'User'.
        // Best-effort: a sync failure must not block an already-authenticated user.
        try {
            if (onSuccess) await onSuccess();
        } catch  {
        /* destination page reloads user info itself */ }
        window.location.href = redirectAfterLogin;
        return;
    } catch (err) {
        $aa6b90b7716035e0$export$7809a8af6f3e4c63();
        if (err?.message === $aa6b90b7716035e0$var$AUTH_REDIRECT_IN_PROGRESS) return;
    }
    try {
        await $aa6b90b7716035e0$var$redirectToAuthorize();
    } catch (err) {
        onError?.(err);
    }
}

});


parcelRegister("8xm5I", function(module, exports) {

$parcel$export(module.exports, "REAL_IMAGE_PATH", function () { return $63728aa8d5042ce9$export$3f6ef097d2b7f6a7; });
$parcel$export(module.exports, "DEFAULT_SHOOT_HELP_IMG", function () { return $63728aa8d5042ce9$export$4b217e8daf86c1e1; });
$parcel$export(module.exports, "OCCO_360_VIEWER_PATH", function () { return $63728aa8d5042ce9$export$8e3e6de9078c835f; });
$parcel$export(module.exports, "photoPlusVariantId", function () { return $63728aa8d5042ce9$export$6bff081d5e550aac; });
$parcel$export(module.exports, "capitalize", function () { return $63728aa8d5042ce9$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "formatCurrency", function () { return $63728aa8d5042ce9$export$3dc27271f5d5c629; });
$parcel$export(module.exports, "formatPrice", function () { return $63728aa8d5042ce9$export$c86caf1be068fb8d; });
$parcel$export(module.exports, "getQueryVariable", function () { return $63728aa8d5042ce9$export$34c5a9262f934fa5; });
$parcel$export(module.exports, "showLoading", function () { return $63728aa8d5042ce9$export$64858b67578a10bb; });
$parcel$export(module.exports, "hideLoading", function () { return $63728aa8d5042ce9$export$7d026bf51c574e0d; });
$parcel$export(module.exports, "customPopUp", function () { return $63728aa8d5042ce9$export$9704d2cd3b48497c; });
$parcel$export(module.exports, "getParameterByName", function () { return $63728aa8d5042ce9$export$7a5418d73bdac342; });
$parcel$export(module.exports, "alertMessagePopup", function () { return $63728aa8d5042ce9$export$32a3bfc434160815; });
$parcel$export(module.exports, "elId", function () { return $63728aa8d5042ce9$export$d5fafd96da807b8f; });
$parcel$export(module.exports, "remoteCapture", function () { return $63728aa8d5042ce9$export$441b80c92889e371; });
$parcel$export(module.exports, "uploadFileToS3", function () { return $63728aa8d5042ce9$export$9c774f4c11be1742; });
$parcel$export(module.exports, "isValidExtension", function () { return $63728aa8d5042ce9$export$adc006f73652ef71; });
$parcel$export(module.exports, "updateAppParams", function () { return $63728aa8d5042ce9$export$c008e664a296dada; });
$parcel$export(module.exports, "unlinkImagesReq", function () { return $63728aa8d5042ce9$export$8191d86d996a9784; });
$parcel$export(module.exports, "pAttendeeAttachPhotosByQR", function () { return $63728aa8d5042ce9$export$c9b084775f33891e; });
$parcel$export(module.exports, "attendeeAttachPhotosByQR", function () { return $63728aa8d5042ce9$export$770078730fa8faec; });
$parcel$export(module.exports, "get360url", function () { return $63728aa8d5042ce9$export$bff2728bbd426c96; });
$parcel$export(module.exports, "backToKioskStoreHome", function () { return $63728aa8d5042ce9$export$2d66ebc03a52fdf6; });
$parcel$export(module.exports, "backToHomePage", function () { return $63728aa8d5042ce9$export$aa31e5ab3c78730a; });
$parcel$export(module.exports, "showPaidMessage", function () { return $63728aa8d5042ce9$export$37d211164fe25ad1; });
$parcel$export(module.exports, "showTipProducts", function () { return $63728aa8d5042ce9$export$5b806f77bd15a21b; });
$parcel$export(module.exports, "buyFullUnlockGlob", function () { return $63728aa8d5042ce9$export$2c9f01379d21d93; });
$parcel$export(module.exports, "alertDigitalPackDuplicationAndRedirect", function () { return $63728aa8d5042ce9$export$c1c8b5173d09e137; });
$parcel$export(module.exports, "alertIfNoEvent", function () { return $63728aa8d5042ce9$export$b4c9562b4fe385a5; });
$parcel$export(module.exports, "getUUID", function () { return $63728aa8d5042ce9$export$36ec425867d538d7; });
$parcel$export(module.exports, "getCustomAttribute", function () { return $63728aa8d5042ce9$export$79a99262bbe888be; });
$parcel$export(module.exports, "trackPhotoEvent", function () { return $63728aa8d5042ce9$export$81c028dff25f2b70; });
$parcel$export(module.exports, "trackListOfPhotoEvent", function () { return $63728aa8d5042ce9$export$2c891fc7eb6d45ab; });
$parcel$export(module.exports, "fromUrlFilename", function () { return $63728aa8d5042ce9$export$a3878ae81adf338a; });
$parcel$export(module.exports, "isValidEmail", function () { return $63728aa8d5042ce9$export$371e338370561054; });
$parcel$export(module.exports, "showAlert", function () { return $63728aa8d5042ce9$export$de026b00723010c1; });
$parcel$export(module.exports, "showBlockingError", function () { return $63728aa8d5042ce9$export$70410f492c55290a; });
$parcel$export(module.exports, "updateQRMenuText", function () { return $63728aa8d5042ce9$export$fdb37755460c48a; });
$parcel$export(module.exports, "createAttendee", function () { return $63728aa8d5042ce9$export$738ce82e3cb95b57; });
$parcel$export(module.exports, "deleteRestrictionHelpMessage", function () { return $63728aa8d5042ce9$export$8859af7305300b0a; });
$parcel$export(module.exports, "prepareTagsFilter", function () { return $63728aa8d5042ce9$export$4db89c48f2651f19; });
$parcel$export(module.exports, "isJsonString", function () { return $63728aa8d5042ce9$export$abd67cc48e99962b; });
$parcel$export(module.exports, "getProductTagType", function () { return $63728aa8d5042ce9$export$f17bf166de11360f; });
$parcel$export(module.exports, "initThrottle", function () { return $63728aa8d5042ce9$export$49e33a6a3ab524d9; });
$parcel$export(module.exports, "isPrintable", function () { return $63728aa8d5042ce9$export$fc95a5c486aa74c0; });
$parcel$export(module.exports, "isNonPrintable", function () { return $63728aa8d5042ce9$export$b7ed17c2edb4d953; });
$parcel$export(module.exports, "isSelectable", function () { return $63728aa8d5042ce9$export$ff75e500ee7af77c; });
$parcel$export(module.exports, "isNonSelectable", function () { return $63728aa8d5042ce9$export$c970901de3da6e49; });
$parcel$export(module.exports, "isValidForPrint", function () { return $63728aa8d5042ce9$export$3509b628d6b4aca5; });
$parcel$export(module.exports, "isValidForPrintAndUnlock", function () { return $63728aa8d5042ce9$export$d700d4bedcca3f6e; });
$parcel$export(module.exports, "preparePhotosForDisplay", function () { return $63728aa8d5042ce9$export$d17b2e634dc29da6; });
$parcel$export(module.exports, "checkProductTagTypeAndImageTag", function () { return $63728aa8d5042ce9$export$c5c99856861f4364; });
$parcel$export(module.exports, "pluck", function () { return $63728aa8d5042ce9$export$c44985b87d605eff; });
$parcel$export(module.exports, "checkProductTagTypeForAllImages", function () { return $63728aa8d5042ce9$export$3610dff0396da865; });
$parcel$export(module.exports, "checkProductTagTypeForAllImagesWrapper", function () { return $63728aa8d5042ce9$export$773647ccbc7c158; });
$parcel$export(module.exports, "checkComboProductsTagTypeForAllImages", function () { return $63728aa8d5042ce9$export$1962d8d7d1ac121; });
$parcel$export(module.exports, "transformIdsToPhotos", function () { return $63728aa8d5042ce9$export$f0fcbfd028dcb7eb; });
$parcel$export(module.exports, "getCurrentFormModelItem", function () { return $63728aa8d5042ce9$export$55def886b2067470; });
$parcel$export(module.exports, "isAndroid", function () { return $63728aa8d5042ce9$export$a11b0059900ceec8; });
$parcel$export(module.exports, "isIPhone", function () { return $63728aa8d5042ce9$export$186c6964ca17d99; });
$parcel$export(module.exports, "isMobile", function () { return $63728aa8d5042ce9$export$d0a8044dce8ff2fc; });
$parcel$export(module.exports, "renameFileNameMutate", function () { return $63728aa8d5042ce9$export$bf344be07946b610; });
$parcel$export(module.exports, "initMultipleDownload", function () { return $63728aa8d5042ce9$export$ebc809a96627e361; });

var $h83rN = parcelRequire("h83rN");

var $eMAh6 = parcelRequire("eMAh6");

var $4odV3 = parcelRequire("4odV3");

var $4iCXN = parcelRequire("4iCXN");
parcelRequire("6wMuu");
var $frM9m = parcelRequire("frM9m");

var $gb01V = parcelRequire("gb01V");
const $63728aa8d5042ce9$export$3f6ef097d2b7f6a7 = "https://images.occo.io";
const $63728aa8d5042ce9$export$4b217e8daf86c1e1 = 'img/remoteShootingDefaultImage.jpg';
const $63728aa8d5042ce9$export$8e3e6de9078c835f = `${$63728aa8d5042ce9$export$3f6ef097d2b7f6a7}/360viewer/`;
const $63728aa8d5042ce9$export$6bff081d5e550aac = localStorage.getItem('shopDigitalVariantId');
const $63728aa8d5042ce9$var$fullUnlockProduct = localStorage.getItem('fullUnlockProduct');
function $63728aa8d5042ce9$export$9a00dee1beb8f576(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function $63728aa8d5042ce9$export$3dc27271f5d5c629(currencyCode) {
    if (currencyCode === 'USD') return '$';
    return currencyCode;
}
function $63728aa8d5042ce9$var$formatDecimals(value, digitals = 2) {
    return (Math.round(value * 100) / 100).toFixed(digitals);
}
function $63728aa8d5042ce9$export$c86caf1be068fb8d({ amount: amount = 0, currencyCode: currencyCode = 'USD' }) {
    return `${$63728aa8d5042ce9$export$3dc27271f5d5c629(currencyCode)}${$63728aa8d5042ce9$var$formatDecimals(amount)}`;
}
function $63728aa8d5042ce9$export$34c5a9262f934fa5(variable) {
    const query = globalThis.location.search.substring(1);
    const vars = query.split('&');
    for(let i = 0; i < vars.length; i += 1){
        const pair = vars[i].split('=');
        if (pair[0] === variable) return decodeURI(pair[1]);
    }
    return false;
}
function $63728aa8d5042ce9$export$64858b67578a10bb() {
    (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('.screenOverlay').show();
    (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#cssload-cupcake').show();
}
function $63728aa8d5042ce9$export$7d026bf51c574e0d() {
    setTimeout(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#cssload-cupcake').hide();
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('.screenOverlay').hide();
    }, 100);
}
const $63728aa8d5042ce9$export$9704d2cd3b48497c = {
    show () {
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#customPopUp').modal('show');
    },
    hide () {
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#customPopUp').modal('hide');
    },
    html (content) {
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#customPopUpBody').html(content || '');
    }
};
function $63728aa8d5042ce9$export$7a5418d73bdac342(name, url) {
    const normalizedName = name.replaceAll(/[\[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${normalizedName}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replaceAll(/\+/g, ' '));
}
function $63728aa8d5042ce9$export$32a3bfc434160815(text) {
    const opt = {
        title: (0, $frM9m.t)('info-title'),
        body: text
    };
    $63728aa8d5042ce9$export$d5fafd96da807b8f('messagePopUpTitle').innerHTML = opt.title ? opt.title : '';
    $63728aa8d5042ce9$export$d5fafd96da807b8f('messagePopUpBody').innerHTML = opt.body ? opt.body : '';
    (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#messagePopUp').modal('show');
}
function $63728aa8d5042ce9$export$441b80c92889e371(attId, robotId) {
    $63728aa8d5042ce9$export$64858b67578a10bb();
    $63728aa8d5042ce9$var$getRobotSettings(robotId, (robotSettings)=>{
        $63728aa8d5042ce9$export$7d026bf51c574e0d();
        const RC_TXT1 = robotSettings.RC_TXT1 || (0, $frM9m.t)('remote-shoot-start-message');
        const RC_TXT2 = robotSettings.RC_TXT2 || (0, $frM9m.t)('remote-shoot-countdown-message');
        const RC_TXT3 = robotSettings.RC_TXT3 || (0, $frM9m.t)('remote-shoot-rendering-message');
        const RC_URL1 = robotSettings.RC_URL1 || $63728aa8d5042ce9$export$4b217e8daf86c1e1;
        const content = `<div id="shootCont">
        <img src="${RC_URL1}" width="100%" alt="" /><br><br>
        <span class="">${RC_TXT1}</span><br><br>
        <button type='button' id="shootPhoto" class='btn btn-primary btn-circle btn-xl'>${(0, $frM9m.t)('remote-shoot-btn')}</button>
        </div><br>`;
        $63728aa8d5042ce9$export$9704d2cd3b48497c.html(content);
        $63728aa8d5042ce9$export$9704d2cd3b48497c.show();
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#shootPhoto').on('click', ()=>{
            const shootContent = `<div id="cDownCont">
            <span class="" id="hpText">${RC_TXT2}</span><br><br>
            <div id ="cDId" class="cDownLabel">3</div> <br>
            <div id ="closeCont">
              <button class="btn btn-primary btn-sh" onclick="backToHomePage()">${(0, $frM9m.t)('ok-btn')}</button>
            </div>
            </div><br>`;
            (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#shootCont').html(shootContent);
            (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#closeCont').hide();
            $63728aa8d5042ce9$var$countDown(3, RC_TXT3);
            $63728aa8d5042ce9$var$remoteCaptureReq(attId, robotId);
        });
    });
}
function $63728aa8d5042ce9$export$9c774f4c11be1742(file, s3key, s3bucketUrl, s3fields, callbackSuccess) {
    const fd = new FormData();
    fd.append('key', s3key);
    fd.append('acl', 'public-read');
    fd.append('success_action_status', '201');
    let fileType = 'image/jpeg';
    if (file.type && file.type !== '') fileType = file.type;
    fd.append('Content-Type', fileType);
    fd.append('X-Amz-Credential', s3fields['X-Amz-Credential']);
    fd.append('X-Amz-Algorithm', s3fields['X-Amz-Algorithm']);
    fd.append('X-Amz-Date', s3fields['X-Amz-Date']);
    fd.append('X-Amz-Security-Token', s3fields['X-Amz-Security-Token']);
    fd.append('Policy', s3fields.Policy);
    fd.append('X-Amz-Signature', s3fields['X-Amz-Signature']);
    fd.append('file', file);
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', ()=>{
        // onSuccess
        let finalPath = `${$63728aa8d5042ce9$export$3f6ef097d2b7f6a7}/${s3key}`;
        if (callbackSuccess) {
            if (s3fields.bucket) finalPath = `https://${s3fields.bucket}/${s3key}`;
            callbackSuccess(finalPath);
        }
    }, false);
    xhr.open('POST', s3bucketUrl, true); // MUST BE LAST LINE BEFORE YOU SEND
    xhr.send(fd);
}
function $63728aa8d5042ce9$export$d5fafd96da807b8f(id) {
    return document.getElementById(id);
}
function $63728aa8d5042ce9$export$adc006f73652ef71(extension) {
    return /(jpg|jpeg|png|gif|mp4)$/gi.test(extension);
}
function $63728aa8d5042ce9$export$c008e664a296dada(visitDate, eventName = null, callback = ()=>{}) {
    const appInfoObj = {
        uId: $63728aa8d5042ce9$export$34c5a9262f934fa5('uId'),
        vDate: visitDate || $63728aa8d5042ce9$export$34c5a9262f934fa5('vDate'),
        lat: $63728aa8d5042ce9$export$34c5a9262f934fa5('lat'),
        long: $63728aa8d5042ce9$export$34c5a9262f934fa5('long'),
        prePaid: $63728aa8d5042ce9$export$34c5a9262f934fa5('prePaid'),
        email: $63728aa8d5042ce9$export$34c5a9262f934fa5('email'),
        lang: $63728aa8d5042ce9$export$34c5a9262f934fa5('lang'),
        eventName: eventName
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($h83rN))).ajax({
        type: 'POST',
        url: `${"https://api-new.occo.io/v1"}/genting-app/add-visit-date-info`,
        data: JSON.stringify({
            app_info_obj: appInfoObj
        }),
        dataType: 'json',
        success (resp) {
            if (resp?.result) callback(resp.result);
        }
    });
}
function $63728aa8d5042ce9$export$8191d86d996a9784(selectedPhotoIdArray, deleteReason, eventId, keyType, keyValue, callback) {
    const body = {
        photo_id_array: selectedPhotoIdArray,
        delete_reason: deleteReason,
        event_id: eventId,
        key_type: keyType,
        key_value: keyValue
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($h83rN))).ajax({
        type: 'POST',
        url: `${"https://api-new.occo.io/v1"}/photo/list/unlink`,
        data: JSON.stringify(body),
        dataType: 'json',
        success (resp) {
            if (resp?.result) callback(null, resp.result);
        },
        error (err) {
            callback(err, null);
        }
    });
}
function $63728aa8d5042ce9$export$c9b084775f33891e(attendeeUid, photoUids) {
    return new Promise((resolve)=>{
        const body = {
            attendee_uid: attendeeUid,
            photo_uid_array: photoUids
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN))).ajax({
            type: 'POST',
            url: `${"https://api-new.occo.io/v1"}/attendee/attach-photos-by-qr-scan`,
            data: JSON.stringify(body),
            dataType: 'json',
            success: resolve
        });
    });
}
function $63728aa8d5042ce9$export$770078730fa8faec(attendeeUid, photoUids) {
    $63728aa8d5042ce9$export$64858b67578a10bb();
    const body = {
        attendee_uid: attendeeUid,
        photo_uid_array: photoUids
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($h83rN))).ajax({
        type: 'POST',
        url: `${"https://api-new.occo.io/v1"}/attendee/attach-photos-by-qr-scan`,
        data: JSON.stringify(body),
        dataType: 'json',
        success () {
            $63728aa8d5042ce9$var$reloadPage();
        }
    });
}
function $63728aa8d5042ce9$var$reloadPage() {
    globalThis.location.reload();
}
function $63728aa8d5042ce9$export$bff2728bbd426c96(normalImageUrl) {
    return `${$63728aa8d5042ce9$export$8e3e6de9078c835f}?url=${normalImageUrl}&closeable=false`;
}
function $63728aa8d5042ce9$export$2d66ebc03a52fdf6() {
    (0, $4iCXN.redirectToPage).index({
        rawSearch: '?hfb=true'
    });
}
function $63728aa8d5042ce9$export$aa31e5ab3c78730a() {
    globalThis.location.href = localStorage.getItem('home');
}
function $63728aa8d5042ce9$export$37d211164fe25ad1(checkout, fromHome) {
    const photoPlusAlreadyExist = (0, $gb01V.ecomHasFullUnlockProduct)(checkout);
    const isVip = localStorage.getItem('isVip');
    if (!fromHome) {
        if (photoPlusAlreadyExist || isVip === '1') {
            $63728aa8d5042ce9$export$5b806f77bd15a21b(checkout);
            return;
        }
    } else if (photoPlusAlreadyExist || isVip === '1') return;
    const message = (0, $frM9m.t)('checkout-digital-package-upsell-message');
    const content = `<div>
    <h6>${message} </h6><br> <br>
     <button id="maybeLaterBtn" type = "button" class = "btn btn-light btn-lg" data-dismiss = "modal">${(0, $frM9m.t)('photo-plus-maybe-later-btn')}</button>
     <button id="buyPhotoPlus" type = "button" class = "btn btn-primary btn-lg">${(0, $frM9m.t)('photo-plus-upgrade-btn')}</button></div>`;
    $63728aa8d5042ce9$export$9704d2cd3b48497c.html(content);
    $63728aa8d5042ce9$export$9704d2cd3b48497c.show();
    if (!fromHome) (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#maybeLaterBtn').on('click', ()=>{
        $63728aa8d5042ce9$export$5b806f77bd15a21b(checkout);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#buyPhotoPlus').on('click', ()=>{
        $63728aa8d5042ce9$export$9704d2cd3b48497c.hide();
        $63728aa8d5042ce9$export$2c9f01379d21d93(checkout);
    });
}
function $63728aa8d5042ce9$export$c1c8b5173d09e137(variant, cart) {
    if (variant.product_purpose === 'full_unlock' && (0, $gb01V.ecomHasFullUnlockProduct)(cart)) {
        const lsMessage = localStorage.getItem('shopDigitalProductDupMsg');
        const message = lsMessage || (0, $frM9m.t)('checkout-digital-package-duplicate-message');
        const content = `<div>
        <h6>${message} </h6><br> <br>
        <button id="buttonOK" type="button" class="btn btn-primary btn-lg">${(0, $frM9m.t)('ok-btn')}</button></div>`;
        $63728aa8d5042ce9$export$9704d2cd3b48497c.html(content);
        $63728aa8d5042ce9$export$9704d2cd3b48497c.show();
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#buttonOK').on('click', ()=>{
            globalThis.location.href = 'shopping-cart.html';
        });
        return true;
    }
    return false;
}
function $63728aa8d5042ce9$export$b4c9562b4fe385a5(eventName) {
    if (!eventName || eventName === false || eventName === 'false' || eventName === null || eventName === 'null') {
        alert('eventName is not provided.');
        return true;
    }
    return false;
}
function $63728aa8d5042ce9$export$2c9f01379d21d93(checkout) {
    const photoPlusAlreadyExist = (0, $gb01V.ecomHasFullUnlockProduct)(checkout);
    if (photoPlusAlreadyExist) {
        $63728aa8d5042ce9$export$5b806f77bd15a21b(checkout);
        return;
    }
    const eventName = localStorage.getItem('eventName');
    // Event name is critical parameter and must be provided correctly
    if ($63728aa8d5042ce9$export$b4c9562b4fe385a5(eventName)) return;
    const lineItems = [];
    const attUid = localStorage.getItem('attUidWA') || $63728aa8d5042ce9$export$34c5a9262f934fa5('uId');
    const fullUnlockProd = JSON.parse($63728aa8d5042ce9$var$fullUnlockProduct);
    const lineItem = {
        variantId: fullUnlockProd.variantId,
        quantity: 1
    };
    lineItem.customAttributes = [];
    const variantArr = [];
    const newVariant = {};
    newVariant.productTitle = fullUnlockProd.title;
    newVariant.pid = 0;
    newVariant.eventName = eventName;
    newVariant.id = fullUnlockProd.id;
    newVariant.attendeeUid = attUid;
    newVariant.action = 'unlock';
    newVariant.uniqueField = $63728aa8d5042ce9$export$36ec425867d538d7();
    variantArr.push(newVariant);
    lineItem.customAttributes.push({
        key: '_variantArr',
        value: JSON.stringify(variantArr)
    });
    lineItems.push(lineItem);
    // alert(JSON.stringify(variantArr))
    (0, $gb01V.ecomAddLineItems)(checkout.id, lineItems).then((updatedCheckout)=>{
        $63728aa8d5042ce9$export$5b806f77bd15a21b(updatedCheckout);
    }).catch((err)=>{
        console.error('Error adding to cart:', err);
    });
}
async function $63728aa8d5042ce9$export$5b806f77bd15a21b(checkout) {
    const tipProducts = await (0, $gb01V.ecomLoadTipProducts)({
        channel: 'webapp'
    });
    if (!Array.isArray(tipProducts) || tipProducts.length === 0 || (0, $gb01V.ecomHasTipProduct)(checkout)) {
        $63728aa8d5042ce9$var$openCheckoutPage(checkout);
        return;
    }
    $63728aa8d5042ce9$export$9704d2cd3b48497c.html((0, $gb01V.ecomRenderTipCheckoutPopupHtml)({
        tipProducts: tipProducts,
        message: (0, $frM9m.t)('checkout-tip-message'),
        description: (0, $frM9m.t)('checkout-tip-description'),
        noTipLabel: (0, $frM9m.t)('checkout-no-tip-btn')
    }));
    $63728aa8d5042ce9$export$9704d2cd3b48497c.show();
    const disableTipActions = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#noTipBtn, .tip-amount-btn').prop('disabled', true);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#noTipBtn').off('click').on('click', ()=>{
        disableTipActions();
        $63728aa8d5042ce9$export$9704d2cd3b48497c.hide();
        $63728aa8d5042ce9$var$openCheckoutPage(checkout);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('.tip-amount-btn').off('click').on('click', async function onTipClick() {
        disableTipActions();
        const tipProduct = tipProducts.find((tip)=>Number(tip.id) === Number(this.dataset.tipId));
        $63728aa8d5042ce9$export$9704d2cd3b48497c.hide();
        if (!tipProduct) {
            $63728aa8d5042ce9$var$openCheckoutPage(checkout);
            return;
        }
        const eventName = localStorage.getItem('eventName');
        if ($63728aa8d5042ce9$export$b4c9562b4fe385a5(eventName)) return;
        try {
            const updatedCheckout = await (0, $gb01V.ecomAddLineItems)(checkout.id, [
                (0, $gb01V.ecomBuildTipLineItem)(tipProduct, {
                    eventName: eventName,
                    attendeeUid: localStorage.getItem('attUidWA') || $63728aa8d5042ce9$export$34c5a9262f934fa5('uId'),
                    uniqueField: $63728aa8d5042ce9$export$36ec425867d538d7()
                })
            ]);
            $63728aa8d5042ce9$var$openCheckoutPage(updatedCheckout || checkout);
        } catch (err) {
            console.error('Error adding tip to cart:', err);
            $63728aa8d5042ce9$var$openCheckoutPage(checkout);
        }
    });
}
function $63728aa8d5042ce9$export$79a99262bbe888be(lineItem, customAttName) {
    return lineItem.customAttributes?.find((att)=>att.key === customAttName)?.value ?? null;
}
function $63728aa8d5042ce9$var$openCheckoutPage(checkout) {
    localStorage.setItem('pendingCheckoutStartedAt', String(Date.now()));
    globalThis.location = checkout.webUrl || checkout.checkoutUrl;
}
function $63728aa8d5042ce9$var$remoteCaptureReq(attendeeUid, robotId) {
    const body = {
        attendee_uid: attendeeUid,
        aws_robot_name: robotId
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($h83rN))).ajax({
        type: 'POST',
        url: `${"https://api-new.occo.io/v1"}/attendee/make-a-shoot`,
        data: JSON.stringify(body),
        dataType: 'json',
        success () {}
    });
}
function $63728aa8d5042ce9$var$countDown(number, RC_TXT3) {
    let count = number;
    if (count >= 0) {
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#cDId').html(count);
        count -= 1;
        setTimeout(()=>{
            $63728aa8d5042ce9$var$countDown(count, RC_TXT3);
        }, 1000);
    } else {
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#cDId').html('');
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#closeCont').show();
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN)))('#hpText').html(RC_TXT3);
    }
}
function $63728aa8d5042ce9$export$81c028dff25f2b70({ activityName: activityName, photoId: photoId, robotId: robotId = null, attendeeUid: attendeeUid }) {
    const activityType = 'info';
    (0, $eMAh6.occoApi).activityCreateByRobotId(robotId, photoId, activityName, activityType, attendeeUid, (err)=>{
        if (err) return $63728aa8d5042ce9$export$32a3bfc434160815(err.message_key);
    });
}
function $63728aa8d5042ce9$export$2c891fc7eb6d45ab({ activityName: activityName, listOfPhotoId: listOfPhotoId, robotId: robotId = null, attendeeUid: attendeeUid }) {
    const activityType = 'info';
    (0, $eMAh6.occoApi).activityBulkCreateByRobotId(robotId, listOfPhotoId, activityName, activityType, attendeeUid, (err)=>{
        if (err) return $63728aa8d5042ce9$export$32a3bfc434160815(err.message_key);
    });
}
function $63728aa8d5042ce9$var$getRobotSettings(robotId, callback) {
    const body = {
        aws_robot_name: robotId
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($h83rN))).ajax({
        type: 'POST',
        url: `${"https://api-new.occo.io/v1"}/robot/settings/retrieve`,
        data: JSON.stringify(body),
        dataType: 'json',
        success (resp) {
            let settings = {};
            if (resp?.result?.state) settings = resp.result.state;
            callback(settings);
        }
    });
}
function $63728aa8d5042ce9$export$a3878ae81adf338a(url) {
    if (!url) return url;
    return url.split('/').pop();
}
function $63728aa8d5042ce9$export$371e338370561054(email, multi = false) {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // Email address
    let validEmail = true;
    if (multi) {
        const emails = email.split(',');
        if (emails && emails.length > 1) (0, (/*@__PURE__*/$parcel$interopDefault($h83rN))).each(emails, (index, value)=>{
            if (!emailRegex.test(value)) return false;
        });
        else validEmail = emailRegex.test(emails[0]);
    } else validEmail = emailRegex.test(email);
    return validEmail;
}
function $63728aa8d5042ce9$export$de026b00723010c1(text) {
    alert(text);
}
function $63728aa8d5042ce9$export$70410f492c55290a(message) {
    // Remove existing error overlay if present
    const existingOverlay = document.getElementById('blocking-error-overlay');
    if (existingOverlay) existingOverlay.remove();
    // Create blocking overlay
    const overlay = document.createElement('div');
    overlay.id = 'blocking-error-overlay';
    overlay.className = 'blocking-error-overlay';
    const errorBox = document.createElement('div');
    errorBox.className = 'blocking-error-box';
    const errorIcon = document.createElement('div');
    errorIcon.className = 'blocking-error-icon';
    errorIcon.textContent = "\u26A0\uFE0F";
    const errorTitle = document.createElement('h3');
    errorTitle.className = 'blocking-error-title';
    errorTitle.textContent = 'Error';
    const errorMessage = document.createElement('p');
    errorMessage.className = 'blocking-error-message';
    errorMessage.textContent = message;
    errorBox.appendChild(errorIcon);
    errorBox.appendChild(errorTitle);
    errorBox.appendChild(errorMessage);
    overlay.appendChild(errorBox);
    document.body.appendChild(overlay);
    // Prevent any interaction with the page
    overlay.addEventListener('click', (e)=>e.stopPropagation());
    overlay.addEventListener('contextmenu', (e)=>e.preventDefault());
}
function $63728aa8d5042ce9$export$fdb37755460c48a(isShowMode = false) {
    const qrMenuItem = document.querySelector('#openQRreader .menu__item-text');
    if (qrMenuItem) qrMenuItem.textContent = isShowMode ? 'My Album Code' : 'QR Scanner';
}
async function $63728aa8d5042ce9$export$738ce82e3cb95b57({ eventCode: eventCode, name: name, email: email, phoneNumber: phoneNumber }) {
    return new Promise((resolve)=>{
        const data = {
            eventCode: eventCode,
            attendeeName: name,
            attendeeEmail: email,
            attendeePhoneNumber: phoneNumber
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($h83rN))).ajax({
            type: 'POST',
            url: `${"https://api-new.occo.io/v1"}/attendee/create-and-send-email`,
            data: JSON.stringify(data),
            dataType: 'json',
            success: resolve
        });
    });
}
function $63728aa8d5042ce9$export$8859af7305300b0a() {
    const content = `<div>${(0, $frM9m.t)('checkout-delete-restriction-message')}</div><br>
                     <button  type = "button" class = "btn btn-primary btn-lg" data-dismiss = "modal">${(0, $frM9m.t)('ok-btn')}</button>`;
    $63728aa8d5042ce9$export$9704d2cd3b48497c.html(content);
    $63728aa8d5042ce9$export$9704d2cd3b48497c.show();
}
function $63728aa8d5042ce9$export$4db89c48f2651f19(desc) {
    if (!desc || !$63728aa8d5042ce9$export$abd67cc48e99962b(desc)) return {
        acceptTags: [],
        denyTags: []
    };
    const params = JSON.parse(desc);
    const acceptTags = params.require_tag || [];
    const denyTags = params.deny_tag || [];
    return {
        acceptTags: acceptTags,
        denyTags: denyTags
    };
}
function $63728aa8d5042ce9$export$f17bf166de11360f(product) {
    const prodDesc = product.desc || product.description;
    let prodDescJson = {};
    const resProdTypes = {
        acceptTags: [],
        denyTags: []
    };
    if (prodDesc) try {
        prodDescJson = JSON.parse(prodDesc);
    } catch (error) {
        console.log(`Wrong JSON format in description: ${prodDesc} error: ${error}`);
        prodDescJson = {};
    }
    let productAcceptTags = [];
    let productDenyTags = [];
    if (prodDescJson.require_tag) {
        productAcceptTags = productAcceptTags.concat(prodDescJson.require_tag);
        resProdTypes.acceptTags = productAcceptTags;
    }
    if (prodDescJson.deny_tag) {
        productDenyTags = productDenyTags.concat(prodDescJson.deny_tag);
        resProdTypes.denyTags = productDenyTags;
    }
    return resProdTypes;
}
function $63728aa8d5042ce9$export$49e33a6a3ab524d9() {
    const throttleData = {};
    // eslint-disable-next-line no-prototype-builtins
    const isEnabled = (key)=>throttleData.hasOwnProperty(key) && throttleData[key];
    const disable = (key)=>{
        throttleData[key] = false;
    };
    const enable = (key)=>{
        throttleData[key] = true;
    };
    const disableOverTime = (key, milliseconds)=>setTimeout(()=>disable(key), milliseconds);
    return (id, cb, timeout)=>{
        if (!isEnabled(id)) {
            cb();
            enable(id);
            disableOverTime(id, timeout);
        }
    };
}
function $63728aa8d5042ce9$export$fc95a5c486aa74c0(variant) {
    return variant?.productPurpose === 'printable' || variant?.product_purpose === 'printable';
}
function $63728aa8d5042ce9$export$b7ed17c2edb4d953(variant) {
    return !$63728aa8d5042ce9$export$fc95a5c486aa74c0(variant);
}
function $63728aa8d5042ce9$var$isUnlockMedia(variant) {
    return variant?.productPurpose === 'partial_unlock_media' || variant?.product_purpose === 'partial_unlock_media';
}
function $63728aa8d5042ce9$export$ff75e500ee7af77c(variant) {
    return $63728aa8d5042ce9$export$fc95a5c486aa74c0(variant) || $63728aa8d5042ce9$var$isUnlockMedia(variant);
}
function $63728aa8d5042ce9$export$c970901de3da6e49(variant) {
    return !$63728aa8d5042ce9$export$ff75e500ee7af77c(variant);
}
function $63728aa8d5042ce9$export$3509b628d6b4aca5(src, tags) {
    return /(jpg|jpeg|png)$/gi.test($63728aa8d5042ce9$var$fileExt(src)) || src.includes('uokg5o') && tags.acceptTags.includes('uokg5o');
}
function $63728aa8d5042ce9$var$fileExt(path) {
    return path.split('.').pop().toLowerCase();
}
function $63728aa8d5042ce9$export$d700d4bedcca3f6e(src, tags, unlockMedia) {
    return /(jpg|jpeg|png)$/gi.test($63728aa8d5042ce9$var$fileExt(src)) || unlockMedia === 'unlock_media' || localStorage.getItem('isUnlockMedia') === 'true' || src.includes('uokg5o') && tags.acceptTags.includes('uokg5o');
}
function $63728aa8d5042ce9$export$abd67cc48e99962b(str) {
    if (!str || str.trim().length === 0) return false;
    try {
        JSON.parse(str);
    } catch (error) {
        console.log(`Wrong JSON string: ${str} error: ${error}`);
        return false;
    }
    return true;
}
const $63728aa8d5042ce9$var$accessDataStorage = (0, $4odV3.initAccessDataStorage)();
$63728aa8d5042ce9$var$accessDataStorage.getData((0, $4odV3.makeAccessData)());
function $63728aa8d5042ce9$export$d17b2e634dc29da6(photos, tags, unlockMedia) {
    return photos.filter((photo)=>$63728aa8d5042ce9$export$d700d4bedcca3f6e(photo.full_path, tags, unlockMedia) && $63728aa8d5042ce9$export$c5c99856861f4364(photo.thumb_full_path, tags)).map((photo)=>({
            ...photo,
            watermarkSrc: (0, $4odV3.getWatermarkSrc)($63728aa8d5042ce9$var$accessDataStorage.getData(), photo)
        }));
}
function $63728aa8d5042ce9$export$c5c99856861f4364(imgUrl, prodTag) {
    if (!prodTag || !prodTag.acceptTags && !prodTag.denyTags || prodTag.acceptTags.length === 0 && prodTag.denyTags.length === 0) return true;
    let fileName = '';
    if (imgUrl) fileName = $63728aa8d5042ce9$export$a3878ae81adf338a(imgUrl);
    let isPassedAccept = prodTag.acceptTags.length === 0;
    let isPassedDeny = true;
    for(let i = 0; i < prodTag.acceptTags.length; i += 1)if (fileName.includes(prodTag.acceptTags[i])) {
        isPassedAccept = true;
        break;
    }
    if (isPassedAccept) {
        for(let i = 0; i < prodTag.denyTags.length; i += 1)if (fileName.includes(prodTag.denyTags[i])) {
            isPassedDeny = false;
            break;
        }
    }
    return isPassedAccept && isPassedDeny;
}
const $63728aa8d5042ce9$export$c44985b87d605eff = (arr, ...keys)=>keys.length > 1 ? arr.map((i)=>keys.map((k)=>i[k])) : arr.map((i)=>i[keys[0]]);
function $63728aa8d5042ce9$export$3610dff0396da865(imgPaths, prodTags) {
    if (!prodTags || !prodTags.acceptTags && !prodTags.denyTags || prodTags.acceptTags.length === 0 && prodTags.denyTags.length === 0 || !imgPaths || imgPaths.length === 0) return true;
    let showProduct = false;
    for(const i in imgPaths)showProduct = showProduct || $63728aa8d5042ce9$export$c5c99856861f4364(imgPaths[i], prodTags);
    return showProduct;
}
function $63728aa8d5042ce9$export$773647ccbc7c158(variant) {
    return $63728aa8d5042ce9$export$3610dff0396da865($63728aa8d5042ce9$export$c44985b87d605eff(JSON.parse(localStorage.getItem('allPhotos')), 'full_path'), $63728aa8d5042ce9$export$4db89c48f2651f19(variant.desc));
}
function $63728aa8d5042ce9$export$1962d8d7d1ac121(combo, alaCarteId, imgPaths) {
    let showComboAfterTagFiltering = !combo.id.includes(alaCarteId);
    const prodTags = {};
    for(const i in combo.products){
        prodTags.acceptTags = $63728aa8d5042ce9$export$f17bf166de11360f(combo.products[i]).acceptTags;
        prodTags.denyTags = $63728aa8d5042ce9$export$f17bf166de11360f(combo.products[i]).denyTags;
        showComboAfterTagFiltering = combo.id.includes(alaCarteId) ? showComboAfterTagFiltering || $63728aa8d5042ce9$export$3610dff0396da865(imgPaths, prodTags) : showComboAfterTagFiltering && $63728aa8d5042ce9$export$3610dff0396da865(imgPaths, prodTags);
    }
    return showComboAfterTagFiltering;
}
function $63728aa8d5042ce9$export$f0fcbfd028dcb7eb(ids, photos) {
    return ids.map((photoId)=>photos.find((photo)=>photo.id === photoId)).filter((photo)=>Boolean(photo));
}
function $63728aa8d5042ce9$export$55def886b2067470(formModel, currentStep) {
    return formModel[currentStep - 1];
}
function $63728aa8d5042ce9$export$a11b0059900ceec8() {
    return /android/i.exec(navigator.userAgent);
}
function $63728aa8d5042ce9$export$186c6964ca17d99() {
    return /(iPad)|(iPhone)|(iPod)/i.exec(navigator.userAgent);
}
function $63728aa8d5042ce9$export$d0a8044dce8ff2fc() {
    return $63728aa8d5042ce9$export$a11b0059900ceec8() || $63728aa8d5042ce9$export$186c6964ca17d99();
}
function $63728aa8d5042ce9$export$bf344be07946b610(file, newName) {
    Object.defineProperty(file, 'name', {
        writable: true,
        value: newName,
        configurable: true
    });
}
function $63728aa8d5042ce9$export$36ec425867d538d7() {
    if (crypto?.randomUUID) return crypto.randomUUID();
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}
const $63728aa8d5042ce9$var$downloadSingleFile = async (url)=>{
    const response = await fetch(url);
    const blob = await response.blob();
    const urlAsArray = url.split('/');
    const fileName = urlAsArray[urlAsArray.length - 1];
    const a = document.createElement('a');
    a.download = fileName;
    a.style.display = 'none';
    a.href = URL.createObjectURL(blob);
    a.addEventListener('click', ()=>{
        setTimeout(()=>{
            URL.revokeObjectURL(a.href);
            a.remove();
        }, 1000);
    });
    document.body.append(a);
    a.click();
};
const $63728aa8d5042ce9$var$isShareTooLargeError = (error)=>{
    const message = `${error?.message || ''}`.toLowerCase();
    return error?.name === 'DataError' || error?.name === 'NotAllowedError' || error?.name === 'TypeError' || message.includes('too large') || message.includes('share data') || message.includes('payload');
};
const $63728aa8d5042ce9$export$ebc809a96627e361 = (waitingNotice)=>async (photos, attendeeUid)=>{
        const title = (0, $frM9m.t)('home-media-share-title');
        // Track download events for each photo
        const photoIdList = photos.map((photo)=>photo.id);
        $63728aa8d5042ce9$export$2c891fc7eb6d45ab({
            activityName: 'Download',
            listOfPhotoId: photoIdList,
            attendeeUid: attendeeUid
        });
        const downloadFiles = async (urls)=>{
            waitingNotice.text((0, $frM9m.t)('home-download-waiting-message'));
            waitingNotice.show();
            try {
                if ($63728aa8d5042ce9$export$186c6964ca17d99()) {
                    // Check sharing capability before downloading
                    if (!navigator.canShare) {
                        alert((0, $frM9m.t)('home-share-files-unsupported-message'));
                        waitingNotice.hide();
                        return;
                    }
                    // iOS handling using navigator.share
                    const files = await Promise.all(urls.map(async (url)=>{
                        const response = await fetch(url);
                        const blob = await response.blob();
                        const urlAsArray = url.split('/');
                        const fileName = urlAsArray[urlAsArray.length - 1];
                        return new File([
                            blob
                        ], fileName, {
                            type: blob.type
                        });
                    }));
                    await navigator.share({
                        files: files,
                        title: title
                    });
                } else // Android and other devices handling
                await Promise.all(urls.map($63728aa8d5042ce9$var$downloadSingleFile));
            } catch (error) {
                // Silently ignore user cancellation, log only actual errors
                const userCanceled = error?.name === 'AbortError' || error?.message === 'Share canceled';
                if (userCanceled) return;
                if ($63728aa8d5042ce9$var$isShareTooLargeError(error)) {
                    alert((0, $frM9m.t)('download-selection-too-large-message'));
                    return;
                }
            } finally{
                waitingNotice.hide();
            }
        };
        await downloadFiles(photos.map((photo)=>photo.full_path));
    };

});
parcelRegister("h83rN", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.6.4
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-03-08T15:28Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.6.4", // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var Sizzle = /*!
 * Sizzle CSS Selector Engine v2.3.10
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2023-02-14
 */ function(window1) {
        var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, // Local document vars
        setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, // Instance-specific data
        expando = "sizzle" + 1 * new Date(), preferredDoc = window1.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, // Instance methods
        hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, pushNative = arr.push, push = arr.push, slice = arr.slice, // Use a stripped-down indexOf as it's faster than native
        // https://jsperf.com/thor-indexof-vs-for/5
        indexOf = function(list, elem) {
            var i = 0, len = list.length;
            for(; i < len; i++){
                if (list[i] === elem) return i;
            }
            return -1;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // http://www.w3.org/TR/css3-selectors/#whitespace
        whitespace = "[\\x20\\t\\r\\n\\f]", // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5]
        // or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            "ID": new RegExp("^#(" + identifier + ")"),
            "CLASS": new RegExp("^\\.(" + identifier + ")"),
            "TAG": new RegExp("^(" + identifier + "|[*])"),
            "ATTR": new RegExp("^" + attributes),
            "PSEUDO": new RegExp("^" + pseudos),
            "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            "bool": new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rhtml = /HTML$/i, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            return nonHex ? // Strip the backslash prefix from a non-hex escape sequence
            nonHex : // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // CSS string/identifier serialization
        // https://drafts.csswg.org/cssom/#common-serializing-idioms
        rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, fcssescape = function(ch, asCodePoint) {
            if (asCodePoint) {
                // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                if (ch === "\0") return "\uFFFD";
                // Control characters and (dependent upon position) numbers get escaped as code points
                return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
            }
            // Other potentially-special ASCII characters get backslash-escaped
            return "\\" + ch;
        }, // Used for iframes
        // See setDocument()
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android<4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: arr.length ? // Leverage slice if possible
                function(target, els) {
                    pushNative.apply(target, slice.call(els));
                } : // Support: IE<9
                // Otherwise append directly
                function(target, els) {
                    var j = target.length, i = 0;
                    // Can't trust NodeList.length
                    while(target[j++] = els[i++]);
                    target.length = j - 1;
                }
            };
        }
        function Sizzle(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE, Opera, Webkit
                                // TODO: identify versions
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        results.push(elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                                results.push(elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && // Support: IE 8 only
                    // Exclude object elements
                    (nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            if (newContext !== context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = nid.replace(rcssescape, fcssescape);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrim, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */ function addHandle(attrs, handler) {
            var arr = attrs.split("|"), i = arr.length;
            while(i--)Expr.attrHandle[arr[i]] = handler;
        }
        /**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */ function siblingCheck(a, b) {
            var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
            // Use IE sourceIndex if available on both nodes
            if (diff) return diff;
            // Check if b follows a
            if (cur) while(cur = cur.nextSibling){
                if (cur === b) return -1;
            }
            return a ? 1 : -1;
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return name === "input" && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return (name === "input" || name === "button") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        /* jshint -W018 */ elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        // Expose support vars for convenience
        support = Sizzle.support = {};
        /**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */ isXML = Sizzle.isXML = function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Support: IE <=8
            // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
            // https://bugs.jquery.com/ticket/4833
            return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
        };
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ setDocument = Sizzle.setDocument = function(node) {
            var hasCompare, subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            docElem = document.documentElement;
            documentIsHTML = !isXML(document);
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                // Support: IE 11, Edge
                if (subWindow.addEventListener) subWindow.addEventListener("unload", unloadHandler, false);
                else if (subWindow.attachEvent) subWindow.attachEvent("onunload", unloadHandler);
            }
            // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
            // Safari 4 - 5 only, Opera <=11.6 - 12.x only
            // IE/Edge & older browsers don't support the :scope pseudo-class.
            // Support: Safari 6.0 only
            // Safari 6.0 supports :scope but it's an alias of :root there.
            support.scope = assert(function(el) {
                docElem.appendChild(el).appendChild(document.createElement("div"));
                return typeof el.querySelectorAll !== "undefined" && !el.querySelectorAll(":scope fieldset div").length;
            });
            // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Make sure the the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            /* Attributes
	---------------------------------------------------------------------- */ // Support: IE<8
            // Verify that getAttribute really returns attributes and not properties
            // (excepting IE8 booleans)
            support.attributes = assert(function(el) {
                el.className = "i";
                return !el.getAttribute("className");
            });
            /* getElement(s)By*
	---------------------------------------------------------------------- */ // Check if getElementsByTagName("*") returns only elements
            support.getElementsByTagName = assert(function(el) {
                el.appendChild(document.createComment(""));
                return !el.getElementsByTagName("*").length;
            });
            // Support: IE<9
            support.getElementsByClassName = rnative.test(document.getElementsByClassName);
            // Support: IE<10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                docElem.appendChild(el).id = expando;
                return !document.getElementsByName || !document.getElementsByName(expando).length;
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find["TAG"] = support.getElementsByTagName ? function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else if (support.qsa) return context.querySelectorAll(tag);
            } : function(tag, context) {
                var elem, tmp = [], i = 0, // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                results = context.getElementsByTagName(tag);
                // Filter out possible comments
                if (tag === "*") {
                    while(elem = results[i++])if (elem.nodeType === 1) tmp.push(elem);
                    return tmp;
                }
                return results;
            };
            // Class
            Expr.find["CLASS"] = support.getElementsByClassName && function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
            rbuggyMatches = [];
            // qSa(:focus) reports false when true (Chrome 21)
            // We allow this because of a bug in IE8/9 that throws an error
            // whenever `document.activeElement` is accessed on an iframe
            // So, we allow :focus to pass through QSA all the time to avoid the IE error
            // See https://bugs.jquery.com/ticket/13378
            rbuggyQSA = [];
            if (support.qsa = rnative.test(document.querySelectorAll)) {
                // Build QSA regex
                // Regex strategy adopted from Diego Perini
                assert(function(el) {
                    var input;
                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // https://bugs.jquery.com/ticket/12359
                    docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (el.querySelectorAll("[msallowcapture^='']").length) rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                    // Support: IE 11+, Edge 15 - 18+
                    // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                    // Adding a temporary attribute to the document before the selection works
                    // around the issue.
                    // Interestingly, IE 10 & older don't seem to have the issue.
                    input = document.createElement("input");
                    input.setAttribute("name", "");
                    el.appendChild(input);
                    if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibling-combinator selector` fails
                    if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                    // Support: Firefox <=3.6 - 5 only
                    // Old Firefox doesn't throw on a badly-escaped identifier.
                    el.querySelectorAll("\\\f");
                    rbuggyQSA.push("[\\r\\n\\f]");
                });
                assert(function(el) {
                    el.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    el.appendChild(input).setAttribute("name", "D");
                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (el.querySelectorAll("[name=d]").length) rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (el.querySelectorAll(":enabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: IE9-11+
                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                    docElem.appendChild(el).disabled = true;
                    if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: Opera 10 - 11 only
                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    el.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                });
            }
            if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) assert(function(el) {
                // Check to see if it's possible to do matchesSelector
                // on a disconnected node (IE 9)
                support.disconnectedMatch = matches.call(el, "*");
                // This should fail with an exception
                // Gecko does not error, returns false instead
                matches.call(el, "[s!='']:x");
                rbuggyMatches.push("!=", pseudos);
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
            /* Contains
	---------------------------------------------------------------------- */ hasCompare = rnative.test(docElem.compareDocumentPosition);
            // Element contains another
            // Purposefully self-exclusive
            // As in, an element does not contain itself
            contains = hasCompare || rnative.test(docElem.contains) ? function(a, b) {
                // Support: IE <9 only
                // IE doesn't have `contains` on `document` so we need to check for
                // `documentElement` presence.
                // We need to fall back to `a` when `documentElement` is missing
                // as `ownerDocument` of elements within `<template/>` may have
                // a null one - a default behavior of all modern browsers.
                var adown = a.nodeType === 9 && a.documentElement || a, bup = b && b.parentNode;
                return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
            } : function(a, b) {
                if (b) while(b = b.parentNode){
                    if (b === a) return true;
                }
                return false;
            };
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = hasCompare ? function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a == document || a.ownerDocument == preferredDoc && contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b == document || b.ownerDocument == preferredDoc && contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            } : function(a, b) {
                // Exit early if the nodes are identical
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [
                    a
                ], bp = [
                    b
                ];
                // Parentless nodes are either documents or disconnected
                if (!aup || !bup) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ return a == document ? -1 : b == document ? 1 : /* eslint-enable eqeqeq */ aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                else if (aup === bup) return siblingCheck(a, b);
                // Otherwise we need full lists of their ancestors for comparison
                cur = a;
                while(cur = cur.parentNode)ap.unshift(cur);
                cur = b;
                while(cur = cur.parentNode)bp.unshift(cur);
                // Walk down the tree looking for a discrepancy
                while(ap[i] === bp[i])i++;
                return i ? // Do a sibling check if the nodes have a common ancestor
                siblingCheck(ap[i], bp[i]) : // Otherwise nodes in our document sort first
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ ap[i] == preferredDoc ? -1 : bp[i] == preferredDoc ? 1 : /* eslint-enable eqeqeq */ 0;
            };
            return document;
        };
        Sizzle.matches = function(expr, elements) {
            return Sizzle(expr, null, null, elements);
        };
        Sizzle.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return Sizzle(expr, document, null, [
                elem
            ]).length > 0;
        };
        Sizzle.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return contains(context, elem);
        };
        Sizzle.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (jQuery #13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        };
        Sizzle.escape = function(sel) {
            return (sel + "").replace(rcssescape, fcssescape);
        };
        Sizzle.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ Sizzle.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            hasDuplicate = !support.detectDuplicates;
            sortInput = !support.sortStable && results.slice(0);
            results.sort(sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)results.splice(duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        /**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */ getText = Sizzle.getText = function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += getText(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                // Use textContent for elements
                // innerText usage removed for consistency of new lines (jQuery #11153)
                if (typeof elem.textContent === "string") return elem.textContent;
                else // Traverse its children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling)ret += getText(elem);
            } else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        };
        Expr = Sizzle.selectors = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                "ATTR": function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                "CHILD": function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) Sizzle.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) Sizzle.error(match[0]);
                    return match;
                },
                "PSEUDO": function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr["CHILD"].test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                "TAG": function(nodeNameSelector) {
                    var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                    };
                },
                "CLASS": function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                "ATTR": function(name, operator, check) {
                    return function(elem) {
                        var result = Sizzle.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        /* eslint-disable max-len */ return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
                    /* eslint-enable max-len */ };
                },
                "CHILD": function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, uniqueCache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                // ...in a gzip-friendly way
                                node = parent;
                                outerCache = node[expando] || (node[expando] = {});
                                // Support: IE <9 only
                                // Defend against cloned attroperties (jQuery gh-1709)
                                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                cache = uniqueCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    uniqueCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    // ...in a gzip-friendly way
                                    node = elem;
                                    outerCache = node[expando] || (node[expando] = {});
                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                    cache = uniqueCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            // Support: IE <9 only
                                            // Defend against cloned attroperties (jQuery gh-1709)
                                            uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                            uniqueCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                "PSEUDO": function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                "not": markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrim, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element (issue #299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                "has": markFunction(function(selector) {
                    return function(elem) {
                        return Sizzle(selector, elem).length > 0;
                    };
                }),
                "contains": markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || getText(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // http://www.w3.org/TR/selectors/#lang-pseudo
                "lang": markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) Sizzle.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                "target": function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                "root": function(elem) {
                    return elem === docElem;
                },
                "focus": function(elem) {
                    return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                "enabled": createDisabledPseudo(false),
                "disabled": createDisabledPseudo(true),
                "checked": function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var nodeName = elem.nodeName.toLowerCase();
                    return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
                },
                "selected": function(elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                "empty": function(elem) {
                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                "parent": function(elem) {
                    return !Expr.pseudos["empty"](elem);
                },
                // Element/input types
                "header": function(elem) {
                    return rheader.test(elem.nodeName);
                },
                "input": function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                "button": function(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === "button" || name === "button";
                },
                "text": function(elem) {
                    var attr;
                    return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                "first": createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                "last": createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                "eq": createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                "even": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "odd": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument > length ? length : argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos["nth"] = Expr.pseudos["eq"];
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        tokenize = Sizzle.tokenize = function(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrim, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        };
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, uniqueCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        // Support: IE <9 only
                        // Defend against cloned attroperties (jQuery gh-1709)
                        uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
                        if (skip && skip === elem.nodeName.toLowerCase()) elem = elem[dir] || elem;
                        else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            uniqueCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)Sizzle(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results : matcherIn;
                // Find primary matches
                if (matcher) matcher(matcherIn, matcherOut, context, xml);
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element (issue #299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find["TAG"]("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: IE<9, Safari
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) Sizzle.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        compile = Sizzle.compile = function(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        };
        /**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ select = Sizzle.select = function(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        };
        // One-time assignments
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Support: Chrome 14-35+
        // Always assume duplicates if they aren't passed to the comparison function
        support.detectDuplicates = !!hasDuplicate;
        // Initialize against the default document
        setDocument();
        // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        // Support: IE<8
        // Prevent attribute/property "interpolation"
        // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
        if (!assert(function(el) {
            el.innerHTML = "<a href='#'></a>";
            return el.firstChild.getAttribute("href") === "#";
        })) addHandle("type|href|height|width", function(elem, name, isXML) {
            if (!isXML) return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        });
        // Support: IE<9
        // Use defaultValue in place of getAttribute("value")
        if (!support.attributes || !assert(function(el) {
            el.innerHTML = "<input/>";
            el.firstChild.setAttribute("value", "");
            return el.firstChild.getAttribute("value") === "";
        })) addHandle("value", function(elem, _name, isXML) {
            if (!isXML && elem.nodeName.toLowerCase() === "input") return elem.defaultValue;
        });
        // Support: IE<9
        // Use getAttributeNode to fetch booleans when getAttribute lies
        if (!assert(function(el) {
            return el.getAttribute("disabled") == null;
        })) addHandle(booleans, function(elem, name, isXML) {
            var val;
            if (!isXML) return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        });
        return Sizzle;
    }(window1);
    jQuery.find = Sizzle;
    jQuery.expr = Sizzle.selectors;
    // Deprecated
    jQuery.expr[":"] = jQuery.expr.pseudos;
    jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
    jQuery.text = Sizzle.getText;
    jQuery.isXMLDoc = Sizzle.isXML;
    jQuery.contains = Sizzle.contains;
    jQuery.escapeSelector = Sizzle.escape;
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to Sizzle
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.stackTrace);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the stack, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getStackHook) process.stackTrace = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    jQuery.Deferred.exceptionHook = function(error, stack) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    // Support: IE <=9 - 11+
    // focus() and blur() are asynchronous, except when they are no-op.
    // So expect focus to be synchronous when the element is already active,
    // and blur to be synchronous when the element is not already active.
    // (focus and blur are always synchronous in other supported browsers,
    // this just defines when we can count on it).
    function expectSync(elem, type) {
        return elem === safeActiveElement() === (type === "focus");
    }
    // Support: IE <=9 only
    // Accessing document.activeElement can throw unexpectedly
    // https://bugs.jquery.com/ticket/13393
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch (err) {}
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", returnTrue);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, expectSync) {
        // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
        if (!expectSync) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var notAsync, result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    // Saved data should be false in such cases, but might be a leftover capture object
                    // from an async native handler (gh-4350)
                    if (!saved.length) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        // Support: IE <=9 - 11+
                        // focus() and blur() are asynchronous
                        notAsync = expectSync(this, type);
                        this[type]();
                        result = dataPriv.get(this, type);
                        if (saved !== result || notAsync) dataPriv.set(this, type, false);
                        else result = {};
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            // Support: Chrome 86+
                            // In Chrome, if an element having a focusout handler is blurred by
                            // clicking outside of it, it invokes the handler synchronously. If
                            // that handler calls `.remove()` on the element, the data is cleared,
                            // leaving `result` undefined. We need to guard against this.
                            return result && result.value;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering the
                    // native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved.length) {
                    // ...and capture the result
                    dataPriv.set(this, type, {
                        value: jQuery.event.trigger(// Support: IE <=9 - 11+
                        // Extend with the prototype to reset the above stopImmediatePropagation()
                        jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
                    });
                    // Abort handling of the native event
                    event.stopImmediatePropagation();
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, expectSync);
                // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is display: block
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            if (box === "margin") delta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            "animationIterationCount": true,
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "gridArea": true,
            "gridColumn": true,
            "gridColumnEnd": true,
            "gridColumnStart": true,
            "gridRow": true,
            "gridRowEnd": true,
            "gridRowStart": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    support.focusin = "onfocusin" in window1;
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    // Support: Firefox <=44
    // Firefox doesn't have focus(in | out) events
    // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
    //
    // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
    // focus(in | out) events fire after focus & blur events,
    // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
    // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
    if (!support.focusin) jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(orig, fix) {
        // Attach a single capturing handler on the document while someone wants focusin/focusout
        var handler = function(event) {
            jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
        };
        jQuery.event.special[fix] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix);
                if (!attaches) doc.addEventListener(orig, handler, true);
                dataPriv.access(doc, fix, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix) - 1;
                if (!attaches) {
                    doc.removeEventListener(orig, handler, true);
                    dataPriv.remove(doc, fix);
                } else dataPriv.access(doc, fix, attaches);
            }
        };
    });
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("eMAh6", function(module, exports) {

$parcel$export(module.exports, "occoApi", function () { return $ac31afd0c7810692$export$3259b9843a3c3aa6; });

var $h83rN = parcelRequire("h83rN");
function $ac31afd0c7810692$var$OccoApi() {
    // organisationId is optional
    this.robotListRetrieve = function(organisationId, callback) {
        const body = {};
        if (organisationId) body.organisation_id = organisationId;
        const methodPath = '/occo-owner/robot/list/retrieve';
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.stockImageListRetrieve = function(eventId, callback) {
        const body = {};
        if (eventId) body.event_id = eventId;
        const methodPath = '/occo-owner/stock-image/list/retrieve';
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.organisationListRetrieve = function(callback) {
        const body = {};
        const methodPath = '/occo-owner/organisation/list/retrieve';
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    /*
   * key_type possible values
   *   - event_owner_api_key (keyValue type string : eventOwnerApiKey)
   *   - event_public_api_key (keyValue type string : eventPublicApiKey)
   *   - event_private_api_key (keyValue type string : eventPrivateApiKey)
   *   - attendee_uid (keyValue type string : attendeeUid)
   *   - attendee_and_org_uids (keyValue type json obj e.g. {"attendee_uid" : "value1", "organisation_uid" : "value2"})
   */ this.eventListRetrieve = function(keyType, keyValue, callback) {
        const body = {};
        body.max_size = 5000;
        body.page_number = 1;
        const hasApiKey = keyType == null;
        if (!hasApiKey) {
            body.key_type = keyType;
            body.key_value = keyValue;
        }
        const showApiErrors = keyType == 'event_owner_api_key';
        const methodPath = hasApiKey ? '/occo-owner/event/list/retrieve' : '/event/list/retrieve';
        _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
    };
    this.pptDelete = function(id, callback) {
        const body = {};
        body.id = id;
        const methodPath = '/occo-owner/ppt/delete';
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    // organisationId is optional
    this.pptListRetrieve = function(organisationId, isWatermarkTemplate, callback) {
        const body = {};
        if (organisationId) body.organisation_id = organisationId;
        if (isWatermarkTemplate) body.is_watermark = isWatermarkTemplate;
        const methodPath = '/occo-owner/ppt/list/retrieve';
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.customPhotoTmpUploadAccessRetrieve = function(event_name, file_name, keep_origin_name, attendeeUid, callback) {
        const body = {};
        body.event_name = event_name;
        body.file_name = file_name;
        body.keep_origin_name = keep_origin_name;
        body.attendee_uid = attendeeUid;
        const methodPath = '/event/tmp-photo-upload-access/retrieve';
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.miniAlbumcreateCustomPhoto = function(eventName, fullPath, attendeeUid, callback) {
        const body = {};
        body.event_name = eventName;
        body.full_path = fullPath;
        body.attendee_uid = attendeeUid;
        const methodPath = '/event/create-attendee-custom-photo/async';
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.activityCreateByRobotId = function(robotId, photoId, activityName, activityType, attUid, callback) {
        const body = {};
        body.robot_id = robotId;
        body.photo_id = photoId;
        body.activity_name = activityName;
        body.activity_type = activityType;
        body.attUid = attUid;
        const methodPath = '/activity/create-by-robot-id';
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.activityBulkCreateByRobotId = function(robotId, listOfPhotoId, activityName, activityType, attUid, callback) {
        const body = {};
        body.robot_id = robotId;
        body.list_of_photo_id = listOfPhotoId;
        body.activity_name = activityName;
        body.activity_type = activityType;
        body.attUid = attUid;
        const methodPath = '/activity/bulk-create-by-robot-id';
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.photoFavoriteSet = function(attendeeUid, photoId, isFavorite, eventCode, callback) {
        const body = {};
        body.attendee_uid = attendeeUid;
        body.photo_id = photoId;
        body.is_favorite = isFavorite;
        body.event_source = 'webapp';
        body.event_code = eventCode;
        const methodPath = '/attendee/photo-favorite/update';
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    /*
   * key_type possible values
   *   - event_name_key (keyValue type string : eventName)
   *   - event_owner_api_key (keyValue type string : eventOwnerApiKey)
   *   - event_public_api_key (keyValue type string : eventPublicApiKey)
   *   - event_private_api_key (keyValue type string : eventPrivateApiKey)
   *   - attendee_uid (keyValue type string : attendeeUid)
   *   - attendee_and_org_uids (keyValue type json obj e.g. {"attendee_uid" : "value1", "organisation_uid" : "value2"})
   */ this.photoListRetrieve = function(keyType, keyValue, eventId, isVisible, startDate, endDate, maxSize, pageNumber, minInterval, maxInterval, forKiosk, isCuratable, isCurated, isOriginal, printable, printed, attId, showTotalCount, fileName, getFromTmp, callback) {
        const body = {};
        body.event_id = eventId;
        body.max_size = maxSize;
        body.page_number = pageNumber;
        body.min_time_minutes_interval = minInterval;
        body.max_time_minutes_interval = maxInterval;
        body.is_kiosk = forKiosk;
        body.is_curatable = isCuratable;
        body.is_curated = isCurated;
        body.is_original = isOriginal;
        body.printable = printable;
        body.printed = printed;
        body.file_name = fileName;
        body.attendee_uid = attId;
        body.show_total_count = showTotalCount;
        body.get_from_tmp = getFromTmp;
        if (typeof isVisible !== 'undefined' && isVisible !== null && isVisible !== '' && isVisible !== 'null') body.is_visible = isVisible;
        const hasApiKey = keyType == null;
        if (startDate) body.start_date = startDate;
        if (endDate) body.end_date = endDate;
        if (!hasApiKey) {
            body.key_type = keyType;
            body.key_value = keyValue;
        }
        const showApiErrors = keyType == 'event_owner_api_key';
        const methodPath = hasApiKey ? '/occo-owner/photo/list/retrieve' : '/photo/list/retrieve';
        _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
    };
    this.passCodeListRetrieve = function(callback) {
        const body = {};
        const methodPath = '/occo-owner/pass-code/list/retrieve';
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.passCodeDelete = function(id, callback) {
        const body = {};
        body.id = id;
        const methodPath = '/occo-owner/pass-code/delete';
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    // profile picture methods
    this.profilePhotoListRetrieve = function(attId, callback) {
        const body = {};
        body.attendee_uid = attId;
        const methodPath = '/attendee/profile-photo/list/retrieve';
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.profilePhotoTmpUploadAccessRetrieve = function(file_name, callback) {
        const body = {};
        body.file_relative_path = file_name;
        const methodPath = '/photo/tmp-upload-access/retrieve';
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.createProfilePhoto = function(attId, full_path, event_name, callback) {
        const body = {};
        body.attendee_uid = attId;
        body.full_path = full_path;
        body.event_name = event_name;
        const methodPath = '/attendee/profile-photo/create-and-attach';
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    function _occoApiPostRequest(hasApiKey, methodPath, body, callback) {
        _occoApiPostRequestBase(hasApiKey, methodPath, body, false, callback);
    }
    function _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback) {
        const showErr = hasApiKey || showApiErrors || window.DEBUG_MODE;
        const ajaxParams = {
            url: "https://api-new.occo.io/v1" + methodPath,
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify(body),
            success (resp, textStatus, jqXHR) {
                if (resp.status == 'ok') callback(null, resp.result);
                else if (resp.status == 'nok') {
                    const err1 = {};
                    err1.type = 'occo';
                    err1.message_key = showErr ? resp.error_message_key : 'Internal Error';
                    err1.message_text = showErr ? resp.error.message_text : 'Internal Error';
                    err1.textStatus = textStatus;
                    err1.jqXHR = jqXHR;
                    err1.resp = resp;
                    console.error('err', JSON.stringify(err1));
                    callback(err1, null);
                } else {
                    const err2 = {};
                    err2.type = 'occo';
                    err2.message_key = 'Internal Error';
                    err2.jqXHR = jqXHR;
                    err2.textStatus = textStatus;
                    err2.resp = resp;
                    console.error('err', JSON.stringify(err2));
                    callback(err2, null);
                }
            },
            error (jqXHR, textStatus, errorThrown) {
                if (jqXHR.readyState == 0 || jqXHR.status == 0) return; // it's not really an error,
                const err = {};
                err.type = 'global';
                err.message_key = 'Internal Error';
                err.jqXHR = jqXHR;
                err.textStatus = textStatus;
                err.errorThrown = errorThrown;
                console.error('err', JSON.stringify(err));
                callback(err, null);
            }
        };
        if (hasApiKey) cognitoApi.getApiKey((err, apiKey)=>{
            if (err) {
                window.location.href = './';
                // callback(err, null);
                return;
            }
            ajaxParams.headers = {
                Authorization: apiKey
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($h83rN))).ajax(ajaxParams);
        });
        else (0, (/*@__PURE__*/$parcel$interopDefault($h83rN))).ajax(ajaxParams);
    }
}
const $ac31afd0c7810692$export$3259b9843a3c3aa6 = new $ac31afd0c7810692$var$OccoApi();

});

parcelRegister("4odV3", function(module, exports) {

$parcel$export(module.exports, "initAccessDataStorage", function () { return $3324335f8aa240f8$export$f7ff41ecbdcf0dc9; });
$parcel$export(module.exports, "makeAccessData", function () { return $3324335f8aa240f8$export$d52e912a0a450989; });
$parcel$export(module.exports, "isEnabledWatermarkBySrc", function () { return $3324335f8aa240f8$export$236edb79db2ae543; });
$parcel$export(module.exports, "isAvailableToUsePhoto", function () { return $3324335f8aa240f8$export$2254fffb7238a3bf; });
$parcel$export(module.exports, "getWatermarkSrc", function () { return $3324335f8aa240f8$export$fc00daa1497efd87; });
$parcel$export(module.exports, "initWatermarkStorage", function () { return $3324335f8aa240f8$export$14db028e6808e544; });
parcelRequire("hH26H");
var $2VuN6 = parcelRequire("2VuN6");
function $3324335f8aa240f8$export$f7ff41ecbdcf0dc9() {
    return {
        setData (access) {
            localStorage.setItem('access', JSON.stringify(access));
        },
        getData () {
            return JSON.parse(localStorage.getItem('access') || '{}');
        }
    };
}
function $3324335f8aa240f8$export$d52e912a0a450989({ isFreeEvent: isFreeEvent = false, wasPaid: wasPaid = false } = {}) {
    return {
        isFreeEvent: isFreeEvent,
        wasPaid: wasPaid
    };
}
function $3324335f8aa240f8$export$5b1ffa3a68bdd25a(access) {
    return access.isFreeEvent || access.wasPaid;
}
function $3324335f8aa240f8$var$isStockImage(photo) {
    return photo?.stock_image_uid !== null && photo?.stock_image_uid !== undefined;
}
function $3324335f8aa240f8$var$shouldApplyWatermarkForStockImage(photo) {
    const value = photo?.stock_image_apply_watermark ?? photo?.stockImageApplyWatermark;
    return value === true || value === 1 || value === '1' || value === 'true';
}
function $3324335f8aa240f8$export$236edb79db2ae543(src) {
    const labelWM = 'nwm845';
    return !src.includes(labelWM);
}
const $3324335f8aa240f8$export$2254fffb7238a3bf = (0, $2VuN6.default)((access, photo)=>{
    if ($3324335f8aa240f8$export$5b1ffa3a68bdd25a(access)) return true;
    if ($3324335f8aa240f8$var$isStockImage(photo)) return !$3324335f8aa240f8$var$shouldApplyWatermarkForStockImage(photo);
    return !$3324335f8aa240f8$export$236edb79db2ae543(photo.full_path);
});
function $3324335f8aa240f8$export$fc00daa1497efd87(access, photo, watermarkSrc = null) {
    if (!$3324335f8aa240f8$export$2254fffb7238a3bf(access, photo)) return watermarkSrc;
    return null;
}
function $3324335f8aa240f8$export$14db028e6808e544() {
    return {
        setSrc (src) {
            localStorage.setItem('watermarkSrc', src);
        },
        getSrc () {
            return localStorage.getItem('watermarkSrc');
        }
    };
}

});
parcelRegister("hH26H", function(module, exports) {

$parcel$export(module.exports, "curry", function () { return (parcelRequire("2VuN6")).default; });
$parcel$export(module.exports, "groupBy", function () { return (parcelRequire("7fzAY")).default; });
$parcel$export(module.exports, "pluck", function () { return (parcelRequire("ayjin")).default; });
$parcel$export(module.exports, "uniq", function () { return (parcelRequire("iQtmQ")).default; });

var $jE0h4 = parcelRequire("jE0h4");

var $jKwj2 = parcelRequire("jKwj2");

var $h8Anj = parcelRequire("h8Anj");

var $cgwpr = parcelRequire("cgwpr");

var $10BJn = parcelRequire("10BJn");

var $j6zVR = parcelRequire("j6zVR");

var $9yN6x = parcelRequire("9yN6x");

var $clJ9m = parcelRequire("clJ9m");

var $gVgoT = parcelRequire("gVgoT");

var $dcmvG = parcelRequire("dcmvG");

var $jbmgQ = parcelRequire("jbmgQ");

var $4v8FY = parcelRequire("4v8FY");

var $9r9kC = parcelRequire("9r9kC");

var $i9nOw = parcelRequire("i9nOw");

var $cEplE = parcelRequire("cEplE");

var $f4dyh = parcelRequire("f4dyh");

var $9taE0 = parcelRequire("9taE0");

var $a4l2i = parcelRequire("a4l2i");

var $4TqhF = parcelRequire("4TqhF");

var $eCXNe = parcelRequire("eCXNe");

var $7BBob = parcelRequire("7BBob");

var $llmg1 = parcelRequire("llmg1");

var $5A4Tr = parcelRequire("5A4Tr");

var $4NB9p = parcelRequire("4NB9p");

var $5heVP = parcelRequire("5heVP");

var $dxvF9 = parcelRequire("dxvF9");

var $9REUd = parcelRequire("9REUd");

var $29s2B = parcelRequire("29s2B");

var $bFCeT = parcelRequire("bFCeT");

var $gSxsL = parcelRequire("gSxsL");

var $95Rhk = parcelRequire("95Rhk");

var $qkq7O = parcelRequire("qkq7O");

var $glKaE = parcelRequire("glKaE");

var $cg8Ag = parcelRequire("cg8Ag");

var $jANtL = parcelRequire("jANtL");

var $4J3hT = parcelRequire("4J3hT");

var $gSKCN = parcelRequire("gSKCN");

var $4IXwC = parcelRequire("4IXwC");

var $7ruQ7 = parcelRequire("7ruQ7");

var $lpV2X = parcelRequire("lpV2X");

var $2VuN6 = parcelRequire("2VuN6");

var $JtjnN = parcelRequire("JtjnN");

var $fCsfV = parcelRequire("fCsfV");

var $Hyj0j = parcelRequire("Hyj0j");

var $ac56O = parcelRequire("ac56O");

var $RNRjT = parcelRequire("RNRjT");

var $llbWy = parcelRequire("llbWy");

var $aJAGq = parcelRequire("aJAGq");

var $lii7K = parcelRequire("lii7K");

var $8OdGk = parcelRequire("8OdGk");

var $4AJH0 = parcelRequire("4AJH0");

var $kCSfk = parcelRequire("kCSfk");

var $37Bkb = parcelRequire("37Bkb");

var $4wJHV = parcelRequire("4wJHV");

var $kBFkh = parcelRequire("kBFkh");

var $5hmq1 = parcelRequire("5hmq1");

var $7bCDC = parcelRequire("7bCDC");

var $7OXcl = parcelRequire("7OXcl");

var $dbZiT = parcelRequire("dbZiT");

var $5jZPf = parcelRequire("5jZPf");

var $x1v6X = parcelRequire("x1v6X");

var $fcCge = parcelRequire("fcCge");

var $c76TO = parcelRequire("c76TO");

var $85XPA = parcelRequire("85XPA");

var $YOl07 = parcelRequire("YOl07");

var $d6JlL = parcelRequire("d6JlL");

var $9u3t0 = parcelRequire("9u3t0");

var $55r0n = parcelRequire("55r0n");

var $b68G7 = parcelRequire("b68G7");

var $6Fx4m = parcelRequire("6Fx4m");

var $2sBlm = parcelRequire("2sBlm");

var $5o0G8 = parcelRequire("5o0G8");

var $4pVJK = parcelRequire("4pVJK");

var $7fzAY = parcelRequire("7fzAY");

var $5UiD2 = parcelRequire("5UiD2");

var $dOnMK = parcelRequire("dOnMK");

var $jZOO5 = parcelRequire("jZOO5");

var $bKh6Y = parcelRequire("bKh6Y");

var $fsJjS = parcelRequire("fsJjS");

var $fbQ2O = parcelRequire("fbQ2O");

var $bZIu3 = parcelRequire("bZIu3");

var $575IS = parcelRequire("575IS");

var $ajVWW = parcelRequire("ajVWW");

var $f1Vrt = parcelRequire("f1Vrt");

var $myktw = parcelRequire("myktw");

var $9OIiA = parcelRequire("9OIiA");

var $7iYax = parcelRequire("7iYax");

var $jnjxT = parcelRequire("jnjxT");

var $dL9Yo = parcelRequire("dL9Yo");

var $bqVE9 = parcelRequire("bqVE9");

var $3kl2U = parcelRequire("3kl2U");

var $eJjPa = parcelRequire("eJjPa");

var $gyweu = parcelRequire("gyweu");

var $WRGgp = parcelRequire("WRGgp");

var $035tu = parcelRequire("035tu");

var $DoxXZ = parcelRequire("DoxXZ");

var $ePygc = parcelRequire("ePygc");

var $ls3ln = parcelRequire("ls3ln");

var $1tSOd = parcelRequire("1tSOd");

var $3CpG8 = parcelRequire("3CpG8");

var $fa1TG = parcelRequire("fa1TG");

var $1U5gw = parcelRequire("1U5gw");

var $geMRr = parcelRequire("geMRr");

var $hTLhm = parcelRequire("hTLhm");

var $ki3DX = parcelRequire("ki3DX");

var $lsRaG = parcelRequire("lsRaG");

var $7HguE = parcelRequire("7HguE");

var $ltDJX = parcelRequire("ltDJX");

var $4kYXk = parcelRequire("4kYXk");

var $bojgq = parcelRequire("bojgq");

var $9Kx3i = parcelRequire("9Kx3i");

var $3HiY6 = parcelRequire("3HiY6");

var $ku3Yl = parcelRequire("ku3Yl");

var $6tKaJ = parcelRequire("6tKaJ");

var $f7TD6 = parcelRequire("f7TD6");

var $9JWXX = parcelRequire("9JWXX");

var $9QW5G = parcelRequire("9QW5G");

var $kBkev = parcelRequire("kBkev");

var $9bu8v = parcelRequire("9bu8v");

var $i3puR = parcelRequire("i3puR");

var $1ALPQ = parcelRequire("1ALPQ");

var $5l2sg = parcelRequire("5l2sg");

var $lmfGS = parcelRequire("lmfGS");

var $f6T7u = parcelRequire("f6T7u");

var $gGwoh = parcelRequire("gGwoh");

var $e4RRO = parcelRequire("e4RRO");

var $1xxco = parcelRequire("1xxco");

var $jzA5q = parcelRequire("jzA5q");

var $1nLUP = parcelRequire("1nLUP");

var $aEGOK = parcelRequire("aEGOK");

var $aXtGg = parcelRequire("aXtGg");

var $5YFJr = parcelRequire("5YFJr");

var $fKqBY = parcelRequire("fKqBY");

var $7Asj5 = parcelRequire("7Asj5");

var $iCZ3W = parcelRequire("iCZ3W");

var $GMQzj = parcelRequire("GMQzj");

var $c9VMe = parcelRequire("c9VMe");

var $bZMar = parcelRequire("bZMar");

var $d4Kq8 = parcelRequire("d4Kq8");

var $cUhgb = parcelRequire("cUhgb");

var $fVhw8 = parcelRequire("fVhw8");

var $ffUgI = parcelRequire("ffUgI");

var $cKDKE = parcelRequire("cKDKE");

var $iLMUu = parcelRequire("iLMUu");

var $25BZy = parcelRequire("25BZy");

var $6VIOq = parcelRequire("6VIOq");

var $kOpxw = parcelRequire("kOpxw");

var $g0Mad = parcelRequire("g0Mad");

var $e1w5i = parcelRequire("e1w5i");

var $fHKhb = parcelRequire("fHKhb");

var $dHiMu = parcelRequire("dHiMu");

var $kmmHy = parcelRequire("kmmHy");

var $4RZmr = parcelRequire("4RZmr");

var $176O6 = parcelRequire("176O6");

var $6S5RE = parcelRequire("6S5RE");

var $7Iwk3 = parcelRequire("7Iwk3");

var $79H4q = parcelRequire("79H4q");

var $4PyNc = parcelRequire("4PyNc");

var $eEvN4 = parcelRequire("eEvN4");

var $gepCn = parcelRequire("gepCn");

var $cwWoR = parcelRequire("cwWoR");

var $4uihT = parcelRequire("4uihT");

var $l6tSH = parcelRequire("l6tSH");

var $1DUp6 = parcelRequire("1DUp6");

var $gW67G = parcelRequire("gW67G");

var $eIR7P = parcelRequire("eIR7P");

var $kKufi = parcelRequire("kKufi");

var $iPpsm = parcelRequire("iPpsm");

var $jNuLi = parcelRequire("jNuLi");

var $k1ol7 = parcelRequire("k1ol7");

var $grpi9 = parcelRequire("grpi9");

var $6RNBD = parcelRequire("6RNBD");

var $bdtKT = parcelRequire("bdtKT");

var $ayjin = parcelRequire("ayjin");

var $lMmgx = parcelRequire("lMmgx");

var $2ZyrB = parcelRequire("2ZyrB");

var $hjfad = parcelRequire("hjfad");

var $fZCJx = parcelRequire("fZCJx");

var $K4FLv = parcelRequire("K4FLv");

var $dhzMc = parcelRequire("dhzMc");

var $ax2Af = parcelRequire("ax2Af");

var $e1am9 = parcelRequire("e1am9");

var $7yofb = parcelRequire("7yofb");

var $iZ4DR = parcelRequire("iZ4DR");

var $9J4aj = parcelRequire("9J4aj");

var $5bThN = parcelRequire("5bThN");

var $7KMMR = parcelRequire("7KMMR");

var $jAcIZ = parcelRequire("jAcIZ");

var $NU3Op = parcelRequire("NU3Op");

var $5RPbZ = parcelRequire("5RPbZ");

var $6OQk6 = parcelRequire("6OQk6");

var $a568Q = parcelRequire("a568Q");

var $iST3a = parcelRequire("iST3a");

var $bQ4CD = parcelRequire("bQ4CD");

var $e42Qj = parcelRequire("e42Qj");

var $8IrZC = parcelRequire("8IrZC");

var $95sBD = parcelRequire("95sBD");

var $cafTW = parcelRequire("cafTW");

var $iM9LE = parcelRequire("iM9LE");

var $8iP7v = parcelRequire("8iP7v");

var $h9kke = parcelRequire("h9kke");

var $2WMg6 = parcelRequire("2WMg6");

var $8bCP5 = parcelRequire("8bCP5");

var $c9F9M = parcelRequire("c9F9M");

var $sh6xI = parcelRequire("sh6xI");

var $kU7Cu = parcelRequire("kU7Cu");

var $5tlGr = parcelRequire("5tlGr");

var $1Bxzw = parcelRequire("1Bxzw");

var $1W3ne = parcelRequire("1W3ne");

var $7UORx = parcelRequire("7UORx");

var $hGSIs = parcelRequire("hGSIs");

var $9z8wZ = parcelRequire("9z8wZ");

var $2LuRT = parcelRequire("2LuRT");

var $cTQ6P = parcelRequire("cTQ6P");

var $ltqMR = parcelRequire("ltqMR");

var $aUUZ6 = parcelRequire("aUUZ6");

var $eeUmw = parcelRequire("eeUmw");

var $ei0mq = parcelRequire("ei0mq");

var $jqAPO = parcelRequire("jqAPO");

var $6f0BW = parcelRequire("6f0BW");

var $gUxwf = parcelRequire("gUxwf");

var $hZMGI = parcelRequire("hZMGI");

var $eakOB = parcelRequire("eakOB");

var $938Wd = parcelRequire("938Wd");

var $jQHxm = parcelRequire("jQHxm");

var $7iWLA = parcelRequire("7iWLA");

var $8Uhvs = parcelRequire("8Uhvs");

var $jI9jM = parcelRequire("jI9jM");

var $aPiSV = parcelRequire("aPiSV");

var $6Cpzl = parcelRequire("6Cpzl");

var $3qrEw = parcelRequire("3qrEw");

var $67eac = parcelRequire("67eac");

var $kFeUc = parcelRequire("kFeUc");

var $2zhex = parcelRequire("2zhex");

var $1Q5pk = parcelRequire("1Q5pk");

var $6r4fi = parcelRequire("6r4fi");

var $2EEyK = parcelRequire("2EEyK");

var $4iPfX = parcelRequire("4iPfX");

var $iQtmQ = parcelRequire("iQtmQ");

var $bduSK = parcelRequire("bduSK");

var $64D31 = parcelRequire("64D31");

var $jKcrx = parcelRequire("jKcrx");

var $61LIg = parcelRequire("61LIg");

var $hWDkA = parcelRequire("hWDkA");

var $5gSxV = parcelRequire("5gSxV");

var $97POB = parcelRequire("97POB");

var $2myCy = parcelRequire("2myCy");

var $7uhTs = parcelRequire("7uhTs");

var $it7Vz = parcelRequire("it7Vz");

var $9MP96 = parcelRequire("9MP96");

var $l6iNf = parcelRequire("l6iNf");

var $eqA1j = parcelRequire("eqA1j");

var $dz2T4 = parcelRequire("dz2T4");

var $dMWae = parcelRequire("dMWae");

var $6vycu = parcelRequire("6vycu");

var $6cV1e = parcelRequire("6cV1e");

var $ie0zV = parcelRequire("ie0zV");

var $gAhRb = parcelRequire("gAhRb");

var $goNGG = parcelRequire("goNGG");

var $lh2Xv = parcelRequire("lh2Xv");

var $hxiVU = parcelRequire("hxiVU");

});
parcelRegister("jE0h4", function(module, exports) {
/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.T
 * @example
 *
 *      R.F(); //=> false
 */ var $e4d1f7367fa18031$var$F = function() {
    return false;
};
var $e4d1f7367fa18031$export$2e2bcd8739ae039 = $e4d1f7367fa18031$var$F;

});

parcelRegister("jKwj2", function(module, exports) {
/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.F
 * @example
 *
 *      R.T(); //=> true
 */ var $e60b5f814167a292$var$T = function() {
    return true;
};
var $e60b5f814167a292$export$2e2bcd8739ae039 = $e60b5f814167a292$var$T;

});

parcelRegister("h8Anj", function(module, exports) {
/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @name __
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      const greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */ var $c79f66581cf92109$export$2e2bcd8739ae039 = {
    '@@functional/placeholder': true
};

});

parcelRegister("cgwpr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ee01e7c410761e1$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");
/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */ var $8ee01e7c410761e1$var$add = /*#__PURE__*/ (0, $kzrqi.default)(function add(a, b) {
    return Number(a) + Number(b);
});
var $8ee01e7c410761e1$export$2e2bcd8739ae039 = $8ee01e7c410761e1$var$add;

});
parcelRegister("kzrqi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef9c5937519dd5cc$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $kKhOC = parcelRequire("kKhOC");
function $ef9c5937519dd5cc$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $kKhOC.default)(a) ? f2 : (0, $ipJAK.default)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $kKhOC.default)(a) && (0, $kKhOC.default)(b) ? f2 : (0, $kKhOC.default)(a) ? (0, $ipJAK.default)(function(_a) {
                    return fn(_a, b);
                }) : (0, $kKhOC.default)(b) ? (0, $ipJAK.default)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}

});
parcelRegister("ipJAK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d67ded55325159de$export$2e2bcd8739ae039; });

var $kKhOC = parcelRequire("kKhOC");
function $d67ded55325159de$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $kKhOC.default)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}

});
parcelRegister("kKhOC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1a5ec4970494cee$export$2e2bcd8739ae039; });
function $f1a5ec4970494cee$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

});




parcelRegister("10BJn", function(module, exports) {

var $8UaC4 = parcelRequire("8UaC4");

var $ipJAK = parcelRequire("ipJAK");

var $JtjnN = parcelRequire("JtjnN");
/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig (((a ...) -> b) ... -> [a] -> *) -> (((a ..., Int, [a]) -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      const mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */ var $0bc30f1379fdcea5$var$addIndex = /*#__PURE__*/ (0, $ipJAK.default)(function addIndex(fn) {
    return (0, $JtjnN.default)(fn.length, function() {
        var idx = 0;
        var origFn = arguments[0];
        var list = arguments[arguments.length - 1];
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = function() {
            var result = origFn.apply(this, (0, $8UaC4.default)(arguments, [
                idx,
                list
            ]));
            idx += 1;
            return result;
        };
        return fn.apply(this, args);
    });
});
var $0bc30f1379fdcea5$export$2e2bcd8739ae039 = $0bc30f1379fdcea5$var$addIndex;

});
parcelRegister("8UaC4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67bbc93d488888b2$export$2e2bcd8739ae039; });
/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */ function $67bbc93d488888b2$export$2e2bcd8739ae039(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;
    while(idx < len1){
        result[result.length] = set1[idx];
        idx += 1;
    }
    idx = 0;
    while(idx < len2){
        result[result.length] = set2[idx];
        idx += 1;
    }
    return result;
}

});

parcelRegister("JtjnN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $088af0c33bbfc73f$export$2e2bcd8739ae039; });

var $72SzR = parcelRequire("72SzR");

var $ipJAK = parcelRequire("ipJAK");

var $kzrqi = parcelRequire("kzrqi");

var $2ukFE = parcelRequire("2ukFE");
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $088af0c33bbfc73f$var$curryN = /*#__PURE__*/ (0, $kzrqi.default)(function curryN(length, fn) {
    if (length === 1) return (0, $ipJAK.default)(fn);
    return (0, $72SzR.default)(length, (0, $2ukFE.default)(length, [], fn));
});
var $088af0c33bbfc73f$export$2e2bcd8739ae039 = $088af0c33bbfc73f$var$curryN;

});
parcelRegister("72SzR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52130e3eba2981ca$export$2e2bcd8739ae039; });
function $52130e3eba2981ca$export$2e2bcd8739ae039(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}

});

parcelRegister("2ukFE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cfe6ae319322028$export$2e2bcd8739ae039; });

var $72SzR = parcelRequire("72SzR");

var $kKhOC = parcelRequire("kKhOC");
function $1cfe6ae319322028$export$2e2bcd8739ae039(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!(0, $kKhOC.default)(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!(0, $kKhOC.default)(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : (0, $72SzR.default)(left, $1cfe6ae319322028$export$2e2bcd8739ae039(length, combined, fn));
    };
}

});



parcelRegister("j6zVR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de8a733aeff3400e$export$2e2bcd8739ae039; });

var $8UaC4 = parcelRequire("8UaC4");

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> (a -> a) -> [a] -> [a]
 * @param {Number} idx The index.
 * @param {Function} fn The function to apply.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(1, R.toUpper, ['a', 'b', 'c', 'd']);      //=> ['a', 'B', 'c', 'd']
 *      R.adjust(-1, R.toUpper, ['a', 'b', 'c', 'd']);     //=> ['a', 'b', 'c', 'D']
 * @symb R.adjust(-1, f, [a, b]) = [a, f(b)]
 * @symb R.adjust(0, f, [a, b]) = [f(a), b]
 */ var $de8a733aeff3400e$var$adjust = /*#__PURE__*/ (0, $5jzlJ.default)(function adjust(idx, fn, list) {
    var len = list.length;
    if (idx >= len || idx < -len) return list;
    var _idx = (len + idx) % len;
    var _list = (0, $8UaC4.default)(list);
    _list[_idx] = fn(list[_idx]);
    return _list;
});
var $de8a733aeff3400e$export$2e2bcd8739ae039 = $de8a733aeff3400e$var$adjust;

});
parcelRegister("5jzlJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dea25c66e030a9c$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $kzrqi = parcelRequire("kzrqi");

var $kKhOC = parcelRequire("kKhOC");
function $3dea25c66e030a9c$export$2e2bcd8739ae039(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, $kKhOC.default)(a) ? f3 : (0, $kzrqi.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, $kKhOC.default)(a) && (0, $kKhOC.default)(b) ? f3 : (0, $kKhOC.default)(a) ? (0, $kzrqi.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $kKhOC.default)(b) ? (0, $kzrqi.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $ipJAK.default)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, $kKhOC.default)(a) && (0, $kKhOC.default)(b) && (0, $kKhOC.default)(c) ? f3 : (0, $kKhOC.default)(a) && (0, $kKhOC.default)(b) ? (0, $kzrqi.default)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, $kKhOC.default)(a) && (0, $kKhOC.default)(c) ? (0, $kzrqi.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $kKhOC.default)(b) && (0, $kKhOC.default)(c) ? (0, $kzrqi.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $kKhOC.default)(a) ? (0, $ipJAK.default)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, $kKhOC.default)(b) ? (0, $ipJAK.default)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, $kKhOC.default)(c) ? (0, $ipJAK.default)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}

});


parcelRegister("9yN6x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f5d612c590c5cfe$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $kcqUr = parcelRequire("kcqUr");
/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      const equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */ var $6f5d612c590c5cfe$var$all = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([
    'all'
], (0, $kcqUr.default), function all(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (!fn(list[idx])) return false;
        idx += 1;
    }
    return true;
}));
var $6f5d612c590c5cfe$export$2e2bcd8739ae039 = $6f5d612c590c5cfe$var$all;

});
parcelRegister("dVL0K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a24510a8e51ef5bd$export$2e2bcd8739ae039; });

var $hPHpo = parcelRequire("hPHpo");

var $xbtfT = parcelRequire("xbtfT");
function $a24510a8e51ef5bd$export$2e2bcd8739ae039(methodNames, transducerCreator, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var obj = arguments[arguments.length - 1];
        if (!(0, $hPHpo.default)(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === 'function') return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
                idx += 1;
            }
            if ((0, $xbtfT.default)(obj)) {
                var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}

});
parcelRegister("hPHpo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfb8df26507d9a81$export$2e2bcd8739ae039; });
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var $cfb8df26507d9a81$export$2e2bcd8739ae039 = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};

});

parcelRegister("xbtfT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $063bfb0e482e086a$export$2e2bcd8739ae039; });
function $063bfb0e482e086a$export$2e2bcd8739ae039(obj) {
    return obj != null && typeof obj['@@transducer/step'] === 'function';
}

});


parcelRegister("kcqUr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb49cd47e36a1e93$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $1RqCc = parcelRequire("1RqCc");

var $g1C1K = parcelRequire("g1C1K");
var $eb49cd47e36a1e93$var$XAll = /*#__PURE__*/ function() {
    function XAll(f, xf) {
        this.xf = xf;
        this.f = f;
        this.all = true;
    }
    XAll.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XAll.prototype['@@transducer/result'] = function(result) {
        if (this.all) result = this.xf['@@transducer/step'](result, true);
        return this.xf['@@transducer/result'](result);
    };
    XAll.prototype['@@transducer/step'] = function(result, input) {
        if (!this.f(input)) {
            this.all = false;
            result = (0, $1RqCc.default)(this.xf['@@transducer/step'](result, false));
        }
        return result;
    };
    return XAll;
}();
var $eb49cd47e36a1e93$var$_xall = /*#__PURE__*/ (0, $kzrqi.default)(function _xall(f, xf) {
    return new $eb49cd47e36a1e93$var$XAll(f, xf);
});
var $eb49cd47e36a1e93$export$2e2bcd8739ae039 = $eb49cd47e36a1e93$var$_xall;

});
parcelRegister("1RqCc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15af62e02e9526a0$export$2e2bcd8739ae039; });
function $15af62e02e9526a0$export$2e2bcd8739ae039(x) {
    return x && x['@@transducer/reduced'] ? x : {
        '@@transducer/value': x,
        '@@transducer/reduced': true
    };
}

});

parcelRegister("g1C1K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baaa3cb87090b09a$export$2e2bcd8739ae039; });
var $baaa3cb87090b09a$export$2e2bcd8739ae039 = {
    init: function() {
        return this.xf['@@transducer/init']();
    },
    result: function(result) {
        return this.xf['@@transducer/result'](result);
    }
};

});



parcelRegister("clJ9m", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $JtjnN = parcelRequire("JtjnN");

var $lmfGS = parcelRequire("lmfGS");

var $ayjin = parcelRequire("ayjin");

var $5bThN = parcelRequire("5bThN");
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      const isQueen = R.propEq('rank', 'Q');
 *      const isSpade = R.propEq('suit', '♠︎');
 *      const isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */ var $8fda780af7ba7b04$var$allPass = /*#__PURE__*/ (0, $ipJAK.default)(function allPass(preds) {
    return (0, $JtjnN.default)((0, $5bThN.default)((0, $lmfGS.default), 0, (0, $ayjin.default)('length', preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (!preds[idx].apply(this, arguments)) return false;
            idx += 1;
        }
        return true;
    });
});
var $8fda780af7ba7b04$export$2e2bcd8739ae039 = $8fda780af7ba7b04$var$allPass;

});
parcelRegister("lmfGS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8c7d2d9d508150b$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */ var $f8c7d2d9d508150b$var$max = /*#__PURE__*/ (0, $kzrqi.default)(function max(a, b) {
    return b > a ? b : a;
});
var $f8c7d2d9d508150b$export$2e2bcd8739ae039 = $f8c7d2d9d508150b$var$max;

});

parcelRegister("ayjin", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aec0c07e0e843c4$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $9QW5G = parcelRequire("9QW5G");

var $K4FLv = parcelRequire("K4FLv");
/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.project, R.prop, R.props
 * @example
 *
 *      var getAges = R.pluck('age');
 *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
 *
 *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */ var $7aec0c07e0e843c4$var$pluck = /*#__PURE__*/ (0, $kzrqi.default)(function pluck(p, list) {
    return (0, $9QW5G.default)((0, $K4FLv.default)(p), list);
});
var $7aec0c07e0e843c4$export$2e2bcd8739ae039 = $7aec0c07e0e843c4$var$pluck;

});
parcelRegister("9QW5G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72c60801327267ac$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $5AqeV = parcelRequire("5AqeV");

var $5bmcu = parcelRequire("5bmcu");

var $bWcTV = parcelRequire("bWcTV");

var $JtjnN = parcelRequire("JtjnN");

var $hTLhm = parcelRequire("hTLhm");
/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex, R.pluck, R.project
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var $72c60801327267ac$var$map = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([
    'fantasy-land/map',
    'map'
], (0, $bWcTV.default), function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case '[object Function]':
            return (0, $JtjnN.default)(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case '[object Object]':
            return (0, $5bmcu.default)(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, (0, $hTLhm.default)(functor));
        default:
            return (0, $5AqeV.default)(fn, functor);
    }
}));
var $72c60801327267ac$export$2e2bcd8739ae039 = $72c60801327267ac$var$map;

});
parcelRegister("5AqeV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4114ab2fc2b74487$export$2e2bcd8739ae039; });
function $4114ab2fc2b74487$export$2e2bcd8739ae039(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}

});

parcelRegister("5bmcu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c5f335feda2f1fa$export$2e2bcd8739ae039; });

var $gXj9X = parcelRequire("gXj9X");

var $kL53y = parcelRequire("kL53y");

var $5A4Tr = parcelRequire("5A4Tr");
function $3c5f335feda2f1fa$var$_arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf['@@transducer/step'](acc, list[idx]);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        idx += 1;
    }
    return xf['@@transducer/result'](acc);
}
function $3c5f335feda2f1fa$var$_iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf['@@transducer/step'](acc, step.value);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        step = iter.next();
    }
    return xf['@@transducer/result'](acc);
}
function $3c5f335feda2f1fa$var$_methodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName]((0, $5A4Tr.default)(xf['@@transducer/step'], xf), acc));
}
var $3c5f335feda2f1fa$var$symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
function $3c5f335feda2f1fa$export$2e2bcd8739ae039(fn, acc, list) {
    if (typeof fn === 'function') fn = (0, $kL53y.default)(fn);
    if ((0, $gXj9X.default)(list)) return $3c5f335feda2f1fa$var$_arrayReduce(fn, acc, list);
    if (typeof list['fantasy-land/reduce'] === 'function') return $3c5f335feda2f1fa$var$_methodReduce(fn, acc, list, 'fantasy-land/reduce');
    if (list[$3c5f335feda2f1fa$var$symIterator] != null) return $3c5f335feda2f1fa$var$_iterableReduce(fn, acc, list[$3c5f335feda2f1fa$var$symIterator]());
    if (typeof list.next === 'function') return $3c5f335feda2f1fa$var$_iterableReduce(fn, acc, list);
    if (typeof list.reduce === 'function') return $3c5f335feda2f1fa$var$_methodReduce(fn, acc, list, 'reduce');
    throw new TypeError('reduce: list must be array or iterable');
}

});
parcelRegister("gXj9X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c58104bada63c220$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $hPHpo = parcelRequire("hPHpo");

var $c83uM = parcelRequire("c83uM");
/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 *      _isArrayLike({nodeType: 1, length: 1}) // => false
 */ var $c58104bada63c220$var$_isArrayLike = /*#__PURE__*/ (0, $ipJAK.default)(function isArrayLike(x) {
    if ((0, $hPHpo.default)(x)) return true;
    if (!x) return false;
    if (typeof x !== 'object') return false;
    if ((0, $c83uM.default)(x)) return false;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
var $c58104bada63c220$export$2e2bcd8739ae039 = $c58104bada63c220$var$_isArrayLike;

});
parcelRegister("c83uM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d48f187dc4a7b95$export$2e2bcd8739ae039; });
function $8d48f187dc4a7b95$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === '[object String]';
}

});


parcelRegister("kL53y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1cc1e874e2a6e33$export$2e2bcd8739ae039; });
var $f1cc1e874e2a6e33$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype['@@transducer/init'] = function() {
        throw new Error('init not implemented on XWrap');
    };
    XWrap.prototype['@@transducer/result'] = function(acc) {
        return acc;
    };
    XWrap.prototype['@@transducer/step'] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $f1cc1e874e2a6e33$export$2e2bcd8739ae039(fn) {
    return new $f1cc1e874e2a6e33$var$XWrap(fn);
}

});

parcelRegister("5A4Tr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41041c3cf82d5773$export$2e2bcd8739ae039; });

var $72SzR = parcelRequire("72SzR");

var $kzrqi = parcelRequire("kzrqi");
/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $41041c3cf82d5773$var$bind = /*#__PURE__*/ (0, $kzrqi.default)(function bind(fn, thisObj) {
    return (0, $72SzR.default)(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
var $41041c3cf82d5773$export$2e2bcd8739ae039 = $41041c3cf82d5773$var$bind;

});


parcelRegister("bWcTV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b0f1e6315ab877f$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $g1C1K = parcelRequire("g1C1K");
var $8b0f1e6315ab877f$var$XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XMap.prototype['@@transducer/result'] = (0, $g1C1K.default).result;
    XMap.prototype['@@transducer/step'] = function(result, input) {
        return this.xf['@@transducer/step'](result, this.f(input));
    };
    return XMap;
}();
var $8b0f1e6315ab877f$var$_xmap = /*#__PURE__*/ (0, $kzrqi.default)(function _xmap(f, xf) {
    return new $8b0f1e6315ab877f$var$XMap(f, xf);
});
var $8b0f1e6315ab877f$export$2e2bcd8739ae039 = $8b0f1e6315ab877f$var$_xmap;

});

parcelRegister("hTLhm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d07c3f5568b02b54$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $j0Aik = parcelRequire("j0Aik");

var $9JxGp = parcelRequire("9JxGp");
var $d07c3f5568b02b54$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable('toString');
var $d07c3f5568b02b54$var$nonEnumerableProps = [
    'constructor',
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
]; // Safari bug
var $d07c3f5568b02b54$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    'use strict';
    return arguments.propertyIsEnumerable('length');
}();
var $d07c3f5568b02b54$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $d07c3f5568b02b54$var$keys = typeof Object.keys === 'function' && !$d07c3f5568b02b54$var$hasArgsEnumBug ? /*#__PURE__*/ (0, $ipJAK.default)(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ (0, $ipJAK.default)(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $d07c3f5568b02b54$var$hasArgsEnumBug && (0, $9JxGp.default)(obj);
    for(prop in obj)if ((0, $j0Aik.default)(prop, obj) && (!checkArgsLength || prop !== 'length')) ks[ks.length] = prop;
    if ($d07c3f5568b02b54$var$hasEnumBug) {
        nIdx = $d07c3f5568b02b54$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $d07c3f5568b02b54$var$nonEnumerableProps[nIdx];
            if ((0, $j0Aik.default)(prop, obj) && !$d07c3f5568b02b54$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
var $d07c3f5568b02b54$export$2e2bcd8739ae039 = $d07c3f5568b02b54$var$keys;

});
parcelRegister("j0Aik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd6a2bbe1c5cbd76$export$2e2bcd8739ae039; });
function $dd6a2bbe1c5cbd76$export$2e2bcd8739ae039(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});

parcelRegister("9JxGp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $716271c52d3d3c6f$export$2e2bcd8739ae039; });

var $j0Aik = parcelRequire("j0Aik");
var $716271c52d3d3c6f$var$toString = Object.prototype.toString;
var $716271c52d3d3c6f$var$_isArguments = /*#__PURE__*/ function() {
    return $716271c52d3d3c6f$var$toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
        return $716271c52d3d3c6f$var$toString.call(x) === '[object Arguments]';
    } : function _isArguments(x) {
        return (0, $j0Aik.default)('callee', x);
    };
}();
var $716271c52d3d3c6f$export$2e2bcd8739ae039 = $716271c52d3d3c6f$var$_isArguments;

});



parcelRegister("K4FLv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08a7ebe14d4090e0$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $3WvPT = parcelRequire("3WvPT");

var $e1w5i = parcelRequire("e1w5i");
/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx -> {s: a} -> a | Undefined
 * @param {String|Number} p The property name or array index
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path, R.props, R.pluck, R.project, R.nth
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.prop(0, [100]); //=> 100
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */ var $08a7ebe14d4090e0$var$prop = /*#__PURE__*/ (0, $kzrqi.default)(function prop(p, obj) {
    if (obj == null) return;
    return (0, $3WvPT.default)(p) ? (0, $e1w5i.default)(p, obj) : obj[p];
});
var $08a7ebe14d4090e0$export$2e2bcd8739ae039 = $08a7ebe14d4090e0$var$prop;

});
parcelRegister("3WvPT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2def7bd4e3761441$export$2e2bcd8739ae039; });
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var $2def7bd4e3761441$export$2e2bcd8739ae039 = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};

});

parcelRegister("e1w5i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a35a0bf7c2157603$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $c83uM = parcelRequire("c83uM");
/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */ var $a35a0bf7c2157603$var$nth = /*#__PURE__*/ (0, $kzrqi.default)(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return (0, $c83uM.default)(list) ? list.charAt(idx) : list[idx];
});
var $a35a0bf7c2157603$export$2e2bcd8739ae039 = $a35a0bf7c2157603$var$nth;

});



parcelRegister("5bThN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c78dd7e00e6141d$export$2e2bcd8739ae039; });

var $5jzlJ = parcelRequire("5jzlJ");

var $5bmcu = parcelRequire("5bmcu");
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $3c78dd7e00e6141d$var$reduce = /*#__PURE__*/ (0, $5jzlJ.default)((0, $5bmcu.default));
var $3c78dd7e00e6141d$export$2e2bcd8739ae039 = $3c78dd7e00e6141d$var$reduce;

});


parcelRegister("gVgoT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c51eb0fca9b01749$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");
/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      const t = R.always('Tee');
 *      t(); //=> 'Tee'
 */ var $c51eb0fca9b01749$var$always = /*#__PURE__*/ (0, $ipJAK.default)(function always(val) {
    return function() {
        return val;
    };
});
var $c51eb0fca9b01749$export$2e2bcd8739ae039 = $c51eb0fca9b01749$var$always;

});

parcelRegister("dcmvG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99bddb5cef90ead7$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns the first argument if it is falsy, otherwise the second argument.
 * Acts as the boolean `and` statement if both inputs are `Boolean`s.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any}
 * @see R.both, R.or
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */ var $99bddb5cef90ead7$var$and = /*#__PURE__*/ (0, $kzrqi.default)(function and(a, b) {
    return a && b;
});
var $99bddb5cef90ead7$export$2e2bcd8739ae039 = $99bddb5cef90ead7$var$and;

});

parcelRegister("jbmgQ", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $5fQtu = parcelRequire("5fQtu");
/**
 * Returns `true` if at least one of the elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      const lessThan0 = R.flip(R.lt)(0);
 *      const lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */ var $df7051e2d46ef203$var$any = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([
    'any'
], (0, $5fQtu.default), function any(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (fn(list[idx])) return true;
        idx += 1;
    }
    return false;
}));
var $df7051e2d46ef203$export$2e2bcd8739ae039 = $df7051e2d46ef203$var$any;

});
parcelRegister("5fQtu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d370ed504720c20$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $1RqCc = parcelRequire("1RqCc");

var $g1C1K = parcelRequire("g1C1K");
var $3d370ed504720c20$var$XAny = /*#__PURE__*/ function() {
    function XAny(f, xf) {
        this.xf = xf;
        this.f = f;
        this.any = false;
    }
    XAny.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XAny.prototype['@@transducer/result'] = function(result) {
        if (!this.any) result = this.xf['@@transducer/step'](result, false);
        return this.xf['@@transducer/result'](result);
    };
    XAny.prototype['@@transducer/step'] = function(result, input) {
        if (this.f(input)) {
            this.any = true;
            result = (0, $1RqCc.default)(this.xf['@@transducer/step'](result, true));
        }
        return result;
    };
    return XAny;
}();
var $3d370ed504720c20$var$_xany = /*#__PURE__*/ (0, $kzrqi.default)(function _xany(f, xf) {
    return new $3d370ed504720c20$var$XAny(f, xf);
});
var $3d370ed504720c20$export$2e2bcd8739ae039 = $3d370ed504720c20$var$_xany;

});


parcelRegister("4v8FY", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $JtjnN = parcelRequire("JtjnN");

var $lmfGS = parcelRequire("lmfGS");

var $ayjin = parcelRequire("ayjin");

var $5bThN = parcelRequire("5bThN");
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      const isClub = R.propEq('suit', '♣');
 *      const isSpade = R.propEq('suit', '♠');
 *      const isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */ var $3470c9862f026344$var$anyPass = /*#__PURE__*/ (0, $ipJAK.default)(function anyPass(preds) {
    return (0, $JtjnN.default)((0, $5bThN.default)((0, $lmfGS.default), 0, (0, $ayjin.default)('length', preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (preds[idx].apply(this, arguments)) return true;
            idx += 1;
        }
        return false;
    });
});
var $3470c9862f026344$export$2e2bcd8739ae039 = $3470c9862f026344$var$anyPass;

});

parcelRegister("9r9kC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6deddfbe53590507$export$2e2bcd8739ae039; });

var $8UaC4 = parcelRequire("8UaC4");

var $kzrqi = parcelRequire("kzrqi");

var $5bmcu = parcelRequire("5bmcu");

var $9QW5G = parcelRequire("9QW5G");
/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */ var $6deddfbe53590507$var$ap = /*#__PURE__*/ (0, $kzrqi.default)(function ap(applyF, applyX) {
    return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function(x) {
        return applyF(x)(applyX(x));
    } : (0, $5bmcu.default)(function(acc, f) {
        return (0, $8UaC4.default)(acc, (0, $9QW5G.default)(f, applyX));
    }, [], applyF);
});
var $6deddfbe53590507$export$2e2bcd8739ae039 = $6deddfbe53590507$var$ap;

});

parcelRegister("i9nOw", function(module, exports) {

var $8laId = parcelRequire("8laId");

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $aFJDu = parcelRequire("aFJDu");
/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */ var $d36b8a32df214f7a$var$aperture = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([], (0, $aFJDu.default), (0, $8laId.default)));
var $d36b8a32df214f7a$export$2e2bcd8739ae039 = $d36b8a32df214f7a$var$aperture;

});
parcelRegister("8laId", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6128981e9e482a63$export$2e2bcd8739ae039; });
function $6128981e9e482a63$export$2e2bcd8739ae039(n, list) {
    var idx = 0;
    var limit = list.length - (n - 1);
    var acc = new Array(limit >= 0 ? limit : 0);
    while(idx < limit){
        acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
        idx += 1;
    }
    return acc;
}

});

parcelRegister("aFJDu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c5122102de72849$export$2e2bcd8739ae039; });

var $8UaC4 = parcelRequire("8UaC4");

var $kzrqi = parcelRequire("kzrqi");

var $g1C1K = parcelRequire("g1C1K");
var $7c5122102de72849$var$XAperture = /*#__PURE__*/ function() {
    function XAperture(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XAperture.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XAperture.prototype['@@transducer/result'] = function(result) {
        this.acc = null;
        return this.xf['@@transducer/result'](result);
    };
    XAperture.prototype['@@transducer/step'] = function(result, input) {
        this.store(input);
        return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
    };
    XAperture.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    XAperture.prototype.getCopy = function() {
        return (0, $8UaC4.default)(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
    };
    return XAperture;
}();
var $7c5122102de72849$var$_xaperture = /*#__PURE__*/ (0, $kzrqi.default)(function _xaperture(n, xf) {
    return new $7c5122102de72849$var$XAperture(n, xf);
});
var $7c5122102de72849$export$2e2bcd8739ae039 = $7c5122102de72849$var$_xaperture;

});


parcelRegister("cEplE", function(module, exports) {

var $8UaC4 = parcelRequire("8UaC4");

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */ var $935ce212f119525a$var$append = /*#__PURE__*/ (0, $kzrqi.default)(function append(el, list) {
    return (0, $8UaC4.default)(list, [
        el
    ]);
});
var $935ce212f119525a$export$2e2bcd8739ae039 = $935ce212f119525a$var$append;

});

parcelRegister("f4dyh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af81bdd81f84680e$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");
/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      const nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */ var $af81bdd81f84680e$var$apply = /*#__PURE__*/ (0, $kzrqi.default)(function apply(fn, args) {
    return fn.apply(this, args);
});
var $af81bdd81f84680e$export$2e2bcd8739ae039 = $af81bdd81f84680e$var$apply;

});

parcelRegister("9taE0", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $hPHpo = parcelRequire("hPHpo");

var $f4dyh = parcelRequire("f4dyh");

var $JtjnN = parcelRequire("JtjnN");

var $lmfGS = parcelRequire("lmfGS");

var $ayjin = parcelRequire("ayjin");

var $5bThN = parcelRequire("5bThN");

var $hTLhm = parcelRequire("hTLhm");

var $7uhTs = parcelRequire("7uhTs");
// delegating calls to .map
function $6e4f143b7fa3beb6$var$mapValues(fn, obj) {
    return (0, $hPHpo.default)(obj) ? obj.map(fn) : (0, $hTLhm.default)(obj).reduce(function(acc, key) {
        acc[key] = fn(obj[key]);
        return acc;
    }, {});
}
/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      const getMetrics = R.applySpec({
 *        sum: R.add,
 *        nested: { mul: R.multiply }
 *      });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */ var $6e4f143b7fa3beb6$var$applySpec = /*#__PURE__*/ (0, $ipJAK.default)(function applySpec(spec) {
    spec = $6e4f143b7fa3beb6$var$mapValues(function(v) {
        return typeof v == 'function' ? v : applySpec(v);
    }, spec);
    return (0, $JtjnN.default)((0, $5bThN.default)((0, $lmfGS.default), 0, (0, $ayjin.default)('length', (0, $7uhTs.default)(spec))), function() {
        var args = arguments;
        return $6e4f143b7fa3beb6$var$mapValues(function(f) {
            return (0, $f4dyh.default)(f, args);
        }, spec);
    });
});
var $6e4f143b7fa3beb6$export$2e2bcd8739ae039 = $6e4f143b7fa3beb6$var$applySpec;

});
parcelRegister("7uhTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5739370ab4aa403d$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $hTLhm = parcelRequire("hTLhm");
/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys, R.toPairs
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */ var $5739370ab4aa403d$var$values = /*#__PURE__*/ (0, $ipJAK.default)(function values(obj) {
    var props = (0, $hTLhm.default)(obj);
    var len = props.length;
    var vals = [];
    var idx = 0;
    while(idx < len){
        vals[idx] = obj[props[idx]];
        idx += 1;
    }
    return vals;
});
var $5739370ab4aa403d$export$2e2bcd8739ae039 = $5739370ab4aa403d$var$values;

});


parcelRegister("a4l2i", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Takes a value and applies a function to it.
 *
 * This function is also known as the `thrush` combinator.
 *
 * @func
 * @memberOf R
 * @since v0.25.0
 * @category Function
 * @sig a -> (a -> b) -> b
 * @param {*} x The value
 * @param {Function} f The function to apply
 * @return {*} The result of applying `f` to `x`
 * @example
 *
 *      const t42 = R.applyTo(42);
 *      t42(R.identity); //=> 42
 *      t42(R.add(1)); //=> 43
 */ var $754a986a9314c471$var$applyTo = /*#__PURE__*/ (0, $kzrqi.default)(function applyTo(x, f) {
    return f(x);
});
var $754a986a9314c471$export$2e2bcd8739ae039 = $754a986a9314c471$var$applyTo;

});

parcelRegister("4TqhF", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      const byAge = R.ascend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByYoungestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var $3900aff29e98fa3d$var$ascend = /*#__PURE__*/ (0, $5jzlJ.default)(function ascend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
});
var $3900aff29e98fa3d$export$2e2bcd8739ae039 = $3900aff29e98fa3d$var$ascend;

});

parcelRegister("eCXNe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa62fef24e2e3a0a$export$2e2bcd8739ae039; });

var $5jzlJ = parcelRequire("5jzlJ");

var $7BBob = parcelRequire("7BBob");
/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig Idx -> a -> {k: v} -> {k: v}
 * @param {String|Number} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc, R.pick
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */ var $aa62fef24e2e3a0a$var$assoc = /*#__PURE__*/ (0, $5jzlJ.default)(function assoc(prop, val, obj) {
    return (0, $7BBob.default)([
        prop
    ], val, obj);
});
var $aa62fef24e2e3a0a$export$2e2bcd8739ae039 = $aa62fef24e2e3a0a$var$assoc;

});
parcelRegister("7BBob", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5898fdc477344ead$export$2e2bcd8739ae039; });

var $5jzlJ = parcelRequire("5jzlJ");

var $j0Aik = parcelRequire("j0Aik");

var $3WvPT = parcelRequire("3WvPT");

var $5XpxN = parcelRequire("5XpxN");

var $fa1TG = parcelRequire("fa1TG");
/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */ var $5898fdc477344ead$var$assocPath = /*#__PURE__*/ (0, $5jzlJ.default)(function assocPath(path, val, obj) {
    if (path.length === 0) return val;
    var idx = path[0];
    if (path.length > 1) {
        var nextObj = !(0, $fa1TG.default)(obj) && (0, $j0Aik.default)(idx, obj) ? obj[idx] : (0, $3WvPT.default)(path[1]) ? [] : {};
        val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
    }
    return (0, $5XpxN.default)(idx, val, obj);
});
var $5898fdc477344ead$export$2e2bcd8739ae039 = $5898fdc477344ead$var$assocPath;

});
parcelRegister("5XpxN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $456646fc88846af7$export$2e2bcd8739ae039; });

var $hPHpo = parcelRequire("hPHpo");

var $3WvPT = parcelRequire("3WvPT");
function $456646fc88846af7$export$2e2bcd8739ae039(prop, val, obj) {
    if ((0, $3WvPT.default)(prop) && (0, $hPHpo.default)(obj)) {
        var arr = [].concat(obj);
        arr[prop] = val;
        return arr;
    }
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = val;
    return result;
}

});

parcelRegister("fa1TG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b09942ec18b26aee$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");
/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */ var $b09942ec18b26aee$var$isNil = /*#__PURE__*/ (0, $ipJAK.default)(function isNil(x) {
    return x == null;
});
var $b09942ec18b26aee$export$2e2bcd8739ae039 = $b09942ec18b26aee$var$isNil;

});



parcelRegister("llmg1", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $iLMUu = parcelRequire("iLMUu");
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (a -> b -> c -> ... -> z) -> ((a, b) -> z)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      const takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      const takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */ var $f89cd304b9fe7e01$var$binary = /*#__PURE__*/ (0, $ipJAK.default)(function binary(fn) {
    return (0, $iLMUu.default)(2, fn);
});
var $f89cd304b9fe7e01$export$2e2bcd8739ae039 = $f89cd304b9fe7e01$var$binary;

});
parcelRegister("iLMUu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $daa28e4d67f5bedd$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      const takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */ var $daa28e4d67f5bedd$var$nAry = /*#__PURE__*/ (0, $kzrqi.default)(function nAry(n, fn) {
    switch(n){
        case 0:
            return function() {
                return fn.call(this);
            };
        case 1:
            return function(a0) {
                return fn.call(this, a0);
            };
        case 2:
            return function(a0, a1) {
                return fn.call(this, a0, a1);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.call(this, a0, a1, a2);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.call(this, a0, a1, a2, a3);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.call(this, a0, a1, a2, a3, a4);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.call(this, a0, a1, a2, a3, a4, a5);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
            };
        default:
            throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
    }
});
var $daa28e4d67f5bedd$export$2e2bcd8739ae039 = $daa28e4d67f5bedd$var$nAry;

});


parcelRegister("4NB9p", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $iKPBD = parcelRequire("iKPBD");

var $dcmvG = parcelRequire("dcmvG");

var $ku3Yl = parcelRequire("ku3Yl");
/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.either, R.and
 * @example
 *
 *      const gt10 = R.gt(R.__, 10)
 *      const lt20 = R.lt(R.__, 20)
 *      const f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 *
 *      R.both(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(false)
 *      R.both([false, false, 'a'], [11]); //=> [false, false, 11]
 */ var $37e88e60cee47676$var$both = /*#__PURE__*/ (0, $kzrqi.default)(function both(f, g) {
    return (0, $iKPBD.default)(f) ? function _both() {
        return f.apply(this, arguments) && g.apply(this, arguments);
    } : (0, $ku3Yl.default)((0, $dcmvG.default))(f, g);
});
var $37e88e60cee47676$export$2e2bcd8739ae039 = $37e88e60cee47676$var$both;

});
parcelRegister("iKPBD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da748dc47fd7267b$export$2e2bcd8739ae039; });
function $da748dc47fd7267b$export$2e2bcd8739ae039(x) {
    var type = Object.prototype.toString.call(x);
    return type === '[object Function]' || type === '[object AsyncFunction]' || type === '[object GeneratorFunction]' || type === '[object AsyncGeneratorFunction]';
}

});

parcelRegister("ku3Yl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee99b0d4449fb51b$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $6tKaJ = parcelRequire("6tKaJ");
/**
 * "lifts" a function of arity >= 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      const madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([100, 200], [30, 40], [5, 6, 7]); //=> [135, 136, 137, 145, 146, 147, 235, 236, 237, 245, 246, 247]
 *
 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([10, 20], [1], [2, 3], [4], [100, 200]); //=> [117, 217, 118, 218, 127, 227, 128, 228]
 */ var $ee99b0d4449fb51b$var$lift = /*#__PURE__*/ (0, $ipJAK.default)(function lift(fn) {
    return (0, $6tKaJ.default)(fn.length, fn);
});
var $ee99b0d4449fb51b$export$2e2bcd8739ae039 = $ee99b0d4449fb51b$var$lift;

});
parcelRegister("6tKaJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b79445661440cd8$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $5bmcu = parcelRequire("5bmcu");

var $9r9kC = parcelRequire("9r9kC");

var $JtjnN = parcelRequire("JtjnN");

var $9QW5G = parcelRequire("9QW5G");
/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */ var $4b79445661440cd8$var$liftN = /*#__PURE__*/ (0, $kzrqi.default)(function liftN(arity, fn) {
    var lifted = (0, $JtjnN.default)(arity, fn);
    return (0, $JtjnN.default)(arity, function() {
        return (0, $5bmcu.default)((0, $9r9kC.default), (0, $9QW5G.default)(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
    });
});
var $4b79445661440cd8$export$2e2bcd8739ae039 = $4b79445661440cd8$var$liftN;

});



parcelRegister("5heVP", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");
/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig ((*... -> a), *...) -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      const indentN = R.pipe(
 *        R.repeat(' '),
 *        R.join(''),
 *        R.replace(/^(?!$)/gm)
 *      );
 *
 *      const format = R.converge(
 *        R.call,
 *        [
 *          R.pipe(R.prop('indent'), indentN),
 *          R.prop('value')
 *        ]
 *      );
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */ var $3d7a1f6e4c2706cf$var$call = /*#__PURE__*/ (0, $ipJAK.default)(function call(fn) {
    return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});
var $3d7a1f6e4c2706cf$export$2e2bcd8739ae039 = $3d7a1f6e4c2706cf$var$call;

});

parcelRegister("dxvF9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9db6eafc3727a14b$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $i1E9W = parcelRequire("i1E9W");

var $39Fje = parcelRequire("39Fje");

var $9QW5G = parcelRequire("9QW5G");
/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries.
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      const duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */ var $9db6eafc3727a14b$var$chain = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([
    'fantasy-land/chain',
    'chain'
], (0, $39Fje.default), function chain(fn, monad) {
    if (typeof monad === 'function') return function(x) {
        return fn(monad(x))(x);
    };
    return (0, $i1E9W.default)(false)((0, $9QW5G.default)(fn, monad));
}));
var $9db6eafc3727a14b$export$2e2bcd8739ae039 = $9db6eafc3727a14b$var$chain;

});
parcelRegister("i1E9W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1f778ca61c42fef$export$2e2bcd8739ae039; });

var $gXj9X = parcelRequire("gXj9X");
function $d1f778ca61c42fef$export$2e2bcd8739ae039(recursive) {
    return function flatt(list) {
        var value, jlen, j;
        var result = [];
        var idx = 0;
        var ilen = list.length;
        while(idx < ilen){
            if ((0, $gXj9X.default)(list[idx])) {
                value = recursive ? flatt(list[idx]) : list[idx];
                j = 0;
                jlen = value.length;
                while(j < jlen){
                    result[result.length] = value[j];
                    j += 1;
                }
            } else result[result.length] = list[idx];
            idx += 1;
        }
        return result;
    };
}

});

parcelRegister("39Fje", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24c24185c93fcee5$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $1vUFL = parcelRequire("1vUFL");

var $9QW5G = parcelRequire("9QW5G");
var $24c24185c93fcee5$var$_xchain = /*#__PURE__*/ (0, $kzrqi.default)(function _xchain(f, xf) {
    return (0, $9QW5G.default)(f, (0, $1vUFL.default)(xf));
});
var $24c24185c93fcee5$export$2e2bcd8739ae039 = $24c24185c93fcee5$var$_xchain;

});
parcelRegister("1vUFL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11a4a5afb65a2d5f$export$2e2bcd8739ae039; });

var $6VEu9 = parcelRequire("6VEu9");

var $gXj9X = parcelRequire("gXj9X");

var $5bmcu = parcelRequire("5bmcu");

var $g1C1K = parcelRequire("g1C1K");
var $11a4a5afb65a2d5f$var$preservingReduced = function(xf) {
    return {
        '@@transducer/init': (0, $g1C1K.default).init,
        '@@transducer/result': function(result) {
            return xf['@@transducer/result'](result);
        },
        '@@transducer/step': function(result, input) {
            var ret = xf['@@transducer/step'](result, input);
            return ret['@@transducer/reduced'] ? (0, $6VEu9.default)(ret) : ret;
        }
    };
};
var $11a4a5afb65a2d5f$var$_flatCat = function _xcat(xf) {
    var rxf = $11a4a5afb65a2d5f$var$preservingReduced(xf);
    return {
        '@@transducer/init': (0, $g1C1K.default).init,
        '@@transducer/result': function(result) {
            return rxf['@@transducer/result'](result);
        },
        '@@transducer/step': function(result, input) {
            return !(0, $gXj9X.default)(input) ? (0, $5bmcu.default)(rxf, result, [
                input
            ]) : (0, $5bmcu.default)(rxf, result, input);
        }
    };
};
var $11a4a5afb65a2d5f$export$2e2bcd8739ae039 = $11a4a5afb65a2d5f$var$_flatCat;

});
parcelRegister("6VEu9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50b7787efd88c317$export$2e2bcd8739ae039; });
function $50b7787efd88c317$export$2e2bcd8739ae039(x) {
    return {
        '@@transducer/value': x,
        '@@transducer/reduced': true
    };
}

});




parcelRegister("9REUd", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */ var $72e8cb4efac9929d$var$clamp = /*#__PURE__*/ (0, $5jzlJ.default)(function clamp(min, max, value) {
    if (min > max) throw new Error('min must not be greater than max in clamp(min, max, value)');
    return value < min ? min : value > max ? max : value;
});
var $72e8cb4efac9929d$export$2e2bcd8739ae039 = $72e8cb4efac9929d$var$clamp;

});

parcelRegister("29s2B", function(module, exports) {

var $beT6k = parcelRequire("beT6k");

var $ipJAK = parcelRequire("ipJAK");
/**
 * Creates a deep copy of the source that can be used in place of the source
 * object without retaining any references to it.
 * The source object may contain (nested) `Array`s and `Object`s,
 * `Number`s, `String`s, `Boolean`s and `Date`s.
 * `Function`s are assigned by reference rather than copied.
 *
 * Dispatches to a `clone` method if present.
 *
 * Note that if the source object has multiple nodes that share a reference,
 * the returned object will have the same structure, but the references will
 * be pointed to the location within the cloned value.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      const objects = [{}, {}, {}];
 *      const objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */ var $19122c678d1d35c0$var$clone = /*#__PURE__*/ (0, $ipJAK.default)(function clone(value) {
    return value != null && typeof value.clone === 'function' ? value.clone() : (0, $beT6k.default)(value, [], [], true);
});
var $19122c678d1d35c0$export$2e2bcd8739ae039 = $19122c678d1d35c0$var$clone;

});
parcelRegister("beT6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82ebbe775bdafbc3$export$2e2bcd8739ae039; });

var $lCIh2 = parcelRequire("lCIh2");

var $67eac = parcelRequire("67eac");
function $82ebbe775bdafbc3$export$2e2bcd8739ae039(value, refFrom, refTo, deep) {
    var copy = function copy(copiedValue) {
        var len = refFrom.length;
        var idx = 0;
        while(idx < len){
            if (value === refFrom[idx]) return refTo[idx];
            idx += 1;
        }
        refFrom[idx] = value;
        refTo[idx] = copiedValue;
        for(var key in value)if (value.hasOwnProperty(key)) copiedValue[key] = deep ? $82ebbe775bdafbc3$export$2e2bcd8739ae039(value[key], refFrom, refTo, true) : value[key];
        return copiedValue;
    };
    switch((0, $67eac.default)(value)){
        case 'Object':
            return copy(Object.create(Object.getPrototypeOf(value)));
        case 'Array':
            return copy([]);
        case 'Date':
            return new Date(value.valueOf());
        case 'RegExp':
            return (0, $lCIh2.default)(value);
        case 'Int8Array':
        case 'Uint8Array':
        case 'Uint8ClampedArray':
        case 'Int16Array':
        case 'Uint16Array':
        case 'Int32Array':
        case 'Uint32Array':
        case 'Float32Array':
        case 'Float64Array':
        case 'BigInt64Array':
        case 'BigUint64Array':
            return value.slice();
        default:
            return value;
    }
}

});
parcelRegister("lCIh2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbdf7d6f8c1965d0$export$2e2bcd8739ae039; });
function $fbdf7d6f8c1965d0$export$2e2bcd8739ae039(pattern) {
    return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
}

});

parcelRegister("67eac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $473e62152f72fa7a$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");
/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var $473e62152f72fa7a$var$type = /*#__PURE__*/ (0, $ipJAK.default)(function type(val) {
    return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});
var $473e62152f72fa7a$export$2e2bcd8739ae039 = $473e62152f72fa7a$var$type;

});



parcelRegister("bFCeT", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $5bmcu = parcelRequire("5bmcu");
/**
 * Splits a list into sub-lists, based on the result of calling a key-returning function on each element,
 * and grouping the results according to values returned.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> [[b]]
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} list The array to group
 * @return {Array}
 *    An array of arrays where each sub-array contains items for which
 *    the String-returning function has returned the same value.
 * @see R.groupBy, R.partition
 * @example
 *      R.collectBy(R.prop('type'), [
 *        {type: 'breakfast', item: '☕️'},
 *        {type: 'lunch', item: '🌯'},
 *        {type: 'dinner', item: '🍝'},
 *        {type: 'breakfast', item: '🥐'},
 *        {type: 'lunch', item: '🍕'}
 *      ]);
 *
 *      // [ [ {type: 'breakfast', item: '☕️'},
 *      //     {type: 'breakfast', item: '🥐'} ],
 *      //   [ {type: 'lunch', item: '🌯'},
 *      //     {type: 'lunch', item: '🍕'} ],
 *      //   [ {type: 'dinner', item: '🍝'} ] ]
 */ var $87f12f8b2835fc8c$var$collectBy = /*#__PURE__*/ (0, $kzrqi.default)(function collectBy(fn, list) {
    var group = (0, $5bmcu.default)(function(o, x) {
        var tag = fn(x);
        if (o[tag] === undefined) o[tag] = [];
        o[tag].push(x);
        return o;
    }, {}, list);
    var newList = [];
    for(var tag in group)newList.push(group[tag]);
    return newList;
});
var $87f12f8b2835fc8c$export$2e2bcd8739ae039 = $87f12f8b2835fc8c$var$collectBy;

});

parcelRegister("gSxsL", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");
/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      const byAge = R.comparator((a, b) => a.age < b.age);
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByIncreasingAge = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var $c49ba581b55621a6$var$comparator = /*#__PURE__*/ (0, $ipJAK.default)(function comparator(pred) {
    return function(a, b) {
        return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
    };
});
var $c49ba581b55621a6$export$2e2bcd8739ae039 = $c49ba581b55621a6$var$comparator;

});

parcelRegister("95Rhk", function(module, exports) {

var $ku3Yl = parcelRequire("ku3Yl");

var $g0Mad = parcelRequire("g0Mad");
/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      const isNotNil = R.complement(R.isNil);
 *      R.isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      R.isNil(7); //=> false
 *      isNotNil(7); //=> true
 */ var $69ede8b2a51f4348$var$complement = /*#__PURE__*/ (0, $ku3Yl.default)((0, $g0Mad.default));
var $69ede8b2a51f4348$export$2e2bcd8739ae039 = $69ede8b2a51f4348$var$complement;

});
parcelRegister("g0Mad", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba8201c1ff9de244$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");
/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */ var $ba8201c1ff9de244$var$not = /*#__PURE__*/ (0, $ipJAK.default)(function not(a) {
    return !a;
});
var $ba8201c1ff9de244$export$2e2bcd8739ae039 = $ba8201c1ff9de244$var$not;

});


parcelRegister("qkq7O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04f244e20ad02728$export$2e2bcd8739ae039; });

var $6RNBD = parcelRequire("6RNBD");

var $e42Qj = parcelRequire("e42Qj");
function $04f244e20ad02728$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error('compose requires at least one argument');
    return (0, $6RNBD.default).apply(this, (0, $e42Qj.default)(arguments));
}

});
parcelRegister("6RNBD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ffe2c06dcd7fea0$export$2e2bcd8739ae039; });

var $72SzR = parcelRequire("72SzR");

var $e7InU = parcelRequire("e7InU");

var $5bThN = parcelRequire("5bThN");

var $2LuRT = parcelRequire("2LuRT");
function $4ffe2c06dcd7fea0$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error('pipe requires at least one argument');
    return (0, $72SzR.default)(arguments[0].length, (0, $5bThN.default)((0, $e7InU.default), arguments[0], (0, $2LuRT.default)(arguments)));
}

});
parcelRegister("e7InU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a48426012d1c6d85$export$2e2bcd8739ae039; });
function $a48426012d1c6d85$export$2e2bcd8739ae039(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}

});

parcelRegister("2LuRT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2037ea53db13dcb8$export$2e2bcd8739ae039; });

var $jKm5n = parcelRequire("jKm5n");

var $ipJAK = parcelRequire("ipJAK");

var $iM9LE = parcelRequire("iM9LE");
/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $2037ea53db13dcb8$var$tail = /*#__PURE__*/ (0, $ipJAK.default)(/*#__PURE__*/ (0, $jKm5n.default)('tail', /*#__PURE__*/ (0, $iM9LE.default)(1, Infinity)));
var $2037ea53db13dcb8$export$2e2bcd8739ae039 = $2037ea53db13dcb8$var$tail;

});
parcelRegister("jKm5n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e60371f517d40418$export$2e2bcd8739ae039; });

var $hPHpo = parcelRequire("hPHpo");
function $e60371f517d40418$export$2e2bcd8739ae039(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, $hPHpo.default)(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}

});

parcelRegister("iM9LE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dab44951914cce13$export$2e2bcd8739ae039; });

var $jKm5n = parcelRequire("jKm5n");

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $dab44951914cce13$var$slice = /*#__PURE__*/ (0, $5jzlJ.default)(/*#__PURE__*/ (0, $jKm5n.default)('slice', function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
var $dab44951914cce13$export$2e2bcd8739ae039 = $dab44951914cce13$var$slice;

});



parcelRegister("e42Qj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3d3a4ed746e071c$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $c83uM = parcelRequire("c83uM");
/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */ var $a3d3a4ed746e071c$var$reverse = /*#__PURE__*/ (0, $ipJAK.default)(function reverse(list) {
    return (0, $c83uM.default)(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
});
var $a3d3a4ed746e071c$export$2e2bcd8739ae039 = $a3d3a4ed746e071c$var$reverse;

});


parcelRegister("glKaE", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $bdtKT = parcelRequire("bdtKT");

var $e42Qj = parcelRequire("e42Qj");
/**
 * Performs right-to-left function composition using transforming function. The last function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of composeWith is not automatically curried. Transforming function is not used
 * on the last argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [(y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)]) -> ((a, b, ..., n) -> z)
 * @param {Function} transformer The transforming function
 * @param {Array} functions The functions to compose
 * @return {Function}
 * @see R.compose, R.pipeWith
 * @example
 *
 *      const composeWhileNotNil = R.composeWith((f, res) => R.isNil(res) ? res : f(res));
 *
 *      composeWhileNotNil([R.inc, R.prop('age')])({age: 1}) //=> 2
 *      composeWhileNotNil([R.inc, R.prop('age')])({}) //=> undefined
 *
 * @symb R.composeWith(f)([g, h, i])(...args) = f(g, f(h, i(...args)))
 */ var $be726c13486693fa$var$composeWith = /*#__PURE__*/ (0, $kzrqi.default)(function composeWith(xf, list) {
    return (0, $bdtKT.default).apply(this, [
        xf,
        (0, $e42Qj.default)(list)
    ]);
});
var $be726c13486693fa$export$2e2bcd8739ae039 = $be726c13486693fa$var$composeWith;

});
parcelRegister("bdtKT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82a7fd64f54a2fb0$export$2e2bcd8739ae039; });

var $72SzR = parcelRequire("72SzR");

var $kzrqi = parcelRequire("kzrqi");

var $bZIu3 = parcelRequire("bZIu3");

var $5bmcu = parcelRequire("5bmcu");

var $2LuRT = parcelRequire("2LuRT");

var $ajVWW = parcelRequire("ajVWW");
/**
 * Performs left-to-right function composition using transforming function. The first function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of pipeWith is not automatically curried. Transforming function is not used on the
 * first argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)]) -> ((a, b, ..., n) -> z)
 * @param {Function} transformer The transforming function
 * @param {Array} functions The functions to pipe
 * @return {Function}
 * @see R.composeWith, R.pipe
 * @example
 *
 *      const pipeWhileNotNil = R.pipeWith((f, res) => R.isNil(res) ? res : f(res));
 *      const f = pipeWhileNotNil([Math.pow, R.negate, R.inc])
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipeWith(f)([g, h, i])(...args) = f(i, f(h, g(...args)))
 */ var $82a7fd64f54a2fb0$var$pipeWith = /*#__PURE__*/ (0, $kzrqi.default)(function pipeWith(xf, list) {
    if (list.length <= 0) return 0, $ajVWW.default;
    var headList = (0, $bZIu3.default)(list);
    var tailList = (0, $2LuRT.default)(list);
    return (0, $72SzR.default)(headList.length, function() {
        return (0, $5bmcu.default)(function(result, f) {
            return xf.call(this, f, result);
        }, headList.apply(this, arguments), tailList);
    });
});
var $82a7fd64f54a2fb0$export$2e2bcd8739ae039 = $82a7fd64f54a2fb0$var$pipeWith;

});
parcelRegister("bZIu3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bb7e5bbfa61bd93$export$2e2bcd8739ae039; });

var $e1w5i = parcelRequire("e1w5i");
/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */ var $8bb7e5bbfa61bd93$var$head = /*#__PURE__*/ (0, $e1w5i.default)(0);
var $8bb7e5bbfa61bd93$export$2e2bcd8739ae039 = $8bb7e5bbfa61bd93$var$head;

});

parcelRegister("ajVWW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7838a152f9239ef6$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $luM0J = parcelRequire("luM0J");
/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      const obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */ var $7838a152f9239ef6$var$identity = /*#__PURE__*/ (0, $ipJAK.default)((0, $luM0J.default));
var $7838a152f9239ef6$export$2e2bcd8739ae039 = $7838a152f9239ef6$var$identity;

});
parcelRegister("luM0J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa61a447bab19b3d$export$2e2bcd8739ae039; });
function $fa61a447bab19b3d$export$2e2bcd8739ae039(x) {
    return x;
}

});




parcelRegister("cg8Ag", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ecda33e2cb490f7$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $hPHpo = parcelRequire("hPHpo");

var $iKPBD = parcelRequire("iKPBD");

var $c83uM = parcelRequire("c83uM");

var $jQHxm = parcelRequire("jQHxm");
/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */ var $8ecda33e2cb490f7$var$concat = /*#__PURE__*/ (0, $kzrqi.default)(function concat(a, b) {
    if ((0, $hPHpo.default)(a)) {
        if ((0, $hPHpo.default)(b)) return a.concat(b);
        throw new TypeError((0, $jQHxm.default)(b) + ' is not an array');
    }
    if ((0, $c83uM.default)(a)) {
        if ((0, $c83uM.default)(b)) return a + b;
        throw new TypeError((0, $jQHxm.default)(b) + ' is not a string');
    }
    if (a != null && (0, $iKPBD.default)(a['fantasy-land/concat'])) return a['fantasy-land/concat'](b);
    if (a != null && (0, $iKPBD.default)(a.concat)) return a.concat(b);
    throw new TypeError((0, $jQHxm.default)(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});
var $8ecda33e2cb490f7$export$2e2bcd8739ae039 = $8ecda33e2cb490f7$var$concat;

});
parcelRegister("jQHxm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e734a52f1373a330$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $45dlW = parcelRequire("45dlW");
/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */ var $e734a52f1373a330$var$toString = /*#__PURE__*/ (0, $ipJAK.default)(function toString(val) {
    return (0, $45dlW.default)(val, []);
});
var $e734a52f1373a330$export$2e2bcd8739ae039 = $e734a52f1373a330$var$toString;

});
parcelRegister("45dlW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f91fcaf8efb7a5b$export$2e2bcd8739ae039; });

var $7eI8l = parcelRequire("7eI8l");

var $5AqeV = parcelRequire("5AqeV");

var $kXiHf = parcelRequire("kXiHf");

var $ipw9T = parcelRequire("ipw9T");

var $hTLhm = parcelRequire("hTLhm");

var $6OQk6 = parcelRequire("6OQk6");
function $2f91fcaf8efb7a5b$export$2e2bcd8739ae039(x, seen) {
    var recur = function recur(y) {
        var xs = seen.concat([
            x
        ]);
        return (0, $7eI8l.default)(y, xs) ? '<Circular>' : $2f91fcaf8efb7a5b$export$2e2bcd8739ae039(y, xs);
    }; //  mapPairs :: (Object, [String]) -> [String]
    var mapPairs = function(obj, keys) {
        return (0, $5AqeV.default)(function(k) {
            return (0, $kXiHf.default)(k) + ': ' + recur(obj[k]);
        }, keys.slice().sort());
    };
    switch(Object.prototype.toString.call(x)){
        case '[object Arguments]':
            return '(function() { return arguments; }(' + (0, $5AqeV.default)(recur, x).join(', ') + '))';
        case '[object Array]':
            return '[' + (0, $5AqeV.default)(recur, x).concat(mapPairs(x, (0, $6OQk6.default)(function(k) {
                return /^\d+$/.test(k);
            }, (0, $hTLhm.default)(x)))).join(', ') + ']';
        case '[object Boolean]':
            return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
        case '[object Date]':
            return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : (0, $kXiHf.default)((0, $ipw9T.default)(x))) + ')';
        case '[object Null]':
            return 'null';
        case '[object Number]':
            return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
        case '[object String]':
            return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : (0, $kXiHf.default)(x);
        case '[object Undefined]':
            return 'undefined';
        default:
            if (typeof x.toString === 'function') {
                var repr = x.toString();
                if (repr !== '[object Object]') return repr;
            }
            return '{' + mapPairs(x, (0, $hTLhm.default)(x)).join(', ') + '}';
    }
}

});
parcelRegister("7eI8l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $544c1337236c79e2$export$2e2bcd8739ae039; });

var $1UKCj = parcelRequire("1UKCj");
function $544c1337236c79e2$export$2e2bcd8739ae039(a, list) {
    return (0, $1UKCj.default)(list, a, 0) >= 0;
}

});
parcelRegister("1UKCj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $164f2e8fcd757dba$export$2e2bcd8739ae039; });

var $fcCge = parcelRequire("fcCge");
function $164f2e8fcd757dba$export$2e2bcd8739ae039(list, a, idx) {
    var inf, item; // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === 'function') switch(typeof a){
        case 'number':
            if (a === 0) {
                // manually crawl the list to distinguish between +0 and -0
                inf = 1 / a;
                while(idx < list.length){
                    item = list[idx];
                    if (item === 0 && 1 / item === inf) return idx;
                    idx += 1;
                }
                return -1;
            } else if (a !== a) {
                // NaN
                while(idx < list.length){
                    item = list[idx];
                    if (typeof item === 'number' && item !== item) return idx;
                    idx += 1;
                }
                return -1;
            } // non-zero numbers can utilise Set
            return list.indexOf(a, idx);
        // all these types can utilise Set
        case 'string':
        case 'boolean':
        case 'function':
        case 'undefined':
            return list.indexOf(a, idx);
        case 'object':
            if (a === null) // null can utilise Set
            return list.indexOf(a, idx);
    }
     // anything else not covered above, defer to R.equals
    while(idx < list.length){
        if ((0, $fcCge.default)(list[idx], a)) return idx;
        idx += 1;
    }
    return -1;
}

});
parcelRegister("fcCge", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b115a7c8bb130c26$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $aJYKa = parcelRequire("aJYKa");
/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var $b115a7c8bb130c26$var$equals = /*#__PURE__*/ (0, $kzrqi.default)(function equals(a, b) {
    return (0, $aJYKa.default)(a, b, [], []);
});
var $b115a7c8bb130c26$export$2e2bcd8739ae039 = $b115a7c8bb130c26$var$equals;

});
parcelRegister("aJYKa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d1d39c240fe6d6e$export$2e2bcd8739ae039; });

var $fLl12 = parcelRequire("fLl12");

var $lJiLY = parcelRequire("lJiLY");

var $cv8db = parcelRequire("cv8db");

var $j0Aik = parcelRequire("j0Aik");

var $pQHse = parcelRequire("pQHse");

var $hTLhm = parcelRequire("hTLhm");

var $67eac = parcelRequire("67eac");
/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparison of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function $7d1d39c240fe6d6e$var$_uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = (0, $fLl12.default)(aIterator);
    var b = (0, $fLl12.default)(bIterator);
    function eq(_a, _b) {
        return $7d1d39c240fe6d6e$export$2e2bcd8739ae039(_a, _b, stackA.slice(), stackB.slice());
    } // if *a* array contains any element that is not included in *b*
    return !(0, $lJiLY.default)(function(b, aItem) {
        return !(0, $lJiLY.default)(eq, aItem, b);
    }, b, a);
}
function $7d1d39c240fe6d6e$export$2e2bcd8739ae039(a, b, stackA, stackB) {
    if ((0, $pQHse.default)(a, b)) return true;
    var typeA = (0, $67eac.default)(a);
    if (typeA !== (0, $67eac.default)(b)) return false;
    if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
    if (typeof a.equals === 'function' || typeof b.equals === 'function') return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
    switch(typeA){
        case 'Arguments':
        case 'Array':
        case 'Object':
            if (typeof a.constructor === 'function' && (0, $cv8db.default)(a.constructor) === 'Promise') return a === b;
            break;
        case 'Boolean':
        case 'Number':
        case 'String':
            if (!(typeof a === typeof b && (0, $pQHse.default)(a.valueOf(), b.valueOf()))) return false;
            break;
        case 'Date':
            if (!(0, $pQHse.default)(a.valueOf(), b.valueOf())) return false;
            break;
        case 'Error':
            return a.name === b.name && a.message === b.message;
        case 'RegExp':
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case 'Map':
            if (a.size !== b.size) return false;
            return $7d1d39c240fe6d6e$var$_uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case 'Set':
            if (a.size !== b.size) return false;
            return $7d1d39c240fe6d6e$var$_uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case 'Arguments':
        case 'Array':
        case 'Object':
        case 'Boolean':
        case 'Number':
        case 'String':
        case 'Date':
        case 'Error':
        case 'RegExp':
        case 'Int8Array':
        case 'Uint8Array':
        case 'Uint8ClampedArray':
        case 'Int16Array':
        case 'Uint16Array':
        case 'Int32Array':
        case 'Uint32Array':
        case 'Float32Array':
        case 'Float64Array':
        case 'ArrayBuffer':
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = (0, $hTLhm.default)(a);
    if (keysA.length !== (0, $hTLhm.default)(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!((0, $j0Aik.default)(key, b) && $7d1d39c240fe6d6e$export$2e2bcd8739ae039(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}

});
parcelRegister("fLl12", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b79b8c147df52dca$export$2e2bcd8739ae039; });
function $b79b8c147df52dca$export$2e2bcd8739ae039(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}

});

parcelRegister("lJiLY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd1c5ccd3746b1fc$export$2e2bcd8739ae039; });
function $fd1c5ccd3746b1fc$export$2e2bcd8739ae039(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}

});

parcelRegister("cv8db", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $919ebfeec05a9e81$export$2e2bcd8739ae039; });
function $919ebfeec05a9e81$export$2e2bcd8739ae039(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? '' : match[1];
}

});

parcelRegister("pQHse", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04db3703256f53ba$export$2e2bcd8739ae039; });
// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $04db3703256f53ba$var$_objectIs(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
}
var $04db3703256f53ba$export$2e2bcd8739ae039 = typeof Object.is === 'function' ? Object.is : $04db3703256f53ba$var$_objectIs;

});





parcelRegister("kXiHf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f417d21345f047c3$export$2e2bcd8739ae039; });
function $f417d21345f047c3$export$2e2bcd8739ae039(s) {
    var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
    return '"' + escaped.replace(/"/g, '\\"') + '"';
}

});

parcelRegister("ipw9T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d67381d3357a6138$export$2e2bcd8739ae039; });
/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */ var $d67381d3357a6138$var$pad = function pad(n) {
    return (n < 10 ? '0' : '') + n;
};
var $d67381d3357a6138$var$_toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
    return d.toISOString();
} : function _toISOString(d) {
    return d.getUTCFullYear() + '-' + $d67381d3357a6138$var$pad(d.getUTCMonth() + 1) + '-' + $d67381d3357a6138$var$pad(d.getUTCDate()) + 'T' + $d67381d3357a6138$var$pad(d.getUTCHours()) + ':' + $d67381d3357a6138$var$pad(d.getUTCMinutes()) + ':' + $d67381d3357a6138$var$pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
};
var $d67381d3357a6138$export$2e2bcd8739ae039 = $d67381d3357a6138$var$_toISOString;

});

parcelRegister("6OQk6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f6fffe2987be5b6$export$2e2bcd8739ae039; });

var $bdeG6 = parcelRequire("bdeG6");

var $kzrqi = parcelRequire("kzrqi");

var $85XPA = parcelRequire("85XPA");
/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 !== 0;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $4f6fffe2987be5b6$var$reject = /*#__PURE__*/ (0, $kzrqi.default)(function reject(pred, filterable) {
    return (0, $85XPA.default)((0, $bdeG6.default)(pred), filterable);
});
var $4f6fffe2987be5b6$export$2e2bcd8739ae039 = $4f6fffe2987be5b6$var$reject;

});
parcelRegister("bdeG6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $829c4b5f055f9d53$export$2e2bcd8739ae039; });
function $829c4b5f055f9d53$export$2e2bcd8739ae039(f) {
    return function() {
        return !f.apply(this, arguments);
    };
}

});

parcelRegister("85XPA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e4d338f6be7f06e$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $8ls0t = parcelRequire("8ls0t");

var $luMT5 = parcelRequire("luMT5");

var $5bmcu = parcelRequire("5bmcu");

var $ecoFT = parcelRequire("ecoFT");

var $hTLhm = parcelRequire("hTLhm");
/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $5e4d338f6be7f06e$var$filter = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([
    'fantasy-land/filter',
    'filter'
], (0, $ecoFT.default), function(pred, filterable) {
    return (0, $luMT5.default)(filterable) ? (0, $5bmcu.default)(function(acc, key) {
        if (pred(filterable[key])) acc[key] = filterable[key];
        return acc;
    }, {}, (0, $hTLhm.default)(filterable)) : (0, $8ls0t.default)(pred, filterable);
}));
var $5e4d338f6be7f06e$export$2e2bcd8739ae039 = $5e4d338f6be7f06e$var$filter;

});
parcelRegister("8ls0t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6136026934d45974$export$2e2bcd8739ae039; });
function $6136026934d45974$export$2e2bcd8739ae039(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while(idx < len){
        if (fn(list[idx])) result[result.length] = list[idx];
        idx += 1;
    }
    return result;
}

});

parcelRegister("luMT5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa6252580b9ef956$export$2e2bcd8739ae039; });
function $fa6252580b9ef956$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
}

});

parcelRegister("ecoFT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a56553896f3821f7$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $g1C1K = parcelRequire("g1C1K");
var $a56553896f3821f7$var$XFilter = /*#__PURE__*/ function() {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XFilter.prototype['@@transducer/result'] = (0, $g1C1K.default).result;
    XFilter.prototype['@@transducer/step'] = function(result, input) {
        return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
    };
    return XFilter;
}();
var $a56553896f3821f7$var$_xfilter = /*#__PURE__*/ (0, $kzrqi.default)(function _xfilter(f, xf) {
    return new $a56553896f3821f7$var$XFilter(f, xf);
});
var $a56553896f3821f7$export$2e2bcd8739ae039 = $a56553896f3821f7$var$_xfilter;

});






parcelRegister("jANtL", function(module, exports) {

var $72SzR = parcelRequire("72SzR");

var $ipJAK = parcelRequire("ipJAK");

var $9QW5G = parcelRequire("9QW5G");

var $lmfGS = parcelRequire("lmfGS");

var $5bThN = parcelRequire("5bThN");
/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * **Please note**: This is not a direct substitute for a `switch` statement.
 * Remember that both elements of every pair passed to `cond` are *functions*,
 * and `cond` returns a function.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @see R.ifElse, R.unless, R.when
 * @example
 *
 *      const fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */ var $e437c2a054dcb8cb$var$cond = /*#__PURE__*/ (0, $ipJAK.default)(function cond(pairs) {
    var arity = (0, $5bThN.default)((0, $lmfGS.default), 0, (0, $9QW5G.default)(function(pair) {
        return pair[0].length;
    }, pairs));
    return (0, $72SzR.default)(arity, function() {
        var idx = 0;
        while(idx < pairs.length){
            if (pairs[idx][0].apply(this, arguments)) return pairs[idx][1].apply(this, arguments);
            idx += 1;
        }
    });
});
var $e437c2a054dcb8cb$export$2e2bcd8739ae039 = $e437c2a054dcb8cb$var$cond;

});

parcelRegister("4J3hT", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $gSKCN = parcelRequire("gSKCN");
/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      const AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      const animalTypes = ["Lion", "Tiger", "Bear"];
 *      const animalSighting = R.invoker(0, 'sighting');
 *      const sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */ var $370dea38d9094237$var$construct = /*#__PURE__*/ (0, $ipJAK.default)(function construct(Fn) {
    return (0, $gSKCN.default)(Fn.length, Fn);
});
var $370dea38d9094237$export$2e2bcd8739ae039 = $370dea38d9094237$var$construct;

});
parcelRegister("gSKCN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4a5db2f365deb91$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $2VuN6 = parcelRequire("2VuN6");

var $iLMUu = parcelRequire("iLMUu");
/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      }
 *
 *      Salad.prototype.recipe = function() {
 *        const instructions = R.map(ingredient => 'Add a dollop of ' + ingredient, this.ingredients);
 *        return R.join('\n', instructions);
 *      };
 *
 *      const ThreeLayerSalad = R.constructN(3, Salad);
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      const salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup');
 *
 *      console.log(salad.recipe());
 *      // Add a dollop of Mayonnaise
 *      // Add a dollop of Potato Chips
 *      // Add a dollop of Ketchup
 */ var $c4a5db2f365deb91$var$constructN = /*#__PURE__*/ (0, $kzrqi.default)(function constructN(n, Fn) {
    if (n > 10) throw new Error('Constructor with greater than ten arguments');
    if (n === 0) return function() {
        return new Fn();
    };
    return (0, $2VuN6.default)((0, $iLMUu.default)(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
        switch(arguments.length){
            case 1:
                return new Fn($0);
            case 2:
                return new Fn($0, $1);
            case 3:
                return new Fn($0, $1, $2);
            case 4:
                return new Fn($0, $1, $2, $3);
            case 5:
                return new Fn($0, $1, $2, $3, $4);
            case 6:
                return new Fn($0, $1, $2, $3, $4, $5);
            case 7:
                return new Fn($0, $1, $2, $3, $4, $5, $6);
            case 8:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
            case 9:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
            case 10:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
        }
    }));
});
var $c4a5db2f365deb91$export$2e2bcd8739ae039 = $c4a5db2f365deb91$var$constructN;

});
parcelRegister("2VuN6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2218ca1a1bd6049e$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $JtjnN = parcelRequire("JtjnN");
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $2218ca1a1bd6049e$var$curry = /*#__PURE__*/ (0, $ipJAK.default)(function curry(fn) {
    return (0, $JtjnN.default)(fn.length, fn);
});
var $2218ca1a1bd6049e$export$2e2bcd8739ae039 = $2218ca1a1bd6049e$var$curry;

});



parcelRegister("4IXwC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $370971e946e19398$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $5AqeV = parcelRequire("5AqeV");

var $JtjnN = parcelRequire("JtjnN");

var $lmfGS = parcelRequire("lmfGS");

var $ayjin = parcelRequire("ayjin");

var $5bThN = parcelRequire("5bThN");
/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. The arity of the new function is the same as the arity of
 * the longest branching function. When invoked, this new function is applied
 * to some arguments, and each branching function is applied to those same
 * arguments. The results of each branching function are passed as arguments
 * to the converging function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      const average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      const strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */ var $370971e946e19398$var$converge = /*#__PURE__*/ (0, $kzrqi.default)(function converge(after, fns) {
    return (0, $JtjnN.default)((0, $5bThN.default)((0, $lmfGS.default), 0, (0, $ayjin.default)('length', fns)), function() {
        var args = arguments;
        var context = this;
        return after.apply(context, (0, $5AqeV.default)(function(fn) {
            return fn.apply(context, args);
        }, fns));
    });
});
var $370971e946e19398$export$2e2bcd8739ae039 = $370971e946e19398$var$converge;

});

parcelRegister("7ruQ7", function(module, exports) {

var $5bmcu = parcelRequire("5bmcu");

var $2VuN6 = parcelRequire("2VuN6");
/**
 * Returns the number of items in a given `list` matching the predicate `f`
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} predicate to match items against
 * @return {Array} list of items to count in
 * @example
 *
 *      const even = x => x % 2 == 0;
 *
 *      R.count(even, [1, 2, 3, 4, 5]); // => 2
 *      R.map(R.count(even), [[1, 1, 1], [2, 3, 4, 5], [6]]); // => [0, 2, 1]
 */ var $56b2fa1f24208741$var$count = /*#__PURE__*/ (0, $2VuN6.default)(function(pred, list) {
    return (0, $5bmcu.default)(function(a, e) {
        return pred(e) ? a + 1 : a;
    }, 0, list);
});
var $56b2fa1f24208741$export$2e2bcd8739ae039 = $56b2fa1f24208741$var$count;

});

parcelRegister("lpV2X", function(module, exports) {

var $7KMMR = parcelRequire("7KMMR");
/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      const numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      const letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */ var $f9782f12071d4a6a$var$countBy = /*#__PURE__*/ (0, $7KMMR.default)(function(acc, elem) {
    return acc + 1;
}, 0);
var $f9782f12071d4a6a$export$2e2bcd8739ae039 = $f9782f12071d4a6a$var$countBy;

});
parcelRegister("7KMMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a52ac5c07f07e61$export$2e2bcd8739ae039; });

var $beT6k = parcelRequire("beT6k");

var $2ukFE = parcelRequire("2ukFE");

var $dVL0K = parcelRequire("dVL0K");

var $j0Aik = parcelRequire("j0Aik");

var $5bmcu = parcelRequire("5bmcu");

var $1RqCc = parcelRequire("1RqCc");

var $1F6rX = parcelRequire("1F6rX");
/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * The value function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to short circuit the iteration.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce, R.reduced
 * @example
 *
 *      const groupNames = (acc, {name}) => acc.concat(name)
 *      const toGrade = ({score}) =>
 *        score < 65 ? 'F' :
 *        score < 70 ? 'D' :
 *        score < 80 ? 'C' :
 *        score < 90 ? 'B' : 'A'
 *
 *      var students = [
 *        {name: 'Abby', score: 83},
 *        {name: 'Bart', score: 62},
 *        {name: 'Curt', score: 88},
 *        {name: 'Dora', score: 92},
 *      ]
 *
 *      reduceBy(groupNames, [], toGrade, students)
 *      //=> {"A": ["Dora"], "B": ["Abby", "Curt"], "F": ["Bart"]}
 */ var $5a52ac5c07f07e61$var$reduceBy = /*#__PURE__*/ (0, $2ukFE.default)(4, [], /*#__PURE__*/ (0, $dVL0K.default)([], (0, $1F6rX.default), function reduceBy(valueFn, valueAcc, keyFn, list) {
    return (0, $5bmcu.default)(function(acc, elt) {
        var key = keyFn(elt);
        var value = valueFn((0, $j0Aik.default)(key, acc) ? acc[key] : (0, $beT6k.default)(valueAcc, [], [], false), elt);
        if (value && value['@@transducer/reduced']) return (0, $1RqCc.default)(acc);
        acc[key] = value;
        return acc;
    }, {}, list);
}));
var $5a52ac5c07f07e61$export$2e2bcd8739ae039 = $5a52ac5c07f07e61$var$reduceBy;

});
parcelRegister("1F6rX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $135e9f941dc5246b$export$2e2bcd8739ae039; });

var $2ukFE = parcelRequire("2ukFE");

var $j0Aik = parcelRequire("j0Aik");

var $g1C1K = parcelRequire("g1C1K");
var $135e9f941dc5246b$var$XReduceBy = /*#__PURE__*/ function() {
    function XReduceBy(valueFn, valueAcc, keyFn, xf) {
        this.valueFn = valueFn;
        this.valueAcc = valueAcc;
        this.keyFn = keyFn;
        this.xf = xf;
        this.inputs = {};
    }
    XReduceBy.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XReduceBy.prototype['@@transducer/result'] = function(result) {
        var key;
        for(key in this.inputs)if ((0, $j0Aik.default)(key, this.inputs)) {
            result = this.xf['@@transducer/step'](result, this.inputs[key]);
            if (result['@@transducer/reduced']) {
                result = result['@@transducer/value'];
                break;
            }
        }
        this.inputs = null;
        return this.xf['@@transducer/result'](result);
    };
    XReduceBy.prototype['@@transducer/step'] = function(result, input) {
        var key = this.keyFn(input);
        this.inputs[key] = this.inputs[key] || [
            key,
            this.valueAcc
        ];
        this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
        return result;
    };
    return XReduceBy;
}();
var $135e9f941dc5246b$var$_xreduceBy = /*#__PURE__*/ (0, $2ukFE.default)(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
    return new $135e9f941dc5246b$var$XReduceBy(valueFn, valueAcc, keyFn, xf);
});
var $135e9f941dc5246b$export$2e2bcd8739ae039 = $135e9f941dc5246b$var$_xreduceBy;

});



parcelRegister("fCsfV", function(module, exports) {

var $cgwpr = parcelRequire("cgwpr");
/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */ var $b5f052a74d766b00$var$dec = /*#__PURE__*/ (0, $cgwpr.default)(-1);
var $b5f052a74d766b00$export$2e2bcd8739ae039 = $b5f052a74d766b00$var$dec;

});

parcelRegister("Hyj0j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $082ea0a0cbf83a09$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      const defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42(false);  //=> false
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */ var $082ea0a0cbf83a09$var$defaultTo = /*#__PURE__*/ (0, $kzrqi.default)(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
});
var $082ea0a0cbf83a09$export$2e2bcd8739ae039 = $082ea0a0cbf83a09$var$defaultTo;

});

parcelRegister("ac56O", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      const byAge = R.descend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByOldestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Peter', age: 78 }, { name: 'Emma', age: 70 }, { name: 'Mikhail', age: 62 }]
 */ var $76befce04ea5325d$var$descend = /*#__PURE__*/ (0, $5jzlJ.default)(function descend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa > bb ? -1 : aa < bb ? 1 : 0;
});
var $76befce04ea5325d$export$2e2bcd8739ae039 = $76befce04ea5325d$var$descend;

});

parcelRegister("RNRjT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a1ba04f6ac7f92f$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $9br0S = parcelRequire("9br0S");
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */ var $0a1ba04f6ac7f92f$var$difference = /*#__PURE__*/ (0, $kzrqi.default)(function difference(first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    var secondLen = second.length;
    var toFilterOut = new (0, $9br0S.default)();
    for(var i = 0; i < secondLen; i += 1)toFilterOut.add(second[i]);
    while(idx < firstLen){
        if (toFilterOut.add(first[idx])) out[out.length] = first[idx];
        idx += 1;
    }
    return out;
});
var $0a1ba04f6ac7f92f$export$2e2bcd8739ae039 = $0a1ba04f6ac7f92f$var$difference;

});
parcelRegister("9br0S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6afa1861770bbb76$export$2e2bcd8739ae039; });

var $7eI8l = parcelRequire("7eI8l");
var $6afa1861770bbb76$var$_Set = /*#__PURE__*/ function() {
    function _Set() {
        /* globals Set */ this._nativeSet = typeof Set === 'function' ? new Set() : null;
        this._items = {};
    }
    // until we figure out why jsdoc chokes on this
    // @param item The item to add to the Set
    // @returns {boolean} true if the item did not exist prior, otherwise false
    //
    _Set.prototype.add = function(item) {
        return !$6afa1861770bbb76$var$hasOrAdd(item, true, this);
    }; //
    // @param item The item to check for existence in the Set
    // @returns {boolean} true if the item exists in the Set, otherwise false
    //
    _Set.prototype.has = function(item) {
        return $6afa1861770bbb76$var$hasOrAdd(item, false, this);
    }; //
    // Combines the logic for checking whether an item is a member of the set and
    // for adding a new item to the set.
    //
    // @param item       The item to check or add to the Set instance.
    // @param shouldAdd  If true, the item will be added to the set if it doesn't
    //                   already exist.
    // @param set        The set instance to check or add to.
    // @return {boolean} true if the item already existed, otherwise false.
    //
    return _Set;
}();
function $6afa1861770bbb76$var$hasOrAdd(item, shouldAdd, set) {
    var type = typeof item;
    var prevSize, newSize;
    switch(type){
        case 'string':
        case 'number':
            // distinguish between +0 and -0
            if (item === 0 && 1 / item === -Infinity) {
                if (set._items['-0']) return true;
                else {
                    if (shouldAdd) set._items['-0'] = true;
                    return false;
                }
            } // these types can all utilise the native Set
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) {
                        set._items[type] = {};
                        set._items[type][item] = true;
                    }
                    return false;
                } else if (item in set._items[type]) return true;
                else {
                    if (shouldAdd) set._items[type][item] = true;
                    return false;
                }
            }
        case 'boolean':
            // set._items['boolean'] holds a two element array
            // representing [ falseExists, trueExists ]
            if (type in set._items) {
                var bIdx = item ? 1 : 0;
                if (set._items[type][bIdx]) return true;
                else {
                    if (shouldAdd) set._items[type][bIdx] = true;
                    return false;
                }
            } else {
                if (shouldAdd) set._items[type] = item ? [
                    false,
                    true
                ] : [
                    true,
                    false
                ];
                return false;
            }
        case 'function':
            // compare functions for reference equality
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) set._items[type] = [
                        item
                    ];
                    return false;
                }
                if (!(0, $7eI8l.default)(item, set._items[type])) {
                    if (shouldAdd) set._items[type].push(item);
                    return false;
                }
                return true;
            }
        case 'undefined':
            if (set._items[type]) return true;
            else {
                if (shouldAdd) set._items[type] = true;
                return false;
            }
        case 'object':
            if (item === null) {
                if (!set._items['null']) {
                    if (shouldAdd) set._items['null'] = true;
                    return false;
                }
                return true;
            }
        /* falls through */ default:
            // reduce the search size of heterogeneous sets by creating buckets
            // for each type.
            type = Object.prototype.toString.call(item);
            if (!(type in set._items)) {
                if (shouldAdd) set._items[type] = [
                    item
                ];
                return false;
            } // scan through all previously applied items
            if (!(0, $7eI8l.default)(item, set._items[type])) {
                if (shouldAdd) set._items[type].push(item);
                return false;
            }
            return true;
    }
} // A simple Set type that honours R.equals semantics
var $6afa1861770bbb76$export$2e2bcd8739ae039 = $6afa1861770bbb76$var$_Set;

});


parcelRegister("llbWy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f894d2d9b3acd212$export$2e2bcd8739ae039; });

var $lJiLY = parcelRequire("lJiLY");

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      const cmp = (x, y) => x.a === y.a;
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      const l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */ var $f894d2d9b3acd212$var$differenceWith = /*#__PURE__*/ (0, $5jzlJ.default)(function differenceWith(pred, first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    while(idx < firstLen){
        if (!(0, $lJiLY.default)(pred, first[idx], second) && !(0, $lJiLY.default)(pred, first[idx], out)) out.push(first[idx]);
        idx += 1;
    }
    return out;
});
var $f894d2d9b3acd212$export$2e2bcd8739ae039 = $f894d2d9b3acd212$var$differenceWith;

});

parcelRegister("aJAGq", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $lii7K = parcelRequire("lii7K");
/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc, R.omit
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */ var $7d0a8fdfdef6aadb$var$dissoc = /*#__PURE__*/ (0, $kzrqi.default)(function dissoc(prop, obj) {
    return (0, $lii7K.default)([
        prop
    ], obj);
});
var $7d0a8fdfdef6aadb$export$2e2bcd8739ae039 = $7d0a8fdfdef6aadb$var$dissoc;

});
parcelRegister("lii7K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f80956782a4c37a4$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $ixOtJ = parcelRequire("ixOtJ");

var $3WvPT = parcelRequire("3WvPT");

var $hPHpo = parcelRequire("hPHpo");

var $eCXNe = parcelRequire("eCXNe");
/**
 * Makes a shallow clone of an object. Note that this copies and flattens
 * prototype properties onto the new object as well. All non-primitive
 * properties are copied by reference.
 *
 * @private
 * @param {String|Integer} prop The prop operating
 * @param {Object|Array} obj The object to clone
 * @return {Object|Array} A new object equivalent to the original.
 */ function $f80956782a4c37a4$var$_shallowCloneObject(prop, obj) {
    if ((0, $3WvPT.default)(prop) && (0, $hPHpo.default)(obj)) return [].concat(obj);
    var result = {};
    for(var p in obj)result[p] = obj[p];
    return result;
}
/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */ var $f80956782a4c37a4$var$dissocPath = /*#__PURE__*/ (0, $kzrqi.default)(function dissocPath(path, obj) {
    if (obj == null) return obj;
    switch(path.length){
        case 0:
            return obj;
        case 1:
            return (0, $ixOtJ.default)(path[0], obj);
        default:
            var head = path[0];
            var tail = Array.prototype.slice.call(path, 1);
            if (obj[head] == null) return $f80956782a4c37a4$var$_shallowCloneObject(head, obj);
            else return (0, $eCXNe.default)(head, dissocPath(tail, obj[head]), obj);
    }
});
var $f80956782a4c37a4$export$2e2bcd8739ae039 = $f80956782a4c37a4$var$dissocPath;

});
parcelRegister("ixOtJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d802770c249501eb$export$2e2bcd8739ae039; });

var $3WvPT = parcelRequire("3WvPT");

var $hPHpo = parcelRequire("hPHpo");

var $a568Q = parcelRequire("a568Q");
function $d802770c249501eb$export$2e2bcd8739ae039(prop, obj) {
    if (obj == null) return obj;
    if ((0, $3WvPT.default)(prop) && (0, $hPHpo.default)(obj)) return (0, $a568Q.default)(prop, 1, obj);
    var result = {};
    for(var p in obj)result[p] = obj[p];
    delete result[prop];
    return result;
}

});
parcelRegister("a568Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $756f22a1c67b806a$export$2e2bcd8739ae039; });

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @see R.without
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */ var $756f22a1c67b806a$var$remove = /*#__PURE__*/ (0, $5jzlJ.default)(function remove(start, count, list) {
    var result = Array.prototype.slice.call(list, 0);
    result.splice(start, count);
    return result;
});
var $756f22a1c67b806a$export$2e2bcd8739ae039 = $756f22a1c67b806a$var$remove;

});




parcelRegister("8OdGk", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      const half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      const reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */ var $669d9b246e2b444c$var$divide = /*#__PURE__*/ (0, $kzrqi.default)(function divide(a, b) {
    return a / b;
});
var $669d9b246e2b444c$export$2e2bcd8739ae039 = $669d9b246e2b444c$var$divide;

});

parcelRegister("4AJH0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $357df7d03d951412$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $gHacz = parcelRequire("gHacz");

var $iM9LE = parcelRequire("iM9LE");
/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */ var $357df7d03d951412$var$drop = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([
    'drop'
], (0, $gHacz.default), function drop(n, xs) {
    return (0, $iM9LE.default)(Math.max(0, n), Infinity, xs);
}));
var $357df7d03d951412$export$2e2bcd8739ae039 = $357df7d03d951412$var$drop;

});
parcelRegister("gHacz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c278935b717f062a$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $g1C1K = parcelRequire("g1C1K");
var $c278935b717f062a$var$XDrop = /*#__PURE__*/ function() {
    function XDrop(n, xf) {
        this.xf = xf;
        this.n = n;
    }
    XDrop.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XDrop.prototype['@@transducer/result'] = (0, $g1C1K.default).result;
    XDrop.prototype['@@transducer/step'] = function(result, input) {
        if (this.n > 0) {
            this.n -= 1;
            return result;
        }
        return this.xf['@@transducer/step'](result, input);
    };
    return XDrop;
}();
var $c278935b717f062a$var$_xdrop = /*#__PURE__*/ (0, $kzrqi.default)(function _xdrop(n, xf) {
    return new $c278935b717f062a$var$XDrop(n, xf);
});
var $c278935b717f062a$export$2e2bcd8739ae039 = $c278935b717f062a$var$_xdrop;

});


parcelRegister("kCSfk", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $fndUY = parcelRequire("fndUY");

var $kmrJ0 = parcelRequire("kmrJ0");
/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */ var $f0416f70ba87848f$var$dropLast = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([], (0, $kmrJ0.default), (0, $fndUY.default)));
var $f0416f70ba87848f$export$2e2bcd8739ae039 = $f0416f70ba87848f$var$dropLast;

});
parcelRegister("fndUY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b313ccd0c30bf975$export$2e2bcd8739ae039; });

var $cTQ6P = parcelRequire("cTQ6P");
function $b313ccd0c30bf975$export$2e2bcd8739ae039(n, xs) {
    return (0, $cTQ6P.default)(n < xs.length ? xs.length - n : 0, xs);
}

});
parcelRegister("cTQ6P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96430ae070f89d6b$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $cHK5N = parcelRequire("cHK5N");

var $iM9LE = parcelRequire("iM9LE");
/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      const personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      const takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */ var $96430ae070f89d6b$var$take = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([
    'take'
], (0, $cHK5N.default), function take(n, xs) {
    return (0, $iM9LE.default)(0, n < 0 ? Infinity : n, xs);
}));
var $96430ae070f89d6b$export$2e2bcd8739ae039 = $96430ae070f89d6b$var$take;

});
parcelRegister("cHK5N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93fd41364315db6e$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $1RqCc = parcelRequire("1RqCc");

var $g1C1K = parcelRequire("g1C1K");
var $93fd41364315db6e$var$XTake = /*#__PURE__*/ function() {
    function XTake(n, xf) {
        this.xf = xf;
        this.n = n;
        this.i = 0;
    }
    XTake.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XTake.prototype['@@transducer/result'] = (0, $g1C1K.default).result;
    XTake.prototype['@@transducer/step'] = function(result, input) {
        this.i += 1;
        var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
        return this.n >= 0 && this.i >= this.n ? (0, $1RqCc.default)(ret) : ret;
    };
    return XTake;
}();
var $93fd41364315db6e$var$_xtake = /*#__PURE__*/ (0, $kzrqi.default)(function _xtake(n, xf) {
    return new $93fd41364315db6e$var$XTake(n, xf);
});
var $93fd41364315db6e$export$2e2bcd8739ae039 = $93fd41364315db6e$var$_xtake;

});



parcelRegister("kmrJ0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed2b5e535c591cf6$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $g1C1K = parcelRequire("g1C1K");
var $ed2b5e535c591cf6$var$XDropLast = /*#__PURE__*/ function() {
    function XDropLast(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XDropLast.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XDropLast.prototype['@@transducer/result'] = function(result) {
        this.acc = null;
        return this.xf['@@transducer/result'](result);
    };
    XDropLast.prototype['@@transducer/step'] = function(result, input) {
        if (this.full) result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
        this.store(input);
        return result;
    };
    XDropLast.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    return XDropLast;
}();
var $ed2b5e535c591cf6$var$_xdropLast = /*#__PURE__*/ (0, $kzrqi.default)(function _xdropLast(n, xf) {
    return new $ed2b5e535c591cf6$var$XDropLast(n, xf);
});
var $ed2b5e535c591cf6$export$2e2bcd8739ae039 = $ed2b5e535c591cf6$var$_xdropLast;

});


parcelRegister("37Bkb", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $bVMOa = parcelRequire("bVMOa");

var $7c7z1 = parcelRequire("7c7z1");
/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} predicate The function to be called on each element
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      const lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 *
 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
 */ var $245efa692ecf2666$var$dropLastWhile = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([], (0, $7c7z1.default), (0, $bVMOa.default)));
var $245efa692ecf2666$export$2e2bcd8739ae039 = $245efa692ecf2666$var$dropLastWhile;

});
parcelRegister("bVMOa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8afae0dae2522cf8$export$2e2bcd8739ae039; });

var $iM9LE = parcelRequire("iM9LE");
function $8afae0dae2522cf8$export$2e2bcd8739ae039(pred, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && pred(xs[idx]))idx -= 1;
    return (0, $iM9LE.default)(0, idx + 1, xs);
}

});

parcelRegister("7c7z1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53cf856c6dfaf777$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $5bmcu = parcelRequire("5bmcu");

var $g1C1K = parcelRequire("g1C1K");
var $53cf856c6dfaf777$var$XDropLastWhile = /*#__PURE__*/ function() {
    function XDropLastWhile(fn, xf) {
        this.f = fn;
        this.retained = [];
        this.xf = xf;
    }
    XDropLastWhile.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XDropLastWhile.prototype['@@transducer/result'] = function(result) {
        this.retained = null;
        return this.xf['@@transducer/result'](result);
    };
    XDropLastWhile.prototype['@@transducer/step'] = function(result, input) {
        return this.f(input) ? this.retain(result, input) : this.flush(result, input);
    };
    XDropLastWhile.prototype.flush = function(result, input) {
        result = (0, $5bmcu.default)(this.xf['@@transducer/step'], result, this.retained);
        this.retained = [];
        return this.xf['@@transducer/step'](result, input);
    };
    XDropLastWhile.prototype.retain = function(result, input) {
        this.retained.push(input);
        return result;
    };
    return XDropLastWhile;
}();
var $53cf856c6dfaf777$var$_xdropLastWhile = /*#__PURE__*/ (0, $kzrqi.default)(function _xdropLastWhile(fn, xf) {
    return new $53cf856c6dfaf777$var$XDropLastWhile(fn, xf);
});
var $53cf856c6dfaf777$export$2e2bcd8739ae039 = $53cf856c6dfaf777$var$_xdropLastWhile;

});


parcelRegister("4wJHV", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $dVL0K = parcelRequire("dVL0K");

var $7fkyx = parcelRequire("7fkyx");

var $kBFkh = parcelRequire("kBFkh");

var $fcCge = parcelRequire("fcCge");
/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */ var $34bd9b2746e5d2a7$var$dropRepeats = /*#__PURE__*/ (0, $ipJAK.default)(/*#__PURE__*/ (0, $dVL0K.default)([], /*#__PURE__*/ (0, $7fkyx.default)((0, $fcCge.default)), /*#__PURE__*/ (0, $kBFkh.default)((0, $fcCge.default))));
var $34bd9b2746e5d2a7$export$2e2bcd8739ae039 = $34bd9b2746e5d2a7$var$dropRepeats;

});
parcelRegister("7fkyx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5469e12161c3c950$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $g1C1K = parcelRequire("g1C1K");
var $5469e12161c3c950$var$XDropRepeatsWith = /*#__PURE__*/ function() {
    function XDropRepeatsWith(pred, xf) {
        this.xf = xf;
        this.pred = pred;
        this.lastValue = undefined;
        this.seenFirstValue = false;
    }
    XDropRepeatsWith.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XDropRepeatsWith.prototype['@@transducer/result'] = (0, $g1C1K.default).result;
    XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
        var sameAsLast = false;
        if (!this.seenFirstValue) this.seenFirstValue = true;
        else if (this.pred(this.lastValue, input)) sameAsLast = true;
        this.lastValue = input;
        return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
    };
    return XDropRepeatsWith;
}();
var $5469e12161c3c950$var$_xdropRepeatsWith = /*#__PURE__*/ (0, $kzrqi.default)(function _xdropRepeatsWith(pred, xf) {
    return new $5469e12161c3c950$var$XDropRepeatsWith(pred, xf);
});
var $5469e12161c3c950$export$2e2bcd8739ae039 = $5469e12161c3c950$var$_xdropRepeatsWith;

});

parcelRegister("kBFkh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f00751d5ee8675f1$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $7fkyx = parcelRequire("7fkyx");

var $lsRaG = parcelRequire("lsRaG");
/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      const l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */ var $f00751d5ee8675f1$var$dropRepeatsWith = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([], (0, $7fkyx.default), function dropRepeatsWith(pred, list) {
    var result = [];
    var idx = 1;
    var len = list.length;
    if (len !== 0) {
        result[0] = list[0];
        while(idx < len){
            if (!pred((0, $lsRaG.default)(result), list[idx])) result[result.length] = list[idx];
            idx += 1;
        }
    }
    return result;
}));
var $f00751d5ee8675f1$export$2e2bcd8739ae039 = $f00751d5ee8675f1$var$dropRepeatsWith;

});
parcelRegister("lsRaG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa05753262093d81$export$2e2bcd8739ae039; });

var $e1w5i = parcelRequire("e1w5i");
/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */ var $fa05753262093d81$var$last = /*#__PURE__*/ (0, $e1w5i.default)(-1);
var $fa05753262093d81$export$2e2bcd8739ae039 = $fa05753262093d81$var$last;

});



parcelRegister("5hmq1", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $9HKDO = parcelRequire("9HKDO");

var $iM9LE = parcelRequire("iM9LE");
/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      const lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 *
 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
 */ var $3d7fee3242384a26$var$dropWhile = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([
    'dropWhile'
], (0, $9HKDO.default), function dropWhile(pred, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && pred(xs[idx]))idx += 1;
    return (0, $iM9LE.default)(idx, Infinity, xs);
}));
var $3d7fee3242384a26$export$2e2bcd8739ae039 = $3d7fee3242384a26$var$dropWhile;

});
parcelRegister("9HKDO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $710c4f2b944e2dc4$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $g1C1K = parcelRequire("g1C1K");
var $710c4f2b944e2dc4$var$XDropWhile = /*#__PURE__*/ function() {
    function XDropWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XDropWhile.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XDropWhile.prototype['@@transducer/result'] = (0, $g1C1K.default).result;
    XDropWhile.prototype['@@transducer/step'] = function(result, input) {
        if (this.f) {
            if (this.f(input)) return result;
            this.f = null;
        }
        return this.xf['@@transducer/step'](result, input);
    };
    return XDropWhile;
}();
var $710c4f2b944e2dc4$var$_xdropWhile = /*#__PURE__*/ (0, $kzrqi.default)(function _xdropWhile(f, xf) {
    return new $710c4f2b944e2dc4$var$XDropWhile(f, xf);
});
var $710c4f2b944e2dc4$export$2e2bcd8739ae039 = $710c4f2b944e2dc4$var$_xdropWhile;

});


parcelRegister("7bCDC", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $iKPBD = parcelRequire("iKPBD");

var $ku3Yl = parcelRequire("ku3Yl");

var $79H4q = parcelRequire("79H4q");
/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.both, R.or
 * @example
 *
 *      const gt10 = x => x > 10;
 *      const even = x => x % 2 === 0;
 *      const f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 *
 *      R.either(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(55)
 *      R.either([false, false, 'a'], [11]) // => [11, 11, "a"]
 */ var $53b78830bbffd297$var$either = /*#__PURE__*/ (0, $kzrqi.default)(function either(f, g) {
    return (0, $iKPBD.default)(f) ? function _either() {
        return f.apply(this, arguments) || g.apply(this, arguments);
    } : (0, $ku3Yl.default)((0, $79H4q.default))(f, g);
});
var $53b78830bbffd297$export$2e2bcd8739ae039 = $53b78830bbffd297$var$either;

});
parcelRegister("79H4q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $535ac890e7aaa13c$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns the first argument if it is truthy, otherwise the second argument.
 * Acts as the boolean `or` statement if both inputs are `Boolean`s.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any}
 * @see R.either, R.and
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */ var $535ac890e7aaa13c$var$or = /*#__PURE__*/ (0, $kzrqi.default)(function or(a, b) {
    return a || b;
});
var $535ac890e7aaa13c$export$2e2bcd8739ae039 = $535ac890e7aaa13c$var$or;

});


parcelRegister("7OXcl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b1b1f6bcd340ab7$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $9JxGp = parcelRequire("9JxGp");

var $hPHpo = parcelRequire("hPHpo");

var $luMT5 = parcelRequire("luMT5");

var $c83uM = parcelRequire("c83uM");

var $exKrE = parcelRequire("exKrE");
/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`),
 * TypedArray (`Uint8Array []`, `Float32Array []`, etc), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));               //=> Nothing()
 *      R.empty([1, 2, 3]);              //=> []
 *      R.empty('unicorns');             //=> ''
 *      R.empty({x: 1, y: 2});           //=> {}
 *      R.empty(Uint8Array.from('123')); //=> Uint8Array []
 */ var $5b1b1f6bcd340ab7$var$empty = /*#__PURE__*/ (0, $ipJAK.default)(function empty(x) {
    return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : (0, $hPHpo.default)(x) ? [] : (0, $c83uM.default)(x) ? '' : (0, $luMT5.default)(x) ? {} : (0, $9JxGp.default)(x) ? function() {
        return arguments;
    }() : (0, $exKrE.default)(x) ? x.constructor.from('') : void 0 // else
    ;
});
var $5b1b1f6bcd340ab7$export$2e2bcd8739ae039 = $5b1b1f6bcd340ab7$var$empty;

});
parcelRegister("exKrE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9682cc1f30f9070$export$2e2bcd8739ae039; });
/**
 * Tests whether or not an object is a typed array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is a typed array, `false` otherwise.
 * @example
 *
 *      _isTypedArray(new Uint8Array([])); //=> true
 *      _isTypedArray(new Float32Array([])); //=> true
 *      _isTypedArray([]); //=> false
 *      _isTypedArray(null); //=> false
 *      _isTypedArray({}); //=> false
 */ function $a9682cc1f30f9070$export$2e2bcd8739ae039(val) {
    var type = Object.prototype.toString.call(val);
    return type === '[object Uint8ClampedArray]' || type === '[object Int8Array]' || type === '[object Uint8Array]' || type === '[object Int16Array]' || type === '[object Uint16Array]' || type === '[object Int32Array]' || type === '[object Uint32Array]' || type === '[object Float32Array]' || type === '[object Float64Array]' || type === '[object BigInt64Array]' || type === '[object BigUint64Array]';
}

});


parcelRegister("dbZiT", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $fcCge = parcelRequire("fcCge");

var $ltqMR = parcelRequire("ltqMR");
/**
 * Checks if a list ends with the provided sublist.
 *
 * Similarly, checks if a string ends with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @see R.startsWith
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var $99abdb0f89c75844$var$endsWith = /*#__PURE__*/ (0, $kzrqi.default)(function(suffix, list) {
    return (0, $fcCge.default)((0, $ltqMR.default)(suffix.length, list), suffix);
});
var $99abdb0f89c75844$export$2e2bcd8739ae039 = $99abdb0f89c75844$var$endsWith;

});
parcelRegister("ltqMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa2115bf222aa8ac$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $4AJH0 = parcelRequire("4AJH0");
/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */ var $fa2115bf222aa8ac$var$takeLast = /*#__PURE__*/ (0, $kzrqi.default)(function takeLast(n, xs) {
    return (0, $4AJH0.default)(n >= 0 ? xs.length - n : 0, xs);
});
var $fa2115bf222aa8ac$export$2e2bcd8739ae039 = $fa2115bf222aa8ac$var$takeLast;

});


parcelRegister("5jZPf", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $fcCge = parcelRequire("fcCge");
/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */ var $3dfeaf64a99b8c81$var$eqBy = /*#__PURE__*/ (0, $5jzlJ.default)(function eqBy(f, x, y) {
    return (0, $fcCge.default)(f(x), f(y));
});
var $3dfeaf64a99b8c81$export$2e2bcd8739ae039 = $3dfeaf64a99b8c81$var$eqBy;

});

parcelRegister("x1v6X", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $fcCge = parcelRequire("fcCge");
/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      const o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      const o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */ var $06343f35749d7c22$var$eqProps = /*#__PURE__*/ (0, $5jzlJ.default)(function eqProps(prop, obj1, obj2) {
    return (0, $fcCge.default)(obj1[prop], obj2[prop]);
});
var $06343f35749d7c22$export$2e2bcd8739ae039 = $06343f35749d7c22$var$eqProps;

});

parcelRegister("c76TO", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $hPHpo = parcelRequire("hPHpo");

var $luMT5 = parcelRequire("luMT5");
/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      const transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */ var $8d1b7d883abde80f$var$evolve = /*#__PURE__*/ (0, $kzrqi.default)(function evolve(transformations, object) {
    if (!(0, $luMT5.default)(object) && !(0, $hPHpo.default)(object)) return object;
    var result = object instanceof Array ? [] : {};
    var transformation, key, type;
    for(key in object){
        transformation = transformations[key];
        type = typeof transformation;
        result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
    }
    return result;
});
var $8d1b7d883abde80f$export$2e2bcd8739ae039 = $8d1b7d883abde80f$var$evolve;

});

parcelRegister("YOl07", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $4iJVv = parcelRequire("4iJVv");
/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */ var $0b6ca6bc1726e9a2$var$find = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([
    'find'
], (0, $4iJVv.default), function find(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return list[idx];
        idx += 1;
    }
}));
var $0b6ca6bc1726e9a2$export$2e2bcd8739ae039 = $0b6ca6bc1726e9a2$var$find;

});
parcelRegister("4iJVv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $321c77e422688b6b$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $1RqCc = parcelRequire("1RqCc");

var $g1C1K = parcelRequire("g1C1K");
var $321c77e422688b6b$var$XFind = /*#__PURE__*/ function() {
    function XFind(f, xf) {
        this.xf = xf;
        this.f = f;
        this.found = false;
    }
    XFind.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XFind.prototype['@@transducer/result'] = function(result) {
        if (!this.found) result = this.xf['@@transducer/step'](result, void 0);
        return this.xf['@@transducer/result'](result);
    };
    XFind.prototype['@@transducer/step'] = function(result, input) {
        if (this.f(input)) {
            this.found = true;
            result = (0, $1RqCc.default)(this.xf['@@transducer/step'](result, input));
        }
        return result;
    };
    return XFind;
}();
var $321c77e422688b6b$var$_xfind = /*#__PURE__*/ (0, $kzrqi.default)(function _xfind(f, xf) {
    return new $321c77e422688b6b$var$XFind(f, xf);
});
var $321c77e422688b6b$export$2e2bcd8739ae039 = $321c77e422688b6b$var$_xfind;

});


parcelRegister("d6JlL", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $iiYFC = parcelRequire("iiYFC");
/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce, R.indexOf
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */ var $98af037e04dbc888$var$findIndex = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([], (0, $iiYFC.default), function findIndex(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return idx;
        idx += 1;
    }
    return -1;
}));
var $98af037e04dbc888$export$2e2bcd8739ae039 = $98af037e04dbc888$var$findIndex;

});
parcelRegister("iiYFC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d538f84dd8ac0c24$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $1RqCc = parcelRequire("1RqCc");

var $g1C1K = parcelRequire("g1C1K");
var $d538f84dd8ac0c24$var$XFindIndex = /*#__PURE__*/ function() {
    function XFindIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.found = false;
    }
    XFindIndex.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XFindIndex.prototype['@@transducer/result'] = function(result) {
        if (!this.found) result = this.xf['@@transducer/step'](result, -1);
        return this.xf['@@transducer/result'](result);
    };
    XFindIndex.prototype['@@transducer/step'] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) {
            this.found = true;
            result = (0, $1RqCc.default)(this.xf['@@transducer/step'](result, this.idx));
        }
        return result;
    };
    return XFindIndex;
}();
var $d538f84dd8ac0c24$var$_xfindIndex = /*#__PURE__*/ (0, $kzrqi.default)(function _xfindIndex(f, xf) {
    return new $d538f84dd8ac0c24$var$XFindIndex(f, xf);
});
var $d538f84dd8ac0c24$export$2e2bcd8739ae039 = $d538f84dd8ac0c24$var$_xfindIndex;

});


parcelRegister("9u3t0", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $hEwgO = parcelRequire("hEwgO");
/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */ var $6e799ad0de7b6746$var$findLast = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([], (0, $hEwgO.default), function findLast(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return list[idx];
        idx -= 1;
    }
}));
var $6e799ad0de7b6746$export$2e2bcd8739ae039 = $6e799ad0de7b6746$var$findLast;

});
parcelRegister("hEwgO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd9f344434e6c778$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $g1C1K = parcelRequire("g1C1K");
var $cd9f344434e6c778$var$XFindLast = /*#__PURE__*/ function() {
    function XFindLast(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFindLast.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XFindLast.prototype['@@transducer/result'] = function(result) {
        return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
    };
    XFindLast.prototype['@@transducer/step'] = function(result, input) {
        if (this.f(input)) this.last = input;
        return result;
    };
    return XFindLast;
}();
var $cd9f344434e6c778$var$_xfindLast = /*#__PURE__*/ (0, $kzrqi.default)(function _xfindLast(f, xf) {
    return new $cd9f344434e6c778$var$XFindLast(f, xf);
});
var $cd9f344434e6c778$export$2e2bcd8739ae039 = $cd9f344434e6c778$var$_xfindLast;

});


parcelRegister("55r0n", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $6f94L = parcelRequire("6f94L");
/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce, R.lastIndexOf
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */ var $3b425e0b101aecae$var$findLastIndex = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([], (0, $6f94L.default), function findLastIndex(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return idx;
        idx -= 1;
    }
    return -1;
}));
var $3b425e0b101aecae$export$2e2bcd8739ae039 = $3b425e0b101aecae$var$findLastIndex;

});
parcelRegister("6f94L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48bb2f0e9ac65e8e$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $g1C1K = parcelRequire("g1C1K");
var $48bb2f0e9ac65e8e$var$XFindLastIndex = /*#__PURE__*/ function() {
    function XFindLastIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.lastIdx = -1;
    }
    XFindLastIndex.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XFindLastIndex.prototype['@@transducer/result'] = function(result) {
        return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
    };
    XFindLastIndex.prototype['@@transducer/step'] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) this.lastIdx = this.idx;
        return result;
    };
    return XFindLastIndex;
}();
var $48bb2f0e9ac65e8e$var$_xfindLastIndex = /*#__PURE__*/ (0, $kzrqi.default)(function _xfindLastIndex(f, xf) {
    return new $48bb2f0e9ac65e8e$var$XFindLastIndex(f, xf);
});
var $48bb2f0e9ac65e8e$export$2e2bcd8739ae039 = $48bb2f0e9ac65e8e$var$_xfindLastIndex;

});


parcelRegister("b68G7", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $i1E9W = parcelRequire("i1E9W");
/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */ var $8146fc945300a9d5$var$flatten = /*#__PURE__*/ (0, $ipJAK.default)(/*#__PURE__*/ (0, $i1E9W.default)(true));
var $8146fc945300a9d5$export$2e2bcd8739ae039 = $8146fc945300a9d5$var$flatten;

});

parcelRegister("6Fx4m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4db0394753ec53d2$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $JtjnN = parcelRequire("JtjnN");
/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      const mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */ var $4db0394753ec53d2$var$flip = /*#__PURE__*/ (0, $ipJAK.default)(function flip(fn) {
    return (0, $JtjnN.default)(fn.length, function(a, b) {
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = b;
        args[1] = a;
        return fn.apply(this, args);
    });
});
var $4db0394753ec53d2$export$2e2bcd8739ae039 = $4db0394753ec53d2$var$flip;

});

parcelRegister("2sBlm", function(module, exports) {

var $jKm5n = parcelRequire("jKm5n");

var $kzrqi = parcelRequire("kzrqi");
/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      const printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */ var $1cab29ef4547d686$var$forEach = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $jKm5n.default)('forEach', function forEach(fn, list) {
    var len = list.length;
    var idx = 0;
    while(idx < len){
        fn(list[idx]);
        idx += 1;
    }
    return list;
}));
var $1cab29ef4547d686$export$2e2bcd8739ae039 = $1cab29ef4547d686$var$forEach;

});

parcelRegister("5o0G8", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $hTLhm = parcelRequire("hTLhm");
/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      const printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */ var $3ebfb869815d200b$var$forEachObjIndexed = /*#__PURE__*/ (0, $kzrqi.default)(function forEachObjIndexed(fn, obj) {
    var keyList = (0, $hTLhm.default)(obj);
    var idx = 0;
    while(idx < keyList.length){
        var key = keyList[idx];
        fn(obj[key], key, obj);
        idx += 1;
    }
    return obj;
});
var $3ebfb869815d200b$export$2e2bcd8739ae039 = $3ebfb869815d200b$var$forEachObjIndexed;

});

parcelRegister("4pVJK", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");
/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */ var $337648925f9bb19e$var$fromPairs = /*#__PURE__*/ (0, $ipJAK.default)(function fromPairs(pairs) {
    var result = {};
    var idx = 0;
    while(idx < pairs.length){
        result[pairs[idx][0]] = pairs[idx][1];
        idx += 1;
    }
    return result;
});
var $337648925f9bb19e$export$2e2bcd8739ae039 = $337648925f9bb19e$var$fromPairs;

});

parcelRegister("7fzAY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54758b9f5f9bf43e$export$2e2bcd8739ae039; });

var $jKm5n = parcelRequire("jKm5n");

var $kzrqi = parcelRequire("kzrqi");

var $7KMMR = parcelRequire("7KMMR");
/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a key-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> {a: [b]}
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.reduceBy, R.transduce, R.indexBy
 * @example
 *
 *      const byGrade = R.groupBy(function(student) {
 *        const score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      const students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */ var $54758b9f5f9bf43e$var$groupBy = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $jKm5n.default)('groupBy', /*#__PURE__*/ (0, $7KMMR.default)(function(acc, item) {
    acc.push(item);
    return acc;
}, [])));
var $54758b9f5f9bf43e$export$2e2bcd8739ae039 = $54758b9f5f9bf43e$var$groupBy;

});

parcelRegister("5UiD2", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * const isVowel = R.test(/^[aeiou]$/i);
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */ var $44d0a1ffcbd04f41$var$groupWith = /*#__PURE__*/ (0, $kzrqi.default)(function(fn, list) {
    var res = [];
    var idx = 0;
    var len = list.length;
    while(idx < len){
        var nextidx = idx + 1;
        while(nextidx < len && fn(list[nextidx - 1], list[nextidx]))nextidx += 1;
        res.push(list.slice(idx, nextidx));
        idx = nextidx;
    }
    return res;
});
var $44d0a1ffcbd04f41$export$2e2bcd8739ae039 = $44d0a1ffcbd04f41$var$groupWith;

});

parcelRegister("dOnMK", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */ var $a0e26520f26290aa$var$gt = /*#__PURE__*/ (0, $kzrqi.default)(function gt(a, b) {
    return a > b;
});
var $a0e26520f26290aa$export$2e2bcd8739ae039 = $a0e26520f26290aa$var$gt;

});

parcelRegister("jZOO5", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */ var $e8eb2005c164b17b$var$gte = /*#__PURE__*/ (0, $kzrqi.default)(function gte(a, b) {
    return a >= b;
});
var $e8eb2005c164b17b$export$2e2bcd8739ae039 = $e8eb2005c164b17b$var$gte;

});

parcelRegister("bKh6Y", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $fbQ2O = parcelRequire("fbQ2O");
/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      const hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      const point = {x: 0, y: 0};
 *      const pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */ var $88d143951114bf25$var$has = /*#__PURE__*/ (0, $kzrqi.default)(function has(prop, obj) {
    return (0, $fbQ2O.default)([
        prop
    ], obj);
});
var $88d143951114bf25$export$2e2bcd8739ae039 = $88d143951114bf25$var$has;

});
parcelRegister("fbQ2O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0f04108b3054962$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $j0Aik = parcelRequire("j0Aik");

var $fa1TG = parcelRequire("fa1TG");
/**
 * Returns whether or not a path exists in an object. Only the object's
 * own properties are checked.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {a} -> Boolean
 * @param {Array} path The path to use.
 * @param {Object} obj The object to check the path in.
 * @return {Boolean} Whether the path exists.
 * @see R.has
 * @example
 *
 *      R.hasPath(['a', 'b'], {a: {b: 2}});         // => true
 *      R.hasPath(['a', 'b'], {a: {b: undefined}}); // => true
 *      R.hasPath(['a', 'b'], {a: {c: 2}});         // => false
 *      R.hasPath(['a', 'b'], {});                  // => false
 */ var $b0f04108b3054962$var$hasPath = /*#__PURE__*/ (0, $kzrqi.default)(function hasPath(_path, obj) {
    if (_path.length === 0 || (0, $fa1TG.default)(obj)) return false;
    var val = obj;
    var idx = 0;
    while(idx < _path.length){
        if (!(0, $fa1TG.default)(val) && (0, $j0Aik.default)(_path[idx], val)) {
            val = val[_path[idx]];
            idx += 1;
        } else return false;
    }
    return true;
});
var $b0f04108b3054962$export$2e2bcd8739ae039 = $b0f04108b3054962$var$hasPath;

});


parcelRegister("fsJjS", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $fa1TG = parcelRequire("fa1TG");
/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      const square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */ var $b41ca00beabf4abb$var$hasIn = /*#__PURE__*/ (0, $kzrqi.default)(function hasIn(prop, obj) {
    if ((0, $fa1TG.default)(obj)) return false;
    return prop in obj;
});
var $b41ca00beabf4abb$export$2e2bcd8739ae039 = $b41ca00beabf4abb$var$hasIn;

});

parcelRegister("575IS", function(module, exports) {

var $pQHse = parcelRequire("pQHse");

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * Note this is merely a curried version of ES6 `Object.is`.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      const o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */ var $3b920ba214eafbee$var$identical = /*#__PURE__*/ (0, $kzrqi.default)((0, $pQHse.default));
var $3b920ba214eafbee$export$2e2bcd8739ae039 = $3b920ba214eafbee$var$identical;

});

parcelRegister("f1Vrt", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $JtjnN = parcelRequire("JtjnN");
/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when, R.cond
 * @example
 *
 *      const incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({ count: 1 }); //=> { count: 2 }
 *      incCount({});           //=> { count: 1 }
 */ var $af1381d63f3bd7ae$var$ifElse = /*#__PURE__*/ (0, $5jzlJ.default)(function ifElse(condition, onTrue, onFalse) {
    return (0, $JtjnN.default)(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
        return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    });
});
var $af1381d63f3bd7ae$export$2e2bcd8739ae039 = $af1381d63f3bd7ae$var$ifElse;

});

parcelRegister("myktw", function(module, exports) {

var $cgwpr = parcelRequire("cgwpr");
/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */ var $043caf42ed9ef66d$var$inc = /*#__PURE__*/ (0, $cgwpr.default)(1);
var $043caf42ed9ef66d$export$2e2bcd8739ae039 = $043caf42ed9ef66d$var$inc;

});

parcelRegister("9OIiA", function(module, exports) {

var $7eI8l = parcelRequire("7eI8l");

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Also works with strings.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.includes(3, [1, 2, 3]); //=> true
 *      R.includes(4, [1, 2, 3]); //=> false
 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.includes([42], [[42]]); //=> true
 *      R.includes('ba', 'banana'); //=>true
 */ var $725b255f8dcc1e67$var$includes = /*#__PURE__*/ (0, $kzrqi.default)((0, $7eI8l.default));
var $725b255f8dcc1e67$export$2e2bcd8739ae039 = $725b255f8dcc1e67$var$includes;

});

parcelRegister("7iYax", function(module, exports) {

var $7KMMR = parcelRequire("7KMMR");
/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> {a: b}
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @see R.groupBy
 * @example
 *
 *      const list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */ var $5518e3244b37dafa$var$indexBy = /*#__PURE__*/ (0, $7KMMR.default)(function(acc, elem) {
    return elem;
}, null);
var $5518e3244b37dafa$export$2e2bcd8739ae039 = $5518e3244b37dafa$var$indexBy;

});

parcelRegister("jnjxT", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $1UKCj = parcelRequire("1UKCj");

var $hPHpo = parcelRequire("hPHpo");
/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf, R.findIndex
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */ var $e1af53a64ee6fc39$var$indexOf = /*#__PURE__*/ (0, $kzrqi.default)(function indexOf(target, xs) {
    return typeof xs.indexOf === 'function' && !(0, $hPHpo.default)(xs) ? xs.indexOf(target) : (0, $1UKCj.default)(xs, target, 0);
});
var $e1af53a64ee6fc39$export$2e2bcd8739ae039 = $e1af53a64ee6fc39$var$indexOf;

});

parcelRegister("dL9Yo", function(module, exports) {

var $iM9LE = parcelRequire("iM9LE");
/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */ var $a0476699bac8bea4$var$init = /*#__PURE__*/ (0, $iM9LE.default)(0, -1);
var $a0476699bac8bea4$export$2e2bcd8739ae039 = $a0476699bac8bea4$var$init;

});

parcelRegister("bqVE9", function(module, exports) {

var $lJiLY = parcelRequire("lJiLY");

var $5jzlJ = parcelRequire("5jzlJ");

var $8ls0t = parcelRequire("8ls0t");
/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */ var $852ed6d4a8d2971a$var$innerJoin = /*#__PURE__*/ (0, $5jzlJ.default)(function innerJoin(pred, xs, ys) {
    return (0, $8ls0t.default)(function(x) {
        return (0, $lJiLY.default)(pred, x, ys);
    }, xs);
});
var $852ed6d4a8d2971a$export$2e2bcd8739ae039 = $852ed6d4a8d2971a$var$innerJoin;

});

parcelRegister("3kl2U", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */ var $26c3909eeb354769$var$insert = /*#__PURE__*/ (0, $5jzlJ.default)(function insert(idx, elt, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    var result = Array.prototype.slice.call(list, 0);
    result.splice(idx, 0, elt);
    return result;
});
var $26c3909eeb354769$export$2e2bcd8739ae039 = $26c3909eeb354769$var$insert;

});

parcelRegister("eJjPa", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */ var $02c476479f4e467e$var$insertAll = /*#__PURE__*/ (0, $5jzlJ.default)(function insertAll(idx, elts, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
});
var $02c476479f4e467e$export$2e2bcd8739ae039 = $02c476479f4e467e$var$insertAll;

});

parcelRegister("gyweu", function(module, exports) {

var $7eI8l = parcelRequire("7eI8l");

var $kzrqi = parcelRequire("kzrqi");

var $8ls0t = parcelRequire("8ls0t");

var $6Fx4m = parcelRequire("6Fx4m");

var $iQtmQ = parcelRequire("iQtmQ");
/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */ var $c0d8d30eadc64972$var$intersection = /*#__PURE__*/ (0, $kzrqi.default)(function intersection(list1, list2) {
    var lookupList, filteredList;
    if (list1.length > list2.length) {
        lookupList = list1;
        filteredList = list2;
    } else {
        lookupList = list2;
        filteredList = list1;
    }
    return (0, $iQtmQ.default)((0, $8ls0t.default)((0, $6Fx4m.default)((0, $7eI8l.default))(lookupList), filteredList));
});
var $c0d8d30eadc64972$export$2e2bcd8739ae039 = $c0d8d30eadc64972$var$intersection;

});
parcelRegister("iQtmQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db83dd16245e629d$export$2e2bcd8739ae039; });

var $ajVWW = parcelRequire("ajVWW");

var $bduSK = parcelRequire("bduSK");
/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */ var $db83dd16245e629d$var$uniq = /*#__PURE__*/ (0, $bduSK.default)((0, $ajVWW.default));
var $db83dd16245e629d$export$2e2bcd8739ae039 = $db83dd16245e629d$var$uniq;

});
parcelRegister("bduSK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82a8dd219cc67b0e$export$2e2bcd8739ae039; });

var $9br0S = parcelRequire("9br0S");

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $1pIuk = parcelRequire("1pIuk");
/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */ var $82a8dd219cc67b0e$var$uniqBy = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([], (0, $1pIuk.default), function(fn, list) {
    var set = new (0, $9br0S.default)();
    var result = [];
    var idx = 0;
    var appliedItem, item;
    while(idx < list.length){
        item = list[idx];
        appliedItem = fn(item);
        if (set.add(appliedItem)) result.push(item);
        idx += 1;
    }
    return result;
}));
var $82a8dd219cc67b0e$export$2e2bcd8739ae039 = $82a8dd219cc67b0e$var$uniqBy;

});
parcelRegister("1pIuk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $107aa2ad255e6ff2$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $9br0S = parcelRequire("9br0S");

var $g1C1K = parcelRequire("g1C1K");
var $107aa2ad255e6ff2$var$XUniqBy = /*#__PURE__*/ function() {
    function XUniqBy(f, xf) {
        this.xf = xf;
        this.f = f;
        this.set = new (0, $9br0S.default)();
    }
    XUniqBy.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XUniqBy.prototype['@@transducer/result'] = (0, $g1C1K.default).result;
    XUniqBy.prototype['@@transducer/step'] = function(result, input) {
        return this.set.add(this.f(input)) ? this.xf['@@transducer/step'](result, input) : result;
    };
    return XUniqBy;
}();
var $107aa2ad255e6ff2$var$_xuniqBy = /*#__PURE__*/ (0, $kzrqi.default)(function _xuniqBy(f, xf) {
    return new $107aa2ad255e6ff2$var$XUniqBy(f, xf);
});
var $107aa2ad255e6ff2$export$2e2bcd8739ae039 = $107aa2ad255e6ff2$var$_xuniqBy;

});




parcelRegister("WRGgp", function(module, exports) {

var $jKm5n = parcelRequire("jKm5n");

var $kzrqi = parcelRequire("kzrqi");
/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('a', ['b', 'n', 'n', 's']); //=> ['b', 'a', 'n', 'a', 'n', 'a', 's']
 */ var $0b0f0ec1f689d4b7$var$intersperse = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $jKm5n.default)('intersperse', function intersperse(separator, list) {
    var out = [];
    var idx = 0;
    var length = list.length;
    while(idx < length){
        if (idx === length - 1) out.push(list[idx]);
        else out.push(list[idx], separator);
        idx += 1;
    }
    return out;
}));
var $0b0f0ec1f689d4b7$export$2e2bcd8739ae039 = $0b0f0ec1f689d4b7$var$intersperse;

});

parcelRegister("035tu", function(module, exports) {

var $beT6k = parcelRequire("beT6k");

var $5jzlJ = parcelRequire("5jzlJ");

var $xbtfT = parcelRequire("xbtfT");

var $5bmcu = parcelRequire("5bmcu");

var $iox14 = parcelRequire("iox14");
/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.transduce
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      const intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */ var $000265469c92ab26$var$into = /*#__PURE__*/ (0, $5jzlJ.default)(function into(acc, xf, list) {
    return (0, $xbtfT.default)(acc) ? (0, $5bmcu.default)(xf(acc), acc['@@transducer/init'](), list) : (0, $5bmcu.default)(xf((0, $iox14.default)(acc)), (0, $beT6k.default)(acc, [], [], false), list);
});
var $000265469c92ab26$export$2e2bcd8739ae039 = $000265469c92ab26$var$into;

});
parcelRegister("iox14", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6441437d7cd0927$export$2e2bcd8739ae039; });

var $9xq8h = parcelRequire("9xq8h");

var $luM0J = parcelRequire("luM0J");

var $gXj9X = parcelRequire("gXj9X");

var $xbtfT = parcelRequire("xbtfT");

var $kmmHy = parcelRequire("kmmHy");
var $d6441437d7cd0927$var$_stepCatArray = {
    '@@transducer/init': Array,
    '@@transducer/step': function(xs, x) {
        xs.push(x);
        return xs;
    },
    '@@transducer/result': (0, $luM0J.default)
};
var $d6441437d7cd0927$var$_stepCatString = {
    '@@transducer/init': String,
    '@@transducer/step': function(a, b) {
        return a + b;
    },
    '@@transducer/result': (0, $luM0J.default)
};
var $d6441437d7cd0927$var$_stepCatObject = {
    '@@transducer/init': Object,
    '@@transducer/step': function(result, input) {
        return (0, $9xq8h.default)(result, (0, $gXj9X.default)(input) ? (0, $kmmHy.default)(input[0], input[1]) : input);
    },
    '@@transducer/result': (0, $luM0J.default)
};
function $d6441437d7cd0927$export$2e2bcd8739ae039(obj) {
    if ((0, $xbtfT.default)(obj)) return obj;
    if ((0, $gXj9X.default)(obj)) return $d6441437d7cd0927$var$_stepCatArray;
    if (typeof obj === 'string') return $d6441437d7cd0927$var$_stepCatString;
    if (typeof obj === 'object') return $d6441437d7cd0927$var$_stepCatObject;
    throw new Error('Cannot create transformer for ' + obj);
}

});
parcelRegister("9xq8h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f1b777b27ab512f$export$2e2bcd8739ae039; });

var $j0Aik = parcelRequire("j0Aik");
function $6f1b777b27ab512f$var$_objectAssign(target) {
    if (target == null) throw new TypeError('Cannot convert undefined or null to object');
    var output = Object(target);
    var idx = 1;
    var length = arguments.length;
    while(idx < length){
        var source = arguments[idx];
        if (source != null) {
            for(var nextKey in source)if ((0, $j0Aik.default)(nextKey, source)) output[nextKey] = source[nextKey];
        }
        idx += 1;
    }
    return output;
}
var $6f1b777b27ab512f$export$2e2bcd8739ae039 = typeof Object.assign === 'function' ? Object.assign : $6f1b777b27ab512f$var$_objectAssign;

});

parcelRegister("kmmHy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed2778c2ef4a4320$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");
/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      const matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */ var $ed2778c2ef4a4320$var$objOf = /*#__PURE__*/ (0, $kzrqi.default)(function objOf(key, val) {
    var obj = {};
    obj[key] = val;
    return obj;
});
var $ed2778c2ef4a4320$export$2e2bcd8739ae039 = $ed2778c2ef4a4320$var$objOf;

});



parcelRegister("DoxXZ", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $j0Aik = parcelRequire("j0Aik");

var $hTLhm = parcelRequire("hTLhm");
/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      const raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */ var $0766af2031cc1ba1$var$invert = /*#__PURE__*/ (0, $ipJAK.default)(function invert(obj) {
    var props = (0, $hTLhm.default)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        var val = obj[key];
        var list = (0, $j0Aik.default)(val, out) ? out[val] : out[val] = [];
        list[list.length] = key;
        idx += 1;
    }
    return out;
});
var $0766af2031cc1ba1$export$2e2bcd8739ae039 = $0766af2031cc1ba1$var$invert;

});

parcelRegister("ePygc", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $hTLhm = parcelRequire("hTLhm");
/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      const raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      const raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */ var $acc0677914107a54$var$invertObj = /*#__PURE__*/ (0, $ipJAK.default)(function invertObj(obj) {
    var props = (0, $hTLhm.default)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        out[obj[key]] = key;
        idx += 1;
    }
    return out;
});
var $acc0677914107a54$export$2e2bcd8739ae039 = $acc0677914107a54$var$invertObj;

});

parcelRegister("ls3ln", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9dece7fbed58533$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $iKPBD = parcelRequire("iKPBD");

var $JtjnN = parcelRequire("JtjnN");

var $jQHxm = parcelRequire("jQHxm");
/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of any of the target object's methods to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      const sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      const sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 *
 *      const dog = {
 *        speak: async () => 'Woof!'
 *      };
 *      const speak = R.invoker(0, 'speak');
 *      speak(dog).then(console.log) //~> 'Woof!'
 *
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */ var $f9dece7fbed58533$var$invoker = /*#__PURE__*/ (0, $kzrqi.default)(function invoker(arity, method) {
    return (0, $JtjnN.default)(arity + 1, function() {
        var target = arguments[arity];
        if (target != null && (0, $iKPBD.default)(target[method])) return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
        throw new TypeError((0, $jQHxm.default)(target) + ' does not have a method named "' + method + '"');
    });
});
var $f9dece7fbed58533$export$2e2bcd8739ae039 = $f9dece7fbed58533$var$invoker;

});

parcelRegister("1tSOd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $114303c5171a10e9$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");
/**
 * See if an object (i.e. `val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 * If `val` was created using `Object.create`, `R.is(Object, val) === true`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */ var $114303c5171a10e9$var$is = /*#__PURE__*/ (0, $kzrqi.default)(function is(Ctor, val) {
    return val instanceof Ctor || val != null && (val.constructor === Ctor || Ctor.name === 'Object' && typeof val === 'object');
});
var $114303c5171a10e9$export$2e2bcd8739ae039 = $114303c5171a10e9$var$is;

});

parcelRegister("3CpG8", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $7OXcl = parcelRequire("7OXcl");

var $fcCge = parcelRequire("fcCge");
/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);           //=> false
 *      R.isEmpty([]);                  //=> true
 *      R.isEmpty('');                  //=> true
 *      R.isEmpty(null);                //=> false
 *      R.isEmpty({});                  //=> true
 *      R.isEmpty({length: 0});         //=> false
 *      R.isEmpty(Uint8Array.from('')); //=> true
 */ var $2a28d6f16572af17$var$isEmpty = /*#__PURE__*/ (0, $ipJAK.default)(function isEmpty(x) {
    return x != null && (0, $fcCge.default)(x, (0, $7OXcl.default)(x));
});
var $2a28d6f16572af17$export$2e2bcd8739ae039 = $2a28d6f16572af17$var$isEmpty;

});

parcelRegister("1U5gw", function(module, exports) {

var $ls3ln = parcelRequire("ls3ln");
/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      const spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */ var $162f1b050229c695$var$join = /*#__PURE__*/ (0, $ls3ln.default)(1, 'join');
var $162f1b050229c695$export$2e2bcd8739ae039 = $162f1b050229c695$var$join;

});

parcelRegister("geMRr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd23dae713ebc902$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $4IXwC = parcelRequire("4IXwC");
/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      const getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */ var $bd23dae713ebc902$var$juxt = /*#__PURE__*/ (0, $ipJAK.default)(function juxt(fns) {
    return (0, $4IXwC.default)(function() {
        return Array.prototype.slice.call(arguments, 0);
    }, fns);
});
var $bd23dae713ebc902$export$2e2bcd8739ae039 = $bd23dae713ebc902$var$juxt;

});

parcelRegister("ki3DX", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");
/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */ var $ec58509bb3f641d3$var$keysIn = /*#__PURE__*/ (0, $ipJAK.default)(function keysIn(obj) {
    var prop;
    var ks = [];
    for(prop in obj)ks[ks.length] = prop;
    return ks;
});
var $ec58509bb3f641d3$export$2e2bcd8739ae039 = $ec58509bb3f641d3$var$keysIn;

});

parcelRegister("7HguE", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $hPHpo = parcelRequire("hPHpo");

var $fcCge = parcelRequire("fcCge");
/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf, R.findLastIndex
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */ var $59a957cc5eb1b501$var$lastIndexOf = /*#__PURE__*/ (0, $kzrqi.default)(function lastIndexOf(target, xs) {
    if (typeof xs.lastIndexOf === 'function' && !(0, $hPHpo.default)(xs)) return xs.lastIndexOf(target);
    else {
        var idx = xs.length - 1;
        while(idx >= 0){
            if ((0, $fcCge.default)(xs[idx], target)) return idx;
            idx -= 1;
        }
        return -1;
    }
});
var $59a957cc5eb1b501$export$2e2bcd8739ae039 = $59a957cc5eb1b501$var$lastIndexOf;

});

parcelRegister("ltDJX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa2b21fa1f89e5b5$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $1bB5u = parcelRequire("1bB5u");
/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */ var $fa2b21fa1f89e5b5$var$length = /*#__PURE__*/ (0, $ipJAK.default)(function length(list) {
    return list != null && (0, $1bB5u.default)(list.length) ? list.length : NaN;
});
var $fa2b21fa1f89e5b5$export$2e2bcd8739ae039 = $fa2b21fa1f89e5b5$var$length;

});
parcelRegister("1bB5u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dd396593958a6b6$export$2e2bcd8739ae039; });
function $0dd396593958a6b6$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === '[object Number]';
}

});


parcelRegister("4kYXk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32885047a38cc0f9$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $9QW5G = parcelRequire("9QW5G");
/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var $32885047a38cc0f9$var$lens = /*#__PURE__*/ (0, $kzrqi.default)(function lens(getter, setter) {
    return function(toFunctorFn) {
        return function(target) {
            return (0, $9QW5G.default)(function(focus) {
                return setter(focus, target);
            }, toFunctorFn(getter(target)));
        };
    };
});
var $32885047a38cc0f9$export$2e2bcd8739ae039 = $32885047a38cc0f9$var$lens;

});

parcelRegister("bojgq", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $4kYXk = parcelRequire("4kYXk");

var $e1w5i = parcelRequire("e1w5i");

var $97POB = parcelRequire("97POB");
/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over, R.nth
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */ var $84b0e10814fd21e9$var$lensIndex = /*#__PURE__*/ (0, $ipJAK.default)(function lensIndex(n) {
    return (0, $4kYXk.default)((0, $e1w5i.default)(n), (0, $97POB.default)(n));
});
var $84b0e10814fd21e9$export$2e2bcd8739ae039 = $84b0e10814fd21e9$var$lensIndex;

});
parcelRegister("97POB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a4cf5f145ad83bf$export$2e2bcd8739ae039; });

var $5jzlJ = parcelRequire("5jzlJ");

var $j6zVR = parcelRequire("j6zVR");

var $gVgoT = parcelRequire("gVgoT");
/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, '_', ['a', 'b', 'c']);      //=> ['a', '_', 'c']
 *      R.update(-1, '_', ['a', 'b', 'c']);     //=> ['a', 'b', '_']
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */ var $6a4cf5f145ad83bf$var$update = /*#__PURE__*/ (0, $5jzlJ.default)(function update(idx, x, list) {
    return (0, $j6zVR.default)(idx, (0, $gVgoT.default)(x), list);
});
var $6a4cf5f145ad83bf$export$2e2bcd8739ae039 = $6a4cf5f145ad83bf$var$update;

});


parcelRegister("9Kx3i", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $7BBob = parcelRequire("7BBob");

var $4kYXk = parcelRequire("4kYXk");

var $1DUp6 = parcelRequire("1DUp6");
/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */ var $71920c6798d38b9d$var$lensPath = /*#__PURE__*/ (0, $ipJAK.default)(function lensPath(p) {
    return (0, $4kYXk.default)((0, $1DUp6.default)(p), (0, $7BBob.default)(p));
});
var $71920c6798d38b9d$export$2e2bcd8739ae039 = $71920c6798d38b9d$var$lensPath;

});
parcelRegister("1DUp6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13252f92f3e0e640$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $gW67G = parcelRequire("gW67G");
/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop, R.nth
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 *      R.path(['a', 'b', 0], {a: {b: [1, 2, 3]}}); //=> 1
 *      R.path(['a', 'b', -2], {a: {b: [1, 2, 3]}}); //=> 2
 */ var $13252f92f3e0e640$var$path = /*#__PURE__*/ (0, $kzrqi.default)(function path(pathAr, obj) {
    return (0, $gW67G.default)([
        pathAr
    ], obj)[0];
});
var $13252f92f3e0e640$export$2e2bcd8739ae039 = $13252f92f3e0e640$var$path;

});
parcelRegister("gW67G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c546cffe8cdca769$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $3WvPT = parcelRequire("3WvPT");

var $e1w5i = parcelRequire("e1w5i");
/**
 * Retrieves the values at given paths of an object.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Object
 * @typedefn Idx = [String | Int | Symbol]
 * @sig [Idx] -> {a} -> [a | Undefined]
 * @param {Array} pathsArray The array of paths to be fetched.
 * @param {Object} obj The object to retrieve the nested properties from.
 * @return {Array} A list consisting of values at paths specified by "pathsArray".
 * @see R.path
 * @example
 *
 *      R.paths([['a', 'b'], ['p', 0, 'q']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, 3]
 *      R.paths([['a', 'b'], ['p', 'r']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, undefined]
 */ var $c546cffe8cdca769$var$paths = /*#__PURE__*/ (0, $kzrqi.default)(function paths(pathsArray, obj) {
    return pathsArray.map(function(paths) {
        var val = obj;
        var idx = 0;
        var p;
        while(idx < paths.length){
            if (val == null) return;
            p = paths[idx];
            val = (0, $3WvPT.default)(p) ? (0, $e1w5i.default)(p, val) : val[p];
            idx += 1;
        }
        return val;
    });
});
var $c546cffe8cdca769$export$2e2bcd8739ae039 = $c546cffe8cdca769$var$paths;

});



parcelRegister("3HiY6", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $eCXNe = parcelRequire("eCXNe");

var $4kYXk = parcelRequire("4kYXk");

var $K4FLv = parcelRequire("K4FLv");
/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var $2b1419fb47fe86cb$var$lensProp = /*#__PURE__*/ (0, $ipJAK.default)(function lensProp(k) {
    return (0, $4kYXk.default)((0, $K4FLv.default)(k), (0, $eCXNe.default)(k));
});
var $2b1419fb47fe86cb$export$2e2bcd8739ae039 = $2b1419fb47fe86cb$var$lensProp;

});

parcelRegister("f7TD6", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */ var $b032a95ce7c5fd4f$var$lt = /*#__PURE__*/ (0, $kzrqi.default)(function lt(a, b) {
    return a < b;
});
var $b032a95ce7c5fd4f$export$2e2bcd8739ae039 = $b032a95ce7c5fd4f$var$lt;

});

parcelRegister("9JWXX", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */ var $71760e70e828099d$var$lte = /*#__PURE__*/ (0, $kzrqi.default)(function lte(a, b) {
    return a <= b;
});
var $71760e70e828099d$export$2e2bcd8739ae039 = $71760e70e828099d$var$lte;

});

parcelRegister("kBkev", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.scan, R.addIndex, R.mapAccumRight
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */ var $eff6f52fcc75e125$var$mapAccum = /*#__PURE__*/ (0, $5jzlJ.default)(function mapAccum(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx < len){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx += 1;
    }
    return [
        tuple[0],
        result
    ];
});
var $eff6f52fcc75e125$export$2e2bcd8739ae039 = $eff6f52fcc75e125$var$mapAccum;

});

parcelRegister("9bu8v", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [b + a, b + a];
 *
 *      R.mapAccumRight(appender, 5, digits); //=> ['12345', ['12345', '2345', '345', '45']]
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   f(f(f(a, d)[0], c)[0], b)[0],
 *   [
 *     f(a, d)[1],
 *     f(f(a, d)[0], c)[1],
 *     f(f(f(a, d)[0], c)[0], b)[1]
 *   ]
 * ]
 */ var $6afc848c41aff96b$var$mapAccumRight = /*#__PURE__*/ (0, $5jzlJ.default)(function mapAccumRight(fn, acc, list) {
    var idx = list.length - 1;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx >= 0){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx -= 1;
    }
    return [
        tuple[0],
        result
    ];
});
var $6afc848c41aff96b$export$2e2bcd8739ae039 = $6afc848c41aff96b$var$mapAccumRight;

});

parcelRegister("i3puR", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $5bmcu = parcelRequire("5bmcu");

var $hTLhm = parcelRequire("hTLhm");
/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      const xyz = { x: 1, y: 2, z: 3 };
 *      const prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, xyz); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */ var $d24c48ecd6da0f65$var$mapObjIndexed = /*#__PURE__*/ (0, $kzrqi.default)(function mapObjIndexed(fn, obj) {
    return (0, $5bmcu.default)(function(acc, key) {
        acc[key] = fn(obj[key], key, obj);
        return acc;
    }, {}, (0, $hTLhm.default)(obj));
});
var $d24c48ecd6da0f65$export$2e2bcd8739ae039 = $d24c48ecd6da0f65$var$mapObjIndexed;

});

parcelRegister("1ALPQ", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */ var $128e424dd41b09df$var$match = /*#__PURE__*/ (0, $kzrqi.default)(function match(rx, str) {
    return str.match(rx) || [];
});
var $128e424dd41b09df$export$2e2bcd8739ae039 = $128e424dd41b09df$var$match;

});

parcelRegister("5l2sg", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $3WvPT = parcelRequire("3WvPT");
/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      const clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      const seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */ var $3e30d16b6d1dfc4b$var$mathMod = /*#__PURE__*/ (0, $kzrqi.default)(function mathMod(m, p) {
    if (!(0, $3WvPT.default)(m)) return NaN;
    if (!(0, $3WvPT.default)(p) || p < 1) return NaN;
    return (m % p + p) % p;
});
var $3e30d16b6d1dfc4b$export$2e2bcd8739ae039 = $3e30d16b6d1dfc4b$var$mathMod;

});

parcelRegister("f6T7u", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */ var $b0022c305a512c25$var$maxBy = /*#__PURE__*/ (0, $5jzlJ.default)(function maxBy(f, a, b) {
    return f(b) > f(a) ? b : a;
});
var $b0022c305a512c25$export$2e2bcd8739ae039 = $b0022c305a512c25$var$maxBy;

});

parcelRegister("gGwoh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c259b1a976338579$export$2e2bcd8739ae039; });

var $ipJAK = parcelRequire("ipJAK");

var $7UORx = parcelRequire("7UORx");
/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */ var $c259b1a976338579$var$mean = /*#__PURE__*/ (0, $ipJAK.default)(function mean(list) {
    return (0, $7UORx.default)(list) / list.length;
});
var $c259b1a976338579$export$2e2bcd8739ae039 = $c259b1a976338579$var$mean;

});
parcelRegister("7UORx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c35379cbfe803f4$export$2e2bcd8739ae039; });

var $cgwpr = parcelRequire("cgwpr");

var $5bThN = parcelRequire("5bThN");
/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */ var $5c35379cbfe803f4$var$sum = /*#__PURE__*/ (0, $5bThN.default)((0, $cgwpr.default), 0);
var $5c35379cbfe803f4$export$2e2bcd8739ae039 = $5c35379cbfe803f4$var$sum;

});


parcelRegister("e4RRO", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $gGwoh = parcelRequire("gGwoh");
/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */ var $a3fb3942dc222f2d$var$median = /*#__PURE__*/ (0, $ipJAK.default)(function median(list) {
    var len = list.length;
    if (len === 0) return NaN;
    var width = 2 - len % 2;
    var idx = (len - width) / 2;
    return (0, $gGwoh.default)(Array.prototype.slice.call(list, 0).sort(function(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }).slice(idx, idx + width));
});
var $a3fb3942dc222f2d$export$2e2bcd8739ae039 = $a3fb3942dc222f2d$var$median;

});

parcelRegister("1xxco", function(module, exports) {

var $72SzR = parcelRequire("72SzR");

var $kzrqi = parcelRequire("kzrqi");

var $j0Aik = parcelRequire("j0Aik");
/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 * Care must be taken when implementing key generation to avoid key collision,
 * or if tracking references, memory leaks and mutating arguments.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(Number, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */ var $11f2a01f1acd84f0$var$memoizeWith = /*#__PURE__*/ (0, $kzrqi.default)(function memoizeWith(mFn, fn) {
    var cache = {};
    return (0, $72SzR.default)(fn.length, function() {
        var key = mFn.apply(this, arguments);
        if (!(0, $j0Aik.default)(key, cache)) cache[key] = fn.apply(this, arguments);
        return cache[key];
    });
});
var $11f2a01f1acd84f0$export$2e2bcd8739ae039 = $11f2a01f1acd84f0$var$memoizeWith;

});

parcelRegister("jzA5q", function(module, exports) {

var $9xq8h = parcelRequire("9xq8h");

var $ipJAK = parcelRequire("ipJAK");
/**
 * Creates one new object with the own properties from a list of objects.
 * If a key exists in more than one object, the value from the last
 * object it exists in will be used.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */ var $e3fd473810365de7$var$mergeAll = /*#__PURE__*/ (0, $ipJAK.default)(function mergeAll(list) {
    return (0, $9xq8h.default).apply(null, [
        {}
    ].concat(list));
});
var $e3fd473810365de7$export$2e2bcd8739ae039 = $e3fd473810365de7$var$mergeAll;

});

parcelRegister("1nLUP", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $5YFJr = parcelRequire("5YFJr");
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var $101d1b7d6b75987f$var$mergeDeepLeft = /*#__PURE__*/ (0, $kzrqi.default)(function mergeDeepLeft(lObj, rObj) {
    return (0, $5YFJr.default)(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
var $101d1b7d6b75987f$export$2e2bcd8739ae039 = $101d1b7d6b75987f$var$mergeDeepLeft;

});
parcelRegister("5YFJr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45a2ed6ea84dd633$export$2e2bcd8739ae039; });

var $5jzlJ = parcelRequire("5jzlJ");

var $luMT5 = parcelRequire("luMT5");

var $GMQzj = parcelRequire("GMQzj");
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $45a2ed6ea84dd633$var$mergeDeepWithKey = /*#__PURE__*/ (0, $5jzlJ.default)(function mergeDeepWithKey(fn, lObj, rObj) {
    return (0, $GMQzj.default)(function(k, lVal, rVal) {
        if ((0, $luMT5.default)(lVal) && (0, $luMT5.default)(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
var $45a2ed6ea84dd633$export$2e2bcd8739ae039 = $45a2ed6ea84dd633$var$mergeDeepWithKey;

});
parcelRegister("GMQzj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0809d054d8d6e3ac$export$2e2bcd8739ae039; });

var $5jzlJ = parcelRequire("5jzlJ");

var $j0Aik = parcelRequire("j0Aik");
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $0809d054d8d6e3ac$var$mergeWithKey = /*#__PURE__*/ (0, $5jzlJ.default)(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    for(k in l)if ((0, $j0Aik.default)(k, l)) result[k] = (0, $j0Aik.default)(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ((0, $j0Aik.default)(k, r) && !(0, $j0Aik.default)(k, result)) result[k] = r[k];
    return result;
});
var $0809d054d8d6e3ac$export$2e2bcd8739ae039 = $0809d054d8d6e3ac$var$mergeWithKey;

});



parcelRegister("aEGOK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c1eda73af14d428$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $5YFJr = parcelRequire("5YFJr");
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */ var $7c1eda73af14d428$var$mergeDeepRight = /*#__PURE__*/ (0, $kzrqi.default)(function mergeDeepRight(lObj, rObj) {
    return (0, $5YFJr.default)(function(k, lVal, rVal) {
        return rVal;
    }, lObj, rObj);
});
var $7c1eda73af14d428$export$2e2bcd8739ae039 = $7c1eda73af14d428$var$mergeDeepRight;

});

parcelRegister("aXtGg", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $5YFJr = parcelRequire("5YFJr");
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */ var $7fa6700f8a1304d1$var$mergeDeepWith = /*#__PURE__*/ (0, $5jzlJ.default)(function mergeDeepWith(fn, lObj, rObj) {
    return (0, $5YFJr.default)(function(k, lVal, rVal) {
        return fn(lVal, rVal);
    }, lObj, rObj);
});
var $7fa6700f8a1304d1$export$2e2bcd8739ae039 = $7fa6700f8a1304d1$var$mergeDeepWith;

});

parcelRegister("fKqBY", function(module, exports) {

var $9xq8h = parcelRequire("9xq8h");

var $kzrqi = parcelRequire("kzrqi");
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepLeft, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeLeft({ 'age': 40 }, { 'name': 'fred', 'age': 10 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const resetToDefault = R.mergeLeft({x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeLeft(a, b) = {...b, ...a}
 */ var $b76fcb64abada078$var$mergeLeft = /*#__PURE__*/ (0, $kzrqi.default)(function mergeLeft(l, r) {
    return (0, $9xq8h.default)({}, r, l);
});
var $b76fcb64abada078$export$2e2bcd8739ae039 = $b76fcb64abada078$var$mergeLeft;

});

parcelRegister("7Asj5", function(module, exports) {

var $9xq8h = parcelRequire("9xq8h");

var $kzrqi = parcelRequire("kzrqi");
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeLeft, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeRight({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.mergeRight({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeRight(a, b) = {...a, ...b}
 */ var $5861da596eaf82c6$var$mergeRight = /*#__PURE__*/ (0, $kzrqi.default)(function mergeRight(l, r) {
    return (0, $9xq8h.default)({}, l, r);
});
var $5861da596eaf82c6$export$2e2bcd8739ae039 = $5861da596eaf82c6$var$mergeRight;

});

parcelRegister("iCZ3W", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $GMQzj = parcelRequire("GMQzj");
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */ var $d8fb245a26d85a75$var$mergeWith = /*#__PURE__*/ (0, $5jzlJ.default)(function mergeWith(fn, l, r) {
    return (0, $GMQzj.default)(function(_, _l, _r) {
        return fn(_l, _r);
    }, l, r);
});
var $d8fb245a26d85a75$export$2e2bcd8739ae039 = $d8fb245a26d85a75$var$mergeWith;

});

parcelRegister("c9VMe", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */ var $8da3249bf1257005$var$min = /*#__PURE__*/ (0, $kzrqi.default)(function min(a, b) {
    return b < a ? b : a;
});
var $8da3249bf1257005$export$2e2bcd8739ae039 = $8da3249bf1257005$var$min;

});

parcelRegister("bZMar", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */ var $8bbac1415e1eea25$var$minBy = /*#__PURE__*/ (0, $5jzlJ.default)(function minBy(f, a, b) {
    return f(b) < f(a) ? b : a;
});
var $8bbac1415e1eea25$export$2e2bcd8739ae039 = $8bbac1415e1eea25$var$minBy;

});

parcelRegister("d4Kq8", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $cUhgb = parcelRequire("cUhgb");
/**
 * Creates a copy of the passed object by applying an `fn` function to the given `prop` property.
 *
 * The function will not be invoked, and the object will not change
 * if its corresponding property does not exist in the object.
 * All non-primitive properties are copied to the new object by reference.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig Idx -> (v -> v) -> {k: v} -> {k: v}
 * @param {String|Number} prop The property to be modified.
 * @param {Function} fn The function to apply to the property.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const person = {name: 'James', age: 20, pets: ['dog', 'cat']};
 *      R.modify('age', R.add(1), person); //=> {name: 'James', age: 21, pets: ['dog', 'cat']}
 *      R.modify('pets', R.append('turtle'), person); //=> {name: 'James', age: 20, pets: ['dog', 'cat', 'turtle']}
 */ var $984fa83d74aee22f$var$modify = /*#__PURE__*/ (0, $5jzlJ.default)(function modify(prop, fn, object) {
    return (0, $cUhgb.default)([
        prop
    ], fn, object);
});
var $984fa83d74aee22f$export$2e2bcd8739ae039 = $984fa83d74aee22f$var$modify;

});
parcelRegister("cUhgb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96581a75086bdb6c$export$2e2bcd8739ae039; });

var $5jzlJ = parcelRequire("5jzlJ");

var $hPHpo = parcelRequire("hPHpo");

var $luMT5 = parcelRequire("luMT5");

var $j0Aik = parcelRequire("j0Aik");

var $5XpxN = parcelRequire("5XpxN");

var $edhhc = parcelRequire("edhhc");
/**
 * Creates a shallow clone of the passed object by applying an `fn` function
 * to the value at the given path.
 *
 * The function will not be invoked, and the object will not change
 * if its corresponding path does not exist in the object.
 * All non-primitive properties are copied to the new object by reference.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig [Idx] -> (v -> v) -> {k: v} -> {k: v}
 * @param {Array} path The path to be modified.
 * @param {Function} fn The function to apply to the path.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const person = {name: 'James', address: { zipCode: '90216' }};
 *      R.modifyPath(['address', 'zipCode'], R.reverse, person); //=> {name: 'James', address: { zipCode: '61209' }}
 *
 *      // Can handle arrays too
 *      const person = {name: 'James', addresses: [{ zipCode: '90216' }]};
 *      R.modifyPath(['addresses', 0, 'zipCode'], R.reverse, person); //=> {name: 'James', addresses: [{ zipCode: '61209' }]}
 */ var $96581a75086bdb6c$var$modifyPath = /*#__PURE__*/ (0, $5jzlJ.default)(function modifyPath(path, fn, object) {
    if (!(0, $luMT5.default)(object) && !(0, $hPHpo.default)(object) || path.length === 0) return object;
    var idx = path[0];
    if (!(0, $j0Aik.default)(idx, object)) return object;
    if (path.length === 1) return (0, $edhhc.default)(idx, fn, object);
    var val = modifyPath(Array.prototype.slice.call(path, 1), fn, object[idx]);
    if (val === object[idx]) return object;
    return (0, $5XpxN.default)(idx, val, object);
});
var $96581a75086bdb6c$export$2e2bcd8739ae039 = $96581a75086bdb6c$var$modifyPath;

});
parcelRegister("edhhc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a58fae522bd14f83$export$2e2bcd8739ae039; });

var $hPHpo = parcelRequire("hPHpo");

var $3WvPT = parcelRequire("3WvPT");
function $a58fae522bd14f83$export$2e2bcd8739ae039(prop, fn, obj) {
    if ((0, $3WvPT.default)(prop) && (0, $hPHpo.default)(obj)) {
        var arr = [].concat(obj);
        arr[prop] = fn(arr[prop]);
        return arr;
    }
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = fn(result[prop]);
    return result;
}

});



parcelRegister("fVhw8", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      const isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */ var $b979c478d82de8f2$var$modulo = /*#__PURE__*/ (0, $kzrqi.default)(function modulo(a, b) {
    return a % b;
});
var $b979c478d82de8f2$export$2e2bcd8739ae039 = $b979c478d82de8f2$var$modulo;

});

parcelRegister("ffUgI", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Move an item, at index `from`, to index `to`, in a list of elements.
 * A new list will be created containing the new elements order.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} from The source index
 * @param {Number} to The destination index
 * @param {Array} list The list which will serve to realise the move
 * @return {Array} The new list reordered
 * @example
 *
 *      R.move(0, 2, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['b', 'c', 'a', 'd', 'e', 'f']
 *      R.move(-1, 0, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['f', 'a', 'b', 'c', 'd', 'e'] list rotation
 */ var $b1b3e7862df92b73$var$move = /*#__PURE__*/ (0, $5jzlJ.default)(function(from, to, list) {
    var length = list.length;
    var result = list.slice();
    var positiveFrom = from < 0 ? length + from : from;
    var positiveTo = to < 0 ? length + to : to;
    var item = result.splice(positiveFrom, 1);
    return positiveFrom < 0 || positiveFrom >= list.length || positiveTo < 0 || positiveTo >= list.length ? list : [].concat(result.slice(0, positiveTo)).concat(item).concat(result.slice(positiveTo, list.length));
});
var $b1b3e7862df92b73$export$2e2bcd8739ae039 = $b1b3e7862df92b73$var$move;

});

parcelRegister("cKDKE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94889db2550a0862$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");
/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      const double = R.multiply(2);
 *      const triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */ var $94889db2550a0862$var$multiply = /*#__PURE__*/ (0, $kzrqi.default)(function multiply(a, b) {
    return a * b;
});
var $94889db2550a0862$export$2e2bcd8739ae039 = $94889db2550a0862$var$multiply;

});

parcelRegister("25BZy", function(module, exports) {

var $aEGOK = parcelRequire("aEGOK");

var $kzrqi = parcelRequire("kzrqi");
var /**
 * Takes a function `f` and an object, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the object
 * provided initially merged deeply (right) with the object provided as an argument to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Function
 * @sig (({ a, b, c, ..., n }) -> x) -> { a, b, c, ...} -> ({ d, e, f, ..., n } -> x)
 * @param {Function} f
 * @param {Object} props
 * @return {Function}
 * @see R.partial, R.partialRight, R.curry, R.mergeDeepRight
 * @example
 *
 *      const multiply2 = ({ a, b }) => a * b;
 *      const double = R.partialObject(multiply2, { a: 2 });
 *      double({ b: 2 }); //=> 4
 *
 *      const greet = ({ salutation, title, firstName, lastName }) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const sayHello = R.partialObject(greet, { salutation: 'Hello' });
 *      const sayHelloToMs = R.partialObject(sayHello, { title: 'Ms.' });
 *      sayHelloToMs({ firstName: 'Jane', lastName: 'Jones' }); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialObject(f, { a, b })({ c, d }) = f({ a, b, c, d })
 */ $185984c57219628f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $kzrqi.default)((f, o)=>(props)=>f.call(undefined, (0, $aEGOK.default)(o, props)));

});

parcelRegister("6VIOq", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");
/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */ var $50bad3b9171b1b72$var$negate = /*#__PURE__*/ (0, $ipJAK.default)(function negate(n) {
    return -n;
});
var $50bad3b9171b1b72$export$2e2bcd8739ae039 = $50bad3b9171b1b72$var$negate;

});

parcelRegister("kOpxw", function(module, exports) {

var $bdeG6 = parcelRequire("bdeG6");

var $kzrqi = parcelRequire("kzrqi");

var $9yN6x = parcelRequire("9yN6x");
/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *      const isOdd = n => n % 2 !== 0;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
 */ var $f26c49d12df47bc2$var$none = /*#__PURE__*/ (0, $kzrqi.default)(function none(fn, input) {
    return (0, $9yN6x.default)((0, $bdeG6.default)(fn), input);
});
var $f26c49d12df47bc2$export$2e2bcd8739ae039 = $f26c49d12df47bc2$var$none;

});

parcelRegister("fHKhb", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $JtjnN = parcelRequire("JtjnN");

var $e1w5i = parcelRequire("e1w5i");
/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */ var $b6eec49f4f64db75$var$nthArg = /*#__PURE__*/ (0, $ipJAK.default)(function nthArg(n) {
    var arity = n < 0 ? 1 : n + 1;
    return (0, $JtjnN.default)(arity, function() {
        return (0, $e1w5i.default)(n, arguments);
    });
});
var $b6eec49f4f64db75$export$2e2bcd8739ae039 = $b6eec49f4f64db75$var$nthArg;

});

parcelRegister("dHiMu", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument. Also, unlike [`compose`](#compose), `o` is
 * limited to accepting only 2 unary functions. The name o was chosen because
 * of its similarity to the mathematical composition operator ∘.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      const classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + name.last
 *      const yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */ var $9f8ddc0dd632b370$var$o = /*#__PURE__*/ (0, $5jzlJ.default)(function o(f, g, x) {
    return f(g(x));
});
var $9f8ddc0dd632b370$export$2e2bcd8739ae039 = $9f8ddc0dd632b370$var$o;

});

parcelRegister("4RZmr", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $59E1a = parcelRequire("59E1a");
/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */ var $38bbb5af12545027$var$of = /*#__PURE__*/ (0, $ipJAK.default)((0, $59E1a.default));
var $38bbb5af12545027$export$2e2bcd8739ae039 = $38bbb5af12545027$var$of;

});
parcelRegister("59E1a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c0cd5befd273cc6$export$2e2bcd8739ae039; });
function $3c0cd5befd273cc6$export$2e2bcd8739ae039(x) {
    return [
        x
    ];
}

});


parcelRegister("176O6", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */ var $0cfbb9a595001ed8$var$omit = /*#__PURE__*/ (0, $kzrqi.default)(function omit(names, obj) {
    var result = {};
    var index = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        index[names[idx]] = 1;
        idx += 1;
    }
    for(var prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
});
var $0cfbb9a595001ed8$export$2e2bcd8739ae039 = $0cfbb9a595001ed8$var$omit;

});

parcelRegister("6S5RE", function(module, exports) {

var $2ukFE = parcelRequire("2ukFE");
/**
 * Takes a binary function `f`, a unary function `g`, and two values.
 * Applies `g` to each value, then applies the result of each to `f`.
 *
 * Also known as the P combinator.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Function
 * @sig ((a, a) -> b) -> (c -> a) -> c -> c -> b
 * @param {Function} f a binary function
 * @param {Function} g a unary function
 * @param {any} a any value
 * @param {any} b any value
 * @return {any} The result of `f`
 * @example
 *
 *      const eqBy = R.on((a, b) => a === b);
 *      eqBy(R.prop('a'), {b:0, a:1}, {a:1}) //=> true;
 *
 *      const containsInsensitive = R.on(R.contains, R.toLower);
 *      containsInsensitive('o', 'FOO'); //=> true
 * @symb R.on(f, g, a, b) = f(g(a), g(b))
 */ var $500c55c84fc63e7e$var$on = /*#__PURE__*/ (0, $2ukFE.default)(4, [], function on(f, g, a, b) {
    return f(g(a), g(b));
});
var $500c55c84fc63e7e$export$2e2bcd8739ae039 = $500c55c84fc63e7e$var$on;

});

parcelRegister("7Iwk3", function(module, exports) {

var $72SzR = parcelRequire("72SzR");

var $ipJAK = parcelRequire("ipJAK");
/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      const addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */ var $59e5b70b1fa24c35$var$once = /*#__PURE__*/ (0, $ipJAK.default)(function once(fn) {
    var called = false;
    var result;
    return (0, $72SzR.default)(fn.length, function() {
        if (called) return result;
        called = true;
        result = fn.apply(this, arguments);
        return result;
    });
});
var $59e5b70b1fa24c35$export$2e2bcd8739ae039 = $59e5b70b1fa24c35$var$once;

});

parcelRegister("4PyNc", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $5XtM8 = parcelRequire("5XtM8");
/**
 * Returns the result of applying the onFailure function to the value inside
 * a failed promise. This is useful for handling rejected promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig (e -> b) -> (Promise e a) -> (Promise e b)
 * @sig (e -> (Promise f b)) -> (Promise e a) -> (Promise f b)
 * @param {Function} onFailure The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(null, onFailure)`
 * @see R.andThen
 * @example
 *
 *      const failedFetch = id => Promise.reject('bad ID');
 *      const useDefault = () => ({ firstName: 'Bob', lastName: 'Loblaw' });
 *
 *      //recoverFromFailure :: String -> Promise ({ firstName, lastName })
 *      const recoverFromFailure = R.pipe(
 *        failedFetch,
 *        R.otherwise(useDefault),
 *        R.andThen(R.pick(['firstName', 'lastName'])),
 *      );
 *      recoverFromFailure(12345).then(console.log);
 */ var $3846e9efc738eb33$var$otherwise = /*#__PURE__*/ (0, $kzrqi.default)(function otherwise(f, p) {
    (0, $5XtM8.default)('otherwise', p);
    return p.then(null, f);
});
var $3846e9efc738eb33$export$2e2bcd8739ae039 = $3846e9efc738eb33$var$otherwise;

});
parcelRegister("5XtM8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45698f39c5129614$export$2e2bcd8739ae039; });

var $iKPBD = parcelRequire("iKPBD");

var $45dlW = parcelRequire("45dlW");
function $45698f39c5129614$export$2e2bcd8739ae039(name, p) {
    if (p == null || !(0, $iKPBD.default)(p.then)) throw new TypeError('`' + name + '` expected a Promise, received ' + (0, $45dlW.default)(p, []));
}

});


parcelRegister("eEvN4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02c0bbb5d5268c14$export$2e2bcd8739ae039; });

var $5jzlJ = parcelRequire("5jzlJ");
// transforms the held value with the provided function.
var $02c0bbb5d5268c14$var$Identity = function(x) {
    return {
        value: x,
        map: function(f) {
            return $02c0bbb5d5268c14$var$Identity(f(x));
        }
    };
};
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.view, R.set, R.lens, R.lensIndex, R.lensProp, R.lensPath
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */ var $02c0bbb5d5268c14$var$over = /*#__PURE__*/ (0, $5jzlJ.default)(function over(lens, f, x) {
    // The value returned by the getter function is first transformed with `f`,
    // then set as the value of an `Identity`. This is then mapped over with the
    // setter function of the lens.
    return lens(function(y) {
        return $02c0bbb5d5268c14$var$Identity(f(y));
    })(x).value;
});
var $02c0bbb5d5268c14$export$2e2bcd8739ae039 = $02c0bbb5d5268c14$var$over;

});

parcelRegister("gepCn", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */ var $bd11d35745e5cd61$var$pair = /*#__PURE__*/ (0, $kzrqi.default)(function pair(fst, snd) {
    return [
        fst,
        snd
    ];
});
var $bd11d35745e5cd61$export$2e2bcd8739ae039 = $bd11d35745e5cd61$var$pair;

});

parcelRegister("cwWoR", function(module, exports) {

var $8UaC4 = parcelRequire("8UaC4");

var $6nk8o = parcelRequire("6nk8o");
/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight, R.curry
 * @example
 *
 *      const multiply2 = (a, b) => a * b;
 *      const double = R.partial(multiply2, [2]);
 *      double(3); //=> 6
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const sayHello = R.partial(greet, ['Hello']);
 *      const sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */ var $91f5c637d3120c17$var$partial = /*#__PURE__*/ (0, $6nk8o.default)((0, $8UaC4.default));
var $91f5c637d3120c17$export$2e2bcd8739ae039 = $91f5c637d3120c17$var$partial;

});
parcelRegister("6nk8o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a448251b24f4c4f$export$2e2bcd8739ae039; });

var $72SzR = parcelRequire("72SzR");

var $kzrqi = parcelRequire("kzrqi");
function $4a448251b24f4c4f$export$2e2bcd8739ae039(concat) {
    return (0, $kzrqi.default)(function(fn, args) {
        return (0, $72SzR.default)(Math.max(0, fn.length - args.length), function() {
            return fn.apply(this, concat(args, arguments));
        });
    });
}

});


parcelRegister("4uihT", function(module, exports) {

var $8UaC4 = parcelRequire("8UaC4");

var $6nk8o = parcelRequire("6nk8o");

var $6Fx4m = parcelRequire("6Fx4m");
/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */ var $34482653dc6c856a$var$partialRight = /*#__PURE__*/ (0, $6nk8o.default)(/*#__PURE__*/ (0, $6Fx4m.default)((0, $8UaC4.default)));
var $34482653dc6c856a$export$2e2bcd8739ae039 = $34482653dc6c856a$var$partialRight;

});

parcelRegister("l6tSH", function(module, exports) {

var $85XPA = parcelRequire("85XPA");

var $geMRr = parcelRequire("geMRr");

var $6OQk6 = parcelRequire("6OQk6");
/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.includes('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.includes('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */ var $f5d15652640fb378$var$partition = /*#__PURE__*/ (0, $geMRr.default)([
    (0, $85XPA.default),
    (0, $6OQk6.default)
]);
var $f5d15652640fb378$export$2e2bcd8739ae039 = $f5d15652640fb378$var$partition;

});

parcelRegister("eIR7P", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $fcCge = parcelRequire("fcCge");

var $1DUp6 = parcelRequire("1DUp6");
/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      const user1 = { address: { zipCode: 90210 } };
 *      const user2 = { address: { zipCode: 55555 } };
 *      const user3 = { name: 'Bob' };
 *      const users = [ user1, user2, user3 ];
 *      const isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */ var $ab7e6253613d1cc2$var$pathEq = /*#__PURE__*/ (0, $5jzlJ.default)(function pathEq(_path, val, obj) {
    return (0, $fcCge.default)((0, $1DUp6.default)(_path, obj), val);
});
var $ab7e6253613d1cc2$export$2e2bcd8739ae039 = $ab7e6253613d1cc2$var$pathEq;

});

parcelRegister("kKufi", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $Hyj0j = parcelRequire("Hyj0j");

var $1DUp6 = parcelRequire("1DUp6");
/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */ var $f1af90acfaeef620$var$pathOr = /*#__PURE__*/ (0, $5jzlJ.default)(function pathOr(d, p, obj) {
    return (0, $Hyj0j.default)(d, (0, $1DUp6.default)(p, obj));
});
var $f1af90acfaeef620$export$2e2bcd8739ae039 = $f1af90acfaeef620$var$pathOr;

});

parcelRegister("iPpsm", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $1DUp6 = parcelRequire("1DUp6");
/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int | Symbol
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 *      R.pathSatisfies(R.is(Object), [], {x: {y: 2}}); //=> true
 */ var $db50bc83dbe4a186$var$pathSatisfies = /*#__PURE__*/ (0, $5jzlJ.default)(function pathSatisfies(pred, propPath, obj) {
    return pred((0, $1DUp6.default)(propPath, obj));
});
var $db50bc83dbe4a186$export$2e2bcd8739ae039 = $db50bc83dbe4a186$var$pathSatisfies;

});

parcelRegister("jNuLi", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */ var $e69a7494c8595f98$var$pick = /*#__PURE__*/ (0, $kzrqi.default)(function pick(names, obj) {
    var result = {};
    var idx = 0;
    while(idx < names.length){
        if (names[idx] in obj) result[names[idx]] = obj[names[idx]];
        idx += 1;
    }
    return result;
});
var $e69a7494c8595f98$export$2e2bcd8739ae039 = $e69a7494c8595f98$var$pick;

});

parcelRegister("k1ol7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e936c7f8fb6bec27$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");
/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */ var $e936c7f8fb6bec27$var$pickAll = /*#__PURE__*/ (0, $kzrqi.default)(function pickAll(names, obj) {
    var result = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        var name = names[idx];
        result[name] = obj[name];
        idx += 1;
    }
    return result;
});
var $e936c7f8fb6bec27$export$2e2bcd8739ae039 = $e936c7f8fb6bec27$var$pickAll;

});

parcelRegister("grpi9", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      const isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */ var $bf82c965cd4aa113$var$pickBy = /*#__PURE__*/ (0, $kzrqi.default)(function pickBy(test, obj) {
    var result = {};
    for(var prop in obj)if (test(obj[prop], prop, obj)) result[prop] = obj[prop];
    return result;
});
var $bf82c965cd4aa113$export$2e2bcd8739ae039 = $bf82c965cd4aa113$var$pickBy;

});

parcelRegister("lMmgx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdaf5a2eb7c1b5b8$export$2e2bcd8739ae039; });

var $8UaC4 = parcelRequire("8UaC4");

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */ var $fdaf5a2eb7c1b5b8$var$prepend = /*#__PURE__*/ (0, $kzrqi.default)(function prepend(el, list) {
    return (0, $8UaC4.default)([
        el
    ], list);
});
var $fdaf5a2eb7c1b5b8$export$2e2bcd8739ae039 = $fdaf5a2eb7c1b5b8$var$prepend;

});

parcelRegister("2ZyrB", function(module, exports) {

var $cKDKE = parcelRequire("cKDKE");

var $5bThN = parcelRequire("5bThN");
/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */ var $22dbff29368de901$var$product = /*#__PURE__*/ (0, $5bThN.default)((0, $cKDKE.default), 1);
var $22dbff29368de901$export$2e2bcd8739ae039 = $22dbff29368de901$var$product;

});

parcelRegister("hjfad", function(module, exports) {

var $5AqeV = parcelRequire("5AqeV");

var $ajVWW = parcelRequire("ajVWW");

var $k1ol7 = parcelRequire("k1ol7");

var $2myCy = parcelRequire("2myCy");
/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @see R.pluck, R.props, R.prop
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      const kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */ var $c99ff938661f0c4a$var$project = /*#__PURE__*/ (0, $2myCy.default)((0, $5AqeV.default), [
    (0, $k1ol7.default),
    (0, $ajVWW.default)
]); // passing `identity` gives correct arity
var $c99ff938661f0c4a$export$2e2bcd8739ae039 = $c99ff938661f0c4a$var$project;

});
parcelRegister("2myCy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b887dd345e18f03$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $JtjnN = parcelRequire("JtjnN");
/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */ var $1b887dd345e18f03$var$useWith = /*#__PURE__*/ (0, $kzrqi.default)(function useWith(fn, transformers) {
    return (0, $JtjnN.default)(transformers.length, function() {
        var args = [];
        var idx = 0;
        while(idx < transformers.length){
            args.push(transformers[idx].call(this, arguments[idx]));
            idx += 1;
        }
        return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
    });
});
var $1b887dd345e18f03$export$2e2bcd8739ae039 = $1b887dd345e18f03$var$useWith;

});


parcelRegister("fZCJx", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $dVL0K = parcelRequire("dVL0K");

var $lgfvp = parcelRequire("lgfvp");

var $ljDpT = parcelRequire("ljDpT");
/**
 * Takes two functions as pre- and post- processors respectively for a third function,
 * i.e. `promap(f, g, h)(x) === g(h(f(x)))`.
 *
 * Dispatches to the `promap` method of the third argument, if present,
 * according to the [FantasyLand Profunctor spec](https://github.com/fantasyland/fantasy-land#profunctor).
 *
 * Acts as a transducer if a transformer is given in profunctor position.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Function
 * @sig (a -> b) -> (c -> d) -> (b -> c) -> (a -> d)
 * @sig Profunctor p => (a -> b) -> (c -> d) -> p b c -> p a d
 * @param {Function} f The preprocessor function, a -> b
 * @param {Function} g The postprocessor function, c -> d
 * @param {Profunctor} profunctor The profunctor instance to be promapped, e.g. b -> c
 * @return {Profunctor} The new profunctor instance, e.g. a -> d
 * @see R.transduce
 * @example
 *
 *      const decodeChar = R.promap(s => s.charCodeAt(), String.fromCharCode, R.add(-8))
 *      const decodeString = R.promap(R.split(''), R.join(''), R.map(decodeChar))
 *      decodeString("ziuli") //=> "ramda"
 *
 * @symb R.promap(f, g, h) = x => g(h(f(x)))
 * @symb R.promap(f, g, profunctor) = profunctor.promap(f, g)
 */ var $ba4a992ad6e2bc2d$var$promap = /*#__PURE__*/ (0, $5jzlJ.default)(/*#__PURE__*/ (0, $dVL0K.default)([
    'fantasy-land/promap',
    'promap'
], (0, $ljDpT.default), (0, $lgfvp.default)));
var $ba4a992ad6e2bc2d$export$2e2bcd8739ae039 = $ba4a992ad6e2bc2d$var$promap;

});
parcelRegister("lgfvp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7a71eaf809f2d26$export$2e2bcd8739ae039; });
function $f7a71eaf809f2d26$export$2e2bcd8739ae039(f, g, profunctor) {
    return function(x) {
        return g(profunctor(f(x)));
    };
}

});

parcelRegister("ljDpT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f849f2a00184ee11$export$2e2bcd8739ae039; });

var $5jzlJ = parcelRequire("5jzlJ");

var $g1C1K = parcelRequire("g1C1K");

var $lgfvp = parcelRequire("lgfvp");
var $f849f2a00184ee11$var$XPromap = /*#__PURE__*/ function() {
    function XPromap(f, g, xf) {
        this.xf = xf;
        this.f = f;
        this.g = g;
    }
    XPromap.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XPromap.prototype['@@transducer/result'] = (0, $g1C1K.default).result;
    XPromap.prototype['@@transducer/step'] = function(result, input) {
        return this.xf['@@transducer/step'](result, (0, $lgfvp.default)(this.f, this.g, input));
    };
    return XPromap;
}();
var $f849f2a00184ee11$var$_xpromap = /*#__PURE__*/ (0, $5jzlJ.default)(function _xpromap(f, g, xf) {
    return new $f849f2a00184ee11$var$XPromap(f, g, xf);
});
var $f849f2a00184ee11$export$2e2bcd8739ae039 = $f849f2a00184ee11$var$_xpromap;

});


parcelRegister("dhzMc", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $K4FLv = parcelRequire("K4FLv");

var $fcCge = parcelRequire("fcCge");
/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.whereEq`](#whereEq).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.whereEq, R.propSatisfies, R.equals
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      const kids = [abby, fred, rusty, alois];
 *      const hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */ var $9ab89d5ca217ca4b$var$propEq = /*#__PURE__*/ (0, $5jzlJ.default)(function propEq(name, val, obj) {
    return (0, $fcCge.default)(val, (0, $K4FLv.default)(name, obj));
});
var $9ab89d5ca217ca4b$export$2e2bcd8739ae039 = $9ab89d5ca217ca4b$var$propEq;

});

parcelRegister("ax2Af", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $K4FLv = parcelRequire("K4FLv");

var $1tSOd = parcelRequire("1tSOd");
/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */ var $7aaefd81632e8a1e$var$propIs = /*#__PURE__*/ (0, $5jzlJ.default)(function propIs(type, name, obj) {
    return (0, $1tSOd.default)(type, (0, $K4FLv.default)(name, obj));
});
var $7aaefd81632e8a1e$export$2e2bcd8739ae039 = $7aaefd81632e8a1e$var$propIs;

});

parcelRegister("e1am9", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $Hyj0j = parcelRequire("Hyj0j");

var $K4FLv = parcelRequire("K4FLv");
/**
 * Return the specified property of the given non-null object if the property
 * is present and it's value is not `null`, `undefined` or `NaN`.
 *
 * Otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const favorite = R.prop('favoriteLibrary');
 *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */ var $a349313f9525d38f$var$propOr = /*#__PURE__*/ (0, $5jzlJ.default)(function propOr(val, p, obj) {
    return (0, $Hyj0j.default)(val, (0, $K4FLv.default)(p, obj));
});
var $a349313f9525d38f$export$2e2bcd8739ae039 = $a349313f9525d38f$var$propOr;

});

parcelRegister("7yofb", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $K4FLv = parcelRequire("K4FLv");
/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise. You can test multiple properties with
 * [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.where, R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */ var $57fe83b1495f2b8b$var$propSatisfies = /*#__PURE__*/ (0, $5jzlJ.default)(function propSatisfies(pred, name, obj) {
    return pred((0, $K4FLv.default)(name, obj));
});
var $57fe83b1495f2b8b$export$2e2bcd8739ae039 = $57fe83b1495f2b8b$var$propSatisfies;

});

parcelRegister("iZ4DR", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $1DUp6 = parcelRequire("1DUp6");
/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @see R.prop, R.pluck, R.project
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      const fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */ var $dd218648905076ae$var$props = /*#__PURE__*/ (0, $kzrqi.default)(function props(ps, obj) {
    return ps.map(function(p) {
        return (0, $1DUp6.default)([
            p
        ], obj);
    });
});
var $dd218648905076ae$export$2e2bcd8739ae039 = $dd218648905076ae$var$props;

});

parcelRegister("9J4aj", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $1bB5u = parcelRequire("1bB5u");
/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in the set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */ var $714b8c2963bc6707$var$range = /*#__PURE__*/ (0, $kzrqi.default)(function range(from, to) {
    if (!((0, $1bB5u.default)(from) && (0, $1bB5u.default)(to))) throw new TypeError('Both arguments to range must be numbers');
    var result = [];
    var n = from;
    while(n < to){
        result.push(n);
        n += 1;
    }
    return result;
});
var $714b8c2963bc6707$export$2e2bcd8739ae039 = $714b8c2963bc6707$var$range;

});

parcelRegister("jAcIZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e41b3ff24a0eee25$export$2e2bcd8739ae039; });

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*. `reduceRight` may use [`reduced`](#reduced)
 * to short circuit the iteration.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex, R.reduced
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *      //    -               -2
 *      //   / \              / \
 *      //  1   -            1   3
 *      //     / \              / \
 *      //    2   -     ==>    2  -1
 *      //       / \              / \
 *      //      3   -            3   4
 *      //         / \              / \
 *      //        4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */ var $e41b3ff24a0eee25$var$reduceRight = /*#__PURE__*/ (0, $5jzlJ.default)(function reduceRight(fn, acc, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        acc = fn(list[idx], acc);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        idx -= 1;
    }
    return acc;
});
var $e41b3ff24a0eee25$export$2e2bcd8739ae039 = $e41b3ff24a0eee25$var$reduceRight;

});

parcelRegister("NU3Op", function(module, exports) {

var $2ukFE = parcelRequire("2ukFE");

var $5bmcu = parcelRequire("5bmcu");

var $1RqCc = parcelRequire("1RqCc");
/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator. `reduceWhile` may alternatively be short-circuited
 * via [`reduced`](#reduced).
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      const isOdd = (acc, x) => x % 2 !== 0;
 *      const xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      const ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */ var $09601029a64731e8$var$reduceWhile = /*#__PURE__*/ (0, $2ukFE.default)(4, [], function _reduceWhile(pred, fn, a, list) {
    return (0, $5bmcu.default)(function(acc, x) {
        return pred(acc, x) ? fn(acc, x) : (0, $1RqCc.default)(acc);
    }, a, list);
});
var $09601029a64731e8$export$2e2bcd8739ae039 = $09601029a64731e8$var$reduceWhile;

});

parcelRegister("5RPbZ", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $1RqCc = parcelRequire("1RqCc");
/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * This optimization is available to the below functions:
 * - [`reduce`](#reduce)
 * - [`reduceWhile`](#reduceWhile)
 * - [`reduceBy`](#reduceBy)
 * - [`reduceRight`](#reduceRight)
 * - [`transduce`](#transduce)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.reduceWhile, R.reduceBy, R.reduceRight, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */ var $44599cb85fbdb8c8$var$reduced = /*#__PURE__*/ (0, $ipJAK.default)((0, $1RqCc.default));
var $44599cb85fbdb8c8$export$2e2bcd8739ae039 = $44599cb85fbdb8c8$var$reduced;

});

parcelRegister("iST3a", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $gVgoT = parcelRequire("gVgoT");

var $gUxwf = parcelRequire("gUxwf");
/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      const obj = {};
 *      const repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */ var $dbf7f8edc0ece0ef$var$repeat = /*#__PURE__*/ (0, $kzrqi.default)(function repeat(value, n) {
    return (0, $gUxwf.default)((0, $gVgoT.default)(value), n);
});
var $dbf7f8edc0ece0ef$export$2e2bcd8739ae039 = $dbf7f8edc0ece0ef$var$repeat;

});
parcelRegister("gUxwf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4fbe083fdf17e18$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");
/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */ var $c4fbe083fdf17e18$var$times = /*#__PURE__*/ (0, $kzrqi.default)(function times(fn, n) {
    var len = Number(n);
    var idx = 0;
    var list;
    if (len < 0 || isNaN(len)) throw new RangeError('n must be a non-negative number');
    list = new Array(len);
    while(idx < len){
        list[idx] = fn(idx);
        idx += 1;
    }
    return list;
});
var $c4fbe083fdf17e18$export$2e2bcd8739ae039 = $c4fbe083fdf17e18$var$times;

});


parcelRegister("bQ4CD", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * The first two parameters correspond to the parameters of the
 * `String.prototype.replace()` function, so the second parameter can also be a
 * function.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */ var $89e822e9bffee5a1$var$replace = /*#__PURE__*/ (0, $5jzlJ.default)(function replace(regex, replacement, str) {
    return str.replace(regex, replacement);
});
var $89e822e9bffee5a1$export$2e2bcd8739ae039 = $89e822e9bffee5a1$var$replace;

});

parcelRegister("8IrZC", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce, R.mapAccum
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */ var $65882599d71e289c$var$scan = /*#__PURE__*/ (0, $5jzlJ.default)(function scan(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [
        acc
    ];
    while(idx < len){
        acc = fn(acc, list[idx]);
        result[idx + 1] = acc;
        idx += 1;
    }
    return result;
});
var $65882599d71e289c$export$2e2bcd8739ae039 = $65882599d71e289c$var$scan;

});

parcelRegister("95sBD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69dac544ce79e76e$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $9r9kC = parcelRequire("9r9kC");

var $9QW5G = parcelRequire("9QW5G");

var $lMmgx = parcelRequire("lMmgx");

var $jAcIZ = parcelRequire("jAcIZ");
/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */ var $69dac544ce79e76e$var$sequence = /*#__PURE__*/ (0, $kzrqi.default)(function sequence(of, traversable) {
    return typeof traversable.sequence === 'function' ? traversable.sequence(of) : (0, $jAcIZ.default)(function(x, acc) {
        return (0, $9r9kC.default)((0, $9QW5G.default)((0, $lMmgx.default), x), acc);
    }, of([]), traversable);
});
var $69dac544ce79e76e$export$2e2bcd8739ae039 = $69dac544ce79e76e$var$sequence;

});

parcelRegister("cafTW", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $gVgoT = parcelRequire("gVgoT");

var $eEvN4 = parcelRequire("eEvN4");
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.view, R.over, R.lens, R.lensIndex, R.lensProp, R.lensPath
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */ var $8db2c0dd24e01f05$var$set = /*#__PURE__*/ (0, $5jzlJ.default)(function set(lens, v, x) {
    return (0, $eEvN4.default)(lens, (0, $gVgoT.default)(v), x);
});
var $8db2c0dd24e01f05$export$2e2bcd8739ae039 = $8db2c0dd24e01f05$var$set;

});

parcelRegister("8iP7v", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, a) -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @see R.ascend, R.descend
 * @example
 *
 *      const diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */ var $60b7a890b171b74e$var$sort = /*#__PURE__*/ (0, $kzrqi.default)(function sort(comparator, list) {
    return Array.prototype.slice.call(list, 0).sort(comparator);
});
var $60b7a890b171b74e$export$2e2bcd8739ae039 = $60b7a890b171b74e$var$sort;

});

parcelRegister("h9kke", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      const sortByFirstItem = R.sortBy(R.prop(0));
 *      const pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *
 *      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      const people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */ var $c7c30b20f06d3b5c$var$sortBy = /*#__PURE__*/ (0, $kzrqi.default)(function sortBy(fn, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var aa = fn(a);
        var bb = fn(b);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
    });
});
var $c7c30b20f06d3b5c$export$2e2bcd8739ae039 = $c7c30b20f06d3b5c$var$sortBy;

});

parcelRegister("2WMg6", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [(a, a) -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @see R.ascend, R.descend
 * @example
 *
 *      const alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      const bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      const people = [clara, bob, alice];
 *      const ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */ var $22566eb4266605f0$var$sortWith = /*#__PURE__*/ (0, $kzrqi.default)(function sortWith(fns, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var result = 0;
        var i = 0;
        while(result === 0 && i < fns.length){
            result = fns[i](a, b);
            i += 1;
        }
        return result;
    });
});
var $22566eb4266605f0$export$2e2bcd8739ae039 = $22566eb4266605f0$var$sortWith;

});

parcelRegister("8bCP5", function(module, exports) {

var $ls3ln = parcelRequire("ls3ln");
/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `sep`.
 * @see R.join
 * @example
 *
 *      const pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */ var $5f5d773c8efdbb11$var$split = /*#__PURE__*/ (0, $ls3ln.default)(1, 'split');
var $5f5d773c8efdbb11$export$2e2bcd8739ae039 = $5f5d773c8efdbb11$var$split;

});

parcelRegister("c9F9M", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $ltDJX = parcelRequire("ltDJX");

var $iM9LE = parcelRequire("iM9LE");
/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */ var $8d96403230e586a0$var$splitAt = /*#__PURE__*/ (0, $kzrqi.default)(function splitAt(index, array) {
    return [
        (0, $iM9LE.default)(0, index, array),
        (0, $iM9LE.default)(index, (0, $ltDJX.default)(array), array)
    ];
});
var $8d96403230e586a0$export$2e2bcd8739ae039 = $8d96403230e586a0$var$splitAt;

});

parcelRegister("sh6xI", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $iM9LE = parcelRequire("iM9LE");
/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */ var $054fe23e2c518f0e$var$splitEvery = /*#__PURE__*/ (0, $kzrqi.default)(function splitEvery(n, list) {
    if (n <= 0) throw new Error('First argument to splitEvery must be a positive integer');
    var result = [];
    var idx = 0;
    while(idx < list.length)result.push((0, $iM9LE.default)(idx, idx += n, list));
    return result;
});
var $054fe23e2c518f0e$export$2e2bcd8739ae039 = $054fe23e2c518f0e$var$splitEvery;

});

parcelRegister("kU7Cu", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */ var $f37ef2bc9e3a459a$var$splitWhen = /*#__PURE__*/ (0, $kzrqi.default)(function splitWhen(pred, list) {
    var idx = 0;
    var len = list.length;
    var prefix = [];
    while(idx < len && !pred(list[idx])){
        prefix.push(list[idx]);
        idx += 1;
    }
    return [
        prefix,
        Array.prototype.slice.call(list, idx)
    ];
});
var $f37ef2bc9e3a459a$export$2e2bcd8739ae039 = $f37ef2bc9e3a459a$var$splitWhen;

});

parcelRegister("5tlGr", function(module, exports) {

var $2ukFE = parcelRequire("2ukFE");
/**
 * Splits an array into slices on every occurrence of a value.
 *
 * @func
 * @memberOf R
 * @since v0.26.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhenever(R.equals(2), [1, 2, 3, 2, 4, 5, 2, 6, 7]); //=> [[1], [3], [4, 5], [6, 7]]
 */ var $3fc07b12110c5dd5$var$splitWhenever = /*#__PURE__*/ (0, $2ukFE.default)(2, [], function splitWhenever(pred, list) {
    var acc = [];
    var curr = [];
    for(var i = 0; i < list.length; i = i + 1){
        if (!pred(list[i])) curr.push(list[i]);
        if ((i < list.length - 1 && pred(list[i + 1]) || i === list.length - 1) && curr.length > 0) {
            acc.push(curr);
            curr = [];
        }
    }
    return acc;
});
var $3fc07b12110c5dd5$export$2e2bcd8739ae039 = $3fc07b12110c5dd5$var$splitWhenever;

});

parcelRegister("1Bxzw", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $fcCge = parcelRequire("fcCge");

var $cTQ6P = parcelRequire("cTQ6P");
/**
 * Checks if a list starts with the provided sublist.
 *
 * Similarly, checks if a string starts with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @see R.endsWith
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var $12b349d931e4164e$var$startsWith = /*#__PURE__*/ (0, $kzrqi.default)(function(prefix, list) {
    return (0, $fcCge.default)((0, $cTQ6P.default)(prefix.length, list), prefix);
});
var $12b349d931e4164e$export$2e2bcd8739ae039 = $12b349d931e4164e$var$startsWith;

});

parcelRegister("1W3ne", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      const minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      const complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */ var $168dd32ec6d14fd9$var$subtract = /*#__PURE__*/ (0, $kzrqi.default)(function subtract(a, b) {
    return Number(a) - Number(b);
});
var $168dd32ec6d14fd9$export$2e2bcd8739ae039 = $168dd32ec6d14fd9$var$subtract;

});

parcelRegister("hGSIs", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $cg8Ag = parcelRequire("cg8Ag");

var $RNRjT = parcelRequire("RNRjT");
/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */ var $ce10cd613f3bc978$var$symmetricDifference = /*#__PURE__*/ (0, $kzrqi.default)(function symmetricDifference(list1, list2) {
    return (0, $cg8Ag.default)((0, $RNRjT.default)(list1, list2), (0, $RNRjT.default)(list2, list1));
});
var $ce10cd613f3bc978$export$2e2bcd8739ae039 = $ce10cd613f3bc978$var$symmetricDifference;

});

parcelRegister("9z8wZ", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $cg8Ag = parcelRequire("cg8Ag");

var $llbWy = parcelRequire("llbWy");
/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      const eqA = R.eqBy(R.prop('a'));
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      const l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */ var $6f6e0005369e763a$var$symmetricDifferenceWith = /*#__PURE__*/ (0, $5jzlJ.default)(function symmetricDifferenceWith(pred, list1, list2) {
    return (0, $cg8Ag.default)((0, $llbWy.default)(pred, list1, list2), (0, $llbWy.default)(pred, list2, list1));
});
var $6f6e0005369e763a$export$2e2bcd8739ae039 = $6f6e0005369e763a$var$symmetricDifferenceWith;

});

parcelRegister("aUUZ6", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $iM9LE = parcelRequire("iM9LE");
/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      const isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 *
 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
 */ var $7f2b564bc2faab58$var$takeLastWhile = /*#__PURE__*/ (0, $kzrqi.default)(function takeLastWhile(fn, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && fn(xs[idx]))idx -= 1;
    return (0, $iM9LE.default)(idx + 1, Infinity, xs);
});
var $7f2b564bc2faab58$export$2e2bcd8739ae039 = $7f2b564bc2faab58$var$takeLastWhile;

});

parcelRegister("eeUmw", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $4JFWX = parcelRequire("4JFWX");

var $iM9LE = parcelRequire("iM9LE");
/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      const isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 *
 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
 */ var $a5de17da1b31795b$var$takeWhile = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([
    'takeWhile'
], (0, $4JFWX.default), function takeWhile(fn, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && fn(xs[idx]))idx += 1;
    return (0, $iM9LE.default)(0, idx, xs);
}));
var $a5de17da1b31795b$export$2e2bcd8739ae039 = $a5de17da1b31795b$var$takeWhile;

});
parcelRegister("4JFWX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $372be7cd07219810$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $1RqCc = parcelRequire("1RqCc");

var $g1C1K = parcelRequire("g1C1K");
var $372be7cd07219810$var$XTakeWhile = /*#__PURE__*/ function() {
    function XTakeWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTakeWhile.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XTakeWhile.prototype['@@transducer/result'] = (0, $g1C1K.default).result;
    XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
        return this.f(input) ? this.xf['@@transducer/step'](result, input) : (0, $1RqCc.default)(result);
    };
    return XTakeWhile;
}();
var $372be7cd07219810$var$_xtakeWhile = /*#__PURE__*/ (0, $kzrqi.default)(function _xtakeWhile(f, xf) {
    return new $372be7cd07219810$var$XTakeWhile(f, xf);
});
var $372be7cd07219810$export$2e2bcd8739ae039 = $372be7cd07219810$var$_xtakeWhile;

});


parcelRegister("ei0mq", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $jZIX1 = parcelRequire("jZIX1");
/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      const sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */ var $a67306c7fe19aedd$var$tap = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([], (0, $jZIX1.default), function tap(fn, x) {
    fn(x);
    return x;
}));
var $a67306c7fe19aedd$export$2e2bcd8739ae039 = $a67306c7fe19aedd$var$tap;

});
parcelRegister("jZIX1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8e6952a6f9c292f$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $g1C1K = parcelRequire("g1C1K");
var $e8e6952a6f9c292f$var$XTap = /*#__PURE__*/ function() {
    function XTap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTap.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XTap.prototype['@@transducer/result'] = (0, $g1C1K.default).result;
    XTap.prototype['@@transducer/step'] = function(result, input) {
        this.f(input);
        return this.xf['@@transducer/step'](result, input);
    };
    return XTap;
}();
var $e8e6952a6f9c292f$var$_xtap = /*#__PURE__*/ (0, $kzrqi.default)(function _xtap(f, xf) {
    return new $e8e6952a6f9c292f$var$XTap(f, xf);
});
var $e8e6952a6f9c292f$export$2e2bcd8739ae039 = $e8e6952a6f9c292f$var$_xtap;

});


parcelRegister("jqAPO", function(module, exports) {

var $lCIh2 = parcelRequire("lCIh2");

var $kzrqi = parcelRequire("kzrqi");

var $fRgxb = parcelRequire("fRgxb");

var $jQHxm = parcelRequire("jQHxm");
/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */ var $e24d049c138e1e4e$var$test = /*#__PURE__*/ (0, $kzrqi.default)(function test(pattern, str) {
    if (!(0, $fRgxb.default)(pattern)) throw new TypeError("\u2018test\u2019 requires a value of type RegExp as its first argument; received " + (0, $jQHxm.default)(pattern));
    return (0, $lCIh2.default)(pattern).test(str);
});
var $e24d049c138e1e4e$export$2e2bcd8739ae039 = $e24d049c138e1e4e$var$test;

});
parcelRegister("fRgxb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8b8a1a07b157130$export$2e2bcd8739ae039; });
function $b8b8a1a07b157130$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === '[object RegExp]';
}

});


parcelRegister("6f0BW", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $5XtM8 = parcelRequire("5XtM8");
/**
 * Returns the result of applying the onSuccess function to the value inside
 * a successfully resolved promise. This is useful for working with promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Function
 * @sig (a -> b) -> (Promise e a) -> (Promise e b)
 * @sig (a -> (Promise e b)) -> (Promise e a) -> (Promise e b)
 * @param {Function} onSuccess The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(onSuccess)`
 * @see R.otherwise
 * @example
 *
 *      const makeQuery = email => ({ query: { email }});
 *      const fetchMember = request =>
 *        Promise.resolve({ firstName: 'Bob', lastName: 'Loblaw', id: 42 });
 *
 *      //getMemberName :: String -> Promise ({ firstName, lastName })
 *      const getMemberName = R.pipe(
 *        makeQuery,
 *        fetchMember,
 *        R.andThen(R.pick(['firstName', 'lastName']))
 *      );
 *
 *      getMemberName('bob@gmail.com').then(console.log);
 */ var $48b49e20d7eff76a$var$andThen = /*#__PURE__*/ (0, $kzrqi.default)(function andThen(f, p) {
    (0, $5XtM8.default)('andThen', p);
    return p.then(f);
});
var $48b49e20d7eff76a$export$2e2bcd8739ae039 = $48b49e20d7eff76a$var$andThen;

});

parcelRegister("hZMGI", function(module, exports) {

var $ls3ln = parcelRequire("ls3ln");
/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */ var $d19de698cb0d3f96$var$toLower = /*#__PURE__*/ (0, $ls3ln.default)(0, 'toLowerCase');
var $d19de698cb0d3f96$export$2e2bcd8739ae039 = $d19de698cb0d3f96$var$toLower;

});

parcelRegister("eakOB", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $j0Aik = parcelRequire("j0Aik");
/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs, R.keys, R.values
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */ var $a502254d7c7806a8$var$toPairs = /*#__PURE__*/ (0, $ipJAK.default)(function toPairs(obj) {
    var pairs = [];
    for(var prop in obj)if ((0, $j0Aik.default)(prop, obj)) pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
var $a502254d7c7806a8$export$2e2bcd8739ae039 = $a502254d7c7806a8$var$toPairs;

});

parcelRegister("938Wd", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");
/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */ var $696b53c7fe55fb13$var$toPairsIn = /*#__PURE__*/ (0, $ipJAK.default)(function toPairsIn(obj) {
    var pairs = [];
    for(var prop in obj)pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
var $696b53c7fe55fb13$export$2e2bcd8739ae039 = $696b53c7fe55fb13$var$toPairsIn;

});

parcelRegister("7iWLA", function(module, exports) {

var $ls3ln = parcelRequire("ls3ln");
/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */ var $5517cca2dc62692a$var$toUpper = /*#__PURE__*/ (0, $ls3ln.default)(0, 'toUpperCase');
var $5517cca2dc62692a$export$2e2bcd8739ae039 = $5517cca2dc62692a$var$toUpper;

});

parcelRegister("8Uhvs", function(module, exports) {

var $5bmcu = parcelRequire("5bmcu");

var $kL53y = parcelRequire("kL53y");

var $JtjnN = parcelRequire("JtjnN");
/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      const isOdd = (x) => x % 2 !== 0;
 *      const firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */ var $67c122143b9f839a$var$transduce = /*#__PURE__*/ (0, $JtjnN.default)(4, function transduce(xf, fn, acc, list) {
    return (0, $5bmcu.default)(xf(typeof fn === 'function' ? (0, $kL53y.default)(fn) : fn), acc, list);
});
var $67c122143b9f839a$export$2e2bcd8739ae039 = $67c122143b9f839a$var$transduce;

});

parcelRegister("jI9jM", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");
/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */ var $e5995ac3a3c41d14$var$transpose = /*#__PURE__*/ (0, $ipJAK.default)(function transpose(outerlist) {
    var i = 0;
    var result = [];
    while(i < outerlist.length){
        var innerlist = outerlist[i];
        var j = 0;
        while(j < innerlist.length){
            if (typeof result[j] === 'undefined') result[j] = [];
            result[j].push(innerlist[j]);
            j += 1;
        }
        i += 1;
    }
    return result;
});
var $e5995ac3a3c41d14$export$2e2bcd8739ae039 = $e5995ac3a3c41d14$var$transpose;

});

parcelRegister("aPiSV", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");

var $9QW5G = parcelRequire("9QW5G");

var $95sBD = parcelRequire("95sBD");
/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `traverse` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Maybe.Nothing` if the given divisor is `0`
 *      const safeDiv = n => d => d === 0 ? Maybe.Nothing() : Maybe.Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Maybe.Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Maybe.Nothing
 */ var $7e1d50f3b09f17b7$var$traverse = /*#__PURE__*/ (0, $5jzlJ.default)(function traverse(of, f, traversable) {
    return typeof traversable['fantasy-land/traverse'] === 'function' ? traversable['fantasy-land/traverse'](f, of) : typeof traversable.traverse === 'function' ? traversable.traverse(f, of) : (0, $95sBD.default)(of, (0, $9QW5G.default)(f, traversable));
});
var $7e1d50f3b09f17b7$export$2e2bcd8739ae039 = $7e1d50f3b09f17b7$var$traverse;

});

parcelRegister("6Cpzl", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");
var $4d1a202a90ee139d$var$ws = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
var $4d1a202a90ee139d$var$zeroWidth = '\u200b';
var $4d1a202a90ee139d$var$hasProtoTrim = typeof String.prototype.trim === 'function';
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */ var $4d1a202a90ee139d$var$trim = !$4d1a202a90ee139d$var$hasProtoTrim || /*#__PURE__*/ $4d1a202a90ee139d$var$ws.trim() || !/*#__PURE__*/ $4d1a202a90ee139d$var$zeroWidth.trim() ? /*#__PURE__*/ (0, $ipJAK.default)(function trim(str) {
    var beginRx = new RegExp('^[' + $4d1a202a90ee139d$var$ws + '][' + $4d1a202a90ee139d$var$ws + ']*');
    var endRx = new RegExp('[' + $4d1a202a90ee139d$var$ws + '][' + $4d1a202a90ee139d$var$ws + ']*$');
    return str.replace(beginRx, '').replace(endRx, '');
}) : /*#__PURE__*/ (0, $ipJAK.default)(function trim(str) {
    return str.trim();
});
var $4d1a202a90ee139d$export$2e2bcd8739ae039 = $4d1a202a90ee139d$var$trim;

});

parcelRegister("3qrEw", function(module, exports) {

var $72SzR = parcelRequire("72SzR");

var $8UaC4 = parcelRequire("8UaC4");

var $kzrqi = parcelRequire("kzrqi");
/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send them to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(() => { throw 'foo'}, R.always('caught'))('bar') // =>
 *      'caught'
 *      R.tryCatch(R.times(R.identity), R.always([]))('s') // => []
 *      R.tryCatch(() => { throw 'this is not a valid value'}, (err, value)=>({error : err,  value }))('bar') // => {'error': 'this is not a valid value', 'value': 'bar'}
 */ var $27e94001f237dfc4$var$tryCatch = /*#__PURE__*/ (0, $kzrqi.default)(function _tryCatch(tryer, catcher) {
    return (0, $72SzR.default)(tryer.length, function() {
        try {
            return tryer.apply(this, arguments);
        } catch (e) {
            return catcher.apply(this, (0, $8UaC4.default)([
                e
            ], arguments));
        }
    });
});
var $27e94001f237dfc4$export$2e2bcd8739ae039 = $27e94001f237dfc4$var$tryCatch;

});

parcelRegister("kFeUc", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");
/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */ var $f0b332e5f471a7d6$var$unapply = /*#__PURE__*/ (0, $ipJAK.default)(function unapply(fn) {
    return function() {
        return fn(Array.prototype.slice.call(arguments, 0));
    };
});
var $f0b332e5f471a7d6$export$2e2bcd8739ae039 = $f0b332e5f471a7d6$var$unapply;

});

parcelRegister("2zhex", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");

var $iLMUu = parcelRequire("iLMUu");
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (a -> b -> c -> ... -> z) -> (a -> z)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      const takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */ var $1dec37dd04e0c470$var$unary = /*#__PURE__*/ (0, $ipJAK.default)(function unary(fn) {
    return (0, $iLMUu.default)(1, fn);
});
var $1dec37dd04e0c470$export$2e2bcd8739ae039 = $1dec37dd04e0c470$var$unary;

});

parcelRegister("1Q5pk", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $JtjnN = parcelRequire("JtjnN");
/**
 * Returns a function of arity `n` from a (manually) curried function.
 * Note that, the returned function is actually a ramda style
 * curryied function, which can accept one or more arguments in each
 * function calling.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b -> c ... -> z) -> ((a -> b -> c ...) -> z)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry, R.curryN
 * @example
 *
 *      const addFour = a => b => c => d => a + b + c + d;
 *
 *      const uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */ var $156ed7985bc157fe$var$uncurryN = /*#__PURE__*/ (0, $kzrqi.default)(function uncurryN(depth, fn) {
    return (0, $JtjnN.default)(depth, function() {
        var currentDepth = 1;
        var value = fn;
        var idx = 0;
        var endIdx;
        while(currentDepth <= depth && typeof value === 'function'){
            endIdx = currentDepth === depth ? arguments.length : idx + value.length;
            value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
            currentDepth += 1;
            idx = endIdx;
        }
        return value;
    });
});
var $156ed7985bc157fe$export$2e2bcd8739ae039 = $156ed7985bc157fe$var$uncurryN;

});

parcelRegister("6r4fi", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      const f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */ var $4af88ecc4d2bcaa9$var$unfold = /*#__PURE__*/ (0, $kzrqi.default)(function unfold(fn, seed) {
    var pair = fn(seed);
    var result = [];
    while(pair && pair.length){
        result[result.length] = pair[0];
        pair = fn(pair[1]);
    }
    return result;
});
var $4af88ecc4d2bcaa9$export$2e2bcd8739ae039 = $4af88ecc4d2bcaa9$var$unfold;

});

parcelRegister("2EEyK", function(module, exports) {

var $8UaC4 = parcelRequire("8UaC4");

var $kzrqi = parcelRequire("kzrqi");

var $qkq7O = parcelRequire("qkq7O");

var $iQtmQ = parcelRequire("iQtmQ");
/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */ var $1eeec772813bfc64$var$union = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $qkq7O.default)((0, $iQtmQ.default), (0, $8UaC4.default)));
var $1eeec772813bfc64$export$2e2bcd8739ae039 = $1eeec772813bfc64$var$union;

});

parcelRegister("4iPfX", function(module, exports) {

var $8UaC4 = parcelRequire("8UaC4");

var $5jzlJ = parcelRequire("5jzlJ");

var $64D31 = parcelRequire("64D31");
/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements. If an element exists
 * in both lists, the first element from the first list will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      const l1 = [{a: 1}, {a: 2}];
 *      const l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */ var $32209a4f5c47c662$var$unionWith = /*#__PURE__*/ (0, $5jzlJ.default)(function unionWith(pred, list1, list2) {
    return (0, $64D31.default)(pred, (0, $8UaC4.default)(list1, list2));
});
var $32209a4f5c47c662$export$2e2bcd8739ae039 = $32209a4f5c47c662$var$unionWith;

});
parcelRegister("64D31", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46c167da01970100$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $dVL0K = parcelRequire("dVL0K");

var $lJiLY = parcelRequire("lJiLY");

var $iDKqV = parcelRequire("iDKqV");
/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      const strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */ var $46c167da01970100$var$uniqWith = /*#__PURE__*/ (0, $kzrqi.default)(/*#__PURE__*/ (0, $dVL0K.default)([], (0, $iDKqV.default), function(pred, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var item;
    while(idx < len){
        item = list[idx];
        if (!(0, $lJiLY.default)(pred, item, result)) result[result.length] = item;
        idx += 1;
    }
    return result;
}));
var $46c167da01970100$export$2e2bcd8739ae039 = $46c167da01970100$var$uniqWith;

});
parcelRegister("iDKqV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d91fe333d4434477$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $lJiLY = parcelRequire("lJiLY");

var $g1C1K = parcelRequire("g1C1K");
var $d91fe333d4434477$var$XUniqWith = /*#__PURE__*/ function() {
    function XUniqWith(pred, xf) {
        this.xf = xf;
        this.pred = pred;
        this.items = [];
    }
    XUniqWith.prototype['@@transducer/init'] = (0, $g1C1K.default).init;
    XUniqWith.prototype['@@transducer/result'] = (0, $g1C1K.default).result;
    XUniqWith.prototype['@@transducer/step'] = function(result, input) {
        if ((0, $lJiLY.default)(this.pred, input, this.items)) return result;
        else {
            this.items.push(input);
            return this.xf['@@transducer/step'](result, input);
        }
    };
    return XUniqWith;
}();
var $d91fe333d4434477$var$_xuniqWith = /*#__PURE__*/ (0, $kzrqi.default)(function _xuniqWith(pred, xf) {
    return new $d91fe333d4434477$var$XUniqWith(pred, xf);
});
var $d91fe333d4434477$export$2e2bcd8739ae039 = $d91fe333d4434477$var$_xuniqWith;

});



parcelRegister("jKcrx", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> b) -> a -> a | b
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when, R.cond
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */ var $e5fbf726f60355be$var$unless = /*#__PURE__*/ (0, $5jzlJ.default)(function unless(pred, whenFalseFn, x) {
    return pred(x) ? x : whenFalseFn(x);
});
var $e5fbf726f60355be$export$2e2bcd8739ae039 = $e5fbf726f60355be$var$unless;

});

parcelRegister("61LIg", function(module, exports) {

var $luM0J = parcelRequire("luM0J");

var $dxvF9 = parcelRequire("dxvF9");
/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */ var $4637d8e000382298$var$unnest = /*#__PURE__*/ (0, $dxvF9.default)((0, $luM0J.default));
var $4637d8e000382298$export$2e2bcd8739ae039 = $4637d8e000382298$var$unnest;

});

parcelRegister("hWDkA", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */ var $d1065ccbed8e0387$var$until = /*#__PURE__*/ (0, $5jzlJ.default)(function until(pred, fn, init) {
    var val = init;
    while(!pred(val))val = fn(val);
    return val;
});
var $d1065ccbed8e0387$export$2e2bcd8739ae039 = $d1065ccbed8e0387$var$until;

});

parcelRegister("5gSxV", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $hPHpo = parcelRequire("hPHpo");

var $5AqeV = parcelRequire("5AqeV");

var $5XpxN = parcelRequire("5XpxN");
/**
 *
 * Deconstructs an array field from the input documents to output a document for each element.
 * Each output document is the input document with the value of the array field replaced by the element.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig String -> {k: [v]} -> [{k: v}]
 * @param {String} key The key to determine which property of the object should be unwind
 * @param {Object} object The object containing list under property named as key which is to unwind
 * @return {List} A new list of object containing the value of input key having list replaced by each element in the object.
 * @example
 *
 * R.unwind('hobbies', {
 *   name: 'alice',
 *   hobbies: ['Golf', 'Hacking'],
 *   colors: ['red', 'green'],
 * });
 * // [
 * //   { name: 'alice', hobbies: 'Golf', colors: ['red', 'green'] },
 * //   { name: 'alice', hobbies: 'Hacking', colors: ['red', 'green'] }
 * // ]
 */ var $3d68c21a02524e33$var$unwind = /*#__PURE__*/ (0, $kzrqi.default)(function(key, object) {
    // If key is not in object or key is not as a list in object
    if (!(key in object && (0, $hPHpo.default)(object[key]))) return [
        object
    ];
     // Map over object[key] which is a list and assoc each element with key
    return (0, $5AqeV.default)(function(item) {
        return (0, $5XpxN.default)(key, item, object);
    }, object[key]);
});
var $3d68c21a02524e33$export$2e2bcd8739ae039 = $3d68c21a02524e33$var$unwind;

});

parcelRegister("it7Vz", function(module, exports) {

var $ipJAK = parcelRequire("ipJAK");
/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */ var $d72115ab958e1841$var$valuesIn = /*#__PURE__*/ (0, $ipJAK.default)(function valuesIn(obj) {
    var prop;
    var vs = [];
    for(prop in obj)vs[vs.length] = obj[prop];
    return vs;
});
var $d72115ab958e1841$export$2e2bcd8739ae039 = $d72115ab958e1841$var$valuesIn;

});

parcelRegister("9MP96", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
var $72004543b4d7159b$var$Const = function(x) {
    return {
        value: x,
        'fantasy-land/map': function() {
            return this;
        }
    };
};
/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.set, R.over, R.lens, R.lensIndex, R.lensProp, R.lensPath
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */ var $72004543b4d7159b$var$view = /*#__PURE__*/ (0, $kzrqi.default)(function view(lens, x) {
    // Using `Const` effectively ignores the setter function of the `lens`,
    // leaving the value returned by the getter function unmodified.
    return lens($72004543b4d7159b$var$Const)(x).value;
});
var $72004543b4d7159b$export$2e2bcd8739ae039 = $72004543b4d7159b$var$view;

});

parcelRegister("l6iNf", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> b) -> a -> a | b
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless, R.cond
 * @example
 *
 *      // truncate :: String -> String
 *      const truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */ var $f5c8bc7963828e4b$var$when = /*#__PURE__*/ (0, $5jzlJ.default)(function when(pred, whenTrueFn, x) {
    return pred(x) ? whenTrueFn(x) : x;
});
var $f5c8bc7963828e4b$export$2e2bcd8739ae039 = $f5c8bc7963828e4b$var$when;

});

parcelRegister("eqA1j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a80f6f3d931abbc9$export$2e2bcd8739ae039; });

var $kzrqi = parcelRequire("kzrqi");

var $j0Aik = parcelRequire("j0Aik");
/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.whereEq
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */ var $a80f6f3d931abbc9$var$where = /*#__PURE__*/ (0, $kzrqi.default)(function where(spec, testObj) {
    for(var prop in spec){
        if ((0, $j0Aik.default)(prop, spec) && !spec[prop](testObj[prop])) return false;
    }
    return true;
});
var $a80f6f3d931abbc9$export$2e2bcd8739ae039 = $a80f6f3d931abbc9$var$where;

});

parcelRegister("dz2T4", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $j0Aik = parcelRequire("j0Aik");
/**
 * Takes a spec object and a test object; each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `whereAny` returns true if at least one of the predicates return true,
 * false otherwise.
 *
 * `whereAny` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereAny({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('xxx')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 8, y: 34}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 9, y: 21}); //=> false
 *      pred({a: 'bar', b: 'xxx', x: 10, y: 20}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 10, y: 20}); //=> true
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> true
 */ var $9e00c89793c7044f$var$whereAny = /*#__PURE__*/ (0, $kzrqi.default)(function whereAny(spec, testObj) {
    for(var prop in spec){
        if ((0, $j0Aik.default)(prop, spec) && spec[prop](testObj[prop])) return true;
    }
    return false;
});
var $9e00c89793c7044f$export$2e2bcd8739ae039 = $9e00c89793c7044f$var$whereAny;

});

parcelRegister("dMWae", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");

var $fcCge = parcelRequire("fcCge");

var $9QW5G = parcelRequire("9QW5G");

var $eqA1j = parcelRequire("eqA1j");
/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propEq, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */ var $a09ce032f999ef02$var$whereEq = /*#__PURE__*/ (0, $kzrqi.default)(function whereEq(spec, testObj) {
    return (0, $eqA1j.default)((0, $9QW5G.default)((0, $fcCge.default), spec), testObj);
});
var $a09ce032f999ef02$export$2e2bcd8739ae039 = $a09ce032f999ef02$var$whereEq;

});

parcelRegister("6vycu", function(module, exports) {

var $7eI8l = parcelRequire("7eI8l");

var $kzrqi = parcelRequire("kzrqi");

var $6Fx4m = parcelRequire("6Fx4m");

var $6OQk6 = parcelRequire("6OQk6");
/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference, R.remove
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */ var $4bd02ad18636e687$var$without = /*#__PURE__*/ (0, $kzrqi.default)(function(xs, list) {
    return (0, $6OQk6.default)((0, $6Fx4m.default)((0, $7eI8l.default))(xs), list);
});
var $4bd02ad18636e687$export$2e2bcd8739ae039 = $4bd02ad18636e687$var$without;

});

parcelRegister("6cV1e", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Exclusive disjunction logical operation.
 * Returns `true` if one of the arguments is truthy and the other is falsy.
 * Otherwise, it returns `false`.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Logic
 * @sig a -> b -> Boolean
 * @param {Any} a
 * @param {Any} b
 * @return {Boolean} true if one of the arguments is truthy and the other is falsy
 * @see R.or, R.and
 * @example
 *
 *      R.xor(true, true); //=> false
 *      R.xor(true, false); //=> true
 *      R.xor(false, true); //=> true
 *      R.xor(false, false); //=> false
 */ var $485017cdeba689da$var$xor = /*#__PURE__*/ (0, $kzrqi.default)(function xor(a, b) {
    return Boolean(!a ^ !b);
});
var $485017cdeba689da$export$2e2bcd8739ae039 = $485017cdeba689da$var$xor;

});

parcelRegister("ie0zV", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */ var $d449fbb00c5a8b16$var$xprod = /*#__PURE__*/ (0, $kzrqi.default)(function xprod(a, b) {
    // = xprodWith(prepend); (takes about 3 times as long...)
    var idx = 0;
    var ilen = a.length;
    var j;
    var jlen = b.length;
    var result = [];
    while(idx < ilen){
        j = 0;
        while(j < jlen){
            result[result.length] = [
                a[idx],
                b[j]
            ];
            j += 1;
        }
        idx += 1;
    }
    return result;
});
var $d449fbb00c5a8b16$export$2e2bcd8739ae039 = $d449fbb00c5a8b16$var$xprod;

});

parcelRegister("gAhRb", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */ var $c12ddc25d6f9fc6d$var$zip = /*#__PURE__*/ (0, $kzrqi.default)(function zip(a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = [
            a[idx],
            b[idx]
        ];
        idx += 1;
    }
    return rv;
});
var $c12ddc25d6f9fc6d$export$2e2bcd8739ae039 = $c12ddc25d6f9fc6d$var$zip;

});

parcelRegister("goNGG", function(module, exports) {

var $kzrqi = parcelRequire("kzrqi");
/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */ var $bf056e1e88c104ca$var$zipObj = /*#__PURE__*/ (0, $kzrqi.default)(function zipObj(keys, values) {
    var idx = 0;
    var len = Math.min(keys.length, values.length);
    var out = {};
    while(idx < len){
        out[keys[idx]] = values[idx];
        idx += 1;
    }
    return out;
});
var $bf056e1e88c104ca$export$2e2bcd8739ae039 = $bf056e1e88c104ca$var$zipObj;

});

parcelRegister("lh2Xv", function(module, exports) {

var $5jzlJ = parcelRequire("5jzlJ");
/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      const f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */ var $f7cd7b127c439b2a$var$zipWith = /*#__PURE__*/ (0, $5jzlJ.default)(function zipWith(fn, a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = fn(a[idx], b[idx]);
        idx += 1;
    }
    return rv;
});
var $f7cd7b127c439b2a$export$2e2bcd8739ae039 = $f7cd7b127c439b2a$var$zipWith;

});

parcelRegister("hxiVU", function(module, exports) {

var $JtjnN = parcelRequire("JtjnN");

var $ipJAK = parcelRequire("ipJAK");
/**
 * Creates a thunk out of a function. A thunk delays a calculation until
 * its result is needed, providing lazy evaluation of arguments.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((a, b, ..., j) -> k) -> (a, b, ..., j) -> (() -> k)
 * @param {Function} fn A function to wrap in a thunk
 * @return {Function} Expects arguments for `fn` and returns a new function
 *  that, when called, applies those arguments to `fn`.
 * @see R.partial, R.partialRight
 * @example
 *
 *      R.thunkify(R.identity)(42)(); //=> 42
 *      R.thunkify((a, b) => a + b)(25, 17)(); //=> 42
 */ var $cc443473000dc8ad$var$thunkify = /*#__PURE__*/ (0, $ipJAK.default)(function thunkify(fn) {
    return (0, $JtjnN.default)(fn.length, function createThunk() {
        var fnArgs = arguments;
        return function invokeThunk() {
            return fn.apply(this, fnArgs);
        };
    });
});
var $cc443473000dc8ad$export$2e2bcd8739ae039 = $cc443473000dc8ad$var$thunkify;

});



parcelRegister("4iCXN", function(module, exports) {

$parcel$export(module.exports, "pageRoutes", function () { return $3217112f0e3d8d6b$export$738797e9235a190b; });
$parcel$export(module.exports, "syncCurrentAccountQueryParams", function () { return $3217112f0e3d8d6b$export$6b02b60e154f1bdc; });
$parcel$export(module.exports, "redirectToPage", function () { return $3217112f0e3d8d6b$export$f37e913827f0fcca; });
const $3217112f0e3d8d6b$export$738797e9235a190b = {
    index: 'index.html',
    addons: 'addons.html',
    changePictures: 'change-pictures.html',
    combos: 'combos.html',
    faq: 'faq.html',
    privacyPolicy: 'privacy.html',
    registration: {
        showIdFirst: 'reg-id-first.html',
        normal: 'reg-user.html'
    },
    contactCompletion: 'contact-completion.html',
    selectImages: 'select-images.html',
    selfies: 'selfies.html',
    shoppingCart: 'shopping-cart.html',
    selectImagesAddon: 'select-images-addon.html',
    shoot: 'shoot.html',
    aShoot: 'a-shoot.html'
};
function $3217112f0e3d8d6b$export$a0b32aef6b0d7373(search, params = {}) {
    const searchParams = new URLSearchParams(search);
    Object.entries(params).forEach(([key, value])=>{
        searchParams.set(key, value);
    });
    return `?${decodeURIComponent(searchParams.toString())}`;
}
function $3217112f0e3d8d6b$export$6b02b60e154f1bdc({ eventCode: eventCode, attendeeUid: attendeeUid }) {
    const url = new URL(globalThis.location.href);
    url.searchParams.set('eName', eventCode);
    url.searchParams.set('uId', attendeeUid);
    globalThis.history.replaceState({}, '', url);
}
function $3217112f0e3d8d6b$var$redirectConstructor(routes) {
    return Object.keys(routes).reduce((acc, key)=>{
        let value;
        if (typeof routes[key] === 'object') value = $3217112f0e3d8d6b$var$redirectConstructor(routes[key]);
        else value = $3217112f0e3d8d6b$var$initRedirectTo(routes[key]);
        return {
            ...acc,
            [key]: value
        };
    }, {});
}
const $3217112f0e3d8d6b$export$f37e913827f0fcca = $3217112f0e3d8d6b$var$redirectConstructor($3217112f0e3d8d6b$export$738797e9235a190b);
function $3217112f0e3d8d6b$var$initRedirectTo(path) {
    return async ({ rawSearch: rawSearch = '' } = {})=>Promise.resolve().then(()=>{
            globalThis.location.href = `${path}${rawSearch}`;
        });
}

});

parcelRegister("6wMuu", function(module, exports) {

$parcel$export(module.exports, "initLoc", function () { return $4c0b5877e0547ae3$export$4dc9bce783e5bbc5; });
$parcel$export(module.exports, "initEventLoc", function () { return $4c0b5877e0547ae3$export$aac4b56eac704995; });
$parcel$export(module.exports, "getLocalizationContext", function () { return $4c0b5877e0547ae3$export$a688459915bc24e8; });
$parcel$export(module.exports, "getCurrentLanguageSettings", function () { return $4c0b5877e0547ae3$export$788df300595f84a7; });
$parcel$export(module.exports, "setTextToElement", function () { return $4c0b5877e0547ae3$export$d40eaf7f02e82c0b; });
$parcel$export(module.exports, "t", function () { return (parcelRequire("frM9m")).t; });

var $7Ff5S = parcelRequire("7Ff5S");

var $hXoW9 = parcelRequire("hXoW9");
var $frM9m = parcelRequire("frM9m");

var $aeSym = parcelRequire("aeSym");
const $4c0b5877e0547ae3$var$LOC_PARAMS_KEY = 'locParams';
async function $4c0b5877e0547ae3$export$4dc9bce783e5bbc5(params) {
    const storedLocParams = $4c0b5877e0547ae3$var$getLocParams();
    const safeParams = params && typeof params === 'object' ? params : undefined;
    const locParams = safeParams || storedLocParams;
    const languageSettings = (0, $aeSym.normalizeLanguageSettings)(locParams.languageSettings);
    const initialLanguage = $4c0b5877e0547ae3$var$resolveInitialLanguage(languageSettings);
    $4c0b5877e0547ae3$var$setLocParams({
        ...locParams,
        languageSettings: languageSettings
    });
    await (0, $hXoW9.initLoc)({
        orgId: locParams.orgId,
        eventCode: locParams.eventCode,
        projectName: 'webapp',
        languageSettings: languageSettings,
        initialLanguage: initialLanguage
    });
}
async function $4c0b5877e0547ae3$export$aac4b56eac704995(event) {
    await $4c0b5877e0547ae3$export$4dc9bce783e5bbc5($4c0b5877e0547ae3$var$createEventLocParams(event));
}
function $4c0b5877e0547ae3$export$a688459915bc24e8() {
    return $4c0b5877e0547ae3$var$getLocParams();
}
function $4c0b5877e0547ae3$export$7116b8382ffc2f62(event) {
    $4c0b5877e0547ae3$var$setLocParams($4c0b5877e0547ae3$var$createEventLocParams(event));
}
function $4c0b5877e0547ae3$export$788df300595f84a7() {
    return (0, $aeSym.normalizeLanguageSettings)($4c0b5877e0547ae3$var$getLocParams().languageSettings);
}
function $4c0b5877e0547ae3$export$d40eaf7f02e82c0b(cssPath, text) {
    const element = document.querySelector(cssPath);
    if (element) element.textContent = text;
    else {
        const error = new Error(`Element not found for CSS path: ${cssPath}`);
        console.error(error);
        $7Ff5S.captureException(error);
    }
}
function $4c0b5877e0547ae3$var$createEventLocParams(event) {
    return {
        orgId: event.organisation?.id,
        eventCode: event.name,
        languageSettings: (0, $aeSym.getEventLanguageSettings)(event.opts)
    };
}
function $4c0b5877e0547ae3$var$setLocParams(locParams = {}) {
    if (typeof sessionStorage === 'undefined' || !locParams.orgId || !locParams.eventCode) return;
    sessionStorage.setItem($4c0b5877e0547ae3$var$LOC_PARAMS_KEY, JSON.stringify(locParams || {}));
}
function $4c0b5877e0547ae3$var$getLocParams() {
    if (typeof sessionStorage === 'undefined') return {};
    return JSON.parse(sessionStorage.getItem($4c0b5877e0547ae3$var$LOC_PARAMS_KEY) || '{}');
}
function $4c0b5877e0547ae3$var$resolveInitialLanguage(languageSettings) {
    const allowedLanguages = new Set(languageSettings.availableLanguages);
    const storedLanguage = (0, $aeSym.resolveLanguageCode)(localStorage.getItem('i18nextLng'));
    if (allowedLanguages.has(storedLanguage)) return storedLanguage;
    const browserLanguage = (0, $aeSym.resolveLanguageCode)(globalThis.navigator?.language);
    if (allowedLanguages.has(browserLanguage)) return browserLanguage;
    return languageSettings.defaultLanguage;
}

});
parcelRegister("hXoW9", function(module, exports) {

$parcel$export(module.exports, "initLoc", function () { return $d12b4a48d2ac9516$export$4dc9bce783e5bbc5; });
$parcel$export(module.exports, "applyDataLocAttributes", function () { return $d12b4a48d2ac9516$export$ff5a3f66c859145c; });
$parcel$export(module.exports, "getCurrentLanguage", function () { return $d12b4a48d2ac9516$export$604ba5624273df44; });
$parcel$export(module.exports, "t", function () { return (parcelRequire("frM9m")).t; });

var $frM9m = parcelRequire("frM9m");

var $jG9hW = parcelRequire("jG9hW");

var $hAS4R = parcelRequire("hAS4R");

var $aeSym = parcelRequire("aeSym");
async function $d12b4a48d2ac9516$export$4dc9bce783e5bbc5({ orgId: orgId, eventCode: eventCode, projectName: projectName, autoApplyDataLoc: autoApplyDataLoc = true, languageSettings: languageSettings = (0, $aeSym.getDefaultLanguageSettings)(), initialLanguage: initialLanguage, detection: detection } = {}) {
    const normalizedLanguageSettings = (0, $aeSym.normalizeLanguageSettings)(languageSettings);
    const supportedLngs = Array.from(new Set([
        ...normalizedLanguageSettings.availableLanguages,
        'en'
    ]));
    const lng = normalizedLanguageSettings.availableLanguages.includes(initialLanguage) ? initialLanguage : undefined;
    await (0, $frM9m.default).use((0, $jG9hW.default)).use((0, $hAS4R.default)).init({
        fallbackLng: 'en',
        ...lng ? {
            lng: lng
        } : {},
        ...detection ? {
            detection: detection
        } : {},
        load: 'languageOnly',
        debug: true,
        supportedLngs: supportedLngs,
        backend: {
            cdn: "https://lang.occo.io",
            orgId: orgId,
            eventCode: eventCode,
            projectName: projectName
        },
        ns: [
            'common'
        ],
        defaultNS: 'common'
    });
    if (autoApplyDataLoc) $d12b4a48d2ac9516$export$ff5a3f66c859145c();
}
function $d12b4a48d2ac9516$export$ff5a3f66c859145c() {
    const root = typeof document !== 'undefined' ? document : null;
    if (!root || typeof root.querySelectorAll !== 'function') return;
    const applyFromAttribute = (selector, attributeName, applyValue)=>{
        root.querySelectorAll(selector).forEach((element)=>{
            const key = element.getAttribute(attributeName);
            if (!key) return;
            const translated = (0, $frM9m.t)(key);
            if (translated === undefined || translated === null) return;
            applyValue(element, translated);
        });
    };
    applyFromAttribute('[data-loc-text]', 'data-loc-text', (element, value)=>{
        element.textContent = value;
    });
    applyFromAttribute('[data-loc-placeholder]', 'data-loc-placeholder', (element, value)=>{
        element.setAttribute('placeholder', value);
    });
    applyFromAttribute('[data-loc-title]', 'data-loc-title', (element, value)=>{
        element.setAttribute('title', value);
    });
    applyFromAttribute('[data-loc-aria-label]', 'data-loc-aria-label', (element, value)=>{
        element.setAttribute('aria-label', value);
    });
}
async function $d12b4a48d2ac9516$export$61465194746e7fd2(lng) {
    return (0, $frM9m.default).changeLanguage(lng);
}
function $d12b4a48d2ac9516$export$604ba5624273df44() {
    return (0, $frM9m.default).language;
}

});
parcelRegister("frM9m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3eeba3b3a1cab1e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "t", function () { return $b3eeba3b3a1cab1e$export$625550452a3fa3ec; });
const $b3eeba3b3a1cab1e$var$isString = (obj)=>typeof obj === 'string';
const $b3eeba3b3a1cab1e$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $b3eeba3b3a1cab1e$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $b3eeba3b3a1cab1e$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $b3eeba3b3a1cab1e$var$lastOfPathSeparatorRegExp = /###/g;
const $b3eeba3b3a1cab1e$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($b3eeba3b3a1cab1e$var$lastOfPathSeparatorRegExp, '.') : key;
const $b3eeba3b3a1cab1e$var$canNotTraverseDeeper = (object)=>!object || $b3eeba3b3a1cab1e$var$isString(object);
const $b3eeba3b3a1cab1e$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$b3eeba3b3a1cab1e$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($b3eeba3b3a1cab1e$var$canNotTraverseDeeper(object)) return {};
        const key = $b3eeba3b3a1cab1e$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($b3eeba3b3a1cab1e$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $b3eeba3b3a1cab1e$var$cleanKey(stack[stackIndex])
    };
};
const $b3eeba3b3a1cab1e$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $b3eeba3b3a1cab1e$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $b3eeba3b3a1cab1e$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $b3eeba3b3a1cab1e$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $b3eeba3b3a1cab1e$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $b3eeba3b3a1cab1e$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $b3eeba3b3a1cab1e$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $b3eeba3b3a1cab1e$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $b3eeba3b3a1cab1e$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $b3eeba3b3a1cab1e$var$getPath(data, key);
    if (value !== undefined) return value;
    return $b3eeba3b3a1cab1e$var$getPath(defaultData, key);
};
const $b3eeba3b3a1cab1e$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($b3eeba3b3a1cab1e$var$isString(target[prop]) || target[prop] instanceof String || $b3eeba3b3a1cab1e$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $b3eeba3b3a1cab1e$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $b3eeba3b3a1cab1e$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $b3eeba3b3a1cab1e$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $b3eeba3b3a1cab1e$var$escape = (data)=>{
    if ($b3eeba3b3a1cab1e$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$b3eeba3b3a1cab1e$var$_entityMap[s]);
    return data;
};
class $b3eeba3b3a1cab1e$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $b3eeba3b3a1cab1e$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $b3eeba3b3a1cab1e$var$looksLikeObjectPathRegExpCache = new $b3eeba3b3a1cab1e$var$RegExpCache(20);
const $b3eeba3b3a1cab1e$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $b3eeba3b3a1cab1e$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $b3eeba3b3a1cab1e$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $b3eeba3b3a1cab1e$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $b3eeba3b3a1cab1e$var$getCleanedCode = (code)=>code?.replace('_', '-');
const $b3eeba3b3a1cab1e$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $b3eeba3b3a1cab1e$var$Logger {
    constructor(concreteLogger, options1 = {}){
        this.init(concreteLogger, options1);
    }
    init(concreteLogger, options1 = {}) {
        this.prefix = options1.prefix || 'i18next:';
        this.logger = concreteLogger || $b3eeba3b3a1cab1e$var$consoleLogger;
        this.options = options1;
        this.debug = options1.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($b3eeba3b3a1cab1e$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $b3eeba3b3a1cab1e$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options1) {
        options1 = options1 || this.options;
        options1.prefix = options1.prefix || this.prefix;
        return new $b3eeba3b3a1cab1e$var$Logger(this.logger, options1);
    }
}
var $b3eeba3b3a1cab1e$var$baseLogger = new $b3eeba3b3a1cab1e$var$Logger();
class $b3eeba3b3a1cab1e$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $b3eeba3b3a1cab1e$var$ResourceStore extends $b3eeba3b3a1cab1e$var$EventEmitter {
    constructor(data, options1 = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options1;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options1 = {}) {
        const keySeparator = options1.keySeparator !== undefined ? options1.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options1.ignoreJSONStructure !== undefined ? options1.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($b3eeba3b3a1cab1e$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $b3eeba3b3a1cab1e$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$b3eeba3b3a1cab1e$var$isString(key)) return result;
        return $b3eeba3b3a1cab1e$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options1 = {
        silent: false
    }) {
        const keySeparator = options1.keySeparator !== undefined ? options1.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $b3eeba3b3a1cab1e$var$setPath(this.data, path, value);
        if (!options1.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options1 = {
        silent: false
    }) {
        for(const m in resources)if ($b3eeba3b3a1cab1e$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options1.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options1 = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $b3eeba3b3a1cab1e$var$getPath(this.data, path) || {};
        if (!options1.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $b3eeba3b3a1cab1e$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $b3eeba3b3a1cab1e$var$setPath(this.data, path, pack);
        if (!options1.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $b3eeba3b3a1cab1e$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options1, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options1, translator) ?? value;
        });
        return value;
    }
};
const $b3eeba3b3a1cab1e$var$checkedLoadedFor = {};
const $b3eeba3b3a1cab1e$var$shouldHandleAsObject = (res)=>!$b3eeba3b3a1cab1e$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $b3eeba3b3a1cab1e$var$Translator extends $b3eeba3b3a1cab1e$var$EventEmitter {
    constructor(services, options1 = {}){
        super();
        $b3eeba3b3a1cab1e$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options1;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        return resolved?.res !== undefined;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$b3eeba3b3a1cab1e$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $b3eeba3b3a1cab1e$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $b3eeba3b3a1cab1e$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$b3eeba3b3a1cab1e$var$isString(opt.count);
        const hasDefaultValue = $b3eeba3b3a1cab1e$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $b3eeba3b3a1cab1e$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($b3eeba3b3a1cab1e$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $b3eeba3b3a1cab1e$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $b3eeba3b3a1cab1e$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $b3eeba3b3a1cab1e$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$b3eeba3b3a1cab1e$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $b3eeba3b3a1cab1e$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $b3eeba3b3a1cab1e$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($b3eeba3b3a1cab1e$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$b3eeba3b3a1cab1e$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($b3eeba3b3a1cab1e$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$b3eeba3b3a1cab1e$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $b3eeba3b3a1cab1e$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options1 = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options1);
        return this.resourceStore.getResource(code, ns, key, options1);
    }
    getUsedParamsDetails(options1 = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options1.replace && !$b3eeba3b3a1cab1e$var$isString(options1.replace);
        let data = useOptionsReplaceForData ? options1.replace : options1;
        if (useOptionsReplaceForData && typeof options1.count !== 'undefined') data.count = options1.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options1) {
        const prefix = 'defaultValue';
        for(const option in options1){
            if (Object.prototype.hasOwnProperty.call(options1, option) && prefix === option.substring(0, prefix.length) && undefined !== options1[option]) return true;
        }
        return false;
    }
}
class $b3eeba3b3a1cab1e$var$LanguageUtil {
    constructor(options1){
        this.options = options1;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $b3eeba3b3a1cab1e$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $b3eeba3b3a1cab1e$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($b3eeba3b3a1cab1e$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($b3eeba3b3a1cab1e$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($b3eeba3b3a1cab1e$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($b3eeba3b3a1cab1e$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $b3eeba3b3a1cab1e$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $b3eeba3b3a1cab1e$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $b3eeba3b3a1cab1e$var$PluralResolver {
    constructor(languageUtils, options1 = {}){
        this.languageUtils = languageUtils;
        this.options = options1;
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options1 = {}) {
        const cleanedCode = $b3eeba3b3a1cab1e$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options1.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $b3eeba3b3a1cab1e$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $b3eeba3b3a1cab1e$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options1);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options1 = {}) {
        let rule = this.getRule(code, options1);
        if (!rule) rule = this.getRule('dev', options1);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options1 = {}) {
        return this.getSuffixes(code, options1).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options1 = {}) {
        let rule = this.getRule(code, options1);
        if (!rule) rule = this.getRule('dev', options1);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$b3eeba3b3a1cab1e$var$suffixesOrder[pluralCategory1] - $b3eeba3b3a1cab1e$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options1.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options1 = {}) {
        const rule = this.getRule(code, options1);
        if (rule) return `${this.options.prepend}${options1.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options1);
    }
}
const $b3eeba3b3a1cab1e$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $b3eeba3b3a1cab1e$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $b3eeba3b3a1cab1e$var$isString(key)) {
        path = $b3eeba3b3a1cab1e$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $b3eeba3b3a1cab1e$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $b3eeba3b3a1cab1e$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $b3eeba3b3a1cab1e$var$Interpolator {
    constructor(options1 = {}){
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger.create('interpolator');
        this.options = options1;
        this.format = options1?.interpolation?.format || ((value)=>value);
        this.init(options1);
    }
    init(options1 = {}) {
        if (!options1.interpolation) options1.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options1.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $b3eeba3b3a1cab1e$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $b3eeba3b3a1cab1e$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $b3eeba3b3a1cab1e$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $b3eeba3b3a1cab1e$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $b3eeba3b3a1cab1e$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $b3eeba3b3a1cab1e$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $b3eeba3b3a1cab1e$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options1) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $b3eeba3b3a1cab1e$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options1,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($b3eeba3b3a1cab1e$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options1,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options1?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options1?.interpolation?.skipOnVariables !== undefined ? options1.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$b3eeba3b3a1cab1e$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $b3eeba3b3a1cab1e$var$regexSafe(this.escape(val)) : $b3eeba3b3a1cab1e$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options1);
                        value = $b3eeba3b3a1cab1e$var$isString(temp) ? temp : '';
                    } else if (options1 && Object.prototype.hasOwnProperty.call(options1, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$b3eeba3b3a1cab1e$var$isString(value) && !this.useRawValueToEscape) value = $b3eeba3b3a1cab1e$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options1 = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options1
            };
            clonedOptions = clonedOptions.replace && !$b3eeba3b3a1cab1e$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$b3eeba3b3a1cab1e$var$isString(value)) return value;
            if (!$b3eeba3b3a1cab1e$var$isString(value)) value = $b3eeba3b3a1cab1e$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options1.lng, {
                    ...options1,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $b3eeba3b3a1cab1e$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $b3eeba3b3a1cab1e$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($b3eeba3b3a1cab1e$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $b3eeba3b3a1cab1e$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($b3eeba3b3a1cab1e$var$getCleanedCode(l), o)(v);
class $b3eeba3b3a1cab1e$var$Formatter {
    constructor(options1 = {}){
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger.create('formatter');
        this.options = options1;
        this.init(options1);
    }
    init(services, options1 = {
        interpolation: {}
    }) {
        this.formatSeparator = options1.interpolation.formatSeparator || ',';
        const cf = options1.cacheInBuiltFormats ? $b3eeba3b3a1cab1e$var$createCachedFormatter : $b3eeba3b3a1cab1e$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $b3eeba3b3a1cab1e$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options1 = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $b3eeba3b3a1cab1e$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options1?.formatParams?.[options1.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options1.locale || options1.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options1,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $b3eeba3b3a1cab1e$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $b3eeba3b3a1cab1e$var$Connector extends $b3eeba3b3a1cab1e$var$EventEmitter {
    constructor(backend, store, services, options1 = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options1;
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options1.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options1.maxRetries >= 0 ? options1.maxRetries : 5;
        this.retryTimeout = options1.retryTimeout >= 1 ? options1.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options1.backend, options1);
    }
    queueLoad(languages, namespaces, options1, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options1.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $b3eeba3b3a1cab1e$var$pushPath(q.loaded, [
                lng
            ], ns);
            $b3eeba3b3a1cab1e$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options1 = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($b3eeba3b3a1cab1e$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($b3eeba3b3a1cab1e$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options1, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options1 = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options1,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $b3eeba3b3a1cab1e$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($b3eeba3b3a1cab1e$var$isString(args[1])) ret.defaultValue = args[1];
            if ($b3eeba3b3a1cab1e$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options1 = args[3] || args[2];
                Object.keys(options1).forEach((key)=>{
                    ret[key] = options1[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $b3eeba3b3a1cab1e$var$transformOptions = (options1)=>{
    if ($b3eeba3b3a1cab1e$var$isString(options1.ns)) options1.ns = [
        options1.ns
    ];
    if ($b3eeba3b3a1cab1e$var$isString(options1.fallbackLng)) options1.fallbackLng = [
        options1.fallbackLng
    ];
    if ($b3eeba3b3a1cab1e$var$isString(options1.fallbackNS)) options1.fallbackNS = [
        options1.fallbackNS
    ];
    if (options1.supportedLngs?.indexOf?.('cimode') < 0) options1.supportedLngs = options1.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options1.initImmediate === 'boolean') options1.initAsync = options1.initImmediate;
    return options1;
};
const $b3eeba3b3a1cab1e$var$noop = ()=>{};
const $b3eeba3b3a1cab1e$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $b3eeba3b3a1cab1e$var$I18n extends $b3eeba3b3a1cab1e$var$EventEmitter {
    constructor(options1 = {}, callback){
        super();
        this.options = $b3eeba3b3a1cab1e$var$transformOptions(options1);
        this.services = {};
        this.logger = $b3eeba3b3a1cab1e$var$baseLogger;
        this.modules = {
            external: []
        };
        $b3eeba3b3a1cab1e$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options1.isClone) {
            if (!this.options.initAsync) {
                this.init(options1, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options1, callback);
            }, 0);
        }
    }
    init(options1 = {}, callback) {
        this.isInitializing = true;
        if (typeof options1 === 'function') {
            callback = options1;
            options1 = {};
        }
        if (options1.defaultNS == null && options1.ns) {
            if ($b3eeba3b3a1cab1e$var$isString(options1.ns)) options1.defaultNS = options1.ns;
            else if (options1.ns.indexOf('translation') < 0) options1.defaultNS = options1.ns[0];
        }
        const defOpts = $b3eeba3b3a1cab1e$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$b3eeba3b3a1cab1e$var$transformOptions(options1)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options1.keySeparator !== undefined) this.options.userDefinedKeySeparator = options1.keySeparator;
        if (options1.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options1.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $b3eeba3b3a1cab1e$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $b3eeba3b3a1cab1e$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $b3eeba3b3a1cab1e$var$Formatter;
            const lu = new $b3eeba3b3a1cab1e$var$LanguageUtil(this.options);
            this.store = new $b3eeba3b3a1cab1e$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $b3eeba3b3a1cab1e$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $b3eeba3b3a1cab1e$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $b3eeba3b3a1cab1e$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $b3eeba3b3a1cab1e$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $b3eeba3b3a1cab1e$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $b3eeba3b3a1cab1e$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $b3eeba3b3a1cab1e$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $b3eeba3b3a1cab1e$var$noop) {
        let usedCallback = callback;
        const usedLng = $b3eeba3b3a1cab1e$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $b3eeba3b3a1cab1e$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $b3eeba3b3a1cab1e$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $b3eeba3b3a1cab1e$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $b3eeba3b3a1cab1e$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $b3eeba3b3a1cab1e$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($b3eeba3b3a1cab1e$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${o.keyPrefix}${keySeparator}${k}`);
            else resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            return this.t(resultKey, o);
        };
        if ($b3eeba3b3a1cab1e$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options1 = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options1.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options1.precheck) {
            const preResult = options1.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $b3eeba3b3a1cab1e$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($b3eeba3b3a1cab1e$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $b3eeba3b3a1cab1e$var$defer();
        if ($b3eeba3b3a1cab1e$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $b3eeba3b3a1cab1e$var$LanguageUtil($b3eeba3b3a1cab1e$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options1 = {}, callback) {
        return new $b3eeba3b3a1cab1e$var$I18n(options1, callback);
    }
    cloneInstance(options1 = {}, callback = $b3eeba3b3a1cab1e$var$noop) {
        const forkResourceStore = options1.forkResourceStore;
        if (forkResourceStore) delete options1.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options1,
            isClone: true
        };
        const clone = new $b3eeba3b3a1cab1e$var$I18n(mergedOptions);
        if (options1.debug !== undefined || options1.prefix !== undefined) clone.logger = clone.logger.clone(options1);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $b3eeba3b3a1cab1e$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $b3eeba3b3a1cab1e$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $b3eeba3b3a1cab1e$export$2e2bcd8739ae039 = $b3eeba3b3a1cab1e$var$I18n.createInstance();
$b3eeba3b3a1cab1e$export$2e2bcd8739ae039.createInstance = $b3eeba3b3a1cab1e$var$I18n.createInstance;
const $b3eeba3b3a1cab1e$export$99152e8d49ca4e7d = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.createInstance;
const $b3eeba3b3a1cab1e$export$147ec2801e896265 = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.dir;
const $b3eeba3b3a1cab1e$export$2cd8252107eb640b = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.init;
const $b3eeba3b3a1cab1e$export$d3d08d944062d7e = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.loadResources;
const $b3eeba3b3a1cab1e$export$a5d9bf5d83fcab09 = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.reloadResources;
const $b3eeba3b3a1cab1e$export$1f96ae73734a86cc = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.use;
const $b3eeba3b3a1cab1e$export$61465194746e7fd2 = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.changeLanguage;
const $b3eeba3b3a1cab1e$export$f90d180fc7da3b3b = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.getFixedT;
const $b3eeba3b3a1cab1e$export$625550452a3fa3ec = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.t;
const $b3eeba3b3a1cab1e$export$f7e9f41ea797a17 = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.exists;
const $b3eeba3b3a1cab1e$export$2b4b218e406d2d00 = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.setDefaultNamespace;
const $b3eeba3b3a1cab1e$export$93d9ee97c1ad3f31 = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.hasLoadedNamespace;
const $b3eeba3b3a1cab1e$export$83be934b53fff43b = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.loadNamespaces;
const $b3eeba3b3a1cab1e$export$8cd7e7a54fa865bc = $b3eeba3b3a1cab1e$export$2e2bcd8739ae039.loadLanguages;

});

parcelRegister("jG9hW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5392509cecfc3c8$export$2e2bcd8739ae039; });
const { slice: $e5392509cecfc3c8$var$slice, forEach: $e5392509cecfc3c8$var$forEach } = [];
function $e5392509cecfc3c8$var$defaults(obj) {
    $e5392509cecfc3c8$var$forEach.call($e5392509cecfc3c8$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $e5392509cecfc3c8$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $e5392509cecfc3c8$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $e5392509cecfc3c8$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$e5392509cecfc3c8$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$e5392509cecfc3c8$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $e5392509cecfc3c8$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $e5392509cecfc3c8$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name) {
        this.create(name, '', -1);
    }
};
var $e5392509cecfc3c8$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $e5392509cecfc3c8$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $e5392509cecfc3c8$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $e5392509cecfc3c8$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
let $e5392509cecfc3c8$var$hasLocalStorageSupport = null;
const $e5392509cecfc3c8$var$localStorageAvailable = ()=>{
    if ($e5392509cecfc3c8$var$hasLocalStorageSupport !== null) return $e5392509cecfc3c8$var$hasLocalStorageSupport;
    try {
        $e5392509cecfc3c8$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$e5392509cecfc3c8$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $e5392509cecfc3c8$var$hasLocalStorageSupport = false;
    }
    return $e5392509cecfc3c8$var$hasLocalStorageSupport;
};
var $e5392509cecfc3c8$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $e5392509cecfc3c8$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $e5392509cecfc3c8$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $e5392509cecfc3c8$var$hasSessionStorageSupport = null;
const $e5392509cecfc3c8$var$sessionStorageAvailable = ()=>{
    if ($e5392509cecfc3c8$var$hasSessionStorageSupport !== null) return $e5392509cecfc3c8$var$hasSessionStorageSupport;
    try {
        $e5392509cecfc3c8$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$e5392509cecfc3c8$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $e5392509cecfc3c8$var$hasSessionStorageSupport = false;
    }
    return $e5392509cecfc3c8$var$hasSessionStorageSupport;
};
var $e5392509cecfc3c8$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $e5392509cecfc3c8$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $e5392509cecfc3c8$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $e5392509cecfc3c8$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $e5392509cecfc3c8$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $e5392509cecfc3c8$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $e5392509cecfc3c8$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $e5392509cecfc3c8$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $e5392509cecfc3c8$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $e5392509cecfc3c8$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$e5392509cecfc3c8$var$canCookies) $e5392509cecfc3c8$var$order.splice(1, 1);
const $e5392509cecfc3c8$var$getDefaults = ()=>({
        order: $e5392509cecfc3c8$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $e5392509cecfc3c8$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $e5392509cecfc3c8$var$defaults(options, this.options || {}, $e5392509cecfc3c8$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($e5392509cecfc3c8$var$cookie$1);
        this.addDetector($e5392509cecfc3c8$var$querystring);
        this.addDetector($e5392509cecfc3c8$var$localStorage);
        this.addDetector($e5392509cecfc3c8$var$sessionStorage);
        this.addDetector($e5392509cecfc3c8$var$navigator$1);
        this.addDetector($e5392509cecfc3c8$var$htmlTag);
        this.addDetector($e5392509cecfc3c8$var$path);
        this.addDetector($e5392509cecfc3c8$var$subdomain);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$e5392509cecfc3c8$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$e5392509cecfc3c8$export$2e2bcd8739ae039.type = 'languageDetector';

});

parcelRegister("hAS4R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccefbf1daf1929b9$export$2e2bcd8739ae039; });

var $72VJ8 = parcelRequire("72VJ8");

var $fd2xD = parcelRequire("fd2xD");
var $a2fRy = parcelRequire("a2fRy");

var $8fp0t = parcelRequire("8fp0t");
class $ccefbf1daf1929b9$export$2e2bcd8739ae039 {
    static type = 'backend';
    init(services, backendOptions = {}, i18nextOptions = {}) {
        this.services = services;
        this.options = backendOptions;
        this.i18nextOptions = i18nextOptions;
        this.missingContextWarningShown = false;
        this.orgBackend = new (0, $72VJ8.default)();
        // All translations are now stored at org level only
        this.orgBackend.init(services, {
            loadPath: `${backendOptions.cdn}/${backendOptions.orgId}/${backendOptions.projectName}/{{lng}}/{{ns}}.json`
        }, i18nextOptions);
    }
    read(language, namespace, callback) {
        const { eventCode: eventCode, orgId: orgId, projectName: projectName } = this.options;
        const fallbackData = (0, $a2fRy.default)([
            projectName,
            language,
            namespace
        ], (0, $8fp0t.default)) || {};
        if (!orgId || !eventCode) {
            if (!this.missingContextWarningShown) {
                console.warn("[I18nOCCOBackend] Organisation ID or Event Code is missing. Using bundled translations; remote localization files will not be requested.");
                this.missingContextWarningShown = true;
            }
            callback(null, fallbackData);
            return;
        }
        this.orgBackend.read(language, namespace, (err, data)=>{
            let orgData = data;
            if (err) {
                console.warn('[I18nOCCOBackend] Failed to read from org source:', err);
                orgData = {};
            }
            // Transform nested structure to flat key-value pairs
            // Structure: { "key": { "value": "org-level", "eventCode1": "event-specific" } }
            const transformedOrgData = Object.entries(orgData || {}).reduce((acc, [key, val])=>{
                const resolvedValue = eventCode && val[eventCode] !== undefined ? val[eventCode] : val.value;
                if (resolvedValue === undefined) return acc;
                // Use event-specific value if exists, otherwise use org-level value
                acc[key] = resolvedValue;
                return acc;
            }, {});
            const merged = (0, $fd2xD.default)(fallbackData, transformedOrgData);
            callback(null, merged);
        });
    }
}

});
parcelRegister("72VJ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52157fb216d7b4ed$export$2e2bcd8739ae039; });

var $cl44U = parcelRequire("cl44U");

var $lvhMn = parcelRequire("lvhMn");
function $52157fb216d7b4ed$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $52157fb216d7b4ed$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $52157fb216d7b4ed$var$_typeof(o);
}
function $52157fb216d7b4ed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $52157fb216d7b4ed$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $52157fb216d7b4ed$var$ownKeys(Object(t), !0).forEach(function(r) {
            $52157fb216d7b4ed$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $52157fb216d7b4ed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $52157fb216d7b4ed$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $52157fb216d7b4ed$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $52157fb216d7b4ed$var$_toPropertyKey(o.key), o);
    }
}
function $52157fb216d7b4ed$var$_createClass(e, r, t) {
    return r && $52157fb216d7b4ed$var$_defineProperties(e.prototype, r), t && $52157fb216d7b4ed$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $52157fb216d7b4ed$var$_defineProperty(e, r, t) {
    return (r = $52157fb216d7b4ed$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $52157fb216d7b4ed$var$_toPropertyKey(t) {
    var i = $52157fb216d7b4ed$var$_toPrimitive(t, "string");
    return "symbol" == $52157fb216d7b4ed$var$_typeof(i) ? i : i + "";
}
function $52157fb216d7b4ed$var$_toPrimitive(t, r) {
    if ("object" != $52157fb216d7b4ed$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $52157fb216d7b4ed$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $52157fb216d7b4ed$var$getDefaults = function getDefaults() {
    return {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        addPath: '/locales/add/{{lng}}/{{ns}}',
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $52157fb216d7b4ed$var$_defineProperty({}, key, fallbackValue || '');
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $lvhMn.default),
        reloadInterval: typeof window !== 'undefined' ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: 'cors',
            credentials: 'same-origin',
            cache: 'default'
        }
    };
};
var $52157fb216d7b4ed$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $52157fb216d7b4ed$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = 'backend';
        this.init(services, options, allOptions);
    }
    return $52157fb216d7b4ed$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $52157fb216d7b4ed$var$_objectSpread($52157fb216d7b4ed$var$_objectSpread($52157fb216d7b4ed$var$_objectSpread({}, $52157fb216d7b4ed$var$getDefaults()), this.options || {}), options);
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) {
                    var timer = setInterval(function() {
                        return _this.reload();
                    }, this.options.reloadInterval);
                    if ($52157fb216d7b4ed$var$_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
                }
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === 'function') loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $cl44U.makePromise)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join('+'),
                        ns: namespaces.join('+')
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === 'string' ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === 'string' ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
                    if (!res && err && err.message) {
                        var errorMessage = err.message.toLowerCase();
                        var isNetworkError = [
                            'failed',
                            'fetch',
                            'network',
                            'load'
                        ].find(function(term) {
                            return errorMessage.indexOf(term) > -1;
                        });
                        if (isNetworkError) return callback('failed loading ' + url + ': ' + err.message, true);
                    }
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === 'string') ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = 'failed parsing ' + url + ' to json';
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === 'string') languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === 'function') addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === 'function') callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, 'read', null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
}();
$52157fb216d7b4ed$var$Backend.type = 'backend';
var $52157fb216d7b4ed$export$2e2bcd8739ae039 = $52157fb216d7b4ed$var$Backend;

});
parcelRegister("cl44U", function(module, exports) {

$parcel$export(module.exports, "hasXMLHttpRequest", function () { return $8fba9c06a56c1a24$export$87022daa49baf612; });
$parcel$export(module.exports, "makePromise", function () { return $8fba9c06a56c1a24$export$1625492ec82002b9; });
function $8fba9c06a56c1a24$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8fba9c06a56c1a24$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8fba9c06a56c1a24$var$_typeof(o);
}
var $8fba9c06a56c1a24$var$arr = [];
var $8fba9c06a56c1a24$var$each = $8fba9c06a56c1a24$var$arr.forEach;
var $8fba9c06a56c1a24$var$slice = $8fba9c06a56c1a24$var$arr.slice;
function $8fba9c06a56c1a24$export$ebe90cb607ad99e(obj) {
    $8fba9c06a56c1a24$var$each.call($8fba9c06a56c1a24$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $8fba9c06a56c1a24$export$87022daa49baf612() {
    return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : $8fba9c06a56c1a24$var$_typeof(XMLHttpRequest)) === 'object';
}
function $8fba9c06a56c1a24$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === 'function';
}
function $8fba9c06a56c1a24$export$1625492ec82002b9(maybePromise) {
    if ($8fba9c06a56c1a24$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}

});

parcelRegister("lvhMn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa7a48ce65104d4c$export$2e2bcd8739ae039; });

var $cl44U = parcelRequire("cl44U");
function $fa7a48ce65104d4c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fa7a48ce65104d4c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fa7a48ce65104d4c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fa7a48ce65104d4c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fa7a48ce65104d4c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fa7a48ce65104d4c$var$_defineProperty(e, r, t) {
    return (r = $fa7a48ce65104d4c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fa7a48ce65104d4c$var$_toPropertyKey(t) {
    var i = $fa7a48ce65104d4c$var$_toPrimitive(t, "string");
    return "symbol" == $fa7a48ce65104d4c$var$_typeof(i) ? i : i + "";
}
function $fa7a48ce65104d4c$var$_toPrimitive(t, r) {
    if ("object" != $fa7a48ce65104d4c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fa7a48ce65104d4c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fa7a48ce65104d4c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fa7a48ce65104d4c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fa7a48ce65104d4c$var$_typeof(o);
}
var $fa7a48ce65104d4c$var$fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $fa7a48ce65104d4c$var$fetchApi = $parcel$global.fetch;
else if (typeof window !== 'undefined' && window.fetch) $fa7a48ce65104d4c$var$fetchApi = window.fetch;
var $fa7a48ce65104d4c$var$XmlHttpRequestApi;
if ((0, $cl44U.hasXMLHttpRequest)()) {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.XMLHttpRequest) $fa7a48ce65104d4c$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== 'undefined' && window.XMLHttpRequest) $fa7a48ce65104d4c$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $fa7a48ce65104d4c$var$ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.ActiveXObject) $fa7a48ce65104d4c$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== 'undefined' && window.ActiveXObject) $fa7a48ce65104d4c$var$ActiveXObjectApi = window.ActiveXObject;
}
if (typeof $fa7a48ce65104d4c$var$fetchApi !== 'function') $fa7a48ce65104d4c$var$fetchApi = undefined;

if (!$fa7a48ce65104d4c$var$fetchApi && !$fa7a48ce65104d4c$var$XmlHttpRequestApi && !$fa7a48ce65104d4c$var$ActiveXObjectApi) try {
    (parcelRequire("jQII8")).then(function(mod) {
        $fa7a48ce65104d4c$var$fetchApi = mod.default;
    }).catch(function() {});
} catch (e) {}
var $fa7a48ce65104d4c$var$addQueryString = function addQueryString(url, params) {
    if (params && $fa7a48ce65104d4c$var$_typeof(params) === 'object') {
        var queryString = '';
        for(var paramName in params)queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
    return url;
};
var $fa7a48ce65104d4c$var$fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
    var resolver = function resolver(response) {
        if (!response.ok) return callback(response.statusText || 'Error', {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (altFetch) {
        var altResponse = altFetch(url, fetchOptions);
        if (altResponse instanceof Promise) {
            altResponse.then(resolver).catch(callback);
            return;
        }
    }
    if (typeof fetch === 'function') fetch(url, fetchOptions).then(resolver).catch(callback);
    else $fa7a48ce65104d4c$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
var $fa7a48ce65104d4c$var$omitFetchOptions = false;
var $fa7a48ce65104d4c$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $fa7a48ce65104d4c$var$addQueryString(url, options.queryStringParams);
    var headers = $fa7a48ce65104d4c$var$_objectSpread({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
    if (typeof window === 'undefined' && typeof $parcel$global !== 'undefined' && typeof $parcel$global.process !== 'undefined' && $parcel$global.process.versions && $parcel$global.process.versions.node) headers['User-Agent'] = "i18next-http-backend (node/".concat($parcel$global.process.version, "; ").concat($parcel$global.process.platform, " ").concat($parcel$global.process.arch, ")");
    if (payload) headers['Content-Type'] = 'application/json';
    var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = $fa7a48ce65104d4c$var$_objectSpread({
        method: payload ? 'POST' : 'GET',
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $fa7a48ce65104d4c$var$omitFetchOptions ? {} : reqOptions);
    var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
    try {
        $fa7a48ce65104d4c$var$fetchIt(url, fetchOptions, callback, altFetch);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $fa7a48ce65104d4c$var$fetchIt(url, fetchOptions, callback, altFetch);
            $fa7a48ce65104d4c$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $fa7a48ce65104d4c$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $fa7a48ce65104d4c$var$_typeof(payload) === 'object') payload = $fa7a48ce65104d4c$var$addQueryString('', payload).slice(1);
    if (options.queryStringParams) url = $fa7a48ce65104d4c$var$addQueryString(url, options.queryStringParams);
    try {
        var x = $fa7a48ce65104d4c$var$XmlHttpRequestApi ? new $fa7a48ce65104d4c$var$XmlHttpRequestApi() : new $fa7a48ce65104d4c$var$ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
        x.open(payload ? 'POST' : 'GET', url, 1);
        if (!options.crossDomain) x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (x.overrideMimeType) x.overrideMimeType('application/json');
        var h = options.customHeaders;
        h = typeof h === 'function' ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $fa7a48ce65104d4c$var$request = function request(options, url, payload, callback) {
    if (typeof payload === 'function') {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($fa7a48ce65104d4c$var$fetchApi && url.indexOf('file:') !== 0) return $fa7a48ce65104d4c$var$requestWithFetch(options, url, payload, callback);
    if ((0, $cl44U.hasXMLHttpRequest)() || typeof ActiveXObject === 'function') return $fa7a48ce65104d4c$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error('No fetch and no xhr implementation found!'));
};
var $fa7a48ce65104d4c$export$2e2bcd8739ae039 = $fa7a48ce65104d4c$var$request;

});
parcelRegister("jQII8", function(module, exports) {
module.exports = $parcel$import("1fhCl").then(()=>parcelRequire('3xLA7'));

});



parcelRegister("fd2xD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b12a0a98000b2ae7$export$2e2bcd8739ae039; });

var $dOqR5 = parcelRequire("dOqR5");

var $aROlV = parcelRequire("aROlV");
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */ var $b12a0a98000b2ae7$var$mergeDeepRight = /*#__PURE__*/ (0, $dOqR5.default)(function mergeDeepRight(lObj, rObj) {
    return (0, $aROlV.default)(function(k, lVal, rVal) {
        return rVal;
    }, lObj, rObj);
});
var $b12a0a98000b2ae7$export$2e2bcd8739ae039 = $b12a0a98000b2ae7$var$mergeDeepRight;

});
parcelRegister("dOqR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0e4c6c51bf5c217$export$2e2bcd8739ae039; });

var $lpfXx = parcelRequire("lpfXx");

var $jfKIm = parcelRequire("jfKIm");
function $a0e4c6c51bf5c217$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $jfKIm.default)(a) ? f2 : (0, $lpfXx.default)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $jfKIm.default)(a) && (0, $jfKIm.default)(b) ? f2 : (0, $jfKIm.default)(a) ? (0, $lpfXx.default)(function(_a) {
                    return fn(_a, b);
                }) : (0, $jfKIm.default)(b) ? (0, $lpfXx.default)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}

});
parcelRegister("lpfXx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9584ff410f094d8$export$2e2bcd8739ae039; });

var $jfKIm = parcelRequire("jfKIm");
function $f9584ff410f094d8$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $jfKIm.default)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}

});
parcelRegister("jfKIm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e043a792a0d4d9c8$export$2e2bcd8739ae039; });
function $e043a792a0d4d9c8$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

});



parcelRegister("aROlV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e95e996ae53c0de$export$2e2bcd8739ae039; });

var $fF7BY = parcelRequire("fF7BY");

var $c4XcU = parcelRequire("c4XcU");

var $gDkGA = parcelRequire("gDkGA");
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $7e95e996ae53c0de$var$mergeDeepWithKey = /*#__PURE__*/ (0, $fF7BY.default)(function mergeDeepWithKey(fn, lObj, rObj) {
    return (0, $gDkGA.default)(function(k, lVal, rVal) {
        if ((0, $c4XcU.default)(lVal) && (0, $c4XcU.default)(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
var $7e95e996ae53c0de$export$2e2bcd8739ae039 = $7e95e996ae53c0de$var$mergeDeepWithKey;

});
parcelRegister("fF7BY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b67096d358a17062$export$2e2bcd8739ae039; });

var $lpfXx = parcelRequire("lpfXx");

var $dOqR5 = parcelRequire("dOqR5");

var $jfKIm = parcelRequire("jfKIm");
function $b67096d358a17062$export$2e2bcd8739ae039(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, $jfKIm.default)(a) ? f3 : (0, $dOqR5.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, $jfKIm.default)(a) && (0, $jfKIm.default)(b) ? f3 : (0, $jfKIm.default)(a) ? (0, $dOqR5.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $jfKIm.default)(b) ? (0, $dOqR5.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $lpfXx.default)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, $jfKIm.default)(a) && (0, $jfKIm.default)(b) && (0, $jfKIm.default)(c) ? f3 : (0, $jfKIm.default)(a) && (0, $jfKIm.default)(b) ? (0, $dOqR5.default)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, $jfKIm.default)(a) && (0, $jfKIm.default)(c) ? (0, $dOqR5.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $jfKIm.default)(b) && (0, $jfKIm.default)(c) ? (0, $dOqR5.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $jfKIm.default)(a) ? (0, $lpfXx.default)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, $jfKIm.default)(b) ? (0, $lpfXx.default)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, $jfKIm.default)(c) ? (0, $lpfXx.default)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}

});

parcelRegister("c4XcU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cb3c915fad82d94$export$2e2bcd8739ae039; });
function $8cb3c915fad82d94$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
}

});

parcelRegister("gDkGA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1c055a83ffa9258$export$2e2bcd8739ae039; });

var $fF7BY = parcelRequire("fF7BY");

var $U36oK = parcelRequire("U36oK");
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $c1c055a83ffa9258$var$mergeWithKey = /*#__PURE__*/ (0, $fF7BY.default)(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    l = l || {};
    r = r || {};
    for(k in l)if ((0, $U36oK.default)(k, l)) result[k] = (0, $U36oK.default)(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ((0, $U36oK.default)(k, r) && !(0, $U36oK.default)(k, result)) result[k] = r[k];
    return result;
});
var $c1c055a83ffa9258$export$2e2bcd8739ae039 = $c1c055a83ffa9258$var$mergeWithKey;

});
parcelRegister("U36oK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a87a31bed377660$export$2e2bcd8739ae039; });
function $0a87a31bed377660$export$2e2bcd8739ae039(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});




parcelRegister("a2fRy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74e66552df694397$export$2e2bcd8739ae039; });

var $dOqR5 = parcelRequire("dOqR5");

var $l7N3M = parcelRequire("l7N3M");
/**
 * Retrieves the value at a given path. The nodes of the path can be arbitrary strings or non-negative integers.
 * For anything else, the value is unspecified. Integer paths are meant to index arrays, strings are meant for objects.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {a} -> a | Undefined
 * @sig Idx = String | NonNegativeInt
 * @param {Array} path The path to use.
 * @param {Object} obj The object or array to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop, R.nth, R.assocPath, R.dissocPath
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 *      R.path(['a', 'b', 0], {a: {b: [1, 2, 3]}}); //=> 1
 *      R.path(['a', 'b', -2], {a: {b: [1, 2, 3]}}); //=> 2
 *      R.path([2], {'2': 2}); //=> 2
 *      R.path([-2], {'-2': 'a'}); //=> undefined
 */ var $74e66552df694397$var$path = /*#__PURE__*/ (0, $dOqR5.default)(function path(pathAr, obj) {
    return (0, $l7N3M.default)([
        pathAr
    ], obj)[0];
});
var $74e66552df694397$export$2e2bcd8739ae039 = $74e66552df694397$var$path;

});
parcelRegister("l7N3M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6104eba586f4119$export$2e2bcd8739ae039; });

var $dOqR5 = parcelRequire("dOqR5");

var $lK5fw = parcelRequire("lK5fw");

var $aTns7 = parcelRequire("aTns7");
/**
 * Retrieves the values at given paths of an object.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Object
 * @typedefn Idx = [String | Int | Symbol]
 * @sig [Idx] -> {a} -> [a | Undefined]
 * @param {Array} pathsArray The array of paths to be fetched.
 * @param {Object} obj The object to retrieve the nested properties from.
 * @return {Array} A list consisting of values at paths specified by "pathsArray".
 * @see R.path
 * @example
 *
 *      R.paths([['a', 'b'], ['p', 0, 'q']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, 3]
 *      R.paths([['a', 'b'], ['p', 'r']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, undefined]
 */ var $f6104eba586f4119$var$paths = /*#__PURE__*/ (0, $dOqR5.default)(function paths(pathsArray, obj) {
    return pathsArray.map(function(paths) {
        var val = obj;
        var idx = 0;
        var p;
        while(idx < paths.length){
            if (val == null) return;
            p = paths[idx];
            val = (0, $lK5fw.default)(p) ? (0, $aTns7.default)(p, val) : val[p];
            idx += 1;
        }
        return val;
    });
});
var $f6104eba586f4119$export$2e2bcd8739ae039 = $f6104eba586f4119$var$paths;

});
parcelRegister("lK5fw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd41f741fadd07a2$export$2e2bcd8739ae039; });
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var $fd41f741fadd07a2$export$2e2bcd8739ae039 = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};

});

parcelRegister("aTns7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ee13b9f347e9ea2$export$2e2bcd8739ae039; });

var $dOqR5 = parcelRequire("dOqR5");

var $bsyWh = parcelRequire("bsyWh");
/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */ var $7ee13b9f347e9ea2$var$nth = /*#__PURE__*/ (0, $dOqR5.default)(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return (0, $bsyWh.default)(list) ? list.charAt(idx) : list[idx];
});
var $7ee13b9f347e9ea2$export$2e2bcd8739ae039 = $7ee13b9f347e9ea2$var$nth;

});
parcelRegister("bsyWh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $857d695ffadcec6c$export$2e2bcd8739ae039; });
function $857d695ffadcec6c$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === '[object String]';
}

});




parcelRegister("8fp0t", function(module, exports) {

$parcel$export(module.exports, "languageOptions", function () { return $60131f43a8adae6e$export$aece9465b5528b4c; });
$parcel$export(module.exports, "default", function () { return $60131f43a8adae6e$export$2e2bcd8739ae039; });

var $fb7mo = parcelRequire("fb7mo");

var $cIgcv = parcelRequire("cIgcv");

var $hCBJP = parcelRequire("hCBJP");

var $2nlDb = parcelRequire("2nlDb");

var $8wWUN = parcelRequire("8wWUN");

var $2hwLH = parcelRequire("2hwLH");

var $jUBlW = parcelRequire("jUBlW");

var $jQqo4 = parcelRequire("jQqo4");

var $9rdsa = parcelRequire("9rdsa");

var $fKver = parcelRequire("fKver");

var $dDbcq = parcelRequire("dDbcq");

var $24lzn = parcelRequire("24lzn");
const $60131f43a8adae6e$export$aece9465b5528b4c = [
    {
        code: 'en',
        label: 'English',
        nativeLabel: 'English',
        flagCode: 'us'
    },
    {
        code: 'fr',
        label: 'French',
        nativeLabel: "Fran\xe7ais",
        flagCode: 'fr'
    },
    {
        code: 'es',
        label: 'Spanish',
        nativeLabel: "Espa\xf1ol",
        flagCode: 'es'
    },
    {
        code: 'ja',
        label: 'Japanese',
        nativeLabel: "\u65E5\u672C\u8A9E",
        flagCode: 'jp'
    },
    {
        code: 'zht',
        label: 'Chinese (Traditional)',
        nativeLabel: "\u7E41\u9AD4\u4E2D\u6587",
        flagCode: 'hk'
    },
    {
        code: 'zhs',
        label: 'Chinese (Simplified)',
        nativeLabel: "\u7B80\u4F53\u4E2D\u6587",
        flagCode: 'cn'
    }
];
const $60131f43a8adae6e$var$fallbackTranslations = {
    'universal-kiosk': {
        en: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($fb7mo)))
        },
        es: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($cIgcv)))
        },
        fr: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($hCBJP)))
        },
        ja: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($2nlDb)))
        },
        zht: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($8wWUN)))
        },
        zhs: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($2hwLH)))
        }
    },
    webapp: {
        en: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($jUBlW)))
        },
        es: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($jQqo4)))
        },
        fr: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($9rdsa)))
        },
        ja: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($fKver)))
        },
        zht: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($dDbcq)))
        },
        zhs: {
            common: (0, (/*@__PURE__*/$parcel$interopDefault($24lzn)))
        }
    }
};
var $60131f43a8adae6e$export$2e2bcd8739ae039 = $60131f43a8adae6e$var$fallbackTranslations;

});
parcelRegister("fb7mo", function(module, exports) {
module.exports = JSON.parse('{"search-join-attendee-submit-btn":"DONE","go-to-package-btn":"Purchase Options","done-exit-btn":"Done (Exit Kiosk)","title-select-package":"Select a Package","title-suggest-a-product":"Would you like to add another product to your order?","title-choose-a-product":"Pick a product to add to your order","store-title":"Select the product you\'d like to purchase","title-shopping-cart":"Shopping Cart","select-images-notice-message":"Select the images you want to print.","select-images-notice-ok":"OK","confirm-change-img-btn":"OK, Use this image","select-image-title":"OCCO Profile Photo","welcome-title":"Photo Album","welcome-event-list-label":"Event List:","welcome-item-count-label":"Item Count:","select-image-selection-title":"Select ({{count}}) image(s)","select-image-step-label":"Step {{currentStep}} of {{totalSteps}}","select-image-for-product-text":"for \\"{{title}}\\"","select-image-next-btn":"Next ({{selectedCount}}/{{requiredCount}})","select-image-clear-btn":"Clear","select-image-no-photos-message":"No photos available","select-image-no-uid-message":"Oops, there was an issue locating your account. Please try again.","select-image-unlock-notice-message":"Select the images you want to unlock.","select-image-print-or-unlock-notice-message":"Select the images you want to print or unlock.","select-image-addon-selection-title":"Select images","select-image-addon-done-count-btn":"Done ({{count}})","select-image-no-compatible-image-message":"No compatible image was found","select-image-photo-limit-message":"Please select {{count}} image(s) you want to print.","welcome-gallery-title":"My Album","welcome-select-images-of-yourself-title":"Select all images of yourself","welcome-select-found-images-title":"Select photos you want to add to your gallery","welcome-back-to-gallery-btn":"Back to album","checkout-subtotal-label":"Subtotal:","checkout-taxes-label":"Taxes:","checkout-total-label":"Total:","checkout-btn":"Checkout","checkout-add-on-btn":"+ ADD ON","checkout-add-product-btn":"Add product","checkout-empty-cart-message":"Cart is empty","checkout-promo-code-placeholder":"staff use only","checkout-invalid-promo-code-message":"Invalid or expired promotion code!","checkout-discount-label":"Discount: {{title}}","checkout-receipt-title":"Receipt","checkout-receipt-product-label":"Product","checkout-receipt-unit-price-label":"Unit Price","checkout-receipt-qty-label":"Qty","checkout-receipt-amount-label":"Amount","checkout-digital-package-upsell-message":"Would you like to add a<br>digital package to your<br>shopping cart and gain access<br>to all your digitals?","checkout-tip-message":"Add a tip?","checkout-tip-description":"Your tip helps support the team.","checkout-no-tip-btn":"No tip","photo-plus-pass-required-message":"Oops, looks like you do not have a Photo+ Pass yet.<br><br>Get yours now to gain access to high resolution content.","photo-plus-valid-ticket-required-message":"Oops, looks like you don\u2019t have a valid ticket yet for your park visit. Link your ticket to enjoy our Photo+ experience.","photo-plus-visit-availability-message":"Your Photo+ experience is available during your Genting SkyWorlds\' visit.","checkout-other-products-upsell-message":"Would you like to add a print to your Digital Package?","checkout-delete-restriction-message":"You must keep at least one package in your shopping cart if you wish to purchase add-ons. If you need to change the package - please first remove all add-ons from your shopping cart.","checkout-digital-package-duplicate-message":"You already have a digital access package in your shopping cart.<br>A new package can not be added until you remove or purchase the current one.","welcome-print-modal-title":"Print","welcome-print-modal-text":"Your photo(s) will be printed and delivered to your event organizer.","cancel-btn":"Cancel","welcome-preview-modal-title":"Preview","close-btn":"Close","ok-btn":"OK","back-btn":"Back","info-title":"Info","apply-btn":"Apply","clear-btn":"Clear","yes-btn":"Yes","no-btn":"No","change-image-btn":"Change Image","done-btn":"Done","skip-btn":"Skip","refresh-btn":"Refresh","exit-btn":"Exit","unsupported-picture-format-message":"Invalid or unsupported picture format","welcome-alert-modal-title":"Modal title","welcome-alert-modal-body-text":"Modal body text goes here.","welcome-alert-save-btn":"Save changes","welcome-passcodes-modal-title":"Generate Pass Codes","welcome-passcodes-events-label":"Select event(s) for which you want to generate passcodes:","welcome-passcodes-email-label":"E-mail address to receive pass codes in XLS format:","welcome-passcodes-count-label":"Number of Pass Codes to generate:","welcome-passcodes-count-help":"A number between 1-200,000","welcome-passcodes-prepaid-label":"Will holders of those cards be considered as pre-paid/VIP?:","welcome-passcodes-expiry-label":"Access to public kiosk must expire (minutes) (0 to disable this option):","welcome-passcodes-url-prefix-label":"Album access URL prefix (e.g. https://domain-name.com):","welcome-passcodes-generate-btn":"Generate","sharing-modal-title":"Share images","sharing-tab-email":"Email","sharing-tab-sms":"SMS","sharing-email-name-placeholder":"Full name","sharing-email-placeholder":"Valid e-mail address","sharing-email-help-text":"Separate multiple email addresses using the semicolon,comma,space and enter keys.","sharing-contact-phone-placeholder":"Phone number","sharing-company-placeholder":"Company/Institution","sharing-sms-name-placeholder":"Full name","sharing-sms-phone-placeholder":"Valid phone number","sharing-privacy-link":"Privacy Policy","sharing-privacy-prefix":"Your privacy is very important to us, please read our","welcome-delete-modal-title":"Delete","welcome-delete-modal-body":"Are you sure you want to delete this picture from your album?","welcome-delete-photo-confirmation-message":"Are you really sure you want to delete this image from your album?","welcome-delete-photo-keep-btn":"Keep this image!","welcome-delete-photo-delete-btn":"Delete this image from my album","welcome-delete-reason-not-mine-btn":"Yes. This is not my picture","welcome-delete-confirm-btn":"Delete","welcome-selfie-modal-title":"Look up my images by face","welcome-selfie-match-found-title":"We think we found you!","welcome-selfie-match-found-confirm-message":"Tap on your images to confirm.","welcome-selfie-capture-btn":"Click here","welcome-delete-reason-dont-want-btn":"Yes. The picture is mine, but don\'t want it","welcome-print-copy-count-label":"Select print copies count","catalog-select-product-package-title":"Select the product package","freedompay-offline-request-title":"Please enter offline transaction request id","square-reader-access-token-title":"Please enter Square Access Token","square-reader-pairing-code-title":"Please use this code to sign into your new Square reader and click OK when done.","square-reader-still-unpaired-text":"This device is still unpaired, please use the code to sign into your new Square reader.","square-reader-security-note-title":"Please take a note of the following two keys as they will not be saved for security reasons","storicard-invalid-code-text":"Invalid StoriCard code.","header-menu-user-id-link":"UserID:","countdown-time-up-text":"Time\'s up!","welcome-find-more-images-btn":"Find more images","welcome-select-images-btn":"Select images","welcome-selected-images-next-btn":"That\'s me on those ({{count}}) images, Next >","welcome-invalid-attendee-id-message":"Invalid attendee ID.","welcome-kiosk-time-expired-message":"Sorry, public kiosk time is expired","welcome-grouping-error-message":"Grouping of accounts created more than 3 days ago is not permitted.","confirm-btn":"Confirm","approved-btn":"Approved","checkout-confirm-purchase-title":"Please Confirm Your Purchase","checkout-confirm-purchase-short-title":"Confirm Purchase","checkout-digital-access-summary":"Access to all of your digital images taken today","checkout-and-text":"and","checkout-print-count-summary":"{{count}} Print(s)","checkout-digitals-copy-message":"Would you like to have a copy of your digitals?<br> In case you misplace your card.","checkout-email-placeholder":"Your email","checkout-email-or-phone-placeholder":"Your email or US phone number","checkout-sms-agreement-label":"I agree to receive notification messages from Storibox at the phone number provided above. I understand I will receive SMS messages containing updates and links to my images. Data and messaging rates may apply. Reply STOP to opt out.","checkout-name-placeholder":"Your name","checkout-cancel-transaction-btn":"Cancel Transaction","checkout-employee-authorization-title":"Employee authorization required","checkout-scan-employee-card-prefix":"Scan your employee card when transaction for","checkout-transaction-complete-suffix":"is complete","checkout-unlock-code-error-message":"Employee authorization code is invalid.","checkout-print-pool-error-message":"The configured PrintPool is invalid or unavailable. Please check the kiosk PrintPool configuration.","checkout-printing-now-title":"Printing now","checkout-prints-ready-message":"Your prints will be ready in a minute","checkout-digitals-unlocked-message":"Your digital photos are now unlocked","checkout-internal-error-title":"Sorry, Internal error","checkout-transaction-processed-title":"TRANSACTION PROCESSED!","checkout-register-receipt-qr-message":"Please scan QR to register your email for digital receipt and album link!","checkout-shop-more-btn":"Shop More","checkout-print-receipt-btn":"Print Receipt","checkout-paid-by-cash-label":"Paid By Cash","checkout-paid-by-card-label":"Paid By Card","checkout-draft-order-error-message":"Creating draft order failed.","checkout-print-confirmation-message":"If you ordered prints, they will be ready in a minute. You can pick up your merchandise at the retail desk","checkout-shopify-params-incomplete-message":"Shopify Params are not complete","checkout-event-name-required-message":"eventName is not provided.","payment-no-device-connected-message":"No Device is connected.","payment-ask-for-assistance-message":"Please ask for assistance.","payment-square-checkout-creation-failed-message":"Checkout request failed. Please try again later.","payment-square-checkout-status-check-failed-message":"Checkout status check failed. Please try again later.","payment-qr-title":"Pay From Your Phone","payment-qr-help-html":"<b>Quick & Easy:</b><br> Scan the QR code above and follow on screen instructions.","payment-qr-transaction-progress-message":"Transaction is in progress...","payment-qr-failed-message":"QR payment failed. Please check the API key and try again.","payment-failed-message":"Payment failed. Please try again later.","payment-failed-short-message":"Your payment failed.","payment-use-pinpad-message":"Please use the PinPad to complete your transaction ...","payment-terminal-progress-message":"Transaction in progress. <br>To cancel, tap the arrow on terminal.","payment-transaction-canceled-message":"Your transaction has been canceled.","payment-transaction-canceled-close-btn":"Back","payment-transaction-canceled-done-btn":"Home","search-version-label":"kiosk v.{{version}}","search-find-by-qr-btn":"Find by QR","search-find-by-face-btn":"Find by Face","search-scan-another-qr-placeholder":"Scan another QR code","search-scanned-attendee-label":"Scanned: {{attId}}","search-qr-or-photos-not-found-message":"QR Code or photos not found. Please scan again.","scanning-qr-page-title":"Photo Album","photo-viewer-back-btn":"Back to album","email-capture-modal-title":"Enter email<br>to view album","email-capture-invalid-email-message":"Please enter a valid email address.","checkout-scan-album-qr-message":"Scan the QR code to access your digital photo album","email-capture-name-label":"Name:","email-capture-email-label":"Email:","email-capture-domain-placeholder":"e.g. gmail.com","email-capture-next-btn":"Next"}');

});

parcelRegister("cIgcv", function(module, exports) {
module.exports = JSON.parse('{"search-join-attendee-submit-btn":"LISTO","go-to-package-btn":"Opciones de compra","done-exit-btn":"Listo (Salir del kiosco)","title-select-package":"Selecciona un paquete","title-suggest-a-product":"\xbfTe gustar\xeda agregar otro producto a tu pedido?","title-choose-a-product":"Elige un producto para agregar a tu pedido","store-title":"Selecciona el producto que deseas comprar","title-shopping-cart":"Carrito de compras","select-images-notice-message":"Selecciona las im\xe1genes que deseas imprimir.","select-images-notice-ok":"OK","confirm-change-img-btn":"OK, usar esta imagen","select-image-title":"Foto de perfil OCCO","welcome-title":"\xc1lbum de fotos","welcome-event-list-label":"Lista de eventos:","welcome-item-count-label":"Cantidad de art\xedculos:","select-image-selection-title":"Selecciona {{count}} imagen(es)","select-image-step-label":"Paso {{currentStep}} de {{totalSteps}}","select-image-for-product-text":"para \\"{{title}}\\"","select-image-next-btn":"Siguiente ({{selectedCount}}/{{requiredCount}})","select-image-clear-btn":"Limpiar","select-image-no-photos-message":"No hay fotos disponibles","select-image-no-uid-message":"Ups, hubo un problema al localizar tu cuenta. Int\xe9ntalo de nuevo.","select-image-unlock-notice-message":"Selecciona las im\xe1genes que deseas desbloquear.","select-image-print-or-unlock-notice-message":"Selecciona las im\xe1genes que deseas imprimir o desbloquear.","select-image-addon-selection-title":"Selecciona im\xe1genes","select-image-addon-done-count-btn":"Listo ({{count}})","select-image-no-compatible-image-message":"No se encontr\xf3 una imagen compatible","select-image-photo-limit-message":"Selecciona {{count}} imagen(es) que deseas imprimir.","welcome-gallery-title":"Mi \xe1lbum","welcome-select-images-of-yourself-title":"Selecciona todas las im\xe1genes en las que apareces","welcome-select-found-images-title":"Selecciona las fotos que deseas agregar a tu galer\xeda","welcome-back-to-gallery-btn":"Volver al \xe1lbum","checkout-subtotal-label":"Subtotal:","checkout-taxes-label":"Impuestos:","checkout-total-label":"Total:","checkout-btn":"Pagar","checkout-add-on-btn":"+ AGREGAR EXTRA","checkout-add-product-btn":"Agregar producto","checkout-empty-cart-message":"El carrito est\xe1 vac\xedo","checkout-promo-code-placeholder":"solo para personal","checkout-invalid-promo-code-message":"\xa1C\xf3digo promocional inv\xe1lido o vencido!","checkout-discount-label":"Descuento: {{title}}","checkout-receipt-title":"Recibo","checkout-receipt-product-label":"Producto","checkout-receipt-unit-price-label":"Precio unitario","checkout-receipt-qty-label":"Cant.","checkout-receipt-amount-label":"Importe","checkout-digital-package-upsell-message":"\xbfTe gustar\xeda agregar un<br>paquete digital a tu<br>carrito de compras y obtener acceso<br>a todos tus archivos digitales?","checkout-tip-message":"\xbfDeseas agregar una propina?","checkout-tip-description":"Tu propina ayuda a apoyar al equipo.","checkout-no-tip-btn":"Sin propina","photo-plus-pass-required-message":"Parece que todav\xeda no tienes un Photo+ Pass.<br><br>Cons\xedguelo ahora para acceder al contenido en alta resoluci\xf3n.","photo-plus-valid-ticket-required-message":"Parece que todav\xeda no tienes un boleto v\xe1lido para tu visita al parque. Vincula tu boleto para disfrutar de nuestra experiencia Photo+.","photo-plus-visit-availability-message":"Tu experiencia Photo+ est\xe1 disponible durante tu visita a Genting SkyWorlds.","checkout-other-products-upsell-message":"\xbfTe gustar\xeda agregar una impresi\xf3n a tu paquete digital?","checkout-delete-restriction-message":"Debes mantener al menos un paquete en tu carrito de compras si deseas comprar extras. Si necesitas cambiar el paquete, primero elimina todos los extras de tu carrito.","checkout-digital-package-duplicate-message":"Ya tienes un paquete de acceso digital en tu carrito de compras.<br>No se puede agregar un nuevo paquete hasta que elimines o compres el actual.","welcome-print-modal-title":"Imprimir","welcome-print-modal-text":"Tus fotos se imprimir\xe1n y se entregar\xe1n a tu organizador del evento.","cancel-btn":"Cancelar","welcome-preview-modal-title":"Vista previa","close-btn":"Cerrar","ok-btn":"OK","back-btn":"Atr\xe1s","info-title":"Informaci\xf3n","apply-btn":"Aplicar","clear-btn":"Limpiar","yes-btn":"S\xed","no-btn":"No","change-image-btn":"Cambiar imagen","done-btn":"Listo","skip-btn":"Omitir","refresh-btn":"Actualizar","exit-btn":"Salir","unsupported-picture-format-message":"Formato de imagen inv\xe1lido o no compatible","welcome-alert-modal-title":"T\xedtulo del modal","welcome-alert-modal-body-text":"El texto del modal va aqu\xed.","welcome-alert-save-btn":"Guardar cambios","welcome-passcodes-modal-title":"Generar c\xf3digos de acceso","welcome-passcodes-events-label":"Selecciona los eventos para los que deseas generar c\xf3digos de acceso:","welcome-passcodes-email-label":"Correo electr\xf3nico para recibir los c\xf3digos de acceso en formato XLS:","welcome-passcodes-count-label":"N\xfamero de c\xf3digos de acceso a generar:","welcome-passcodes-count-help":"Un n\xfamero entre 1 y 200,000","welcome-passcodes-prepaid-label":"\xbfLos titulares de esas tarjetas ser\xe1n considerados prepagados/VIP?:","welcome-passcodes-expiry-label":"El acceso al kiosco p\xfablico debe vencer (minutos) (0 para desactivar esta opci\xf3n):","welcome-passcodes-url-prefix-label":"Prefijo de URL de acceso al \xe1lbum (ej. https://domain-name.com):","welcome-passcodes-generate-btn":"Generar","sharing-modal-title":"Compartir im\xe1genes","sharing-tab-email":"Correo","sharing-tab-sms":"SMS","sharing-email-name-placeholder":"Nombre completo","sharing-email-placeholder":"Correo electr\xf3nico v\xe1lido","sharing-email-help-text":"Separa varias direcciones de correo con punto y coma, coma, espacio o la tecla Enter.","sharing-contact-phone-placeholder":"N\xfamero de tel\xe9fono","sharing-company-placeholder":"Empresa/Instituci\xf3n","sharing-sms-name-placeholder":"Nombre completo","sharing-sms-phone-placeholder":"N\xfamero de tel\xe9fono v\xe1lido","sharing-privacy-link":"Pol\xedtica de privacidad","sharing-privacy-prefix":"Tu privacidad es muy importante para nosotros, por favor lee nuestra","welcome-delete-modal-title":"Eliminar","welcome-delete-modal-body":"\xbfEst\xe1s seguro de que deseas eliminar esta foto de tu \xe1lbum?","welcome-delete-photo-confirmation-message":"\xbfDe verdad est\xe1s seguro de que deseas eliminar esta imagen de tu \xe1lbum?","welcome-delete-photo-keep-btn":"\xa1Conservar esta imagen!","welcome-delete-photo-delete-btn":"Eliminar esta imagen de mi \xe1lbum","welcome-delete-reason-not-mine-btn":"S\xed. Esta no es mi foto","welcome-delete-confirm-btn":"Eliminar","welcome-selfie-modal-title":"Buscar mis im\xe1genes por rostro","welcome-selfie-match-found-title":"\xa1Creemos que te encontramos!","welcome-selfie-match-found-confirm-message":"Toca tus im\xe1genes para confirmar.","welcome-selfie-capture-btn":"Haz clic aqu\xed","welcome-delete-reason-dont-want-btn":"S\xed. La foto es m\xeda, pero no la quiero","welcome-print-copy-count-label":"Selecciona la cantidad de copias impresas","catalog-select-product-package-title":"Selecciona el paquete del producto","freedompay-offline-request-title":"Ingresa el ID de solicitud de transacci\xf3n offline","square-reader-access-token-title":"Ingresa el token de acceso de Square","square-reader-pairing-code-title":"Usa este c\xf3digo para iniciar sesi\xf3n en tu nuevo lector Square y haz clic en OK cuando termines.","square-reader-still-unpaired-text":"Este dispositivo a\xfan no est\xe1 emparejado; usa el c\xf3digo para iniciar sesi\xf3n en tu nuevo lector Square.","square-reader-security-note-title":"Toma nota de las siguientes dos claves, ya que no se guardar\xe1n por razones de seguridad","storicard-invalid-code-text":"C\xf3digo de StoriCard inv\xe1lido.","header-menu-user-id-link":"UserID:","countdown-time-up-text":"\xa1Se acab\xf3 el tiempo!","welcome-find-more-images-btn":"Buscar m\xe1s im\xe1genes","welcome-select-images-btn":"Seleccionar im\xe1genes","welcome-selected-images-next-btn":"Soy yo en estas {{count}} im\xe1genes, Siguiente >","welcome-invalid-attendee-id-message":"ID de asistente inv\xe1lido.","welcome-kiosk-time-expired-message":"Lo sentimos, el tiempo del kiosco p\xfablico ha expirado","welcome-grouping-error-message":"No se permite agrupar cuentas creadas hace m\xe1s de 3 d\xedas.","confirm-btn":"Confirmar","approved-btn":"Aprobado","checkout-confirm-purchase-title":"Por favor confirma tu compra","checkout-confirm-purchase-short-title":"Confirmar compra","checkout-digital-access-summary":"Acceso a todas tus im\xe1genes digitales tomadas hoy","checkout-and-text":"y","checkout-print-count-summary":"{{count}} impresi\xf3n(es)","checkout-digitals-copy-message":"\xbfTe gustar\xeda tener una copia de tus archivos digitales?<br> Por si pierdes tu tarjeta.","checkout-email-placeholder":"Tu correo electr\xf3nico","checkout-email-or-phone-placeholder":"Tu correo electr\xf3nico o n\xfamero de tel\xe9fono de EE. UU.","checkout-sms-agreement-label":"Acepto recibir mensajes de notificaci\xf3n de Storibox en el n\xfamero de tel\xe9fono proporcionado arriba. Entiendo que recibir\xe9 mensajes SMS con actualizaciones y enlaces a mis im\xe1genes. Pueden aplicarse tarifas de datos y mensajer\xeda. Responde STOP para cancelar.","checkout-name-placeholder":"Tu nombre","checkout-cancel-transaction-btn":"Cancelar transacci\xf3n","checkout-employee-authorization-title":"Se requiere autorizaci\xf3n del empleado","checkout-scan-employee-card-prefix":"Escanea tu tarjeta de empleado cuando la transacci\xf3n de","checkout-transaction-complete-suffix":"est\xe9 completa","checkout-unlock-code-error-message":"El c\xf3digo de autorizaci\xf3n del empleado es inv\xe1lido.","checkout-print-pool-error-message":"El PrintPool configurado no es v\xe1lido o no est\xe1 disponible. Comprueba la configuraci\xf3n del PrintPool del kiosco.","checkout-printing-now-title":"Imprimiendo ahora","checkout-prints-ready-message":"Tus impresiones estar\xe1n listas en un minuto","checkout-digitals-unlocked-message":"Tus fotos digitales ahora est\xe1n desbloqueadas","checkout-internal-error-title":"Lo sentimos, error interno","checkout-transaction-processed-title":"\xa1TRANSACCI\xd3N PROCESADA!","checkout-register-receipt-qr-message":"\xa1Escanea el c\xf3digo QR para registrar tu correo y recibir el recibo digital y el enlace al \xe1lbum!","checkout-shop-more-btn":"Seguir comprando","checkout-print-receipt-btn":"Imprimir recibo","checkout-paid-by-cash-label":"Pagado en efectivo","checkout-paid-by-card-label":"Pagado con tarjeta","checkout-draft-order-error-message":"No se pudo crear el borrador del pedido.","checkout-print-confirmation-message":"Si pediste impresiones, estar\xe1n listas en un minuto. Puedes recoger tu mercanc\xeda en el mostrador de venta","checkout-shopify-params-incomplete-message":"Los par\xe1metros de Shopify no est\xe1n completos","checkout-event-name-required-message":"No se proporcion\xf3 eventName.","payment-no-device-connected-message":"No hay ning\xfan dispositivo conectado.","payment-ask-for-assistance-message":"Por favor solicita ayuda.","payment-square-checkout-creation-failed-message":"La solicitud de checkout fall\xf3. Int\xe9ntalo de nuevo m\xe1s tarde.","payment-square-checkout-status-check-failed-message":"La verificaci\xf3n del estado del checkout fall\xf3. Int\xe9ntalo de nuevo m\xe1s tarde.","payment-qr-title":"Paga desde tu tel\xe9fono","payment-qr-help-html":"<b>R\xe1pido y f\xe1cil:</b><br> Escanea el c\xf3digo QR de arriba y sigue las instrucciones en pantalla.","payment-qr-transaction-progress-message":"La transacci\xf3n est\xe1 en curso...","payment-qr-failed-message":"El pago por QR fall\xf3. Verifica la clave API e int\xe9ntalo de nuevo.","payment-failed-message":"El pago fall\xf3. Int\xe9ntalo de nuevo m\xe1s tarde.","payment-failed-short-message":"Tu pago fall\xf3.","payment-use-pinpad-message":"Por favor usa el PinPad para completar tu transacci\xf3n...","payment-terminal-progress-message":"Transacci\xf3n en progreso. <br>Para cancelar, toca la flecha en la terminal.","payment-transaction-canceled-message":"Tu transacci\xf3n ha sido cancelada.","payment-transaction-canceled-close-btn":"Volver","payment-transaction-canceled-done-btn":"Inicio","search-version-label":"kiosk v.{{version}}","search-find-by-qr-btn":"Buscar por QR","search-find-by-face-btn":"Buscar por rostro","search-scan-another-qr-placeholder":"Escanea otro c\xf3digo QR","search-scanned-attendee-label":"Escaneado: {{attId}}","search-qr-or-photos-not-found-message":"No se encontraron el c\xf3digo QR o las fotos. Escanea nuevamente.","scanning-qr-page-title":"\xc1lbum de fotos","photo-viewer-back-btn":"Volver al \xe1lbum","email-capture-modal-title":"Introduce tu correo electr\xf3nico para ver el \xe1lbum","checkout-scan-album-qr-message":"Escanea el c\xf3digo QR para acceder a tu \xe1lbum de fotos digital","email-capture-name-label":"Nombre:","email-capture-email-label":"Correo electr\xf3nico:","email-capture-domain-placeholder":"p. ej., gmail.com","email-capture-next-btn":"Siguiente"}');

});

parcelRegister("hCBJP", function(module, exports) {
module.exports = JSON.parse('{"search-join-attendee-submit-btn":"TERMIN\xc9","go-to-package-btn":"Options d\'achat","done-exit-btn":"Termin\xe9 (Quitter le kiosque)","title-select-package":"S\xe9lectionnez un pack","title-suggest-a-product":"Souhaitez-vous ajouter un autre produit \xe0 votre commande ?","title-choose-a-product":"Choisissez un produit \xe0 ajouter \xe0 votre commande","store-title":"S\xe9lectionnez le produit que vous souhaitez acheter","title-shopping-cart":"Panier","select-images-notice-message":"Veuillez s\xe9lectionner les images que vous souhaitez imprimer.","select-images-notice-ok":"OK","confirm-change-img-btn":"OK, utiliser cette image","select-image-title":"Photo de profil OCCO","welcome-title":"Album photo","welcome-event-list-label":"Liste des \xe9v\xe9nements :","welcome-item-count-label":"Nombre d\'\xe9l\xe9ments :","select-image-selection-title":"S\xe9lectionnez ({{count}}) image(s)","select-image-step-label":"\xc9tape {{currentStep}} sur {{totalSteps}}","select-image-for-product-text":"pour \\"{{title}}\\"","select-image-next-btn":"Suivant ({{selectedCount}}/{{requiredCount}})","select-image-clear-btn":"Effacer","select-image-no-photos-message":"Aucune photo disponible","select-image-no-uid-message":"Oups, un probl\xe8me est survenu lors de la localisation de votre compte. Veuillez r\xe9essayer.","select-image-unlock-notice-message":"Veuillez s\xe9lectionner les images que vous souhaitez d\xe9verrouiller.","select-image-print-or-unlock-notice-message":"Veuillez s\xe9lectionner les images que vous souhaitez imprimer ou d\xe9verrouiller.","select-image-addon-selection-title":"S\xe9lectionner des images","select-image-addon-done-count-btn":"Termin\xe9 ({{count}})","select-image-no-compatible-image-message":"Aucune image compatible n\'a \xe9t\xe9 trouv\xe9e","select-image-photo-limit-message":"Veuillez s\xe9lectionner {{count}} image(s) que vous souhaitez imprimer.","welcome-gallery-title":"Mon album","welcome-select-images-of-yourself-title":"S\xe9lectionnez toutes les images de vous-m\xeame","welcome-select-found-images-title":"S\xe9lectionnez les photos \xe0 ajouter \xe0 votre galerie","welcome-back-to-gallery-btn":"Retour \xe0 l\'album","checkout-subtotal-label":"Sous-total :","checkout-taxes-label":"Taxes :","checkout-total-label":"Total :","checkout-btn":"Paiement","checkout-add-on-btn":"+ AJOUTER UN ARTICLE","checkout-add-product-btn":"Ajouter un produit","checkout-empty-cart-message":"Le panier est vide","checkout-promo-code-placeholder":"r\xe9serv\xe9 au personnel","checkout-invalid-promo-code-message":"Code promotionnel invalide ou expir\xe9 !","checkout-discount-label":"Remise : {{title}}","checkout-receipt-title":"Re\xe7u","checkout-receipt-product-label":"Produit","checkout-receipt-unit-price-label":"Prix unitaire","checkout-receipt-qty-label":"Qt\xe9","checkout-receipt-amount-label":"Montant","checkout-digital-package-upsell-message":"Souhaitez-vous ajouter<br>un pack num\xe9rique \xe0 votre<br>panier et obtenir l\'acc\xe8s \xe0<br>tous vos fichiers num\xe9riques ?","checkout-tip-message":"Souhaitez-vous laisser un pourboire ?","checkout-tip-description":"Votre pourboire aide \xe0 soutenir l\'\xe9quipe.","checkout-no-tip-btn":"Pas de pourboire","photo-plus-pass-required-message":"Oups, il semble que vous n\'ayez pas encore de pass Photo+.<br><br>Obtenez-le maintenant pour acc\xe9der au contenu en haute r\xe9solution.","photo-plus-valid-ticket-required-message":"Oups, il semble que vous n\'ayez pas encore de billet valide pour votre visite du parc. Associez votre billet pour profiter de notre exp\xe9rience Photo+.","photo-plus-visit-availability-message":"Votre exp\xe9rience Photo+ est disponible pendant votre visite \xe0 Genting SkyWorlds.","checkout-other-products-upsell-message":"Souhaitez-vous ajouter un tirage \xe0 votre pack num\xe9rique ?","checkout-delete-restriction-message":"Vous devez conserver au moins un pack dans votre panier si vous souhaitez acheter des articles suppl\xe9mentaires. Si vous devez changer de pack, veuillez d\'abord retirer tous les articles suppl\xe9mentaires de votre panier.","checkout-digital-package-duplicate-message":"Vous avez d\xe9j\xe0 un pack d\'acc\xe8s num\xe9rique dans votre panier.<br>Un nouveau pack ne peut pas \xeatre ajout\xe9 tant que l\'actuel n\'est pas supprim\xe9 ou achet\xe9.","welcome-print-modal-title":"Impression","welcome-print-modal-text":"Votre ou vos photo(s) seront imprim\xe9es et remises \xe0 l\'organisateur de votre \xe9v\xe9nement.","cancel-btn":"Annuler","welcome-preview-modal-title":"Aper\xe7u","close-btn":"Fermer","ok-btn":"OK","back-btn":"Retour","info-title":"Info","apply-btn":"Appliquer","clear-btn":"Effacer","yes-btn":"Oui","no-btn":"Non","change-image-btn":"Changer l\'image","done-btn":"Termin\xe9","skip-btn":"Passer","refresh-btn":"Actualiser","exit-btn":"Quitter","unsupported-picture-format-message":"Format d\'image invalide ou non pris en charge","welcome-alert-modal-title":"Titre de la fen\xeatre","welcome-alert-modal-body-text":"Le texte du corps de la fen\xeatre s\'affiche ici.","welcome-alert-save-btn":"Enregistrer les modifications","welcome-passcodes-modal-title":"G\xe9n\xe9rer des codes d\'acc\xe8s","welcome-passcodes-events-label":"S\xe9lectionnez le ou les \xe9v\xe9nements pour lesquels vous souhaitez g\xe9n\xe9rer des codes d\'acc\xe8s :","welcome-passcodes-email-label":"Adresse e-mail pour recevoir les codes d\'acc\xe8s au format XLS :","welcome-passcodes-count-label":"Nombre de codes d\'acc\xe8s \xe0 g\xe9n\xe9rer :","welcome-passcodes-count-help":"Un nombre entre 1 et 200 000","welcome-passcodes-prepaid-label":"Les d\xe9tenteurs de ces cartes seront-ils consid\xe9r\xe9s comme pr\xe9pay\xe9s / VIP ? :","welcome-passcodes-expiry-label":"L\'acc\xe8s au kiosque public doit expirer (minutes) (0 pour d\xe9sactiver cette option) :","welcome-passcodes-url-prefix-label":"Pr\xe9fixe d\'URL d\'acc\xe8s \xe0 l\'album (par ex. https://nom-de-domaine.com) :","welcome-passcodes-generate-btn":"G\xe9n\xe9rer","sharing-modal-title":"Partager des images","sharing-tab-email":"E-mail","sharing-tab-sms":"SMS","sharing-email-name-placeholder":"Nom complet","sharing-email-placeholder":"Adresse e-mail valide","sharing-email-help-text":"S\xe9parez plusieurs adresses e-mail \xe0 l\'aide des touches point-virgule, virgule, espace et entr\xe9e.","sharing-contact-phone-placeholder":"Num\xe9ro de t\xe9l\xe9phone","sharing-company-placeholder":"Entreprise / Institution","sharing-sms-name-placeholder":"Nom complet","sharing-sms-phone-placeholder":"Num\xe9ro de t\xe9l\xe9phone valide","sharing-privacy-link":"Politique de confidentialit\xe9","sharing-privacy-prefix":"Votre vie priv\xe9e est tr\xe8s importante pour nous, veuillez lire notre","welcome-delete-modal-title":"Supprimer","welcome-delete-modal-body":"\xcates-vous s\xfbr de vouloir supprimer cette image de votre album ?","welcome-delete-photo-confirmation-message":"\xcates-vous vraiment s\xfbr de vouloir supprimer cette image de votre album ?","welcome-delete-photo-keep-btn":"Conserver cette image !","welcome-delete-photo-delete-btn":"Supprimer cette image de mon album","welcome-delete-reason-not-mine-btn":"Oui. Cette image n\'est pas la mienne","welcome-delete-confirm-btn":"Supprimer","welcome-selfie-modal-title":"Retrouver mes images par visage","welcome-selfie-match-found-title":"Nous pensons vous avoir trouv\xe9 !","welcome-selfie-match-found-confirm-message":"Appuyez sur vos images pour confirmer.","welcome-selfie-capture-btn":"Cliquez ici","welcome-delete-reason-dont-want-btn":"Oui. L\'image est \xe0 moi, mais je n\'en veux pas","welcome-print-copy-count-label":"S\xe9lectionnez le nombre d\'exemplaires \xe0 imprimer","catalog-select-product-package-title":"S\xe9lectionnez le pack produit","freedompay-offline-request-title":"Veuillez saisir l\'identifiant de la demande de transaction hors ligne","square-reader-access-token-title":"Veuillez saisir le jeton d\'acc\xe8s Square","square-reader-pairing-code-title":"Veuillez utiliser ce code pour vous connecter \xe0 votre nouveau lecteur Square et cliquez sur OK une fois termin\xe9.","square-reader-still-unpaired-text":"Cet appareil n\'est toujours pas appair\xe9, veuillez utiliser le code pour vous connecter \xe0 votre nouveau lecteur Square.","square-reader-security-note-title":"Veuillez noter les deux cl\xe9s suivantes car elles ne seront pas enregistr\xe9es pour des raisons de s\xe9curit\xe9","storicard-invalid-code-text":"Code StoriCard invalide.","header-menu-user-id-link":"ID utilisateur :","countdown-time-up-text":"Temps \xe9coul\xe9 !","welcome-find-more-images-btn":"Trouver plus d\'images","welcome-select-images-btn":"S\xe9lectionner des images","welcome-selected-images-next-btn":"C\'est bien moi sur ces ({{count}}) images, Suivant >","welcome-invalid-attendee-id-message":"ID participant invalide.","welcome-kiosk-time-expired-message":"D\xe9sol\xe9, le temps d\'acc\xe8s au kiosque public a expir\xe9","welcome-grouping-error-message":"Le regroupement de comptes cr\xe9\xe9s il y a plus de 3 jours n\'est pas autoris\xe9.","confirm-btn":"Confirmer","approved-btn":"Approuv\xe9","checkout-confirm-purchase-title":"Veuillez confirmer votre achat","checkout-confirm-purchase-short-title":"Confirmer l\'achat","checkout-digital-access-summary":"Acc\xe8s \xe0 toutes vos images num\xe9riques prises aujourd\'hui","checkout-and-text":"et","checkout-print-count-summary":"{{count}} tirage(s)","checkout-digitals-copy-message":"Souhaitez-vous avoir une copie de vos fichiers num\xe9riques ?<br> Au cas o\xf9 vous \xe9gareriez votre carte.","checkout-email-placeholder":"Votre e-mail","checkout-email-or-phone-placeholder":"Votre e-mail ou votre num\xe9ro de t\xe9l\xe9phone US","checkout-sms-agreement-label":"J\'accepte de recevoir des messages de notification de Storibox au num\xe9ro de t\xe9l\xe9phone fourni ci-dessus. Je comprends que je recevrai des SMS contenant des mises \xe0 jour et des liens vers mes images. Des frais de donn\xe9es et de messagerie peuvent s\'appliquer. R\xe9pondez STOP pour vous d\xe9sinscrire.","checkout-name-placeholder":"Votre nom","checkout-cancel-transaction-btn":"Annuler la transaction","checkout-employee-authorization-title":"Autorisation d\'employ\xe9 requise","checkout-scan-employee-card-prefix":"Scannez votre carte d\'employ\xe9 lorsque la transaction pour","checkout-transaction-complete-suffix":"est termin\xe9e","checkout-unlock-code-error-message":"Le code d\'autorisation de l\'employ\xe9 est invalide.","checkout-print-pool-error-message":"Le PrintPool configur\xe9 est invalide ou indisponible. V\xe9rifiez la configuration du PrintPool du kiosque.","checkout-printing-now-title":"Impression en cours","checkout-prints-ready-message":"Vos tirages seront pr\xeats dans une minute","checkout-digitals-unlocked-message":"Vos photos num\xe9riques sont maintenant d\xe9verrouill\xe9es","checkout-internal-error-title":"D\xe9sol\xe9, erreur interne","checkout-transaction-processed-title":"TRANSACTION TRAIT\xc9E !","checkout-register-receipt-qr-message":"Veuillez scanner le QR pour enregistrer votre e-mail afin de recevoir votre re\xe7u num\xe9rique et le lien vers l\'album !","checkout-shop-more-btn":"Continuer les achats","checkout-print-receipt-btn":"Imprimer le re\xe7u","checkout-paid-by-cash-label":"Pay\xe9 en esp\xe8ces","checkout-paid-by-card-label":"Pay\xe9 par carte","checkout-draft-order-error-message":"La cr\xe9ation de la commande brouillon a \xe9chou\xe9.","checkout-print-confirmation-message":"Si vous avez command\xe9 des tirages, ils seront pr\xeats dans une minute. Vous pouvez r\xe9cup\xe9rer votre marchandise au comptoir de vente","checkout-shopify-params-incomplete-message":"Les param\xe8tres Shopify ne sont pas complets","checkout-event-name-required-message":"eventName n\'est pas fourni.","payment-no-device-connected-message":"Aucun appareil n\'est connect\xe9.","payment-ask-for-assistance-message":"Veuillez demander de l\'aide.","payment-square-checkout-creation-failed-message":"La demande de paiement a \xe9chou\xe9. Veuillez r\xe9essayer plus tard.","payment-square-checkout-status-check-failed-message":"La v\xe9rification du statut du paiement a \xe9chou\xe9. Veuillez r\xe9essayer plus tard.","payment-qr-title":"Payez depuis votre t\xe9l\xe9phone","payment-qr-help-html":"<b>Rapide et facile :</b><br> Scannez le code QR ci-dessus et suivez les instructions \xe0 l\'\xe9cran.","payment-qr-transaction-progress-message":"Transaction en cours...","payment-qr-failed-message":"Le paiement par QR a \xe9chou\xe9. Veuillez v\xe9rifier la cl\xe9 API et r\xe9essayer.","payment-failed-message":"Le paiement a \xe9chou\xe9. Veuillez r\xe9essayer plus tard.","payment-failed-short-message":"Votre paiement a \xe9chou\xe9.","payment-use-pinpad-message":"Veuillez utiliser le terminal de paiement pour finaliser votre transaction ...","payment-terminal-progress-message":"Transaction en cours. <br>Pour annuler, appuyez sur la fl\xe8che du terminal.","payment-transaction-canceled-message":"Votre transaction a \xe9t\xe9 annul\xe9e.","payment-transaction-canceled-close-btn":"Retour","payment-transaction-canceled-done-btn":"Accueil","search-version-label":"kiosque v.{{version}}","search-find-by-qr-btn":"Trouver par QR","search-find-by-face-btn":"Trouver par visage","search-scan-another-qr-placeholder":"Scanner un autre code QR","search-scanned-attendee-label":"Scann\xe9 : {{attId}}","search-qr-or-photos-not-found-message":"Code QR ou photos introuvables. Veuillez scanner \xe0 nouveau.","scanning-qr-page-title":"Album photo","photo-viewer-back-btn":"Retour \xe0 l\'album","email-capture-modal-title":"Saisissez votre e-mail pour voir l\'album","checkout-scan-album-qr-message":"Scannez le code QR pour acc\xe9der \xe0 votre album photo num\xe9rique","email-capture-name-label":"Nom :","email-capture-email-label":"E-mail :","email-capture-domain-placeholder":"ex. gmail.com","email-capture-next-btn":"Suivant"}');

});

parcelRegister("2nlDb", function(module, exports) {
module.exports = JSON.parse('{"search-join-attendee-submit-btn":"\u5B8C\u4E86","go-to-package-btn":"\u8CFC\u5165\u30AA\u30D7\u30B7\u30E7\u30F3","done-exit-btn":"\u5B8C\u4E86\uFF08\u30AD\u30AA\u30B9\u30AF\u7D42\u4E86\uFF09","title-select-package":"\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u9078\u629E","title-suggest-a-product":"\u6CE8\u6587\u306B\u5225\u306E\u5546\u54C1\u3092\u8FFD\u52A0\u3057\u307E\u3059\u304B\uFF1F","title-choose-a-product":"\u6CE8\u6587\u306B\u8FFD\u52A0\u3059\u308B\u5546\u54C1\u3092\u9078\u629E","store-title":"\u8CFC\u5165\u3057\u305F\u3044\u5546\u54C1\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","title-shopping-cart":"\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u30AB\u30FC\u30C8","select-images-notice-message":"\u5370\u5237\u3057\u305F\u3044\u753B\u50CF\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","select-images-notice-ok":"OK","confirm-change-img-btn":"OK\u3001\u3053\u306E\u753B\u50CF\u3092\u4F7F\u3046","select-image-title":"OCCO\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u5199\u771F","welcome-title":"\u30D5\u30A9\u30C8\u30A2\u30EB\u30D0\u30E0","welcome-event-list-label":"\u30A4\u30D9\u30F3\u30C8\u4E00\u89A7:","welcome-item-count-label":"\u30A2\u30A4\u30C6\u30E0\u6570:","select-image-selection-title":"\u753B\u50CF\u3092\u9078\u629E\uFF08{{count}}\uFF09","select-image-step-label":"\u30B9\u30C6\u30C3\u30D7 {{currentStep}} / {{totalSteps}}","select-image-for-product-text":"\u300C{{title}}\u300D\u7528","select-image-next-btn":"\u6B21\u3078\uFF08{{selectedCount}}/{{requiredCount}}\uFF09","select-image-clear-btn":"\u30AF\u30EA\u30A2","select-image-no-photos-message":"\u5229\u7528\u53EF\u80FD\u306A\u5199\u771F\u304C\u3042\u308A\u307E\u305B\u3093","select-image-no-uid-message":"\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u7279\u5B9A\u4E2D\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","select-image-unlock-notice-message":"\u30A2\u30F3\u30ED\u30C3\u30AF\u3057\u305F\u3044\u753B\u50CF\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","select-image-print-or-unlock-notice-message":"\u5370\u5237\u307E\u305F\u306F\u30A2\u30F3\u30ED\u30C3\u30AF\u3057\u305F\u3044\u753B\u50CF\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","select-image-addon-selection-title":"\u753B\u50CF\u3092\u9078\u629E","select-image-addon-done-count-btn":"\u5B8C\u4E86\uFF08{{count}}\uFF09","select-image-no-compatible-image-message":"\u4E92\u63DB\u6027\u306E\u3042\u308B\u753B\u50CF\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F","select-image-photo-limit-message":"\u5370\u5237\u3057\u305F\u3044\u753B\u50CF\u3092 {{count}} \u679A\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","welcome-gallery-title":"\u30DE\u30A4\u30A2\u30EB\u30D0\u30E0","welcome-select-images-of-yourself-title":"\u3054\u81EA\u8EAB\u304C\u5199\u3063\u3066\u3044\u308B\u753B\u50CF\u3092\u3059\u3079\u3066\u9078\u629E","welcome-select-found-images-title":"\u30AE\u30E3\u30E9\u30EA\u30FC\u306B\u8FFD\u52A0\u3057\u305F\u3044\u5199\u771F\u3092\u9078\u629E","welcome-back-to-gallery-btn":"\u30A2\u30EB\u30D0\u30E0\u306B\u623B\u308B","checkout-subtotal-label":"\u5C0F\u8A08:","checkout-taxes-label":"\u7A0E\u91D1:","checkout-total-label":"\u5408\u8A08:","checkout-btn":"\u4F1A\u8A08\u3078","checkout-add-on-btn":"+ \u8FFD\u52A0\u30AA\u30D7\u30B7\u30E7\u30F3","checkout-add-product-btn":"\u5546\u54C1\u3092\u8FFD\u52A0","checkout-empty-cart-message":"\u30AB\u30FC\u30C8\u306F\u7A7A\u3067\u3059","checkout-promo-code-placeholder":"\u30B9\u30BF\u30C3\u30D5\u5C02\u7528","checkout-invalid-promo-code-message":"\u7121\u52B9\u307E\u305F\u306F\u671F\u9650\u5207\u308C\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30FC\u30C9\u3067\u3059\uFF01","checkout-discount-label":"\u5272\u5F15: {{title}}","checkout-receipt-title":"\u30EC\u30B7\u30FC\u30C8","checkout-receipt-product-label":"\u5546\u54C1","checkout-receipt-unit-price-label":"\u5358\u4FA1","checkout-receipt-qty-label":"\u6570\u91CF","checkout-receipt-amount-label":"\u91D1\u984D","checkout-digital-package-upsell-message":"\u30C7\u30B8\u30BF\u30EB\u30D1\u30C3\u30B1\u30FC\u30B8\u3092<br>\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u30AB\u30FC\u30C8\u306B\u8FFD\u52A0\u3057\u3066\u3001<br>\u3059\u3079\u3066\u306E\u30C7\u30B8\u30BF\u30EB\u30B3\u30F3\u30C6\u30F3\u30C4\u306B<br>\u30A2\u30AF\u30BB\u30B9\u3057\u307E\u3059\u304B\uFF1F","checkout-tip-message":"\u30C1\u30C3\u30D7\u3092\u8FFD\u52A0\u3057\u307E\u3059\u304B\uFF1F","checkout-tip-description":"\u30C1\u30C3\u30D7\u306F\u30C1\u30FC\u30E0\u306E\u30B5\u30DD\u30FC\u30C8\u306B\u306A\u308A\u307E\u3059\u3002","checkout-no-tip-btn":"\u30C1\u30C3\u30D7\u306A\u3057","photo-plus-pass-required-message":"Photo+ Pass \u3092\u307E\u3060\u304A\u6301\u3061\u3067\u306A\u3044\u3088\u3046\u3067\u3059\u3002<br><br>\u9AD8\u89E3\u50CF\u5EA6\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u306B\u306F\u3001\u4ECA\u3059\u3050\u5165\u624B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","photo-plus-valid-ticket-required-message":"\u3054\u6765\u5712\u306B\u6709\u52B9\u306A\u30C1\u30B1\u30C3\u30C8\u304C\u307E\u3060\u78BA\u8A8D\u3067\u304D\u307E\u305B\u3093\u3002\u30C1\u30B1\u30C3\u30C8\u3092\u9023\u643A\u3057\u3066 Photo+ \u4F53\u9A13\u3092\u304A\u697D\u3057\u307F\u304F\u3060\u3055\u3044\u3002","photo-plus-visit-availability-message":"Photo+ \u4F53\u9A13\u306F Genting SkyWorlds \u3054\u6765\u5712\u4E2D\u306B\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002","checkout-other-products-upsell-message":"\u30C7\u30B8\u30BF\u30EB\u30D1\u30C3\u30B1\u30FC\u30B8\u306B\u30D7\u30EA\u30F3\u30C8\u3092\u8FFD\u52A0\u3057\u307E\u3059\u304B\uFF1F","checkout-delete-restriction-message":"\u8FFD\u52A0\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u8CFC\u5165\u3059\u308B\u5834\u5408\u3001\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u30AB\u30FC\u30C8\u306B\u306F\u5C11\u306A\u304F\u3068\u30821\u3064\u306E\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u6B8B\u3059\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u5909\u66F4\u3059\u308B\u5834\u5408\u306F\u3001\u5148\u306B\u8FFD\u52A0\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u3059\u3079\u3066\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002","checkout-digital-package-duplicate-message":"\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u30AB\u30FC\u30C8\u306B\u306F\u3059\u3067\u306B\u30C7\u30B8\u30BF\u30EB\u30A2\u30AF\u30BB\u30B9\u30D1\u30C3\u30B1\u30FC\u30B8\u304C\u3042\u308A\u307E\u3059\u3002<br>\u73FE\u5728\u306E\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u524A\u9664\u307E\u305F\u306F\u8CFC\u5165\u3059\u308B\u307E\u3067\u3001\u65B0\u3057\u3044\u30D1\u30C3\u30B1\u30FC\u30B8\u306F\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002","welcome-print-modal-title":"\u5370\u5237","welcome-print-modal-text":"\u5199\u771F\u306F\u5370\u5237\u3055\u308C\u3001\u30A4\u30D9\u30F3\u30C8\u4E3B\u50AC\u8005\u306B\u5F15\u304D\u6E21\u3055\u308C\u307E\u3059\u3002","cancel-btn":"\u30AD\u30E3\u30F3\u30BB\u30EB","welcome-preview-modal-title":"\u30D7\u30EC\u30D3\u30E5\u30FC","close-btn":"\u9589\u3058\u308B","ok-btn":"\u78BA\u8A8D","back-btn":"\u623B\u308B","info-title":"\u304A\u77E5\u3089\u305B","apply-btn":"\u9069\u7528","clear-btn":"\u30AF\u30EA\u30A2","yes-btn":"\u306F\u3044","no-btn":"\u3044\u3044\u3048","change-image-btn":"\u753B\u50CF\u3092\u5909\u66F4","done-btn":"\u5B8C\u4E86","skip-btn":"\u30B9\u30AD\u30C3\u30D7","refresh-btn":"\u66F4\u65B0","exit-btn":"\u7D42\u4E86","unsupported-picture-format-message":"\u7121\u52B9\u307E\u305F\u306F\u672A\u5BFE\u5FDC\u306E\u753B\u50CF\u5F62\u5F0F\u3067\u3059","welcome-alert-modal-title":"\u30E2\u30FC\u30C0\u30EB\u30BF\u30A4\u30C8\u30EB","welcome-alert-modal-body-text":"\u3053\u3053\u306B\u30E2\u30FC\u30C0\u30EB\u672C\u6587\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002","welcome-alert-save-btn":"\u5909\u66F4\u3092\u4FDD\u5B58","welcome-passcodes-modal-title":"\u30D1\u30B9\u30B3\u30FC\u30C9\u3092\u751F\u6210","welcome-passcodes-events-label":"\u30D1\u30B9\u30B3\u30FC\u30C9\u3092\u751F\u6210\u3059\u308B\u30A4\u30D9\u30F3\u30C8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044:","welcome-passcodes-email-label":"XLS\u5F62\u5F0F\u306E\u30D1\u30B9\u30B3\u30FC\u30C9\u53D7\u4FE1\u7528\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9:","welcome-passcodes-count-label":"\u751F\u6210\u3059\u308B\u30D1\u30B9\u30B3\u30FC\u30C9\u6570:","welcome-passcodes-count-help":"1\u301C200,000\u306E\u6570\u5024","welcome-passcodes-prepaid-label":"\u3053\u308C\u3089\u306E\u30AB\u30FC\u30C9\u4FDD\u6709\u8005\u3092\u524D\u6255\u3044/VIP\u3068\u3057\u3066\u6271\u3044\u307E\u3059\u304B\uFF1F:","welcome-passcodes-expiry-label":"\u516C\u958B\u30AD\u30AA\u30B9\u30AF\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u6709\u52B9\u671F\u9650\uFF08\u5206\uFF09\uFF08\u7121\u52B9\u5316\u3059\u308B\u5834\u5408\u306F0\uFF09:","welcome-passcodes-url-prefix-label":"\u30A2\u30EB\u30D0\u30E0\u30A2\u30AF\u30BB\u30B9URL\u306E\u30D7\u30EC\u30D5\u30A3\u30C3\u30AF\u30B9\uFF08\u4F8B: https://domain-name.com\uFF09:","welcome-passcodes-generate-btn":"\u751F\u6210","sharing-modal-title":"\u753B\u50CF\u3092\u5171\u6709","sharing-tab-email":"\u30E1\u30FC\u30EB","sharing-tab-sms":"SMS","sharing-email-name-placeholder":"\u6C0F\u540D","sharing-email-placeholder":"\u6709\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9","sharing-email-help-text":"\u8907\u6570\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u3001\u30BB\u30DF\u30B3\u30ED\u30F3\u30FB\u30AB\u30F3\u30DE\u30FB\u30B9\u30DA\u30FC\u30B9\u30FBEnter\u3067\u533A\u5207\u3063\u3066\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","sharing-contact-phone-placeholder":"\u96FB\u8A71\u756A\u53F7","sharing-company-placeholder":"\u4F1A\u793E\u30FB\u6A5F\u95A2\u540D","sharing-sms-name-placeholder":"\u6C0F\u540D","sharing-sms-phone-placeholder":"\u6709\u52B9\u306A\u96FB\u8A71\u756A\u53F7","sharing-privacy-link":"\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC","sharing-privacy-prefix":"\u304A\u5BA2\u69D8\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u306F\u975E\u5E38\u306B\u91CD\u8981\u3067\u3059\u3002\u4EE5\u4E0B\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044","welcome-delete-modal-title":"\u524A\u9664","welcome-delete-modal-body":"\u3053\u306E\u5199\u771F\u3092\u30A2\u30EB\u30D0\u30E0\u304B\u3089\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F","welcome-delete-photo-confirmation-message":"\u672C\u5F53\u306B\u3053\u306E\u753B\u50CF\u3092\u30A2\u30EB\u30D0\u30E0\u304B\u3089\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","welcome-delete-photo-keep-btn":"\u3053\u306E\u753B\u50CF\u3092\u6B8B\u3059\uFF01","welcome-delete-photo-delete-btn":"\u3053\u306E\u753B\u50CF\u3092\u30A2\u30EB\u30D0\u30E0\u304B\u3089\u524A\u9664","welcome-delete-reason-not-mine-btn":"\u306F\u3044\u3002\u3053\u308C\u306F\u79C1\u306E\u5199\u771F\u3067\u306F\u3042\u308A\u307E\u305B\u3093","welcome-delete-confirm-btn":"\u524A\u9664","welcome-selfie-modal-title":"\u9854\u3067\u81EA\u5206\u306E\u753B\u50CF\u3092\u691C\u7D22","welcome-selfie-match-found-title":"\u898B\u3064\u304B\u3063\u305F\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\uFF01","welcome-selfie-match-found-confirm-message":"\u3042\u306A\u305F\u306E\u753B\u50CF\u3092\u30BF\u30C3\u30D7\u3057\u3066\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","welcome-selfie-capture-btn":"\u3053\u3053\u3092\u30AF\u30EA\u30C3\u30AF","welcome-delete-reason-dont-want-btn":"\u306F\u3044\u3002\u79C1\u306E\u5199\u771F\u3067\u3059\u304C\u4E0D\u8981\u3067\u3059","welcome-print-copy-count-label":"\u5370\u5237\u679A\u6570\u3092\u9078\u629E","catalog-select-product-package-title":"\u5546\u54C1\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u9078\u629E","freedompay-offline-request-title":"\u30AA\u30D5\u30E9\u30A4\u30F3\u53D6\u5F15\u30EA\u30AF\u30A8\u30B9\u30C8ID\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","square-reader-access-token-title":"Square Access Token \u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","square-reader-pairing-code-title":"\u3053\u306E\u30B3\u30FC\u30C9\u3092\u4F7F\u3063\u3066\u65B0\u3057\u3044 Square \u30EA\u30FC\u30C0\u30FC\u306B\u30B5\u30A4\u30F3\u30A4\u30F3\u3057\u3001\u5B8C\u4E86\u5F8C\u306B OK \u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002","square-reader-still-unpaired-text":"\u3053\u306E\u7AEF\u672B\u306F\u307E\u3060\u30DA\u30A2\u30EA\u30F3\u30B0\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u30B3\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u65B0\u3057\u3044 Square \u30EA\u30FC\u30C0\u30FC\u306B\u30B5\u30A4\u30F3\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002","square-reader-security-note-title":"\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u4E0A\u306E\u7406\u7531\u3067\u4FDD\u5B58\u3055\u308C\u306A\u3044\u305F\u3081\u3001\u6B21\u306E2\u3064\u306E\u30AD\u30FC\u3092\u63A7\u3048\u3066\u304F\u3060\u3055\u3044","storicard-invalid-code-text":"\u7121\u52B9\u306A StoriCard \u30B3\u30FC\u30C9\u3067\u3059\u3002","header-menu-user-id-link":"UserID:","countdown-time-up-text":"\u6642\u9593\u5207\u308C\u3067\u3059\uFF01","welcome-find-more-images-btn":"\u753B\u50CF\u3092\u3055\u3089\u306B\u63A2\u3059","welcome-select-images-btn":"\u753B\u50CF\u3092\u9078\u629E","welcome-selected-images-next-btn":"\u3053\u306E {{count}} \u679A\u306E\u753B\u50CF\u306B\u5199\u3063\u3066\u3044\u308B\u306E\u306F\u79C1\u3067\u3059\u3002\u6B21\u3078 >","welcome-invalid-attendee-id-message":"\u7121\u52B9\u306A attendee ID \u3067\u3059\u3002","welcome-kiosk-time-expired-message":"\u516C\u958B\u30AD\u30AA\u30B9\u30AF\u306E\u5229\u7528\u6642\u9593\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F","welcome-grouping-error-message":"3\u65E5\u4EE5\u4E0A\u524D\u306B\u4F5C\u6210\u3055\u308C\u305F\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30B0\u30EB\u30FC\u30D7\u5316\u306F\u8A31\u53EF\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002","confirm-btn":"\u78BA\u8A8D","approved-btn":"\u627F\u8A8D\u6E08\u307F","checkout-confirm-purchase-title":"\u8CFC\u5165\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044","checkout-confirm-purchase-short-title":"\u8CFC\u5165\u78BA\u8A8D","checkout-digital-access-summary":"\u672C\u65E5\u64AE\u5F71\u3057\u305F\u3059\u3079\u3066\u306E\u30C7\u30B8\u30BF\u30EB\u753B\u50CF\u3078\u306E\u30A2\u30AF\u30BB\u30B9","checkout-and-text":"\u3068","checkout-print-count-summary":"{{count}} \u679A\u30D7\u30EA\u30F3\u30C8","checkout-digitals-copy-message":"\u30C7\u30B8\u30BF\u30EB\u30C7\u30FC\u30BF\u306E\u30B3\u30D4\u30FC\u3092\u4F5C\u6210\u3057\u307E\u3059\u304B\uFF1F<br>\u30AB\u30FC\u30C9\u7D1B\u5931\u6642\u306E\u305F\u3081\u306B\u304A\u3059\u3059\u3081\u3057\u307E\u3059\u3002","checkout-email-placeholder":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9","checkout-email-or-phone-placeholder":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u307E\u305F\u306F\u7C73\u56FD\u306E\u96FB\u8A71\u756A\u53F7","checkout-sms-agreement-label":"\u4E0A\u8A18\u306E\u96FB\u8A71\u756A\u53F7\u5B9B\u3066\u306B Storibox \u304B\u3089\u901A\u77E5\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u53D7\u3051\u53D6\u308B\u3053\u3068\u306B\u540C\u610F\u3057\u307E\u3059\u3002\u753B\u50CF\u306B\u95A2\u3059\u308B\u66F4\u65B0\u60C5\u5831\u3084\u30EA\u30F3\u30AF\u3092\u542B\u3080 SMS \u3092\u53D7\u4FE1\u3059\u308B\u3053\u3068\u3092\u7406\u89E3\u3057\u3066\u3044\u307E\u3059\u3002\u901A\u4FE1\u6599\u30FB\u30E1\u30C3\u30BB\u30FC\u30B8\u6599\u91D1\u304C\u767A\u751F\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u505C\u6B62\u3059\u308B\u306B\u306F STOP \u3068\u8FD4\u4FE1\u3057\u3066\u304F\u3060\u3055\u3044\u3002","checkout-name-placeholder":"\u304A\u540D\u524D","checkout-cancel-transaction-btn":"\u53D6\u5F15\u3092\u30AD\u30E3\u30F3\u30BB\u30EB","checkout-employee-authorization-title":"\u5F93\u696D\u54E1\u306E\u8A8D\u8A3C\u304C\u5FC5\u8981\u3067\u3059","checkout-scan-employee-card-prefix":"\u6B21\u306E\u53D6\u5F15\u304C\u5B8C\u4E86\u3057\u305F\u3089\u5F93\u696D\u54E1\u30AB\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u304F\u3060\u3055\u3044:","checkout-transaction-complete-suffix":"\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F","checkout-unlock-code-error-message":"\u5F93\u696D\u54E1\u8A8D\u8A3C\u30B3\u30FC\u30C9\u304C\u7121\u52B9\u3067\u3059\u3002","checkout-print-pool-error-message":"\u8A2D\u5B9A\u3055\u308C\u305FPrintPool\u304C\u7121\u52B9\u307E\u305F\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u30AD\u30AA\u30B9\u30AF\u306EPrintPool\u8A2D\u5B9A\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","checkout-printing-now-title":"\u5370\u5237\u4E2D","checkout-prints-ready-message":"\u5370\u5237\u7269\u306F1\u5206\u307B\u3069\u3067\u6E96\u5099\u3067\u304D\u307E\u3059","checkout-digitals-unlocked-message":"\u30C7\u30B8\u30BF\u30EB\u5199\u771F\u306E\u30ED\u30C3\u30AF\u304C\u89E3\u9664\u3055\u308C\u307E\u3057\u305F","checkout-internal-error-title":"\u7533\u3057\u8A33\u3042\u308A\u307E\u305B\u3093\u3002\u5185\u90E8\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","checkout-transaction-processed-title":"\u53D6\u5F15\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\uFF01","checkout-register-receipt-qr-message":"\u30C7\u30B8\u30BF\u30EB\u30EC\u30B7\u30FC\u30C8\u3068\u30A2\u30EB\u30D0\u30E0\u30EA\u30F3\u30AF\u3092\u53D7\u3051\u53D6\u308B\u305F\u3081\u3001QR\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044\uFF01","checkout-shop-more-btn":"\u3055\u3089\u306B\u8CFC\u5165","checkout-print-receipt-btn":"\u30EC\u30B7\u30FC\u30C8\u3092\u5370\u5237","checkout-paid-by-cash-label":"\u73FE\u91D1\u6255\u3044","checkout-paid-by-card-label":"\u30AB\u30FC\u30C9\u6255\u3044","checkout-draft-order-error-message":"\u4E0B\u66F8\u304D\u6CE8\u6587\u306E\u4F5C\u6210\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002","checkout-print-confirmation-message":"\u5370\u5237\u5546\u54C1\u3092\u3054\u6CE8\u6587\u306E\u5834\u5408\u30011\u5206\u307B\u3069\u3067\u6E96\u5099\u3067\u304D\u307E\u3059\u3002\u5546\u54C1\u306F\u8CA9\u58F2\u30AB\u30A6\u30F3\u30BF\u30FC\u3067\u304A\u53D7\u3051\u53D6\u308A\u304F\u3060\u3055\u3044","checkout-shopify-params-incomplete-message":"Shopify \u30D1\u30E9\u30E1\u30FC\u30BF\u304C\u4E0D\u5B8C\u5168\u3067\u3059","checkout-event-name-required-message":"eventName \u304C\u6307\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002","payment-no-device-connected-message":"\u63A5\u7D9A\u3055\u308C\u3066\u3044\u308B\u30C7\u30D0\u30A4\u30B9\u304C\u3042\u308A\u307E\u305B\u3093\u3002","payment-ask-for-assistance-message":"\u30B9\u30BF\u30C3\u30D5\u306B\u304A\u58F0\u304C\u3051\u304F\u3060\u3055\u3044\u3002","payment-square-checkout-creation-failed-message":"\u4F1A\u8A08\u30EA\u30AF\u30A8\u30B9\u30C8\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","payment-square-checkout-status-check-failed-message":"\u4F1A\u8A08\u30B9\u30C6\u30FC\u30BF\u30B9\u306E\u78BA\u8A8D\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","payment-qr-title":"\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3067\u652F\u6255\u3046","payment-qr-help-html":"<b>\u7C21\u5358\u30FB\u30B9\u30D4\u30FC\u30C7\u30A3:</b><br> \u4E0A\u306EQR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u3001\u753B\u9762\u306E\u6848\u5185\u306B\u5F93\u3063\u3066\u304F\u3060\u3055\u3044\u3002","payment-qr-transaction-progress-message":"\u53D6\u5F15\u3092\u51E6\u7406\u4E2D\u3067\u3059...","payment-qr-failed-message":"QR\u6C7A\u6E08\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002API\u30AD\u30FC\u3092\u78BA\u8A8D\u3057\u3066\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","payment-failed-message":"\u304A\u652F\u6255\u3044\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","payment-failed-short-message":"\u304A\u652F\u6255\u3044\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002","payment-use-pinpad-message":"\u53D6\u5F15\u3092\u5B8C\u4E86\u3059\u308B\u306B\u306F PinPad \u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044...","payment-terminal-progress-message":"\u53D6\u5F15\u3092\u51E6\u7406\u4E2D\u3067\u3059\u3002<br>\u30AD\u30E3\u30F3\u30BB\u30EB\u3059\u308B\u306B\u306F\u3001\u7AEF\u672B\u306E\u77E2\u5370\u3092\u30BF\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002","payment-transaction-canceled-message":"\u53D6\u5F15\u306F\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3057\u305F\u3002","payment-transaction-canceled-close-btn":"\u623B\u308B","payment-transaction-canceled-done-btn":"\u30DB\u30FC\u30E0","search-version-label":"kiosk v.{{version}}","search-find-by-qr-btn":"QR\u3067\u691C\u7D22","search-find-by-face-btn":"\u9854\u3067\u691C\u7D22","search-scan-another-qr-placeholder":"\u5225\u306EQR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3","search-scanned-attendee-label":"\u30B9\u30AD\u30E3\u30F3\u6E08\u307F: {{attId}}","search-qr-or-photos-not-found-message":"QR\u30B3\u30FC\u30C9\u307E\u305F\u306F\u5199\u771F\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002\u3082\u3046\u4E00\u5EA6\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002","scanning-qr-page-title":"\u30D5\u30A9\u30C8\u30A2\u30EB\u30D0\u30E0","photo-viewer-back-btn":"\u30A2\u30EB\u30D0\u30E0\u306B\u623B\u308B","email-capture-modal-title":"\u30A2\u30EB\u30D0\u30E0\u3092\u898B\u308B\u306B\u306F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","checkout-scan-album-qr-message":"QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u30C7\u30B8\u30BF\u30EB\u30D5\u30A9\u30C8\u30A2\u30EB\u30D0\u30E0\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u3066\u304F\u3060\u3055\u3044","email-capture-name-label":"\u304A\u540D\u524D\uFF1A","email-capture-email-label":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF1A","email-capture-domain-placeholder":"\u4F8B\uFF1Agmail.com","email-capture-next-btn":"\u6B21\u3078"}');

});

parcelRegister("8wWUN", function(module, exports) {
module.exports = JSON.parse('{"search-join-attendee-submit-btn":"\u5B8C\u6210","go-to-package-btn":"\u8CFC\u8CB7\u9078\u9805","done-exit-btn":"\u5B8C\u6210\uFF08\u96E2\u958B\u81EA\u52A9\u6A5F\uFF09","title-select-package":"\u9078\u64C7\u5957\u88DD","title-suggest-a-product":"\u60A8\u60F3\u70BA\u8A02\u55AE\u52A0\u8CFC\u5176\u4ED6\u5546\u54C1\u55CE\uFF1F","title-choose-a-product":"\u9078\u64C7\u8981\u52A0\u5165\u8A02\u55AE\u7684\u5546\u54C1","store-title":"\u8ACB\u9078\u64C7\u60A8\u60F3\u8CFC\u8CB7\u7684\u5546\u54C1","title-shopping-cart":"\u8CFC\u7269\u8ECA","select-images-notice-message":"\u8ACB\u9078\u64C7\u60A8\u8981\u5217\u5370\u7684\u5716\u7247\u3002","select-images-notice-ok":"\u78BA\u8A8D","confirm-change-img-btn":"\u78BA\u8A8D\uFF0C\u4F7F\u7528\u6B64\u5716\u7247","select-image-title":"OCCO \u500B\u4EBA\u7167\u7247","welcome-title":"\u76F8\u7C3F","welcome-event-list-label":"\u6D3B\u52D5\u6E05\u55AE:","welcome-item-count-label":"\u9805\u76EE\u6578\u91CF:","select-image-selection-title":"\u9078\u64C7\uFF08{{count}}\uFF09\u5F35\u5716\u7247","select-image-step-label":"\u6B65\u9A5F {{currentStep}} / {{totalSteps}}","select-image-for-product-text":"\u7528\u65BC\u300C{{title}}\u300D","select-image-next-btn":"\u4E0B\u4E00\u6B65\uFF08{{selectedCount}}/{{requiredCount}}\uFF09","select-image-clear-btn":"\u6E05\u9664","select-image-no-photos-message":"\u6C92\u6709\u53EF\u7528\u7167\u7247","select-image-no-uid-message":"\u7CDF\u7CD5\uFF0C\u627E\u4E0D\u5230\u60A8\u7684\u5E33\u6236\u3002\u8ACB\u518D\u8A66\u4E00\u6B21\u3002","select-image-unlock-notice-message":"\u8ACB\u9078\u64C7\u60A8\u8981\u89E3\u9396\u7684\u5716\u7247\u3002","select-image-print-or-unlock-notice-message":"\u8ACB\u9078\u64C7\u60A8\u8981\u5217\u5370\u6216\u89E3\u9396\u7684\u5716\u7247\u3002","select-image-addon-selection-title":"\u9078\u64C7\u5716\u7247","select-image-addon-done-count-btn":"\u5B8C\u6210\uFF08{{count}}\uFF09","select-image-no-compatible-image-message":"\u627E\u4E0D\u5230\u76F8\u5BB9\u7684\u5716\u7247","select-image-photo-limit-message":"\u8ACB\u9078\u64C7 {{count}} \u5F35\u8981\u5217\u5370\u7684\u5716\u7247\u3002","welcome-gallery-title":"\u6211\u7684\u76F8\u7C3F","welcome-select-images-of-yourself-title":"\u9078\u64C7\u6240\u6709\u60A8\u7684\u7167\u7247","welcome-select-found-images-title":"\u9078\u64C7\u8981\u52A0\u5165\u76F8\u7C3F\u7684\u7167\u7247","welcome-back-to-gallery-btn":"\u8FD4\u56DE\u76F8\u7C3F","checkout-subtotal-label":"\u5C0F\u8A08:","checkout-taxes-label":"\u7A05\u91D1:","checkout-total-label":"\u7E3D\u8A08:","checkout-btn":"\u7D50\u5E33","checkout-add-on-btn":"+ \u52A0\u8CFC","checkout-add-product-btn":"\u65B0\u589E\u5546\u54C1","checkout-empty-cart-message":"\u8CFC\u7269\u8ECA\u662F\u7A7A\u7684","checkout-promo-code-placeholder":"\u50C5\u4F9B\u54E1\u5DE5\u4F7F\u7528","checkout-invalid-promo-code-message":"\u7121\u6548\u6216\u5DF2\u904E\u671F\u7684\u512A\u60E0\u78BC\uFF01","checkout-discount-label":"\u6298\u6263: {{title}}","checkout-receipt-title":"\u6536\u64DA","checkout-receipt-product-label":"\u5546\u54C1","checkout-receipt-unit-price-label":"\u55AE\u50F9","checkout-receipt-qty-label":"\u6578\u91CF","checkout-receipt-amount-label":"\u91D1\u984D","checkout-digital-package-upsell-message":"\u8981\u5C07<br>\u6578\u4F4D\u5957\u88DD\u52A0\u5165<br>\u8CFC\u7269\u8ECA\uFF0C\u4E26\u53D6\u5F97<br>\u6240\u6709\u6578\u4F4D\u5167\u5BB9\u7684\u5B58\u53D6\u6B0A\u55CE\uFF1F","checkout-tip-message":"\u8981\u65B0\u589E\u5C0F\u8CBB\u55CE\uFF1F","checkout-tip-description":"\u60A8\u7684\u5C0F\u8CBB\u5C07\u5E6B\u52A9\u652F\u6301\u5718\u968A\u3002","checkout-no-tip-btn":"\u4E0D\u7D66\u5C0F\u8CBB","photo-plus-pass-required-message":"\u60A8\u4F3C\u4E4E\u5C1A\u672A\u64C1\u6709 Photo+ Pass\u3002<br><br>\u7ACB\u5373\u8CFC\u8CB7\u5373\u53EF\u5B58\u53D6\u9AD8\u89E3\u6790\u5EA6\u5167\u5BB9\u3002","photo-plus-valid-ticket-required-message":"\u60A8\u76EE\u524D\u4F3C\u4E4E\u5C1A\u672A\u6709\u672C\u6B21\u5712\u5340\u884C\u7A0B\u7684\u6709\u6548\u9580\u7968\u3002\u8ACB\u5148\u9023\u7D50\u9580\u7968\uFF0C\u4EE5\u4EAB\u53D7 Photo+ \u9AD4\u9A57\u3002","photo-plus-visit-availability-message":"\u60A8\u7684 Photo+ \u9AD4\u9A57\u50C5\u5728\u9020\u8A2A Genting SkyWorlds \u671F\u9593\u53EF\u7528\u3002","checkout-other-products-upsell-message":"\u8981\u70BA\u60A8\u7684\u6578\u4F4D\u5957\u88DD\u52A0\u8CFC\u6C96\u5370\u55CE\uFF1F","checkout-delete-restriction-message":"\u82E5\u8981\u8CFC\u8CB7\u52A0\u8CFC\u9805\u76EE\uFF0C\u8CFC\u7269\u8ECA\u4E2D\u5FC5\u9808\u81F3\u5C11\u4FDD\u7559\u4E00\u500B\u5957\u88DD\u3002\u82E5\u8981\u66F4\u63DB\u5957\u88DD\uFF0C\u8ACB\u5148\u79FB\u9664\u6240\u6709\u52A0\u8CFC\u9805\u76EE\u3002","checkout-digital-package-duplicate-message":"\u60A8\u7684\u8CFC\u7269\u8ECA\u4E2D\u5DF2\u6709\u6578\u4F4D\u5B58\u53D6\u5957\u88DD\u3002<br>\u5728\u79FB\u9664\u6216\u8CFC\u8CB7\u76EE\u524D\u5957\u88DD\u4E4B\u524D\uFF0C\u7121\u6CD5\u65B0\u589E\u65B0\u5957\u88DD\u3002","welcome-print-modal-title":"\u5217\u5370","welcome-print-modal-text":"\u60A8\u7684\u7167\u7247\u5C07\u6703\u5217\u5370\u4E26\u4EA4\u4ED8\u7D66\u6D3B\u52D5\u4E3B\u8FA6\u65B9\u3002","cancel-btn":"\u53D6\u6D88","welcome-preview-modal-title":"\u9810\u89BD","close-btn":"\u95DC\u9589","ok-btn":"\u78BA\u8A8D","back-btn":"\u8FD4\u56DE","info-title":"\u8CC7\u8A0A","apply-btn":"\u5957\u7528","clear-btn":"\u6E05\u9664","yes-btn":"\u662F","no-btn":"\u5426","change-image-btn":"\u66F4\u63DB\u5716\u7247","done-btn":"\u5B8C\u6210","skip-btn":"\u7565\u904E","refresh-btn":"\u91CD\u65B0\u6574\u7406","exit-btn":"\u96E2\u958B","unsupported-picture-format-message":"\u7121\u6548\u6216\u4E0D\u652F\u63F4\u7684\u5716\u7247\u683C\u5F0F","welcome-alert-modal-title":"\u5C0D\u8A71\u6846\u6A19\u984C","welcome-alert-modal-body-text":"\u5C0D\u8A71\u6846\u5167\u5BB9\u986F\u793A\u65BC\u6B64\u3002","welcome-alert-save-btn":"\u5132\u5B58\u8B8A\u66F4","welcome-passcodes-modal-title":"\u7522\u751F\u901A\u884C\u78BC","welcome-passcodes-events-label":"\u8ACB\u9078\u64C7\u8981\u7522\u751F\u901A\u884C\u78BC\u7684\u6D3B\u52D5\uFF1A","welcome-passcodes-email-label":"\u63A5\u6536 XLS \u683C\u5F0F\u901A\u884C\u78BC\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\uFF1A","welcome-passcodes-count-label":"\u8981\u7522\u751F\u7684\u901A\u884C\u78BC\u6578\u91CF\uFF1A","welcome-passcodes-count-help":"\u4ECB\u65BC 1-200,000 \u7684\u6578\u5B57","welcome-passcodes-prepaid-label":"\u9019\u4E9B\u5361\u7247\u6301\u6709\u4EBA\u662F\u5426\u8996\u70BA\u9810\u4ED8 / VIP\uFF1F\uFF1A","welcome-passcodes-expiry-label":"\u516C\u958B\u81EA\u52A9\u6A5F\u5B58\u53D6\u5230\u671F\u6642\u9593\uFF08\u5206\u9418\uFF09\uFF08\u8F38\u5165 0 \u4EE5\u505C\u7528\uFF09\uFF1A","welcome-passcodes-url-prefix-label":"\u76F8\u7C3F\u5B58\u53D6 URL \u524D\u7DB4\uFF08\u4F8B\u5982 https://domain-name.com\uFF09\uFF1A","welcome-passcodes-generate-btn":"\u7522\u751F","sharing-modal-title":"\u5206\u4EAB\u5716\u7247","sharing-tab-email":"Email","sharing-tab-sms":"SMS","sharing-email-name-placeholder":"\u5168\u540D","sharing-email-placeholder":"\u6709\u6548\u96FB\u5B50\u90F5\u4EF6\u5730\u5740","sharing-email-help-text":"\u591A\u500B\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u53EF\u7528\u5206\u865F\u3001\u9017\u865F\u3001\u7A7A\u683C\u6216 Enter \u9375\u5206\u9694\u3002","sharing-contact-phone-placeholder":"\u96FB\u8A71\u865F\u78BC","sharing-company-placeholder":"\u516C\u53F8 / \u6A5F\u69CB","sharing-sms-name-placeholder":"\u5168\u540D","sharing-sms-phone-placeholder":"\u6709\u6548\u96FB\u8A71\u865F\u78BC","sharing-privacy-link":"\u96B1\u79C1\u653F\u7B56","sharing-privacy-prefix":"\u6211\u5011\u975E\u5E38\u91CD\u8996\u60A8\u7684\u96B1\u79C1\uFF0C\u8ACB\u95B1\u8B80\u6211\u5011\u7684","welcome-delete-modal-title":"\u522A\u9664","welcome-delete-modal-body":"\u78BA\u5B9A\u8981\u5F9E\u76F8\u7C3F\u522A\u9664\u6B64\u5716\u7247\u55CE\uFF1F","welcome-delete-photo-confirmation-message":"\u60A8\u78BA\u5B9A\u8981\u5F9E\u76F8\u7C3F\u522A\u9664\u6B64\u5716\u7247\u55CE\uFF1F","welcome-delete-photo-keep-btn":"\u4FDD\u7559\u9019\u5F35\u5716\u7247\uFF01","welcome-delete-photo-delete-btn":"\u5F9E\u6211\u7684\u76F8\u7C3F\u522A\u9664\u6B64\u5716\u7247","welcome-delete-reason-not-mine-btn":"\u662F\u3002\u9019\u4E0D\u662F\u6211\u7684\u5716\u7247","welcome-delete-confirm-btn":"\u522A\u9664","welcome-selfie-modal-title":"\u4EE5\u4EBA\u81C9\u641C\u5C0B\u6211\u7684\u5716\u7247","welcome-selfie-match-found-title":"\u6211\u5011\u53EF\u80FD\u627E\u5230\u60A8\u4E86\uFF01","welcome-selfie-match-found-confirm-message":"\u9EDE\u64CA\u60A8\u7684\u5716\u7247\u4EE5\u78BA\u8A8D\u3002","welcome-selfie-capture-btn":"\u9EDE\u6B64","welcome-delete-reason-dont-want-btn":"\u662F\u3002\u9019\u662F\u6211\u7684\u5716\u7247\uFF0C\u4F46\u6211\u4E0D\u60F3\u8981","welcome-print-copy-count-label":"\u9078\u64C7\u5217\u5370\u4EFD\u6578","catalog-select-product-package-title":"\u9078\u64C7\u5546\u54C1\u5957\u88DD","freedompay-offline-request-title":"\u8ACB\u8F38\u5165\u96E2\u7DDA\u4EA4\u6613\u8ACB\u6C42 ID","square-reader-access-token-title":"\u8ACB\u8F38\u5165 Square Access Token","square-reader-pairing-code-title":"\u8ACB\u4F7F\u7528\u6B64\u4EE3\u78BC\u767B\u5165\u65B0\u7684 Square reader\uFF0C\u5B8C\u6210\u5F8C\u6309\u78BA\u8A8D\u3002","square-reader-still-unpaired-text":"\u6B64\u88DD\u7F6E\u5C1A\u672A\u914D\u5C0D\uFF0C\u8ACB\u4F7F\u7528\u4EE3\u78BC\u767B\u5165\u65B0\u7684 Square reader\u3002","square-reader-security-note-title":"\u57FA\u65BC\u5B89\u5168\u539F\u56E0\uFF0C\u4EE5\u4E0B\u5169\u7D44\u91D1\u9470\u4E0D\u6703\u88AB\u5132\u5B58\uFF0C\u8ACB\u5148\u8A18\u9304","storicard-invalid-code-text":"\u7121\u6548\u7684 StoriCard \u4EE3\u78BC\u3002","header-menu-user-id-link":"UserID:","countdown-time-up-text":"\u6642\u9593\u5230\uFF01","welcome-find-more-images-btn":"\u5C0B\u627E\u66F4\u591A\u5716\u7247","welcome-select-images-btn":"\u9078\u64C7\u5716\u7247","welcome-selected-images-next-btn":"\u9019 {{count}} \u5F35\u5716\u7247\u4E2D\u7684\u662F\u6211\uFF0C\u4E0B\u4E00\u6B65 >","welcome-invalid-attendee-id-message":"\u7121\u6548\u7684 attendee ID\u3002","welcome-kiosk-time-expired-message":"\u62B1\u6B49\uFF0C\u516C\u958B\u81EA\u52A9\u6A5F\u4F7F\u7528\u6642\u9593\u5DF2\u5230","welcome-grouping-error-message":"\u4E0D\u5141\u8A31\u5408\u4F75 3 \u5929\u524D\u5EFA\u7ACB\u7684\u5E33\u6236\u3002","confirm-btn":"\u78BA\u8A8D","approved-btn":"\u5DF2\u6838\u51C6","checkout-confirm-purchase-title":"\u8ACB\u78BA\u8A8D\u60A8\u7684\u8CFC\u8CB7","checkout-confirm-purchase-short-title":"\u78BA\u8A8D\u8CFC\u8CB7","checkout-digital-access-summary":"\u5B58\u53D6\u60A8\u4ECA\u5929\u62CD\u651D\u7684\u6240\u6709\u6578\u4F4D\u5716\u7247","checkout-and-text":"\u53CA","checkout-print-count-summary":"{{count}} \u4EFD\u5217\u5370","checkout-digitals-copy-message":"\u60A8\u8981\u5099\u4EFD\u4E00\u4EFD\u6578\u4F4D\u5167\u5BB9\u55CE\uFF1F<br>\u4EE5\u9632\u5361\u7247\u907A\u5931\u3002","checkout-email-placeholder":"\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6","checkout-email-or-phone-placeholder":"\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u6216\u7F8E\u570B\u96FB\u8A71\u865F\u78BC","checkout-sms-agreement-label":"\u6211\u540C\u610F\u63A5\u6536\u4F86\u81EA Storibox \u7684\u901A\u77E5\u8A0A\u606F\u81F3\u4E0A\u65B9\u63D0\u4F9B\u7684\u96FB\u8A71\u865F\u78BC\u3002\u6211\u660E\u767D\u6211\u5C07\u6536\u5230\u5305\u542B\u66F4\u65B0\u8207\u5716\u7247\u9023\u7D50\u7684 SMS \u8A0A\u606F\u3002\u53EF\u80FD\u6703\u7522\u751F\u6578\u64DA\u53CA\u8A0A\u606F\u8CBB\u7528\u3002\u5982\u8981\u53D6\u6D88\uFF0C\u8ACB\u56DE\u8986 STOP\u3002","checkout-name-placeholder":"\u60A8\u7684\u59D3\u540D","checkout-cancel-transaction-btn":"\u53D6\u6D88\u4EA4\u6613","checkout-employee-authorization-title":"\u9700\u8981\u54E1\u5DE5\u6388\u6B0A","checkout-scan-employee-card-prefix":"\u4EA4\u6613\u5B8C\u6210\u6642\u8ACB\u6383\u63CF\u54E1\u5DE5\u5361\uFF1A","checkout-transaction-complete-suffix":"\u5DF2\u5B8C\u6210","checkout-unlock-code-error-message":"\u54E1\u5DE5\u6388\u6B0A\u78BC\u7121\u6548\u3002","checkout-print-pool-error-message":"\u8A2D\u5B9A\u7684 PrintPool \u7121\u6548\u6216\u7121\u6CD5\u4F7F\u7528\u3002\u8ACB\u6AA2\u67E5 kiosk \u7684 PrintPool \u8A2D\u5B9A\u3002","checkout-printing-now-title":"\u6B63\u5728\u5217\u5370","checkout-prints-ready-message":"\u60A8\u7684\u6C96\u5370\u54C1\u5C07\u65BC\u4E00\u5206\u9418\u5167\u5B8C\u6210","checkout-digitals-unlocked-message":"\u60A8\u7684\u6578\u4F4D\u7167\u7247\u5DF2\u89E3\u9396","checkout-internal-error-title":"\u62B1\u6B49\uFF0C\u7CFB\u7D71\u5167\u90E8\u932F\u8AA4","checkout-transaction-processed-title":"\u4EA4\u6613\u5DF2\u5B8C\u6210\uFF01","checkout-register-receipt-qr-message":"\u8ACB\u6383\u63CF QR \u4EE5\u767B\u8A18\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\uFF0C\u63A5\u6536\u96FB\u5B50\u6536\u64DA\u8207\u76F8\u7C3F\u9023\u7D50\uFF01","checkout-shop-more-btn":"\u7E7C\u7E8C\u9078\u8CFC","checkout-print-receipt-btn":"\u5217\u5370\u6536\u64DA","checkout-paid-by-cash-label":"\u73FE\u91D1\u4ED8\u6B3E","checkout-paid-by-card-label":"\u5237\u5361\u4ED8\u6B3E","checkout-draft-order-error-message":"\u5EFA\u7ACB\u8349\u7A3F\u8A02\u55AE\u5931\u6557\u3002","checkout-print-confirmation-message":"\u82E5\u60A8\u6709\u8A02\u8CFC\u6C96\u5370\u54C1\uFF0C\u5C07\u65BC\u4E00\u5206\u9418\u5167\u6E96\u5099\u5B8C\u6210\u3002\u60A8\u53EF\u65BC\u96F6\u552E\u6AC3\u6AAF\u9818\u53D6\u5546\u54C1","checkout-shopify-params-incomplete-message":"Shopify \u53C3\u6578\u4E0D\u5B8C\u6574","checkout-event-name-required-message":"\u672A\u63D0\u4F9B eventName\u3002","payment-no-device-connected-message":"\u672A\u9023\u63A5\u4EFB\u4F55\u88DD\u7F6E\u3002","payment-ask-for-assistance-message":"\u8ACB\u5C0B\u6C42\u5DE5\u4F5C\u4EBA\u54E1\u5354\u52A9\u3002","payment-square-checkout-creation-failed-message":"\u5EFA\u7ACB\u7D50\u5E33\u8ACB\u6C42\u5931\u6557\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002","payment-square-checkout-status-check-failed-message":"\u6AA2\u67E5\u7D50\u5E33\u72C0\u614B\u5931\u6557\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002","payment-qr-title":"\u4F7F\u7528\u624B\u6A5F\u4ED8\u6B3E","payment-qr-help-html":"<b>\u5FEB\u901F\u53C8\u65B9\u4FBF\uFF1A</b><br> \u6383\u63CF\u4E0A\u65B9 QR code\uFF0C\u4E26\u6309\u7167\u756B\u9762\u6307\u793A\u64CD\u4F5C\u3002","payment-qr-transaction-progress-message":"\u4EA4\u6613\u9032\u884C\u4E2D...","payment-qr-failed-message":"QR \u4ED8\u6B3E\u5931\u6557\u3002\u8ACB\u6AA2\u67E5 API key \u5F8C\u91CD\u8A66\u3002","payment-failed-message":"\u4ED8\u6B3E\u5931\u6557\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002","payment-failed-short-message":"\u60A8\u7684\u4ED8\u6B3E\u5931\u6557\u3002","payment-use-pinpad-message":"\u8ACB\u4F7F\u7528 PinPad \u5B8C\u6210\u4EA4\u6613...","payment-terminal-progress-message":"\u4EA4\u6613\u8655\u7406\u4E2D\u3002<br>\u82E5\u8981\u53D6\u6D88\uFF0C\u8ACB\u9EDE\u9078\u7D42\u7AEF\u6A5F\u4E0A\u7684\u7BAD\u982D\u3002","payment-transaction-canceled-message":"\u60A8\u7684\u4EA4\u6613\u5DF2\u53D6\u6D88\u3002","payment-transaction-canceled-close-btn":"\u8FD4\u56DE","payment-transaction-canceled-done-btn":"\u9996\u9801","search-version-label":"kiosk v.{{version}}","search-find-by-qr-btn":"\u4EE5 QR \u641C\u5C0B","search-find-by-face-btn":"\u4EE5\u4EBA\u81C9\u641C\u5C0B","search-scan-another-qr-placeholder":"\u6383\u63CF\u53E6\u4E00\u500B QR code","search-scanned-attendee-label":"\u5DF2\u6383\u63CF\uFF1A{{attId}}","search-qr-or-photos-not-found-message":"\u627E\u4E0D\u5230 QR code \u6216\u7167\u7247\u3002\u8ACB\u91CD\u65B0\u6383\u63CF\u3002","scanning-qr-page-title":"\u76F8\u7C3F","photo-viewer-back-btn":"\u8FD4\u56DE\u76F8\u7C3F","email-capture-modal-title":"\u8F38\u5165\u96FB\u5B50\u90F5\u4EF6\u4EE5\u67E5\u770B\u76F8\u7C3F","checkout-scan-album-qr-message":"\u6383\u63CF QR code \u4EE5\u5B58\u53D6\u60A8\u7684\u6578\u4F4D\u76F8\u7C3F","email-capture-name-label":"\u59D3\u540D\uFF1A","email-capture-email-label":"\u96FB\u5B50\u90F5\u4EF6\uFF1A","email-capture-domain-placeholder":"\u4F8B\u5982\uFF1Agmail.com","email-capture-next-btn":"\u4E0B\u4E00\u6B65"}');

});

parcelRegister("2hwLH", function(module, exports) {
module.exports = JSON.parse('{"search-join-attendee-submit-btn":"\u5B8C\u6210","go-to-package-btn":"\u8D2D\u4E70\u9009\u9879","done-exit-btn":"\u5B8C\u6210\uFF08\u79BB\u5F00\u81EA\u52A9\u673A\uFF09","title-select-package":"\u9009\u62E9\u5957\u88C5","title-suggest-a-product":"\u60A8\u60F3\u4E3A\u8BA2\u5355\u52A0\u8D2D\u5176\u4ED6\u5546\u54C1\u5417\uFF1F","title-choose-a-product":"\u9009\u62E9\u8981\u52A0\u5165\u8BA2\u5355\u7684\u5546\u54C1","store-title":"\u8BF7\u9009\u62E9\u60A8\u60F3\u8D2D\u4E70\u7684\u5546\u54C1","title-shopping-cart":"\u8D2D\u7269\u8F66","select-images-notice-message":"\u8BF7\u9009\u62E9\u60A8\u8981\u5217\u5370\u7684\u56FE\u7247\u3002","select-images-notice-ok":"\u786E\u8BA4","confirm-change-img-btn":"\u786E\u8BA4\uFF0C\u4F7F\u7528\u6B64\u56FE\u7247","select-image-title":"OCCO \u4E2A\u4EBA\u7167\u7247","welcome-title":"\u76F8\u518C","welcome-event-list-label":"\u6D3B\u52A8\u6E05\u5355:","welcome-item-count-label":"\u9879\u76EE\u6570\u91CF:","select-image-selection-title":"\u9009\u62E9\uFF08{{count}}\uFF09\u5F20\u56FE\u7247","select-image-step-label":"\u6B65\u9AA4 {{currentStep}} / {{totalSteps}}","select-image-for-product-text":"\u7528\u4E8E\u300C{{title}}\u300D","select-image-next-btn":"\u4E0B\u4E00\u6B65\uFF08{{selectedCount}}/{{requiredCount}}\uFF09","select-image-clear-btn":"\u6E05\u9664","select-image-no-photos-message":"\u6CA1\u6709\u53EF\u7528\u7167\u7247","select-image-no-uid-message":"\u7CDF\u7CD5\uFF0C\u627E\u4E0D\u5230\u60A8\u7684\u5E10\u6237\u3002\u8BF7\u518D\u8BD5\u4E00\u6B21\u3002","select-image-unlock-notice-message":"\u8BF7\u9009\u62E9\u60A8\u8981\u89E3\u9501\u7684\u56FE\u7247\u3002","select-image-print-or-unlock-notice-message":"\u8BF7\u9009\u62E9\u60A8\u8981\u5217\u5370\u6216\u89E3\u9501\u7684\u56FE\u7247\u3002","select-image-addon-selection-title":"\u9009\u62E9\u56FE\u7247","select-image-addon-done-count-btn":"\u5B8C\u6210\uFF08{{count}}\uFF09","select-image-no-compatible-image-message":"\u627E\u4E0D\u5230\u76F8\u5BB9\u7684\u56FE\u7247","select-image-photo-limit-message":"\u8BF7\u9009\u62E9 {{count}} \u5F20\u8981\u5217\u5370\u7684\u56FE\u7247\u3002","welcome-gallery-title":"\u6211\u7684\u76F8\u518C","welcome-select-images-of-yourself-title":"\u9009\u62E9\u6240\u6709\u60A8\u7684\u7167\u7247","welcome-select-found-images-title":"\u9009\u62E9\u8981\u52A0\u5165\u76F8\u518C\u7684\u7167\u7247","welcome-back-to-gallery-btn":"\u8FD4\u56DE\u76F8\u518C","checkout-subtotal-label":"\u5C0F\u8BA1:","checkout-taxes-label":"\u7A0E\u91D1:","checkout-total-label":"\u603B\u8BA1:","checkout-btn":"\u7ED3\u8D26","checkout-add-on-btn":"+ \u52A0\u8D2D","checkout-add-product-btn":"\u65B0\u589E\u5546\u54C1","checkout-empty-cart-message":"\u8D2D\u7269\u8F66\u662F\u7A7A\u7684","checkout-promo-code-placeholder":"\u4EC5\u4F9B\u5458\u5DE5\u4F7F\u7528","checkout-invalid-promo-code-message":"\u65E0\u6548\u6216\u5DF2\u8FC7\u671F\u7684\u4F18\u60E0\u7801\uFF01","checkout-discount-label":"\u6298\u6263: {{title}}","checkout-receipt-title":"\u6536\u636E","checkout-receipt-product-label":"\u5546\u54C1","checkout-receipt-unit-price-label":"\u5355\u4EF7","checkout-receipt-qty-label":"\u6570\u91CF","checkout-receipt-amount-label":"\u91D1\u989D","checkout-digital-package-upsell-message":"\u8981\u5C06<br>\u6570\u4F4D\u5957\u88C5\u52A0\u5165<br>\u8D2D\u7269\u8F66\uFF0C\u5E76\u53D6\u5F97<br>\u6240\u6709\u6570\u4F4D\u5185\u5BB9\u7684\u8BBF\u95EE\u6743\u9650\u5417\uFF1F","checkout-tip-message":"\u8981\u6DFB\u52A0\u5C0F\u8D39\u5417\uFF1F","checkout-tip-description":"\u60A8\u7684\u5C0F\u8D39\u5C06\u5E2E\u52A9\u652F\u6301\u56E2\u961F\u3002","checkout-no-tip-btn":"\u4E0D\u7ED9\u5C0F\u8D39","photo-plus-pass-required-message":"\u60A8\u4F3C\u4E4E\u5C1A\u672A\u62E5\u6709 Photo+ Pass\u3002<br><br>\u7ACB\u5373\u8D2D\u4E70\u5373\u53EF\u8BBF\u95EE\u9AD8\u89E3\u6790\u5EA6\u5185\u5BB9\u3002","photo-plus-valid-ticket-required-message":"\u60A8\u76EE\u524D\u4F3C\u4E4E\u5C1A\u672A\u6709\u672C\u6B21\u56ED\u533A\u884C\u7A0B\u7684\u6709\u6548\u95E8\u7968\u3002\u8BF7\u5148\u94FE\u63A5\u95E8\u7968\uFF0C\u4EE5\u4EAB\u53D7 Photo+ \u4F53\u9A8C\u3002","photo-plus-visit-availability-message":"\u60A8\u7684 Photo+ \u4F53\u9A8C\u4EC5\u5728\u9020\u8BBF Genting SkyWorlds \u671F\u95F4\u53EF\u7528\u3002","checkout-other-products-upsell-message":"\u8981\u4E3A\u60A8\u7684\u6570\u4F4D\u5957\u88C5\u52A0\u8D2D\u6253\u5370\u5417\uFF1F","checkout-delete-restriction-message":"\u82E5\u8981\u8D2D\u4E70\u52A0\u8D2D\u9879\u76EE\uFF0C\u8D2D\u7269\u8F66\u4E2D\u5FC5\u987B\u81F3\u5C11\u4FDD\u7559\u4E00\u4E2A\u5957\u88C5\u3002\u82E5\u8981\u66F4\u6362\u5957\u88C5\uFF0C\u8BF7\u5148\u79FB\u9664\u6240\u6709\u52A0\u8D2D\u9879\u76EE\u3002","checkout-digital-package-duplicate-message":"\u60A8\u7684\u8D2D\u7269\u8F66\u4E2D\u5DF2\u6709\u6570\u4F4D\u8BBF\u95EE\u5957\u88C5\u3002<br>\u5728\u79FB\u9664\u6216\u8D2D\u4E70\u76EE\u524D\u5957\u88C5\u4E4B\u524D\uFF0C\u65E0\u6CD5\u65B0\u589E\u65B0\u5957\u88C5\u3002","welcome-print-modal-title":"\u5217\u5370","welcome-print-modal-text":"\u60A8\u7684\u7167\u7247\u5C06\u4F1A\u5217\u5370\u5E76\u4EA4\u4ED8\u7ED9\u6D3B\u52A8\u4E3B\u529E\u65B9\u3002","cancel-btn":"\u53D6\u6D88","welcome-preview-modal-title":"\u9884\u89C8","close-btn":"\u5173\u95ED","ok-btn":"\u786E\u8BA4","back-btn":"\u8FD4\u56DE","info-title":"\u8D44\u8BAF","apply-btn":"\u5957\u7528","clear-btn":"\u6E05\u9664","yes-btn":"\u662F","no-btn":"\u5426","change-image-btn":"\u66F4\u6362\u56FE\u7247","done-btn":"\u5B8C\u6210","skip-btn":"\u8DF3\u8FC7","refresh-btn":"\u5237\u65B0","exit-btn":"\u79BB\u5F00","unsupported-picture-format-message":"\u65E0\u6548\u6216\u4E0D\u652F\u6301\u7684\u56FE\u7247\u683C\u5F0F","welcome-alert-modal-title":"\u5BF9\u8BDD\u6846\u6807\u9898","welcome-alert-modal-body-text":"\u5BF9\u8BDD\u6846\u5185\u5BB9\u663E\u793A\u4E8E\u6B64\u3002","welcome-alert-save-btn":"\u50A8\u5B58\u53D8\u66F4","welcome-passcodes-modal-title":"\u4EA7\u751F\u901A\u884C\u7801","welcome-passcodes-events-label":"\u8BF7\u9009\u62E9\u8981\u4EA7\u751F\u901A\u884C\u7801\u7684\u6D3B\u52A8\uFF1A","welcome-passcodes-email-label":"\u63A5\u6536 XLS \u683C\u5F0F\u901A\u884C\u7801\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\uFF1A","welcome-passcodes-count-label":"\u8981\u4EA7\u751F\u7684\u901A\u884C\u7801\u6570\u91CF\uFF1A","welcome-passcodes-count-help":"\u4ECB\u4E8E 1-200,000 \u7684\u6570\u5B57","welcome-passcodes-prepaid-label":"\u8FD9\u4E9B\u5361\u7247\u6301\u6709\u4EBA\u662F\u5426\u89C6\u4E3A\u9884\u4ED8 / VIP\uFF1F\uFF1A","welcome-passcodes-expiry-label":"\u516C\u5F00\u81EA\u52A9\u673A\u8BBF\u95EE\u5230\u671F\u65F6\u95F4\uFF08\u5206\u949F\uFF09\uFF08\u8F93\u5165 0 \u4EE5\u505C\u7528\uFF09\uFF1A","welcome-passcodes-url-prefix-label":"\u76F8\u518C\u8BBF\u95EE URL \u524D\u7F00\uFF08\u4F8B\u5982 https://domain-name.com\uFF09\uFF1A","welcome-passcodes-generate-btn":"\u4EA7\u751F","sharing-modal-title":"\u5206\u4EAB\u56FE\u7247","sharing-tab-email":"Email","sharing-tab-sms":"SMS","sharing-email-name-placeholder":"\u5168\u540D","sharing-email-placeholder":"\u6709\u6548\u7535\u5B50\u90AE\u4EF6\u5730\u5740","sharing-email-help-text":"\u591A\u4E2A\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u53EF\u7528\u5206\u53F7\u3001\u9017\u53F7\u3001\u7A7A\u683C\u6216 Enter \u952E\u5206\u9694\u3002","sharing-contact-phone-placeholder":"\u7535\u8BDD\u53F7\u7801","sharing-company-placeholder":"\u516C\u53F8 / \u673A\u6784","sharing-sms-name-placeholder":"\u5168\u540D","sharing-sms-phone-placeholder":"\u6709\u6548\u7535\u8BDD\u53F7\u7801","sharing-privacy-link":"\u9690\u79C1\u653F\u7B56","sharing-privacy-prefix":"\u6211\u4EEC\u975E\u5E38\u91CD\u89C6\u60A8\u7684\u9690\u79C1\uFF0C\u8BF7\u9605\u8BFB\u6211\u4EEC\u7684","welcome-delete-modal-title":"\u5220\u9664","welcome-delete-modal-body":"\u786E\u5B9A\u8981\u4ECE\u76F8\u518C\u5220\u9664\u6B64\u56FE\u7247\u5417\uFF1F","welcome-delete-photo-confirmation-message":"\u60A8\u786E\u5B9A\u8981\u4ECE\u76F8\u518C\u5220\u9664\u6B64\u56FE\u7247\u5417\uFF1F","welcome-delete-photo-keep-btn":"\u4FDD\u7559\u8FD9\u5F20\u56FE\u7247\uFF01","welcome-delete-photo-delete-btn":"\u4ECE\u6211\u7684\u76F8\u518C\u5220\u9664\u6B64\u56FE\u7247","welcome-delete-reason-not-mine-btn":"\u662F\u3002\u8FD9\u4E0D\u662F\u6211\u7684\u56FE\u7247","welcome-delete-confirm-btn":"\u5220\u9664","welcome-selfie-modal-title":"\u4EE5\u4EBA\u8138\u641C\u5BFB\u6211\u7684\u56FE\u7247","welcome-selfie-match-found-title":"\u6211\u4EEC\u53EF\u80FD\u627E\u5230\u60A8\u4E86\uFF01","welcome-selfie-match-found-confirm-message":"\u70B9\u51FB\u60A8\u7684\u56FE\u7247\u4EE5\u786E\u8BA4\u3002","welcome-selfie-capture-btn":"\u70B9\u6B64","welcome-delete-reason-dont-want-btn":"\u662F\u3002\u8FD9\u662F\u6211\u7684\u56FE\u7247\uFF0C\u4F46\u6211\u4E0D\u60F3\u8981","welcome-print-copy-count-label":"\u9009\u62E9\u5217\u5370\u4EFD\u6570","catalog-select-product-package-title":"\u9009\u62E9\u5546\u54C1\u5957\u88C5","freedompay-offline-request-title":"\u8BF7\u8F93\u5165\u79BB\u7EBF\u4EA4\u6613\u8BF7\u6C42 ID","square-reader-access-token-title":"\u8BF7\u8F93\u5165 Square Access Token","square-reader-pairing-code-title":"\u8BF7\u4F7F\u7528\u6B64\u4EE3\u7801\u767B\u5165\u65B0\u7684 Square reader\uFF0C\u5B8C\u6210\u540E\u6309\u786E\u8BA4\u3002","square-reader-still-unpaired-text":"\u6B64\u8BBE\u5907\u5C1A\u672A\u914D\u5BF9\uFF0C\u8BF7\u4F7F\u7528\u4EE3\u7801\u767B\u5165\u65B0\u7684 Square reader\u3002","square-reader-security-note-title":"\u57FA\u4E8E\u5B89\u5168\u539F\u56E0\uFF0C\u4EE5\u4E0B\u4E24\u7EC4\u91D1\u94A5\u4E0D\u4F1A\u88AB\u50A8\u5B58\uFF0C\u8BF7\u5148\u8BB0\u5F55","storicard-invalid-code-text":"\u65E0\u6548\u7684 StoriCard \u4EE3\u7801\u3002","header-menu-user-id-link":"UserID:","countdown-time-up-text":"\u65F6\u95F4\u5230\uFF01","welcome-find-more-images-btn":"\u5BFB\u627E\u66F4\u591A\u56FE\u7247","welcome-select-images-btn":"\u9009\u62E9\u56FE\u7247","welcome-selected-images-next-btn":"\u8FD9 {{count}} \u5F20\u56FE\u7247\u4E2D\u7684\u662F\u6211\uFF0C\u4E0B\u4E00\u6B65 >","welcome-invalid-attendee-id-message":"\u65E0\u6548\u7684 attendee ID\u3002","welcome-kiosk-time-expired-message":"\u62B1\u6B49\uFF0C\u516C\u5F00\u81EA\u52A9\u673A\u4F7F\u7528\u65F6\u95F4\u5DF2\u5230","welcome-grouping-error-message":"\u4E0D\u5141\u8BB8\u5408\u4F75 3 \u5929\u524D\u5EFA\u7ACB\u7684\u5E10\u6237\u3002","confirm-btn":"\u786E\u8BA4","approved-btn":"\u5DF2\u6838\u51C6","checkout-confirm-purchase-title":"\u8BF7\u786E\u8BA4\u60A8\u7684\u8D2D\u4E70","checkout-confirm-purchase-short-title":"\u786E\u8BA4\u8D2D\u4E70","checkout-digital-access-summary":"\u8BBF\u95EE\u60A8\u4ECA\u5929\u62CD\u6444\u7684\u6240\u6709\u6570\u4F4D\u56FE\u7247","checkout-and-text":"\u53CA","checkout-print-count-summary":"{{count}} \u4EFD\u5217\u5370","checkout-digitals-copy-message":"\u60A8\u8981\u5907\u4EFD\u4E00\u4EFD\u6570\u4F4D\u5185\u5BB9\u5417\uFF1F<br>\u4EE5\u9632\u5361\u7247\u9057\u5931\u3002","checkout-email-placeholder":"\u60A8\u7684\u7535\u5B50\u90AE\u4EF6","checkout-email-or-phone-placeholder":"\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u6216\u7F8E\u56FD\u7535\u8BDD\u53F7\u7801","checkout-sms-agreement-label":"\u6211\u540C\u610F\u63A5\u6536\u6765\u81EA Storibox \u7684\u901A\u77E5\u8BAF\u606F\u81F3\u4E0A\u65B9\u63D0\u4F9B\u7684\u7535\u8BDD\u53F7\u7801\u3002\u6211\u660E\u767D\u6211\u5C06\u6536\u5230\u5305\u542B\u66F4\u65B0\u4E0E\u56FE\u7247\u94FE\u63A5\u7684 SMS \u8BAF\u606F\u3002\u53EF\u80FD\u4F1A\u4EA7\u751F\u6570\u636E\u53CA\u8BAF\u606F\u8D39\u7528\u3002\u5982\u8981\u53D6\u6D88\uFF0C\u8BF7\u56DE\u8986 STOP\u3002","checkout-name-placeholder":"\u60A8\u7684\u59D3\u540D","checkout-cancel-transaction-btn":"\u53D6\u6D88\u4EA4\u6613","checkout-employee-authorization-title":"\u9700\u8981\u5458\u5DE5\u6388\u6743","checkout-scan-employee-card-prefix":"\u4EA4\u6613\u5B8C\u6210\u65F6\u8BF7\u626B\u63CF\u5458\u5DE5\u5361\uFF1A","checkout-transaction-complete-suffix":"\u5DF2\u5B8C\u6210","checkout-unlock-code-error-message":"\u5458\u5DE5\u6388\u6743\u7801\u65E0\u6548\u3002","checkout-print-pool-error-message":"\u914D\u7F6E\u7684 PrintPool \u65E0\u6548\u6216\u4E0D\u53EF\u7528\u3002\u8BF7\u68C0\u67E5 kiosk \u7684 PrintPool \u914D\u7F6E\u3002","checkout-printing-now-title":"\u6B63\u5728\u5217\u5370","checkout-prints-ready-message":"\u60A8\u7684\u6253\u5370\u54C1\u5C06\u4E8E\u4E00\u5206\u949F\u5185\u5B8C\u6210","checkout-digitals-unlocked-message":"\u60A8\u7684\u6570\u4F4D\u7167\u7247\u5DF2\u89E3\u9501","checkout-internal-error-title":"\u62B1\u6B49\uFF0C\u7CFB\u7EDF\u5185\u90E8\u9519\u8BEF","checkout-transaction-processed-title":"\u4EA4\u6613\u5DF2\u5B8C\u6210\uFF01","checkout-register-receipt-qr-message":"\u8BF7\u626B\u63CF QR \u4EE5\u6CE8\u518C\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\uFF0C\u63A5\u6536\u7535\u5B50\u6536\u636E\u4E0E\u76F8\u518C\u94FE\u63A5\uFF01","checkout-shop-more-btn":"\u7EE7\u7EED\u9009\u8D2D","checkout-print-receipt-btn":"\u5217\u5370\u6536\u636E","checkout-paid-by-cash-label":"\u73B0\u91D1\u4ED8\u6B3E","checkout-paid-by-card-label":"\u5237\u5361\u4ED8\u6B3E","checkout-draft-order-error-message":"\u5EFA\u7ACB\u8349\u7A3F\u8BA2\u5355\u5931\u8D25\u3002","checkout-print-confirmation-message":"\u82E5\u60A8\u6709\u8BA2\u8D2D\u6253\u5370\u54C1\uFF0C\u5C06\u4E8E\u4E00\u5206\u949F\u5185\u51C6\u5099\u5B8C\u6210\u3002\u60A8\u53EF\u4E8E\u96F6\u552E\u67DC\u53F0\u9886\u53D6\u5546\u54C1","checkout-shopify-params-incomplete-message":"Shopify \u53C2\u6570\u4E0D\u5B8C\u6574","checkout-event-name-required-message":"\u672A\u63D0\u4F9B eventName\u3002","payment-no-device-connected-message":"\u672A\u8FDE\u63A5\u4EFB\u4F55\u8BBE\u5907\u3002","payment-ask-for-assistance-message":"\u8BF7\u5BFB\u6C42\u5DE5\u4F5C\u4EBA\u5458\u534F\u52A9\u3002","payment-square-checkout-creation-failed-message":"\u5EFA\u7ACB\u7ED3\u8D26\u8BF7\u6C42\u5931\u8D25\u3002\u8BF7\u7A0D\u540E\u518D\u8BD5\u3002","payment-square-checkout-status-check-failed-message":"\u68C0\u67E5\u7ED3\u8D26\u72B6\u6001\u5931\u8D25\u3002\u8BF7\u7A0D\u540E\u518D\u8BD5\u3002","payment-qr-title":"\u4F7F\u7528\u624B\u673A\u4ED8\u6B3E","payment-qr-help-html":"<b>\u5FEB\u901F\u4E14\u65B9\u4FBF\uFF1A</b><br> \u626B\u63CF\u4E0A\u65B9 QR code\uFF0C\u5E76\u6309\u7167\u753B\u9762\u6307\u793A\u64CD\u4F5C\u3002","payment-qr-transaction-progress-message":"\u4EA4\u6613\u8FDB\u884C\u4E2D...","payment-qr-failed-message":"QR \u4ED8\u6B3E\u5931\u8D25\u3002\u8BF7\u68C0\u67E5 API key \u540E\u91CD\u8BD5\u3002","payment-failed-message":"\u4ED8\u6B3E\u5931\u8D25\u3002\u8BF7\u7A0D\u540E\u518D\u8BD5\u3002","payment-failed-short-message":"\u60A8\u7684\u4ED8\u6B3E\u5931\u8D25\u3002","payment-use-pinpad-message":"\u8BF7\u4F7F\u7528 PinPad \u5B8C\u6210\u4EA4\u6613...","payment-terminal-progress-message":"\u4EA4\u6613\u5904\u7406\u4E2D\u3002<br>\u82E5\u8981\u53D6\u6D88\uFF0C\u8BF7\u70B9\u9009\u7D42\u7AEF\u673A\u4E0A\u7684\u7BAD\u5934\u3002","payment-transaction-canceled-message":"\u60A8\u7684\u4EA4\u6613\u5DF2\u53D6\u6D88\u3002","payment-transaction-canceled-close-btn":"\u8FD4\u56DE","payment-transaction-canceled-done-btn":"\u9996\u9875","search-version-label":"kiosk v.{{version}}","search-find-by-qr-btn":"\u4EE5 QR \u641C\u5BFB","search-find-by-face-btn":"\u4EE5\u4EBA\u8138\u641C\u5BFB","search-scan-another-qr-placeholder":"\u626B\u63CF\u53E6\u4E00\u4E2A QR code","search-scanned-attendee-label":"\u5DF2\u626B\u63CF\uFF1A{{attId}}","search-qr-or-photos-not-found-message":"\u627E\u4E0D\u5230 QR code \u6216\u7167\u7247\u3002\u8BF7\u91CD\u65B0\u626B\u63CF\u3002","scanning-qr-page-title":"\u76F8\u518C","photo-viewer-back-btn":"\u8FD4\u56DE\u76F8\u518C","email-capture-modal-title":"\u8F93\u5165\u90AE\u7BB1\u4EE5\u67E5\u770B\u76F8\u518C","checkout-scan-album-qr-message":"\u626B\u63CF QR code \u4EE5\u8BBF\u95EE\u60A8\u7684\u6570\u7801\u76F8\u518C","email-capture-name-label":"\u59D3\u540D\uFF1A","email-capture-email-label":"\u7535\u5B50\u90AE\u4EF6\uFF1A","email-capture-domain-placeholder":"\u4F8B\u5982\uFF1Agmail.com","email-capture-next-btn":"\u4E0B\u4E00\u6B65"}');

});

parcelRegister("jUBlW", function(module, exports) {
module.exports = JSON.parse('{"home-page-title":"Webapp","clear-btn":"Clear","close-btn":"Close","cancel-btn":"Cancel","delete-btn":"Delete","share-btn":"Share","download-btn":"Download","favorite-btn":"Favorite","ok-btn":"OK","done-btn":"Done","yes-btn":"Yes","no-btn":"No","create-story-btn":"Create a Story","submit-registration-btn":"Open Album","save-btn":"Save","apply-btn":"Apply","checkout-btn":"Checkout","info-title":"Info","registration-page-title":"Register","contact-completion-page-title":"Contact completion","registration-name-placeholder":"Your name","registration-email-placeholder":"Your email","registration-email-or-phone-placeholder":"Your email or US phone number","registration-country-code-default":"US +1","registration-accept-label":"I Accept","registration-privacy-link":"Terms and Conditions","registration-sms-agreement-label":"I agree to receive notification messages from Storibox at the phone number provided above. I understand I will receive SMS messages containing updates and links to my images. Data and messaging rates may apply. Reply STOP to opt out.","registration-submit-loading-label":"Loading...","registration-create-attendee-error-message":"Failed to create an attendee. Please try again later.","registration-create-attendee-email-confirmation-error-message":"Failed to create an attendee. Please try again later. Check please your email is confirmed.","registration-invalid-us-phone-message":"Please use only a US phone number like this: +11234567890.","registration-us-phone-length-message":"Phone number should be 10 digits after country code (+1), but yours is {{length}}.","registration-contact-required-message":"Email or phone number is required.","registration-invalid-email-message":"Please enter valid E-mail address.","registration-email-required-message":"Email is required.","registration-sms-consent-required-message":"Your consent to the SMS agreement is required. Otherwise, you cannot register for the service.","registration-privacy-consent-required-message":"Your consent to the Terms and Conditions is required. Otherwise, you cannot register for the service.","selfies-empty-title":"Missing a Selfie!","selfies-empty-message":"Please add a good portrait picture\\nfor all people in your party to find\\nyour images quickly.","selfies-add-btn":"+ Add","purchase-btn":"Purchase","home-select-all-btn":"Select All","home-selected-count-label_one":"1 item selected","home-selected-count-label_other":"{{count}} items selected","home-empty-album-message":"The album is empty","home-empty-album-subtext-message":"There are no images in your<br>album yet.","home-qr-modal-title":"My Album Code","home-qr-modal-message":"Scan this QR at the kiosk to access your photos, or present it to our roaming photographers when asked.","home-qr-scanner-message":"Scan the QR code on images or videos of you from the photo viewing kiosk to link your media with this app.","home-qr-camera-access-message":"\uD83C\uDFA5 Please ensure that you have enabled the camera access to scan QR code.","home-qr-scanner-show-my-qr-btn":"Show my QR","menu-registered-selfies":"Registered Faces","menu-qr-scanner":"QR Scanner","menu-album-code":"My Album Code","menu-privacy":"Terms and Conditions","menu-faq":"FAQ","menu-support":"Support","home-step-label":"Step {{amount}} of {{total}}","home-select-up-to-images-title_one":"Select up to 1 image","home-select-up-to-images-title_other":"Select up to {{count}} images","home-select-as-many-images-title":"Select as many images as you want","home-select-target-label":"for \\"{{name}}\\"","home-no-albums-found-message":"No albums found.","home-event-config-missing-message":"This event is not configured for the web app.","home-create-story-waiting-message":"Your story is being created. Please check your album again in a few minutes.","home-ugc-tooltip-message":"You can upload photos from your camera roll and have them printed at the kiosk!","home-face-reco-tooltip-message":"Please upload a selfie, or a good portrait picture of everyone in your party so we can find your images!","home-select-to-share-or-download-message":"Select at least one image to share or download.","home-select-without-watermark-message":"Only images without watermarks can be shared or downloaded.","home-select-to-delete-message":"Select at least one image to delete.","home-share-download-locked-message":"Some of your selected photos are locked. To share or download them, please purchase a Digital Pass.","home-face-register-help-message":"Please make sure that your face is evenly illuminated and fully visible. Maintain a neutral expression.","home-no-selfies-suggestion-message":"Oops, looks like you have not registered your selfie. Take a selfie now to receive your priceless memories.","home-no-face-mask-message":"NO FACE MASKS","home-selfie-maybe-later-btn":"Maybe Later","home-delete-stock-warning-message":"You have selected an event stock image to delete. It cannot be deleted from your album and will be skipped.","home-delete-confirm-message":"Deleting images from your album cannot be undone. Are you sure you want to proceed?","home-delete-reason-not-wanted":"I don\'t want those images in my album","home-delete-reason-not-mine":"Those are not my images","home-delete-confirm-btn":"Yes, delete","home-upload-unsupported-format-message":"Unsupported image format. Please use a different image file.","home-upload-generic-error-message":"An error occurred while uploading your photo. Please try again or contact support.","home-upload-limit-reached-message":"You have reached your photo upload limit. Please contact support if you need to upload more photos.","home-upload-processing-error-message":"An error occurred while processing your photo. Please try again or contact support.","home-upload-processing-message":"Your photos will be in your album in a minute!","home-upload-photo-message":"Upload a photo from your camera roll for printing!","home-turn-me-into-tag-upload-message":"Take a selfie or upload a portrait from your camera roll.","home-turn-me-into-tag-processing-message":"We are working on transforming your image! Refresh this page in a minute or so.","home-download-waiting-message":"Downloading files.<br/>Please be patient.","download-selection-too-large-message":"You\u2019ve selected too many photos or videos to download at once. Please choose fewer and try again, or download them one by one.","home-download-360-message":"This is interactive content, best viewed within this album. You can still download the raw file to share online or view later in apps that recognize 360 spherical format.","home-scanned-image-confirm-message":"Yay, great picture! For security please confirm. Is this your image?","home-media-share-title":"Media","webapp-share-title":"Check out my Storibox album!","webapp-ogp-title":"My Storibox Album","webapp-ogp-description":"View and share photos and videos from my Storibox album.","home-share-files-unsupported-message":"Your browser does not support sharing files. Please use a different browser or download the files directly.","home-share-files-waiting-message":"Downloading files for sharing.<br/>Please be patient.","title-select-a-combo":"Choose a Combo","title-select-a-la-carte":"A La Carte","title-shopping-cart":"Shopping Cart","checkout-change-image-btn":"Change Image","checkout-empty-cart-message":"Cart is empty","checkout-add-product-btn":"Add product","checkout-subtotal-label":"Subtotal:","checkout-taxes-label":"Taxes (0%)","checkout-total-label":"Total Amount:","checkout-promo-code-placeholder":"promotion code","checkout-add-on-btn":"+ Add On","checkout-invalid-promo-code-message":"Invalid or not applicable promotion code!","checkout-discount-label":"Discount: {{title}}","checkout-delete-restriction-message":"You must keep at least one package in your shopping cart if you wish to purchase add-ons. If you need to change the package, please first remove all add-ons from your shopping cart.","checkout-digital-package-upsell-message":"Would you like to add a<br>digital package to your<br>shopping cart and gain access<br>to all your digitals?","checkout-tip-message":"Add a tip?","checkout-tip-description":"Your tip helps support the team.","checkout-no-tip-btn":"No tip","photo-plus-maybe-later-btn":"Maybe Later","photo-plus-upgrade-btn":"Yes, Upgrade","checkout-digital-package-duplicate-message":"You already have a digital access package in your shopping cart.<br>A new package can not be added until you remove or purchase the current one.","title-change-image":"Select photo","title-select-images":"Select photos","title-registered-selfies":"Registered Faces","title-privacy":"Terms and Conditions","title-faq":"FAQ","title-shoot":"Shoot","title-remote-shoot":"Remote Shoot","title-thank-you":"Thank you","thank-you-header":"Thank you for your purchase!","thank-you-message":"Please click the \'Back to Album\' button to view your new photos.","thank-you-go-to-album-btn":"Back to Album","order-pickup":"Please collect your photos from the Print Station.","shoot-again-btn":"Shoot again","select-image-done-btn-name_final":"Done","select-image-done-btn-name_incomplete":"Next","select-image-done-btn-counter_finite":"({{amount}}/{{total}})","select-image-done-btn-counter_infinite":"({{amount}})","remote-shoot-btn":"Shoot","remote-shoot-start-message":"Look at the camera and click \'Shoot\' when ready","remote-shoot-countdown-message":"Look at the lights","remote-shoot-rendering-message":"Your content is being created. Check your album in a few seconds for an awesome new video!","selfie-upload-window-expired-message":"The time window for finding your photos using a selfie has expired for this event."}');

});

parcelRegister("jQqo4", function(module, exports) {
module.exports = JSON.parse('{"home-page-title":"Webapp","clear-btn":"Limpiar","close-btn":"Cerrar","cancel-btn":"Cancelar","delete-btn":"Eliminar","share-btn":"Compartir","download-btn":"Descargar","favorite-btn":"Favorito","ok-btn":"OK","done-btn":"Listo","yes-btn":"S\xed","no-btn":"No","create-story-btn":"Crear una historia","submit-registration-btn":"Abrir \xe1lbum","save-btn":"Guardar","apply-btn":"Aplicar","checkout-btn":"Pagar","info-title":"Informaci\xf3n","registration-page-title":"Registrarse","contact-completion-page-title":"Completar contacto","registration-name-placeholder":"Tu nombre","registration-email-placeholder":"Tu correo electr\xf3nico","registration-email-or-phone-placeholder":"Tu correo electr\xf3nico o n\xfamero de tel\xe9fono de EE. UU.","registration-country-code-default":"US +1","registration-accept-label":"Acepto","registration-privacy-link":"T\xe9rminos y condiciones","registration-sms-agreement-label":"Acepto recibir mensajes de notificaci\xf3n de Storibox en el n\xfamero de tel\xe9fono proporcionado arriba. Entiendo que recibir\xe9 mensajes SMS con actualizaciones y enlaces a mis im\xe1genes. Pueden aplicarse tarifas de datos y mensajer\xeda. Responde STOP para cancelar.","registration-submit-loading-label":"Cargando...","registration-create-attendee-error-message":"No se pudo crear un asistente. Int\xe9ntalo de nuevo m\xe1s tarde.","registration-create-attendee-email-confirmation-error-message":"No se pudo crear un asistente. Int\xe9ntalo de nuevo m\xe1s tarde. Verifica que tu correo electr\xf3nico est\xe9 confirmado.","registration-invalid-us-phone-message":"Usa solo un n\xfamero de tel\xe9fono de EE. UU. como este: +11234567890.","registration-us-phone-length-message":"El n\xfamero de tel\xe9fono debe tener 10 d\xedgitos despu\xe9s del c\xf3digo de pa\xeds (+1), pero el tuyo tiene {{length}}.","registration-contact-required-message":"Se requiere correo electr\xf3nico o n\xfamero de tel\xe9fono.","registration-invalid-email-message":"Ingresa una direcci\xf3n de correo electr\xf3nico v\xe1lida.","registration-email-required-message":"El correo electr\xf3nico es obligatorio.","registration-sms-consent-required-message":"Se requiere tu consentimiento al acuerdo de SMS. De lo contrario, no podr\xe1s registrarte en el servicio.","registration-privacy-consent-required-message":"Se requiere tu consentimiento a los T\xe9rminos y condiciones. De lo contrario, no podr\xe1s registrarte en el servicio.","selfies-empty-title":"\xa1Falta una selfie!","selfies-empty-message":"Agrega una buena foto de retrato\\nde todas las personas de tu grupo para encontrar\\ntus im\xe1genes r\xe1pidamente.","selfies-add-btn":"+ Agregar","selfie-upload-window-expired-message":"El per\xedodo de tiempo para encontrar tus fotos usando una selfie ha expirado para este evento.","purchase-btn":"Comprar","home-select-all-btn":"Seleccionar todo","home-selected-count-label_one":"1 elemento seleccionado","home-selected-count-label_other":"{{count}} elementos seleccionados","home-empty-album-message":"El \xe1lbum est\xe1 vac\xedo","home-empty-album-subtext-message":"Todav\xeda no hay im\xe1genes en tu<br>\xe1lbum.","home-qr-modal-title":"Mi c\xf3digo de \xe1lbum","home-qr-modal-message":"Escanea este QR en el kiosco para acceder a tus fotos, o mu\xe9stralo a nuestros fot\xf3grafos itinerantes cuando te lo pidan.","home-qr-scanner-message":"Escanea el c\xf3digo QR de tus im\xe1genes o videos desde el kiosco de visualizaci\xf3n de fotos para vincular tu contenido multimedia con esta app.","home-qr-camera-access-message":"\uD83C\uDFA5 Aseg\xfarate de haber habilitado el acceso a la c\xe1mara para escanear el c\xf3digo QR.","home-qr-scanner-show-my-qr-btn":"Mostrar mi QR","menu-registered-selfies":"Rostros registrados","menu-qr-scanner":"Esc\xe1ner QR","menu-album-code":"Mi c\xf3digo de \xe1lbum","menu-privacy":"T\xe9rminos y condiciones","menu-faq":"FAQ","menu-support":"Soporte","home-step-label":"Paso {{amount}} de {{total}}","home-select-up-to-images-title_one":"Selecciona hasta 1 imagen","home-select-up-to-images-title_other":"Selecciona hasta {{count}} im\xe1genes","home-select-as-many-images-title":"Selecciona tantas im\xe1genes como quieras","home-select-target-label":"para \\"{{name}}\\"","home-no-albums-found-message":"No se encontraron \xe1lbumes.","home-event-config-missing-message":"Este evento no est\xe1 configurado para la web app.","home-create-story-waiting-message":"Tu historia se est\xe1 creando. Vuelve a revisar tu \xe1lbum en unos minutos.","home-ugc-tooltip-message":"\xa1Puedes subir fotos desde el carrete de tu c\xe1mara y mandarlas a imprimir en el kiosco!","home-face-reco-tooltip-message":"Sube una selfie o una buena foto de retrato de todas las personas de tu grupo para que podamos encontrar tus im\xe1genes.","home-select-to-share-or-download-message":"Selecciona al menos una imagen para compartir o descargar.","home-select-without-watermark-message":"Solo se pueden compartir o descargar im\xe1genes sin marca de agua.","home-select-to-delete-message":"Selecciona al menos una imagen para eliminar.","home-share-download-locked-message":"Algunas de las fotos seleccionadas est\xe1n bloqueadas. Para compartirlas o descargarlas, compra un Pase Digital.","home-face-register-help-message":"Aseg\xfarate de que tu rostro est\xe9 uniformemente iluminado y completamente visible. Mant\xe9n una expresi\xf3n neutral.","home-no-selfies-suggestion-message":"Ups, parece que no has registrado tu selfie. T\xf3mate una selfie ahora para recibir tus recuerdos invaluables.","home-no-face-mask-message":"SIN MASCARILLAS","home-selfie-maybe-later-btn":"Tal vez despu\xe9s","home-delete-stock-warning-message":"Has seleccionado una imagen de stock del evento para eliminar. No se puede eliminar de tu \xe1lbum y se omitir\xe1.","home-delete-confirm-message":"Eliminar im\xe1genes de tu \xe1lbum no se puede deshacer. \xbfSeguro que deseas continuar?","home-delete-reason-not-wanted":"No quiero esas im\xe1genes en mi \xe1lbum","home-delete-reason-not-mine":"Esas no son mis im\xe1genes","home-delete-confirm-btn":"S\xed, eliminar","home-upload-unsupported-format-message":"Formato de imagen no compatible. Usa un archivo de imagen diferente.","home-upload-generic-error-message":"Ocurri\xf3 un error al subir tu foto. Int\xe9ntalo de nuevo o contacta a soporte.","home-upload-limit-reached-message":"Has alcanzado tu l\xedmite de carga de fotos. Contacta a soporte si necesitas subir m\xe1s fotos.","home-upload-processing-error-message":"Ocurri\xf3 un error al procesar tu foto. Int\xe9ntalo de nuevo o contacta a soporte.","home-upload-processing-message":"Tus fotos estar\xe1n en tu \xe1lbum en un minuto.","home-upload-photo-message":"Sube una foto desde el carrete de tu c\xe1mara para imprimirla.","home-turn-me-into-tag-upload-message":"T\xf3mate una selfie o sube un retrato desde el carrete de tu c\xe1mara.","home-turn-me-into-tag-processing-message":"Estamos trabajando en transformar tu imagen. Actualiza esta p\xe1gina en un minuto aproximadamente.","home-download-waiting-message":"Descargando archivos.<br/>Por favor, espera.","download-selection-too-large-message":"Has seleccionado demasiadas fotos o v\xeddeos para descargarlos a la vez. Selecciona menos e int\xe9ntalo de nuevo, o desc\xe1rgalos uno por uno.","home-download-360-message":"Este es contenido interactivo, se ve mejor dentro de este \xe1lbum. Aun as\xed, puedes descargar el archivo original para compartirlo en l\xednea o verlo m\xe1s tarde en apps que reconozcan el formato esf\xe9rico 360.","home-scanned-image-confirm-message":"\xa1Qu\xe9 buena foto! Por seguridad, por favor confirma. \xbfEs esta tu imagen?","home-media-share-title":"Contenido multimedia","webapp-share-title":"\xa1Mira mi \xe1lbum de Storibox!","webapp-ogp-title":"Mi \xe1lbum de Storibox","webapp-ogp-description":"Mira y comparte fotos y videos de mi \xe1lbum de Storibox.","home-share-files-unsupported-message":"Tu navegador no admite compartir archivos. Usa otro navegador o descarga los archivos directamente.","home-share-files-waiting-message":"Descargando archivos para compartir.<br/>Por favor, espera.","title-select-a-combo":"Elige un combo","title-select-a-la-carte":"A la carta","title-shopping-cart":"Carrito de compras","checkout-change-image-btn":"Cambiar imagen","checkout-empty-cart-message":"El carrito est\xe1 vac\xedo","checkout-add-product-btn":"Agregar producto","checkout-subtotal-label":"Subtotal:","checkout-taxes-label":"Impuestos (0%)","checkout-total-label":"Importe total:","checkout-promo-code-placeholder":"c\xf3digo promocional","checkout-add-on-btn":"+ Agregar extra","checkout-invalid-promo-code-message":"\xa1C\xf3digo promocional inv\xe1lido o no aplicable!","checkout-discount-label":"Descuento: {{title}}","checkout-delete-restriction-message":"Debes mantener al menos un paquete en tu carrito de compras si deseas comprar extras. Si necesitas cambiar el paquete, primero elimina todos los extras de tu carrito.","checkout-digital-package-upsell-message":"\xbfTe gustar\xeda agregar un<br>paquete digital a tu<br>carrito de compras y obtener acceso<br>a todos tus archivos digitales?","checkout-tip-message":"\xbfDeseas agregar una propina?","checkout-tip-description":"Tu propina ayuda a apoyar al equipo.","checkout-no-tip-btn":"Sin propina","photo-plus-maybe-later-btn":"Tal vez despu\xe9s","photo-plus-upgrade-btn":"S\xed, mejorar","checkout-digital-package-duplicate-message":"Ya tienes un paquete de acceso digital en tu carrito de compras.<br>No se puede agregar un nuevo paquete hasta que elimines o compres el actual.","title-change-image":"Seleccionar foto","title-select-images":"Seleccionar fotos","title-registered-selfies":"Rostros registrados","title-privacy":"T\xe9rminos y condiciones","title-faq":"FAQ","title-shoot":"Tomar foto","title-remote-shoot":"Disparo remoto","title-thank-you":"Gracias","thank-you-header":"\xa1Gracias por su compra!","thank-you-message":"Haga clic en el bot\xf3n \'Volver al \xe1lbum\' para ver sus nuevas fotos.","thank-you-go-to-album-btn":"Volver al \xe1lbum","order-pickup":"Recoja sus fotos en la Estaci\xf3n de impresi\xf3n.","shoot-again-btn":"Tomar otra vez","select-image-done-btn-name_final":"Listo","select-image-done-btn-name_incomplete":"Siguiente","select-image-done-btn-counter_finite":"({{amount}}/{{total}})","select-image-done-btn-counter_infinite":"({{amount}})","remote-shoot-btn":"Tomar foto","remote-shoot-start-message":"Mira a la c\xe1mara y haz clic en \'Tomar foto\' cuando est\xe9s listo","remote-shoot-countdown-message":"Mira las luces","remote-shoot-rendering-message":"Tu contenido se est\xe1 creando. Revisa tu \xe1lbum en unos segundos para ver un incre\xedble video nuevo."}');

});

parcelRegister("9rdsa", function(module, exports) {
module.exports = JSON.parse('{"home-page-title":"Webapp","clear-btn":"Effacer","close-btn":"Fermer","cancel-btn":"Annuler","delete-btn":"Supprimer","share-btn":"Partager","download-btn":"T\xe9l\xe9charger","favorite-btn":"Favori","ok-btn":"OK","done-btn":"Termin\xe9","yes-btn":"Oui","no-btn":"Non","create-story-btn":"Cr\xe9er une story","submit-registration-btn":"CONTINUER","save-btn":"Enregistrer","apply-btn":"Appliquer","checkout-btn":"Paiement","info-title":"Info","registration-page-title":"Inscription","contact-completion-page-title":"Compl\xe9ter vos coordonn\xe9es","registration-name-placeholder":"Votre nom","registration-email-placeholder":"Votre e-mail","registration-email-or-phone-placeholder":"Votre e-mail ou votre num\xe9ro de t\xe9l\xe9phone US","registration-country-code-default":"US +1","registration-accept-label":"J\'accepte","registration-privacy-link":"Conditions g\xe9n\xe9rales","registration-sms-agreement-label":"J\'accepte de recevoir des messages de notification de Storibox au num\xe9ro de t\xe9l\xe9phone fourni ci-dessus. Je comprends que je recevrai des SMS contenant des mises \xe0 jour et des liens vers mes images. Des frais de donn\xe9es et de messagerie peuvent s\'appliquer. R\xe9pondez STOP pour vous d\xe9sinscrire.","registration-submit-loading-label":"Chargement...","registration-create-attendee-error-message":"Impossible de cr\xe9er un participant. Veuillez r\xe9essayer plus tard.","registration-create-attendee-email-confirmation-error-message":"Impossible de cr\xe9er un participant. Veuillez r\xe9essayer plus tard. V\xe9rifiez que votre adresse e-mail est confirm\xe9e.","registration-invalid-us-phone-message":"Veuillez utiliser uniquement un num\xe9ro de t\xe9l\xe9phone US au format suivant : +11234567890.","registration-us-phone-length-message":"Le num\xe9ro de t\xe9l\xe9phone doit comporter 10 chiffres apr\xe8s l\'indicatif (+1), mais le v\xf4tre en comporte {{length}}.","registration-contact-required-message":"Une adresse e-mail ou un num\xe9ro de t\xe9l\xe9phone est requis.","registration-invalid-email-message":"Veuillez saisir une adresse e-mail valide.","registration-email-required-message":"L\'adresse e-mail est requise.","registration-sms-consent-required-message":"Votre consentement \xe0 l\'accord SMS est requis. Sans cela, vous ne pouvez pas vous inscrire au service.","registration-privacy-consent-required-message":"Votre consentement aux Conditions g\xe9n\xe9rales est requis. Sans cela, vous ne pouvez pas vous inscrire au service.","selfies-empty-title":"Il manque un selfie !","selfies-empty-message":"Veuillez ajouter une belle photo portrait\\nde chaque personne de votre groupe afin de retrouver\\nvos images rapidement.","selfies-add-btn":"+ Ajouter","selfie-upload-window-expired-message":"La p\xe9riode pendant laquelle vous pouviez retrouver vos photos \xe0 l\u2019aide d\u2019un selfie est termin\xe9e pour cet \xe9v\xe9nement.","purchase-btn":"Acheter","home-select-all-btn":"Tout s\xe9lectionner","home-selected-count-label_one":"1 \xe9l\xe9ment s\xe9lectionn\xe9","home-selected-count-label_other":"{{count}} \xe9l\xe9ments s\xe9lectionn\xe9s","home-empty-album-message":"L\'album est vide","home-empty-album-subtext-message":"Il n\'y a pas encore d\'images dans votre<br>album.","home-qr-modal-title":"Code de mon album","home-qr-modal-message":"Scannez ce QR au kiosque pour acc\xe9der \xe0 vos photos, ou pr\xe9sentez-le \xe0 nos photographes itin\xe9rants lorsqu\'ils le demandent.","home-qr-scanner-message":"Scannez le code QR sur vos photos ou vid\xe9os depuis le kiosque de visualisation afin d\'associer vos m\xe9dias \xe0 cette application.","home-qr-camera-access-message":"\uD83C\uDFA5 Veuillez vous assurer d\'avoir autoris\xe9 l\'acc\xe8s \xe0 la cam\xe9ra pour scanner le code QR.","home-qr-scanner-show-my-qr-btn":"Afficher mon QR","menu-registered-selfies":"Visages enregistr\xe9s","menu-qr-scanner":"Scanner QR","menu-album-code":"Code de mon album","menu-privacy":"Conditions g\xe9n\xe9rales","menu-faq":"FAQ","menu-support":"Assistance","home-step-label":"\xc9tape {{amount}} sur {{total}}","home-select-up-to-images-title_one":"S\xe9lectionnez jusqu\'\xe0 1 image","home-select-up-to-images-title_other":"S\xe9lectionnez jusqu\'\xe0 {{count}} images","home-select-as-many-images-title":"S\xe9lectionnez autant d\'images que vous le souhaitez","home-select-target-label":"pour \\"{{name}}\\"","home-no-albums-found-message":"Aucun album trouv\xe9.","home-event-config-missing-message":"Cet \xe9v\xe9nement n\'est pas configur\xe9 pour l\'application web.","home-create-story-waiting-message":"Votre story est en cours de cr\xe9ation. Veuillez v\xe9rifier \xe0 nouveau votre album dans quelques minutes.","home-ugc-tooltip-message":"Vous pouvez t\xe9l\xe9charger des photos depuis votre galerie et les faire imprimer au kiosque !","home-face-reco-tooltip-message":"Veuillez t\xe9l\xe9charger un selfie ou un bon portrait de chaque personne de votre groupe afin que nous puissions retrouver vos images !","home-select-to-share-or-download-message":"S\xe9lectionnez au moins une image \xe0 partager ou \xe0 t\xe9l\xe9charger.","home-select-without-watermark-message":"Seules les images sans filigrane peuvent \xeatre partag\xe9es ou t\xe9l\xe9charg\xe9es.","home-select-to-delete-message":"S\xe9lectionnez au moins une image \xe0 supprimer.","home-share-download-locked-message":"Certaines des photos que vous avez s\xe9lectionn\xe9es sont verrouill\xe9es. Pour les partager ou les t\xe9l\xe9charger, veuillez acheter un Pass num\xe9rique.","home-face-register-help-message":"Veuillez vous assurer que votre visage est uniform\xe9ment \xe9clair\xe9 et enti\xe8rement visible. Gardez une expression neutre.","home-no-selfies-suggestion-message":"Oups, il semble que vous n\'ayez pas enregistr\xe9 votre selfie. Prenez-en un maintenant pour retrouver vos pr\xe9cieux souvenirs.","home-no-face-mask-message":"PAS DE MASQUE","home-selfie-maybe-later-btn":"Peut-\xeatre plus tard","home-delete-stock-warning-message":"Vous avez s\xe9lectionn\xe9 une image de stock de l\'\xe9v\xe9nement \xe0 supprimer. Elle ne peut pas \xeatre supprim\xe9e de votre album et sera ignor\xe9e.","home-delete-confirm-message":"La suppression d\'images de votre album est irr\xe9versible. Voulez-vous vraiment continuer ?","home-delete-reason-not-wanted":"Je ne veux pas de ces images dans mon album","home-delete-reason-not-mine":"Ces images ne sont pas \xe0 moi","home-delete-confirm-btn":"Oui, supprimer","home-upload-unsupported-format-message":"Format d\'image non pris en charge. Veuillez utiliser un autre fichier image.","home-upload-generic-error-message":"Une erreur s\'est produite lors du t\xe9l\xe9chargement de votre photo. Veuillez r\xe9essayer ou contacter l\'assistance.","home-upload-limit-reached-message":"Vous avez atteint votre limite de t\xe9l\xe9chargements de photos. Veuillez contacter l\'assistance si vous devez en ajouter davantage.","home-upload-processing-error-message":"Une erreur s\'est produite lors du traitement de votre photo. Veuillez r\xe9essayer ou contacter l\'assistance.","home-upload-processing-message":"Vos photos appara\xeetront dans votre album dans une minute !","home-upload-photo-message":"T\xe9l\xe9chargez une photo depuis votre galerie pour l\'imprimer !","home-turn-me-into-tag-upload-message":"Prenez un selfie ou t\xe9l\xe9chargez un portrait depuis votre galerie.","home-turn-me-into-tag-processing-message":"Nous travaillons sur la transformation de votre image ! Actualisez cette page dans une minute environ.","home-download-waiting-message":"T\xe9l\xe9chargement des fichiers.<br/>Veuillez patienter.","download-selection-too-large-message":"Vous avez s\xe9lectionn\xe9 trop de photos ou de vid\xe9os pour les t\xe9l\xe9charger en une seule fois. S\xe9lectionnez-en moins et r\xe9essayez, ou t\xe9l\xe9chargez-les une par une.","home-download-360-message":"Il s\'agit d\'un contenu interactif, mieux visible dans cet album. Vous pouvez tout de m\xeame t\xe9l\xe9charger le fichier brut pour le partager en ligne ou l\'ouvrir plus tard dans des applications prenant en charge le format 360 sph\xe9rique.","home-scanned-image-confirm-message":"Super photo ! Pour des raisons de s\xe9curit\xe9, veuillez confirmer. Est-ce bien votre image ?","home-media-share-title":"M\xe9dia","webapp-share-title":"D\xe9couvrez mon album Storibox !","webapp-ogp-title":"Mon album Storibox","webapp-ogp-description":"Consultez et partagez les photos et vid\xe9os de mon album Storibox.","home-share-files-unsupported-message":"Votre navigateur ne prend pas en charge le partage de fichiers. Veuillez utiliser un autre navigateur ou t\xe9l\xe9charger directement les fichiers.","home-share-files-waiting-message":"T\xe9l\xe9chargement des fichiers \xe0 partager.<br/>Veuillez patienter.","title-select-a-combo":"Choisissez un pack","title-select-a-la-carte":"\xc0 la carte","title-shopping-cart":"Panier","checkout-change-image-btn":"Changer l\'image","checkout-empty-cart-message":"Le panier est vide","checkout-add-product-btn":"Ajouter un produit","checkout-subtotal-label":"Sous-total :","checkout-taxes-label":"Taxes (0 %)","checkout-total-label":"Montant total :","checkout-promo-code-placeholder":"code promo","checkout-add-on-btn":"+ Ajouter un article","checkout-invalid-promo-code-message":"Code promotionnel invalide ou non applicable !","checkout-discount-label":"Remise : {{title}}","checkout-delete-restriction-message":"Vous devez conserver au moins un pack dans votre panier si vous souhaitez acheter des articles suppl\xe9mentaires. Si vous devez changer de pack, veuillez d\'abord retirer tous les articles suppl\xe9mentaires de votre panier.","checkout-digital-package-upsell-message":"Souhaitez-vous ajouter<br>un pack num\xe9rique \xe0 votre<br>panier et obtenir l\'acc\xe8s \xe0<br>tous vos fichiers num\xe9riques ?","checkout-tip-message":"Souhaitez-vous laisser un pourboire ?","checkout-tip-description":"Votre pourboire aide \xe0 soutenir l\'\xe9quipe.","checkout-no-tip-btn":"Pas de pourboire","photo-plus-maybe-later-btn":"Peut-\xeatre plus tard","photo-plus-upgrade-btn":"Oui, passer \xe0 Photo+","checkout-digital-package-duplicate-message":"Vous avez d\xe9j\xe0 un pack d\'acc\xe8s num\xe9rique dans votre panier.<br>Un nouveau pack ne peut pas \xeatre ajout\xe9 tant que l\'actuel n\'est pas supprim\xe9 ou achet\xe9.","title-change-image":"S\xe9lectionner une photo","title-select-images":"S\xe9lectionner des photos","title-registered-selfies":"Visages enregistr\xe9s","title-privacy":"Conditions g\xe9n\xe9rales","title-faq":"FAQ","title-shoot":"Prise de vue","title-remote-shoot":"Prise de vue \xe0 distance","title-thank-you":"Merci","thank-you-header":"Merci pour votre achat !","thank-you-message":"Veuillez cliquer sur le bouton \xab Retour \xe0 l\'album \xbb pour voir vos nouvelles photos.","thank-you-go-to-album-btn":"Retour \xe0 l\'album","order-pickup":"Veuillez r\xe9cup\xe9rer vos photos \xe0 la station d\'impression.","shoot-again-btn":"Reprendre","select-image-done-btn-name_final":"Termin\xe9","select-image-done-btn-name_incomplete":"Suivant","select-image-done-btn-counter_finite":"({{amount}}/{{total}})","select-image-done-btn-counter_infinite":"({{amount}})","remote-shoot-btn":"Prendre la photo","remote-shoot-start-message":"Regardez l\'appareil photo et cliquez sur \\"Prendre la photo\\" quand vous \xeates pr\xeat","remote-shoot-countdown-message":"Regardez les lumi\xe8res","remote-shoot-rendering-message":"Votre contenu est en cours de cr\xe9ation. Consultez votre album dans quelques secondes pour d\xe9couvrir votre nouvelle vid\xe9o !"}');

});

parcelRegister("fKver", function(module, exports) {
module.exports = JSON.parse('{"home-page-title":"Webapp","clear-btn":"\u30AF\u30EA\u30A2","close-btn":"\u9589\u3058\u308B","cancel-btn":"\u30AD\u30E3\u30F3\u30BB\u30EB","delete-btn":"\u524A\u9664","share-btn":"\u5171\u6709","download-btn":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","favorite-btn":"\u304A\u6C17\u306B\u5165\u308A","ok-btn":"\u78BA\u8A8D","done-btn":"\u5B8C\u4E86","yes-btn":"\u306F\u3044","no-btn":"\u3044\u3044\u3048","create-story-btn":"\u30B9\u30C8\u30FC\u30EA\u30FC\u3092\u4F5C\u6210","submit-registration-btn":"\u30A2\u30EB\u30D0\u30E0\u3092\u958B\u304F","save-btn":"\u4FDD\u5B58","apply-btn":"\u9069\u7528","checkout-btn":"\u4F1A\u8A08\u3078","info-title":"\u304A\u77E5\u3089\u305B","registration-page-title":"\u767B\u9332","contact-completion-page-title":"\u9023\u7D61\u5148\u306E\u5165\u529B","registration-name-placeholder":"\u304A\u540D\u524D","registration-email-placeholder":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9","registration-email-or-phone-placeholder":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u307E\u305F\u306F\u7C73\u56FD\u306E\u96FB\u8A71\u756A\u53F7","registration-country-code-default":"\u7C73\u56FD +1","registration-accept-label":"\u540C\u610F\u3059\u308B","registration-privacy-link":"\u5229\u7528\u898F\u7D04","registration-sms-agreement-label":"\u4E0A\u8A18\u306E\u96FB\u8A71\u756A\u53F7\u5B9B\u3066\u306B Storibox \u304B\u3089\u901A\u77E5\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u53D7\u3051\u53D6\u308B\u3053\u3068\u306B\u540C\u610F\u3057\u307E\u3059\u3002\u753B\u50CF\u306B\u95A2\u3059\u308B\u66F4\u65B0\u60C5\u5831\u3084\u30EA\u30F3\u30AF\u3092\u542B\u3080 SMS \u3092\u53D7\u4FE1\u3059\u308B\u3053\u3068\u3092\u7406\u89E3\u3057\u3066\u3044\u307E\u3059\u3002\u901A\u4FE1\u6599\u30FB\u30E1\u30C3\u30BB\u30FC\u30B8\u6599\u91D1\u304C\u767A\u751F\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u505C\u6B62\u3059\u308B\u306B\u306F STOP \u3068\u8FD4\u4FE1\u3057\u3066\u304F\u3060\u3055\u3044\u3002","registration-submit-loading-label":"\u8AAD\u307F\u8FBC\u307F\u4E2D...","registration-create-attendee-error-message":"\u5229\u7528\u8005\u306E\u4F5C\u6210\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","registration-create-attendee-email-confirmation-error-message":"\u5229\u7528\u8005\u306E\u4F5C\u6210\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u78BA\u8A8D\u6E08\u307F\u304B\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","registration-invalid-us-phone-message":"+11234567890 \u306E\u3088\u3046\u306A\u7C73\u56FD\u306E\u96FB\u8A71\u756A\u53F7\u306E\u307F\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002","registration-us-phone-length-message":"\u96FB\u8A71\u756A\u53F7\u306F\u56FD\u756A\u53F7\uFF08+1\uFF09\u306E\u5F8C\u306B10\u6841\u5FC5\u8981\u3067\u3059\u3002\u73FE\u5728\u306F {{length}} \u6841\u3067\u3059\u3002","registration-contact-required-message":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u307E\u305F\u306F\u96FB\u8A71\u756A\u53F7\u306F\u5FC5\u9808\u3067\u3059\u3002","registration-invalid-email-message":"\u6709\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","registration-email-required-message":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u5FC5\u9808\u3067\u3059\u3002","registration-sms-consent-required-message":"\u30B5\u30FC\u30D3\u30B9\u767B\u9332\u306B\u306F SMS \u540C\u610F\u304C\u5FC5\u8981\u3067\u3059\u3002","registration-privacy-consent-required-message":"\u30B5\u30FC\u30D3\u30B9\u767B\u9332\u306B\u306F\u5229\u7528\u898F\u7D04\u3078\u306E\u540C\u610F\u304C\u5FC5\u8981\u3067\u3059\u3002","selfies-empty-title":"\u81EA\u64AE\u308A\u5199\u771F\u304C\u3042\u308A\u307E\u305B\u3093\uFF01","selfies-empty-message":"\u3059\u3070\u3084\u304F\u5199\u771F\u3092\u898B\u3064\u3051\u308B\u305F\u3081\u306B\u3001\\n\u30B0\u30EB\u30FC\u30D7\u5168\u54E1\u306E\\n\u9BAE\u660E\u306A\u30DD\u30FC\u30C8\u30EC\u30FC\u30C8\u5199\u771F\u3092\\n\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","selfies-add-btn":"+ \u8FFD\u52A0","selfie-upload-window-expired-message":"\u3053\u306E\u30A4\u30D9\u30F3\u30C8\u3067\u81EA\u64AE\u308A\u5199\u771F\u3092\u4F7F\u3063\u3066\u753B\u50CF\u3092\u691C\u7D22\u3067\u304D\u308B\u6642\u9593\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002","purchase-btn":"\u8CFC\u5165","home-select-all-btn":"\u3059\u3079\u3066\u9078\u629E","home-selected-count-label_one":"1\u4EF6\u9078\u629E\u4E2D","home-selected-count-label_other":"{{count}}\u4EF6\u9078\u629E\u4E2D","home-empty-album-message":"\u30A2\u30EB\u30D0\u30E0\u306F\u7A7A\u3067\u3059","home-empty-album-subtext-message":"\u307E\u3060\u30A2\u30EB\u30D0\u30E0\u306B<br>\u753B\u50CF\u304C\u3042\u308A\u307E\u305B\u3093\u3002","home-qr-modal-title":"\u30DE\u30A4\u30A2\u30EB\u30D0\u30E0\u30B3\u30FC\u30C9","home-qr-modal-message":"\u3053\u306EQR\u3092\u30AD\u30AA\u30B9\u30AF\u3067\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u5199\u771F\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u304B\u3001\u30ED\u30FC\u30DF\u30F3\u30B0\u30D5\u30A9\u30C8\u30B0\u30E9\u30D5\u30A1\u30FC\u304B\u3089\u6C42\u3081\u3089\u308C\u305F\u969B\u306B\u63D0\u793A\u3057\u3066\u304F\u3060\u3055\u3044\u3002","home-qr-scanner-message":"\u30D5\u30A9\u30C8\u95B2\u89A7\u30AD\u30AA\u30B9\u30AF\u4E0A\u306E\u3042\u306A\u305F\u306E\u5199\u771F\u3084\u52D5\u753B\u306B\u8868\u793A\u3055\u308C\u305F QR \u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u3001\u3053\u306E\u30A2\u30D7\u30EA\u306B\u30E1\u30C7\u30A3\u30A2\u3092\u9023\u643A\u3057\u307E\u3059\u3002","home-qr-camera-access-message":"\uD83C\uDFA5 QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3059\u308B\u305F\u3081\u306B\u3001\u30AB\u30E1\u30E9\u30A2\u30AF\u30BB\u30B9\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","home-qr-scanner-show-my-qr-btn":"\u81EA\u5206\u306EQR\u3092\u8868\u793A","menu-registered-selfies":"\u767B\u9332\u6E08\u307F\u306E\u9854","menu-qr-scanner":"QR\u30B9\u30AD\u30E3\u30CA\u30FC","menu-album-code":"\u30DE\u30A4\u30A2\u30EB\u30D0\u30E0\u30B3\u30FC\u30C9","menu-privacy":"\u5229\u7528\u898F\u7D04","menu-faq":"FAQ","menu-support":"\u30B5\u30DD\u30FC\u30C8","home-step-label":"\u30B9\u30C6\u30C3\u30D7 {{amount}} / {{total}}","home-select-up-to-images-title_one":"\u6700\u59271\u679A\u9078\u629E","home-select-up-to-images-title_other":"\u6700\u5927{{count}}\u679A\u9078\u629E","home-select-as-many-images-title":"\u597D\u304D\u306A\u3060\u3051\u753B\u50CF\u3092\u9078\u629E","home-select-target-label":"\u300C{{name}}\u300D\u7528","home-no-albums-found-message":"\u30A2\u30EB\u30D0\u30E0\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","home-event-config-missing-message":"\u3053\u306E\u30A4\u30D9\u30F3\u30C8\u306F Web\u30A2\u30D7\u30EA\u7528\u306B\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002","home-create-story-waiting-message":"\u30B9\u30C8\u30FC\u30EA\u30FC\u3092\u4F5C\u6210\u3057\u3066\u3044\u307E\u3059\u3002\u6570\u5206\u5F8C\u306B\u30A2\u30EB\u30D0\u30E0\u3092\u518D\u5EA6\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","home-ugc-tooltip-message":"\u30AB\u30E1\u30E9\u30ED\u30FC\u30EB\u304B\u3089\u5199\u771F\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u3001\u30AD\u30AA\u30B9\u30AF\u3067\u5370\u5237\u3067\u304D\u307E\u3059\uFF01","home-face-reco-tooltip-message":"\u30B0\u30EB\u30FC\u30D7\u5168\u54E1\u306E\u81EA\u64AE\u308A\u307E\u305F\u306F\u9BAE\u660E\u306A\u30DD\u30FC\u30C8\u30EC\u30FC\u30C8\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u5199\u771F\u3092\u898B\u3064\u3051\u3084\u3059\u304F\u306A\u308A\u307E\u3059\uFF01","home-select-to-share-or-download-message":"\u5171\u6709\u307E\u305F\u306F\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B\u306B\u306F\u3001\u5C11\u306A\u304F\u3068\u30821\u679A\u306E\u753B\u50CF\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","home-select-without-watermark-message":"\u5171\u6709\u307E\u305F\u306F\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u308B\u306E\u306F\u3001\u900F\u304B\u3057\u306E\u306A\u3044\u753B\u50CF\u306E\u307F\u3067\u3059\u3002","home-select-to-delete-message":"\u524A\u9664\u3059\u308B\u306B\u306F\u3001\u5C11\u306A\u304F\u3068\u30821\u679A\u306E\u753B\u50CF\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","home-share-download-locked-message":"\u9078\u629E\u3057\u305F\u5199\u771F\u306E\u4E00\u90E8\u306F\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u5171\u6709\u307E\u305F\u306F\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B\u306B\u306F\u3001\u30C7\u30B8\u30BF\u30EB\u30D1\u30B9\u3092\u3054\u8CFC\u5165\u304F\u3060\u3055\u3044\u3002","home-face-register-help-message":"\u9854\u5168\u4F53\u304C\u5747\u4E00\u306B\u660E\u308B\u304F\u3001\u306F\u3063\u304D\u308A\u898B\u3048\u308B\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u8868\u60C5\u306F\u81EA\u7136\u306A\u72B6\u614B\u3067\u304A\u9858\u3044\u3057\u307E\u3059\u3002","home-no-selfies-suggestion-message":"\u81EA\u64AE\u308A\u304C\u307E\u3060\u767B\u9332\u3055\u308C\u3066\u3044\u306A\u3044\u3088\u3046\u3067\u3059\u3002\u4ECA\u3059\u3050\u81EA\u64AE\u308A\u3092\u767B\u9332\u3057\u3066\u3001\u5927\u5207\u306A\u601D\u3044\u51FA\u3092\u53D7\u3051\u53D6\u308A\u307E\u3057\u3087\u3046\u3002","home-no-face-mask-message":"\u30DE\u30B9\u30AF\u4E0D\u53EF","home-selfie-maybe-later-btn":"\u5F8C\u3067","home-delete-stock-warning-message":"\u524A\u9664\u5BFE\u8C61\u306B\u30A4\u30D9\u30F3\u30C8\u306E\u30B9\u30C8\u30C3\u30AF\u753B\u50CF\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059\u3002\u3053\u306E\u753B\u50CF\u306F\u30A2\u30EB\u30D0\u30E0\u304B\u3089\u524A\u9664\u3067\u304D\u306A\u3044\u305F\u3081\u3001\u30B9\u30AD\u30C3\u30D7\u3055\u308C\u307E\u3059\u3002","home-delete-confirm-message":"\u30A2\u30EB\u30D0\u30E0\u304B\u3089\u753B\u50CF\u3092\u524A\u9664\u3059\u308B\u3068\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002\u672C\u5F53\u306B\u7D9A\u884C\u3057\u307E\u3059\u304B\uFF1F","home-delete-reason-not-wanted":"\u3053\u306E\u753B\u50CF\u306F\u30A2\u30EB\u30D0\u30E0\u306B\u4E0D\u8981\u3067\u3059","home-delete-reason-not-mine":"\u3053\u306E\u753B\u50CF\u306F\u81EA\u5206\u306E\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093","home-delete-confirm-btn":"\u306F\u3044\u3001\u524A\u9664","home-upload-unsupported-format-message":"\u5BFE\u5FDC\u3057\u3066\u3044\u306A\u3044\u753B\u50CF\u5F62\u5F0F\u3067\u3059\u3002\u5225\u306E\u753B\u50CF\u30D5\u30A1\u30A4\u30EB\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002","home-upload-generic-error-message":"\u5199\u771F\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30B5\u30DD\u30FC\u30C8\u3078\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002","home-upload-limit-reached-message":"\u5199\u771F\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F\u3002\u3055\u3089\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u304C\u5FC5\u8981\u306A\u5834\u5408\u306F\u30B5\u30DD\u30FC\u30C8\u3078\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002","home-upload-processing-error-message":"\u5199\u771F\u306E\u51E6\u7406\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30B5\u30DD\u30FC\u30C8\u3078\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002","home-upload-processing-message":"\u5199\u771F\u306F1\u5206\u307B\u3069\u3067\u30A2\u30EB\u30D0\u30E0\u306B\u8868\u793A\u3055\u308C\u307E\u3059\uFF01","home-upload-photo-message":"\u30AB\u30E1\u30E9\u30ED\u30FC\u30EB\u304B\u3089\u5199\u771F\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u5370\u5237\u3057\u307E\u3057\u3087\u3046\uFF01","home-turn-me-into-tag-upload-message":"\u81EA\u64AE\u308A\u3092\u64AE\u5F71\u3059\u308B\u304B\u3001\u30AB\u30E1\u30E9\u30ED\u30FC\u30EB\u304B\u3089\u30DD\u30FC\u30C8\u30EC\u30FC\u30C8\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002","home-turn-me-into-tag-processing-message":"\u753B\u50CF\u3092\u5909\u63DB\u3057\u3066\u3044\u307E\u3059\uFF011\u5206\u307B\u3069\u3057\u3066\u304B\u3089\u3053\u306E\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","home-download-waiting-message":"\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D\u3067\u3059\u3002<br/>\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002","download-selection-too-large-message":"\u5199\u771F\u307E\u305F\u306F\u52D5\u753B\u306E\u9078\u629E\u6570\u304C\u591A\u3059\u304E\u3066\u3001\u4E00\u5EA6\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u307E\u305B\u3093\u3002\u9078\u629E\u6570\u3092\u6E1B\u3089\u3057\u3066\u518D\u8A66\u884C\u3059\u308B\u304B\u30011\u3064\u305A\u3064\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002","home-download-360-message":"\u3053\u308C\u306F\u30A4\u30F3\u30BF\u30E9\u30AF\u30C6\u30A3\u30D6\u30B3\u30F3\u30C6\u30F3\u30C4\u3067\u3059\u3002\u30A2\u30EB\u30D0\u30E0\u5185\u3067\u306E\u95B2\u89A7\u3092\u63A8\u5968\u3057\u307E\u3059\u3002\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u751F\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3001\u30AA\u30F3\u30E9\u30A4\u30F3\u5171\u6709\u3084360\u7403\u9762\u5F62\u5F0F\u5BFE\u5FDC\u30A2\u30D7\u30EA\u3067\u5F8C\u304B\u3089\u95B2\u89A7\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002","home-scanned-image-confirm-message":"\u7D20\u6575\u306A\u5199\u771F\u3067\u3059\u306D\uFF01\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306E\u305F\u3081\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u308C\u306F\u3042\u306A\u305F\u306E\u753B\u50CF\u3067\u3059\u304B\uFF1F","home-media-share-title":"\u30E1\u30C7\u30A3\u30A2","webapp-share-title":"\u79C1\u306EStoribox\u30A2\u30EB\u30D0\u30E0\u3092\u30C1\u30A7\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\uFF01","webapp-ogp-title":"\u79C1\u306EStoribox\u30A2\u30EB\u30D0\u30E0","webapp-ogp-description":"\u79C1\u306EStoribox\u30A2\u30EB\u30D0\u30E0\u306E\u5199\u771F\u3068\u52D5\u753B\u3092\u95B2\u89A7\u30FB\u5171\u6709\u3067\u304D\u307E\u3059\u3002","home-share-files-unsupported-message":"\u3053\u306E\u30D6\u30E9\u30A6\u30B6\u306F\u30D5\u30A1\u30A4\u30EB\u5171\u6709\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u5225\u306E\u30D6\u30E9\u30A6\u30B6\u3092\u4F7F\u3046\u304B\u3001\u76F4\u63A5\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002","home-share-files-waiting-message":"\u5171\u6709\u7528\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D\u3067\u3059\u3002<br/>\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002","title-select-a-combo":"\u30B3\u30F3\u30DC\u3092\u9078\u629E","title-select-a-la-carte":"\u30A2\u30E9\u30AB\u30EB\u30C8","title-shopping-cart":"\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u30AB\u30FC\u30C8","checkout-change-image-btn":"\u5199\u771F\u3092\u5909\u66F4","checkout-empty-cart-message":"\u30AB\u30FC\u30C8\u306F\u7A7A\u3067\u3059","checkout-add-product-btn":"\u5546\u54C1\u3092\u8FFD\u52A0","checkout-subtotal-label":"\u5C0F\u8A08:","checkout-taxes-label":"\u7A0E\u91D1 (0%)","checkout-total-label":"\u5408\u8A08\u91D1\u984D:","checkout-promo-code-placeholder":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30FC\u30C9","checkout-add-on-btn":"+ \u8FFD\u52A0\u30AA\u30D7\u30B7\u30E7\u30F3","checkout-invalid-promo-code-message":"\u7121\u52B9\u3001\u307E\u305F\u306F\u9069\u7528\u3067\u304D\u306A\u3044\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30FC\u30C9\u3067\u3059\uFF01","checkout-discount-label":"\u5272\u5F15: {{title}}","checkout-delete-restriction-message":"\u8FFD\u52A0\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u8CFC\u5165\u3059\u308B\u5834\u5408\u3001\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u30AB\u30FC\u30C8\u306B\u306F\u5C11\u306A\u304F\u3068\u30821\u3064\u306E\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u6B8B\u3059\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u5909\u66F4\u3059\u308B\u5834\u5408\u306F\u3001\u5148\u306B\u8FFD\u52A0\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u3059\u3079\u3066\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002","checkout-digital-package-upsell-message":"\u30C7\u30B8\u30BF\u30EB\u30D1\u30C3\u30B1\u30FC\u30B8\u3092<br>\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u30AB\u30FC\u30C8\u306B\u8FFD\u52A0\u3057\u3066\u3001<br>\u3059\u3079\u3066\u306E\u30C7\u30B8\u30BF\u30EB\u30B3\u30F3\u30C6\u30F3\u30C4\u306B<br>\u30A2\u30AF\u30BB\u30B9\u3057\u307E\u3059\u304B\uFF1F","checkout-tip-message":"\u30C1\u30C3\u30D7\u3092\u8FFD\u52A0\u3057\u307E\u3059\u304B\uFF1F","checkout-tip-description":"\u30C1\u30C3\u30D7\u306F\u30C1\u30FC\u30E0\u306E\u30B5\u30DD\u30FC\u30C8\u306B\u306A\u308A\u307E\u3059\u3002","checkout-no-tip-btn":"\u30C1\u30C3\u30D7\u306A\u3057","photo-plus-maybe-later-btn":"\u5F8C\u3067","photo-plus-upgrade-btn":"\u306F\u3044\u3001\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B","checkout-digital-package-duplicate-message":"\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u30AB\u30FC\u30C8\u306B\u306F\u3059\u3067\u306B\u30C7\u30B8\u30BF\u30EB\u30A2\u30AF\u30BB\u30B9\u30D1\u30C3\u30B1\u30FC\u30B8\u304C\u3042\u308A\u307E\u3059\u3002<br>\u73FE\u5728\u306E\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u524A\u9664\u307E\u305F\u306F\u8CFC\u5165\u3059\u308B\u307E\u3067\u3001\u65B0\u3057\u3044\u30D1\u30C3\u30B1\u30FC\u30B8\u306F\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002","title-change-image":"\u5199\u771F\u3092\u9078\u629E","title-select-images":"\u5199\u771F\u3092\u9078\u629E","title-registered-selfies":"\u767B\u9332\u6E08\u307F\u306E\u9854","title-privacy":"\u5229\u7528\u898F\u7D04","title-faq":"\u3088\u304F\u3042\u308B\u8CEA\u554F","title-shoot":"\u64AE\u5F71","title-remote-shoot":"\u30EA\u30E2\u30FC\u30C8\u64AE\u5F71","title-thank-you":"\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059","thank-you-header":"\u3054\u8CFC\u5165\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01","thank-you-message":"\u300C\u30A2\u30EB\u30D0\u30E0\u306B\u623B\u308B\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u65B0\u3057\u3044\u5199\u771F\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002","thank-you-go-to-album-btn":"\u30A2\u30EB\u30D0\u30E0\u306B\u623B\u308B","order-pickup":"\u30D7\u30EA\u30F3\u30C8\u30B9\u30C6\u30FC\u30B7\u30E7\u30F3\u3067\u5199\u771F\u3092\u304A\u53D7\u3051\u53D6\u308A\u304F\u3060\u3055\u3044\u3002","shoot-again-btn":"\u3082\u3046\u4E00\u5EA6\u64AE\u5F71","select-image-done-btn-name_final":"\u5B8C\u4E86","select-image-done-btn-name_incomplete":"\u6B21\u3078","select-image-done-btn-counter_finite":"({{amount}}/{{total}})","select-image-done-btn-counter_infinite":"({{amount}})","remote-shoot-btn":"\u64AE\u5F71","remote-shoot-start-message":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u3001\u6E96\u5099\u304C\u3067\u304D\u305F\u3089\u300C\u64AE\u5F71\u300D\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044","remote-shoot-countdown-message":"\u30E9\u30A4\u30C8\u3092\u898B\u3066\u304F\u3060\u3055\u3044","remote-shoot-rendering-message":"\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u3066\u3044\u307E\u3059\u3002\u6570\u79D2\u5F8C\u306B\u30A2\u30EB\u30D0\u30E0\u3092\u78BA\u8A8D\u3057\u3066\u3001\u65B0\u3057\u3044\u7D20\u6575\u306A\u52D5\u753B\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\uFF01"}');

});

parcelRegister("dDbcq", function(module, exports) {
module.exports = JSON.parse('{"home-page-title":"Webapp","clear-btn":"\u6E05\u9664","close-btn":"\u95DC\u9589","cancel-btn":"\u53D6\u6D88","delete-btn":"\u522A\u9664","share-btn":"\u5206\u4EAB","download-btn":"\u4E0B\u8F09","favorite-btn":"\u6536\u85CF","ok-btn":"\u78BA\u8A8D","done-btn":"\u5B8C\u6210","yes-btn":"\u662F","no-btn":"\u5426","create-story-btn":"\u5EFA\u7ACB\u6545\u4E8B","submit-registration-btn":"\u958B\u555F\u76F8\u7C3F","save-btn":"\u5132\u5B58","apply-btn":"\u5957\u7528","checkout-btn":"\u7D50\u5E33","info-title":"\u8CC7\u8A0A","registration-page-title":"\u8A3B\u518A","contact-completion-page-title":"\u5B8C\u6210\u806F\u7D61\u8CC7\u6599","registration-name-placeholder":"\u60A8\u7684\u59D3\u540D","registration-email-placeholder":"\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6","registration-email-or-phone-placeholder":"\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u6216\u7F8E\u570B\u96FB\u8A71\u865F\u78BC","registration-country-code-default":"\u7F8E\u570B +1","registration-accept-label":"\u6211\u540C\u610F","registration-privacy-link":"\u689D\u6B3E\u8207\u7D30\u5247","registration-sms-agreement-label":"\u6211\u540C\u610F\u63A5\u6536\u4F86\u81EA Storibox \u7684\u901A\u77E5\u8A0A\u606F\u81F3\u4E0A\u65B9\u63D0\u4F9B\u7684\u96FB\u8A71\u865F\u78BC\u3002\u6211\u660E\u767D\u6211\u5C07\u6536\u5230\u5305\u542B\u66F4\u65B0\u8207\u5716\u7247\u9023\u7D50\u7684 SMS \u8A0A\u606F\u3002\u53EF\u80FD\u6703\u7522\u751F\u6578\u64DA\u53CA\u8A0A\u606F\u8CBB\u7528\u3002\u5982\u8981\u53D6\u6D88\uFF0C\u8ACB\u56DE\u8986 STOP\u3002","registration-submit-loading-label":"\u8F09\u5165\u4E2D...","registration-create-attendee-error-message":"\u5EFA\u7ACB\u4F7F\u7528\u8005\u5931\u6557\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002","registration-create-attendee-email-confirmation-error-message":"\u5EFA\u7ACB\u4F7F\u7528\u8005\u5931\u6557\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002\u8ACB\u78BA\u8A8D\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u5DF2\u5B8C\u6210\u9A57\u8B49\u3002","registration-invalid-us-phone-message":"\u8ACB\u50C5\u4F7F\u7528\u7F8E\u570B\u96FB\u8A71\u865F\u78BC\uFF0C\u4F8B\u5982\uFF1A+11234567890\u3002","registration-us-phone-length-message":"\u96FB\u8A71\u865F\u78BC\u5728\u570B\u78BC\uFF08+1\uFF09\u5F8C\u61C9\u70BA 10 \u4F4D\u6578\uFF0C\u4F46\u60A8\u8F38\u5165\u7684\u662F {{length}} \u4F4D\u3002","registration-contact-required-message":"\u96FB\u5B50\u90F5\u4EF6\u6216\u96FB\u8A71\u865F\u78BC\u70BA\u5FC5\u586B\u3002","registration-invalid-email-message":"\u8ACB\u8F38\u5165\u6709\u6548\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u3002","registration-email-required-message":"\u96FB\u5B50\u90F5\u4EF6\u70BA\u5FC5\u586B\u3002","registration-sms-consent-required-message":"\u60A8\u5FC5\u9808\u540C\u610F SMS \u689D\u6B3E\uFF0C\u5426\u5247\u7121\u6CD5\u8A3B\u518A\u6B64\u670D\u52D9\u3002","registration-privacy-consent-required-message":"\u60A8\u5FC5\u9808\u540C\u610F\u689D\u6B3E\u8207\u7D30\u5247\uFF0C\u5426\u5247\u7121\u6CD5\u8A3B\u518A\u6B64\u670D\u52D9\u3002","selfies-empty-title":"\u5C1A\u672A\u6709\u81EA\u62CD\uFF01","selfies-empty-message":"\u8ACB\u70BA\u540C\u884C\u7684\u6BCF\u4F4D\u6210\u54E1\\n\u65B0\u589E\u6E05\u6670\u7684\u4EBA\u50CF\u7167\u7247\uFF0C\\n\u4EE5\u4FBF\u5FEB\u901F\u627E\u5230\\n\u60A8\u7684\u5F71\u50CF\u3002","selfies-add-btn":"+ \u65B0\u589E","selfie-upload-window-expired-message":"\u5728\u6B64\u6D3B\u52D5\u4E2D\u4F7F\u7528\u81EA\u62CD\u641C\u5C0B\u60A8\u7167\u7247\u7684\u6642\u9593\u7A97\u53E3\u5DF2\u5230\u671F\u3002","purchase-btn":"\u8CFC\u8CB7","home-select-all-btn":"\u5168\u9078","home-selected-count-label_one":"\u5DF2\u9078\u64C7 1 \u9805","home-selected-count-label_other":"\u5DF2\u9078\u64C7 {{count}} \u9805","home-empty-album-message":"\u76F8\u7C3F\u662F\u7A7A\u7684","home-empty-album-subtext-message":"\u60A8\u7684\u76F8\u7C3F\u4E2D<br>\u76EE\u524D\u6C92\u6709\u4EFB\u4F55\u5716\u7247\u3002","home-qr-modal-title":"\u6211\u7684\u76F8\u7C3F\u4EE3\u78BC","home-qr-modal-message":"\u8ACB\u5728\u81EA\u52A9\u6A5F\u6383\u63CF\u6B64 QR \u4EE5\u5B58\u53D6\u60A8\u7684\u7167\u7247\uFF0C\u6216\u5728\u6D41\u52D5\u651D\u5F71\u5E2B\u8981\u6C42\u6642\u51FA\u793A\u3002","home-qr-scanner-message":"\u6383\u63CF\u7167\u7247\u81EA\u52A9\u6A5F\u4E2D\u60A8\u7167\u7247\u6216\u5F71\u7247\u4E0A\u7684 QR code\uFF0C\u5C07\u5A92\u9AD4\u8207\u6B64\u61C9\u7528\u7A0B\u5F0F\u9023\u7D50\u3002","home-qr-camera-access-message":"\uD83C\uDFA5 \u8ACB\u78BA\u8A8D\u60A8\u5DF2\u958B\u555F\u76F8\u6A5F\u6B0A\u9650\u4EE5\u6383\u63CF QR code\u3002","home-qr-scanner-show-my-qr-btn":"\u986F\u793A\u6211\u7684 QR","menu-registered-selfies":"\u5DF2\u767B\u8A18\u7684\u4EBA\u81C9","menu-qr-scanner":"QR \u6383\u63CF\u5668","menu-album-code":"\u6211\u7684\u76F8\u7C3F\u4EE3\u78BC","menu-privacy":"\u689D\u6B3E\u8207\u7D30\u5247","menu-faq":"\u5E38\u898B\u554F\u984C","menu-support":"\u652F\u63F4","home-step-label":"\u6B65\u9A5F {{amount}} / {{total}}","home-select-up-to-images-title_one":"\u6700\u591A\u9078\u64C7 1 \u5F35\u5716\u7247","home-select-up-to-images-title_other":"\u6700\u591A\u9078\u64C7 {{count}} \u5F35\u5716\u7247","home-select-as-many-images-title":"\u53EF\u9078\u64C7\u4EFB\u610F\u6578\u91CF\u7684\u5716\u7247","home-select-target-label":"\u7528\u65BC\u300C{{name}}\u300D","home-no-albums-found-message":"\u627E\u4E0D\u5230\u4EFB\u4F55\u76F8\u7C3F\u3002","home-event-config-missing-message":"\u6B64\u6D3B\u52D5\u5C1A\u672A\u8A2D\u5B9A Web \u61C9\u7528\u3002","home-create-story-waiting-message":"\u6B63\u5728\u5EFA\u7ACB\u60A8\u7684\u6545\u4E8B\u3002\u8ACB\u5E7E\u5206\u9418\u5F8C\u518D\u67E5\u770B\u76F8\u7C3F\u3002","home-ugc-tooltip-message":"\u60A8\u53EF\u4EE5\u5F9E\u76F8\u7C3F\u4E0A\u50B3\u7167\u7247\uFF0C\u4E26\u5728\u81EA\u52A9\u6A5F\u5217\u5370\uFF01","home-face-reco-tooltip-message":"\u8ACB\u4E0A\u50B3\u60A8\u7684\u81EA\u62CD\uFF0C\u6216\u540C\u884C\u6BCF\u4F4D\u6210\u54E1\u6E05\u6670\u7684\u4EBA\u50CF\u7167\u7247\uFF0C\u4EE5\u4FBF\u6211\u5011\u627E\u5230\u60A8\u7684\u5F71\u50CF\uFF01","home-select-to-share-or-download-message":"\u8ACB\u81F3\u5C11\u9078\u64C7\u4E00\u5F35\u5716\u7247\u4EE5\u5206\u4EAB\u6216\u4E0B\u8F09\u3002","home-select-without-watermark-message":"\u53EA\u6709\u7121\u6D6E\u6C34\u5370\u7684\u5716\u7247\u53EF\u5206\u4EAB\u6216\u4E0B\u8F09\u3002","home-select-to-delete-message":"\u8ACB\u81F3\u5C11\u9078\u64C7\u4E00\u5F35\u5716\u7247\u4EE5\u522A\u9664\u3002","home-share-download-locked-message":"\u60A8\u9078\u64C7\u7684\u90E8\u5206\u7167\u7247\u5DF2\u88AB\u9396\u5B9A\u3002\u82E5\u8981\u5206\u4EAB\u6216\u4E0B\u8F09\uFF0C\u8ACB\u8CFC\u8CB7 Digital Pass\u3002","home-face-register-help-message":"\u8ACB\u78BA\u4FDD\u81C9\u90E8\u5149\u7DDA\u5747\u52FB\u4E14\u5B8C\u6574\u53EF\u898B\uFF0C\u4E26\u4FDD\u6301\u81EA\u7136\u8868\u60C5\u3002","home-no-selfies-suggestion-message":"\u770B\u8D77\u4F86\u60A8\u5C1A\u672A\u767B\u8A18\u81EA\u62CD\u3002\u7ACB\u5373\u62CD\u651D\u81EA\u62CD\u4EE5\u7372\u53D6\u73CD\u8CB4\u56DE\u61B6\u3002","home-no-face-mask-message":"\u8ACB\u52FF\u4F69\u6234\u53E3\u7F69","home-selfie-maybe-later-btn":"\u7A0D\u5F8C","home-delete-stock-warning-message":"\u60A8\u9078\u64C7\u4E86\u6D3B\u52D5\u7D20\u6750\u5716\u7247\u8981\u522A\u9664\u3002\u6B64\u5716\u7247\u7121\u6CD5\u5F9E\u60A8\u7684\u76F8\u7C3F\u522A\u9664\uFF0C\u5C07\u88AB\u7565\u904E\u3002","home-delete-confirm-message":"\u5F9E\u76F8\u7C3F\u522A\u9664\u5716\u7247\u5F8C\u7121\u6CD5\u5FA9\u539F\u3002\u78BA\u5B9A\u8981\u7E7C\u7E8C\u55CE\uFF1F","home-delete-reason-not-wanted":"\u6211\u4E0D\u60F3\u8981\u9019\u4E9B\u5716\u7247\u5728\u76F8\u7C3F\u4E2D","home-delete-reason-not-mine":"\u9019\u4E9B\u4E0D\u662F\u6211\u7684\u5716\u7247","home-delete-confirm-btn":"\u662F\uFF0C\u522A\u9664","home-upload-unsupported-format-message":"\u4E0D\u652F\u63F4\u7684\u5716\u7247\u683C\u5F0F\u3002\u8ACB\u4F7F\u7528\u5176\u4ED6\u5716\u7247\u6A94\u6848\u3002","home-upload-generic-error-message":"\u4E0A\u50B3\u7167\u7247\u6642\u767C\u751F\u932F\u8AA4\u3002\u8ACB\u91CD\u8A66\u6216\u806F\u7D61\u652F\u63F4\u3002","home-upload-limit-reached-message":"\u60A8\u5DF2\u9054\u7167\u7247\u4E0A\u50B3\u4E0A\u9650\u3002\u5982\u9700\u4E0A\u50B3\u66F4\u591A\u7167\u7247\uFF0C\u8ACB\u806F\u7D61\u652F\u63F4\u3002","home-upload-processing-error-message":"\u8655\u7406\u7167\u7247\u6642\u767C\u751F\u932F\u8AA4\u3002\u8ACB\u91CD\u8A66\u6216\u806F\u7D61\u652F\u63F4\u3002","home-upload-processing-message":"\u60A8\u7684\u7167\u7247\u5C07\u65BC\u4E00\u5206\u9418\u5167\u51FA\u73FE\u5728\u76F8\u7C3F\u4E2D\uFF01","home-upload-photo-message":"\u5F9E\u76F8\u7C3F\u4E0A\u50B3\u7167\u7247\u4EE5\u4F9B\u5217\u5370\uFF01","home-turn-me-into-tag-upload-message":"\u62CD\u651D\u81EA\u62CD\uFF0C\u6216\u5F9E\u76F8\u7C3F\u4E0A\u50B3\u4EBA\u50CF\u7167\u7247\u3002","home-turn-me-into-tag-processing-message":"\u6211\u5011\u6B63\u5728\u8F49\u63DB\u60A8\u7684\u5716\u7247\uFF01\u8ACB\u7D04\u4E00\u5206\u9418\u5F8C\u91CD\u65B0\u6574\u7406\u6B64\u9801\u9762\u3002","home-download-waiting-message":"\u6B63\u5728\u4E0B\u8F09\u6A94\u6848\u3002<br/>\u8ACB\u7A0D\u5019\u3002","download-selection-too-large-message":"\u60A8\u9078\u53D6\u7684\u7167\u7247\u6216\u5F71\u7247\u904E\u591A\uFF0C\u7121\u6CD5\u4E00\u6B21\u4E0B\u8F09\u3002\u8ACB\u6E1B\u5C11\u9078\u53D6\u6578\u91CF\u5F8C\u91CD\u8A66\uFF0C\u6216\u9010\u4E00\u4E0B\u8F09\u3002","home-download-360-message":"\u9019\u662F\u4E92\u52D5\u5167\u5BB9\uFF0C\u5EFA\u8B70\u65BC\u76F8\u7C3F\u5167\u6AA2\u8996\u3002\u60A8\u4ECD\u53EF\u4E0B\u8F09\u539F\u59CB\u6A94\u6848\u4EE5\u5728\u7DDA\u4E0A\u5206\u4EAB\uFF0C\u6216\u65E5\u5F8C\u5728\u652F\u63F4 360 \u7403\u5F62\u683C\u5F0F\u7684\u61C9\u7528\u7A0B\u5F0F\u4E2D\u6AA2\u8996\u3002","home-scanned-image-confirm-message":"\u5F88\u68D2\u7684\u7167\u7247\uFF01\u70BA\u4E86\u5B89\u5168\u8ACB\u78BA\u8A8D\uFF1A\u9019\u662F\u60A8\u7684\u5716\u7247\u55CE\uFF1F","home-media-share-title":"\u5A92\u9AD4","webapp-share-title":"\u4F86\u770B\u770B\u6211\u7684 Storibox \u76F8\u7C3F\uFF01","webapp-ogp-title":"\u6211\u7684 Storibox \u76F8\u7C3F","webapp-ogp-description":"\u67E5\u770B\u4E26\u5206\u4EAB\u6211\u5728 Storibox \u76F8\u7C3F\u4E2D\u7684\u7167\u7247\u8207\u5F71\u7247\u3002","home-share-files-unsupported-message":"\u60A8\u7684\u700F\u89BD\u5668\u4E0D\u652F\u63F4\u6A94\u6848\u5206\u4EAB\u3002\u8ACB\u4F7F\u7528\u5176\u4ED6\u700F\u89BD\u5668\uFF0C\u6216\u76F4\u63A5\u4E0B\u8F09\u6A94\u6848\u3002","home-share-files-waiting-message":"\u6B63\u5728\u4E0B\u8F09\u8981\u5206\u4EAB\u7684\u6A94\u6848\u3002<br/>\u8ACB\u7A0D\u5019\u3002","title-select-a-combo":"\u9078\u64C7\u7D44\u5408","title-select-a-la-carte":"\u55AE\u9EDE\u9805\u76EE","title-shopping-cart":"\u8CFC\u7269\u8ECA","checkout-change-image-btn":"\u66F4\u63DB\u5716\u7247","checkout-empty-cart-message":"\u8CFC\u7269\u8ECA\u662F\u7A7A\u7684","checkout-add-product-btn":"\u65B0\u589E\u5546\u54C1","checkout-subtotal-label":"\u5C0F\u8A08:","checkout-taxes-label":"\u7A05\u91D1 (0%)","checkout-total-label":"\u7E3D\u91D1\u984D:","checkout-promo-code-placeholder":"\u512A\u60E0\u4EE3\u78BC","checkout-add-on-btn":"+ \u52A0\u8CFC","checkout-invalid-promo-code-message":"\u7121\u6548\u6216\u4E0D\u9069\u7528\u7684\u512A\u60E0\u4EE3\u78BC\uFF01","checkout-discount-label":"\u6298\u6263: {{title}}","checkout-delete-restriction-message":"\u5982\u8981\u8CFC\u8CB7\u52A0\u8CFC\u9805\u76EE\uFF0C\u8CFC\u7269\u8ECA\u4E2D\u5FC5\u9808\u81F3\u5C11\u4FDD\u7559\u4E00\u500B\u5957\u88DD\u3002\u82E5\u9700\u66F4\u63DB\u5957\u88DD\uFF0C\u8ACB\u5148\u79FB\u9664\u8CFC\u7269\u8ECA\u4E2D\u7684\u6240\u6709\u52A0\u8CFC\u9805\u76EE\u3002","checkout-digital-package-upsell-message":"\u8981\u5C07<br>\u6578\u4F4D\u5957\u88DD\u52A0\u5165<br>\u8CFC\u7269\u8ECA\uFF0C\u4E26\u53D6\u5F97<br>\u6240\u6709\u6578\u4F4D\u5167\u5BB9\u7684\u5B58\u53D6\u6B0A\u55CE\uFF1F","checkout-tip-message":"\u8981\u65B0\u589E\u5C0F\u8CBB\u55CE\uFF1F","checkout-tip-description":"\u60A8\u7684\u5C0F\u8CBB\u5C07\u5E6B\u52A9\u652F\u6301\u5718\u968A\u3002","checkout-no-tip-btn":"\u4E0D\u7D66\u5C0F\u8CBB","photo-plus-maybe-later-btn":"\u7A0D\u5F8C","photo-plus-upgrade-btn":"\u662F\uFF0C\u7ACB\u5373\u5347\u7D1A","checkout-digital-package-duplicate-message":"\u60A8\u7684\u8CFC\u7269\u8ECA\u4E2D\u5DF2\u5305\u542B\u6578\u4F4D\u5B58\u53D6\u5957\u88DD\u3002<br>\u5728\u79FB\u9664\u6216\u8CFC\u8CB7\u76EE\u524D\u5957\u88DD\u4E4B\u524D\uFF0C\u7121\u6CD5\u65B0\u589E\u65B0\u5957\u88DD\u3002","title-change-image":"\u9078\u64C7\u7167\u7247","title-select-images":"\u9078\u64C7\u7167\u7247","title-registered-selfies":"\u5DF2\u767B\u8A18\u7684\u4EBA\u81C9","title-privacy":"\u689D\u6B3E\u8207\u7D30\u5247","title-faq":"\u5E38\u898B\u554F\u984C","title-shoot":"\u62CD\u651D","title-remote-shoot":"\u9060\u7AEF\u62CD\u651D","title-thank-you":"\u8B1D\u8B1D","thank-you-header":"\u611F\u8B1D\u60A8\u7684\u8CFC\u8CB7\uFF01","thank-you-message":"\u8ACB\u9EDE\u64CA\u300C\u8FD4\u56DE\u76F8\u7C3F\u300D\u6309\u9215\u4EE5\u67E5\u770B\u60A8\u7684\u65B0\u7167\u7247\u3002","thank-you-go-to-album-btn":"\u8FD4\u56DE\u76F8\u7C3F","order-pickup":"\u8ACB\u5728\u5217\u5370\u7AD9\u9818\u53D6\u60A8\u7684\u7167\u7247\u3002","shoot-again-btn":"\u518D\u62CD\u4E00\u6B21","select-image-done-btn-name_final":"\u5B8C\u6210","select-image-done-btn-name_incomplete":"\u4E0B\u4E00\u6B65","select-image-done-btn-counter_finite":"({{amount}}/{{total}})","select-image-done-btn-counter_infinite":"({{amount}})","remote-shoot-btn":"\u62CD\u651D","remote-shoot-start-message":"\u8ACB\u770B\u8457\u93E1\u982D\uFF0C\u6E96\u5099\u597D\u5F8C\u6309\u300C\u62CD\u651D\u300D","remote-shoot-countdown-message":"\u8ACB\u770B\u8457\u71C8\u865F","remote-shoot-rendering-message":"\u6B63\u5728\u5EFA\u7ACB\u60A8\u7684\u5167\u5BB9\u3002\u5E7E\u79D2\u5F8C\u8ACB\u67E5\u770B\u76F8\u7C3F\uFF0C\u6B23\u8CDE\u5168\u65B0\u7CBE\u5F69\u5F71\u7247\uFF01"}');

});

parcelRegister("24lzn", function(module, exports) {
module.exports = JSON.parse('{"home-page-title":"Webapp","clear-btn":"\u6E05\u9664","close-btn":"\u5173\u95ED","cancel-btn":"\u53D6\u6D88","delete-btn":"\u5220\u9664","share-btn":"\u5206\u4EAB","download-btn":"\u4E0B\u8F7D","favorite-btn":"\u6536\u85CF","ok-btn":"\u786E\u8BA4","done-btn":"\u5B8C\u6210","yes-btn":"\u662F","no-btn":"\u5426","create-story-btn":"\u5EFA\u7ACB\u6545\u4E8B","submit-registration-btn":"\u5F00\u542F\u76F8\u518C","save-btn":"\u50A8\u5B58","apply-btn":"\u5957\u7528","checkout-btn":"\u7ED3\u8D26","info-title":"\u8D44\u8BAF","registration-page-title":"\u6CE8\u518C","contact-completion-page-title":"\u5B8C\u6210\u8054\u7EDC\u8D44\u6599","registration-name-placeholder":"\u60A8\u7684\u59D3\u540D","registration-email-placeholder":"\u60A8\u7684\u7535\u5B50\u90AE\u4EF6","registration-email-or-phone-placeholder":"\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u6216\u7F8E\u56FD\u7535\u8BDD\u53F7\u7801","registration-country-code-default":"\u7F8E\u56FD +1","registration-accept-label":"\u6211\u540C\u610F","registration-privacy-link":"\u6761\u6B3E\u4E0E\u7EC6\u5219","registration-sms-agreement-label":"\u6211\u540C\u610F\u63A5\u6536\u6765\u81EA Storibox \u7684\u901A\u77E5\u8BAF\u606F\u81F3\u4E0A\u65B9\u63D0\u4F9B\u7684\u7535\u8BDD\u53F7\u7801\u3002\u6211\u660E\u767D\u6211\u5C06\u6536\u5230\u5305\u542B\u66F4\u65B0\u4E0E\u56FE\u7247\u94FE\u63A5\u7684 SMS \u8BAF\u606F\u3002\u53EF\u80FD\u4F1A\u4EA7\u751F\u6570\u636E\u53CA\u8BAF\u606F\u8D39\u7528\u3002\u5982\u8981\u53D6\u6D88\uFF0C\u8BF7\u56DE\u8986 STOP\u3002","registration-submit-loading-label":"\u8F7D\u5165\u4E2D...","registration-create-attendee-error-message":"\u5EFA\u7ACB\u4F7F\u7528\u8005\u5931\u8D25\u3002\u8BF7\u7A0D\u540E\u518D\u8BD5\u3002","registration-create-attendee-email-confirmation-error-message":"\u5EFA\u7ACB\u4F7F\u7528\u8005\u5931\u8D25\u3002\u8BF7\u7A0D\u540E\u518D\u8BD5\u3002\u8BF7\u786E\u8BA4\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u5DF2\u5B8C\u6210\u9A8C\u8BC1\u3002","registration-invalid-us-phone-message":"\u8BF7\u4EC5\u4F7F\u7528\u7F8E\u56FD\u7535\u8BDD\u53F7\u7801\uFF0C\u4F8B\u5982\uFF1A+11234567890\u3002","registration-us-phone-length-message":"\u7535\u8BDD\u53F7\u7801\u5728\u56FD\u7801\uFF08+1\uFF09\u540E\u5E94\u4E3A 10 \u4F4D\u6570\uFF0C\u4F46\u60A8\u8F93\u5165\u7684\u662F {{length}} \u4F4D\u3002","registration-contact-required-message":"\u7535\u5B50\u90AE\u4EF6\u6216\u7535\u8BDD\u53F7\u7801\u4E3A\u5FC5\u586B\u3002","registration-invalid-email-message":"\u8BF7\u8F93\u5165\u6709\u6548\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u3002","registration-email-required-message":"\u7535\u5B50\u90AE\u4EF6\u4E3A\u5FC5\u586B\u3002","registration-sms-consent-required-message":"\u60A8\u5FC5\u987B\u540C\u610F SMS \u6761\u6B3E\uFF0C\u5426\u5219\u65E0\u6CD5\u6CE8\u518C\u6B64\u670D\u52A1\u3002","registration-privacy-consent-required-message":"\u60A8\u5FC5\u987B\u540C\u610F\u6761\u6B3E\u4E0E\u7EC6\u5219\uFF0C\u5426\u5219\u65E0\u6CD5\u6CE8\u518C\u6B64\u670D\u52A1\u3002","selfies-empty-title":"\u5C1A\u672A\u6709\u81EA\u62CD\uFF01","selfies-empty-message":"\u8BF7\u4E3A\u540C\u884C\u7684\u6BCF\u4F4D\u6210\u5458\\n\u65B0\u589E\u6E05\u6670\u7684\u4EBA\u50CF\u7167\u7247\uFF0C\\n\u4EE5\u4FBF\u5FEB\u901F\u627E\u5230\\n\u60A8\u7684\u5F71\u50CF\u3002","selfies-add-btn":"+ \u65B0\u589E","selfie-upload-window-expired-message":"\u5728\u6B64\u6D3B\u52A8\u4E2D\u4F7F\u7528\u81EA\u62CD\u641C\u7D22\u60A8\u7167\u7247\u7684\u65F6\u95F4\u7A97\u53E3\u5DF2\u5230\u671F\u3002","purchase-btn":"\u8D2D\u4E70","home-select-all-btn":"\u5168\u9009","home-selected-count-label_one":"\u5DF2\u9009\u62E9 1 \u9879","home-selected-count-label_other":"\u5DF2\u9009\u62E9 {{count}} \u9879","home-empty-album-message":"\u76F8\u518C\u662F\u7A7A\u7684","home-empty-album-subtext-message":"\u60A8\u7684\u76F8\u518C\u4E2D<br>\u76EE\u524D\u6CA1\u6709\u4EFB\u4F55\u56FE\u7247\u3002","home-qr-modal-title":"\u6211\u7684\u76F8\u518C\u4EE3\u7801","home-qr-modal-message":"\u8BF7\u5728\u81EA\u52A9\u673A\u626B\u63CF\u6B64 QR \u4EE5\u8BBF\u95EE\u60A8\u7684\u7167\u7247\uFF0C\u6216\u5728\u6D41\u52A8\u6444\u5F71\u5E08\u8981\u6C42\u65F6\u51FA\u793A\u3002","home-qr-scanner-message":"\u626B\u63CF\u7167\u7247\u81EA\u52A9\u673A\u4E2D\u60A8\u7167\u7247\u6216\u89C6\u9891\u4E0A\u7684 QR code\uFF0C\u5C06\u5A92\u4F53\u4E0E\u6B64\u5E94\u7528\u7A0B\u5E8F\u94FE\u63A5\u3002","home-qr-camera-access-message":"\uD83C\uDFA5 \u8BF7\u786E\u8BA4\u60A8\u5DF2\u5F00\u542F\u76F8\u673A\u6743\u9650\u4EE5\u626B\u63CF QR code\u3002","home-qr-scanner-show-my-qr-btn":"\u663E\u793A\u6211\u7684 QR","menu-registered-selfies":"\u5DF2\u6CE8\u518C\u7684\u4EBA\u8138","menu-qr-scanner":"QR \u626B\u63CF\u5668","menu-album-code":"\u6211\u7684\u76F8\u518C\u4EE3\u7801","menu-privacy":"\u6761\u6B3E\u4E0E\u7EC6\u5219","menu-faq":"\u5E38\u89C1\u95EE\u9898","menu-support":"\u652F\u6301","home-step-label":"\u6B65\u9AA4 {{amount}} / {{total}}","home-select-up-to-images-title_one":"\u6700\u591A\u9009\u62E9 1 \u5F20\u56FE\u7247","home-select-up-to-images-title_other":"\u6700\u591A\u9009\u62E9 {{count}} \u5F20\u56FE\u7247","home-select-as-many-images-title":"\u53EF\u9009\u62E9\u4EFB\u610F\u6570\u91CF\u7684\u56FE\u7247","home-select-target-label":"\u7528\u4E8E\u300C{{name}}\u300D","home-no-albums-found-message":"\u627E\u4E0D\u5230\u4EFB\u4F55\u76F8\u518C\u3002","home-event-config-missing-message":"\u6B64\u6D3B\u52A8\u5C1A\u672A\u8BBE\u5B9A Web \u5E94\u7528\u3002","home-create-story-waiting-message":"\u6B63\u5728\u5EFA\u7ACB\u60A8\u7684\u6545\u4E8B\u3002\u8BF7\u51E0\u5206\u949F\u540E\u518D\u67E5\u770B\u76F8\u518C\u3002","home-ugc-tooltip-message":"\u60A8\u53EF\u4EE5\u4ECE\u76F8\u518C\u4E0A\u4F20\u7167\u7247\uFF0C\u5E76\u5728\u81EA\u52A9\u673A\u5217\u5370\uFF01","home-face-reco-tooltip-message":"\u8BF7\u4E0A\u4F20\u60A8\u7684\u81EA\u62CD\uFF0C\u6216\u540C\u884C\u6BCF\u4F4D\u6210\u5458\u6E05\u6670\u7684\u4EBA\u50CF\u7167\u7247\uFF0C\u4EE5\u4FBF\u6211\u4EEC\u627E\u5230\u60A8\u7684\u5F71\u50CF\uFF01","home-select-to-share-or-download-message":"\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u5F20\u56FE\u7247\u4EE5\u5206\u4EAB\u6216\u4E0B\u8F7D\u3002","home-select-without-watermark-message":"\u53EA\u6709\u65E0\u6D6E\u6C34\u5370\u7684\u56FE\u7247\u53EF\u5206\u4EAB\u6216\u4E0B\u8F7D\u3002","home-select-to-delete-message":"\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u5F20\u56FE\u7247\u4EE5\u5220\u9664\u3002","home-share-download-locked-message":"\u60A8\u9009\u62E9\u7684\u90E8\u5206\u7167\u7247\u5DF2\u88AB\u9501\u5B9A\u3002\u82E5\u8981\u5206\u4EAB\u6216\u4E0B\u8F7D\uFF0C\u8BF7\u8D2D\u4E70 Digital Pass\u3002","home-face-register-help-message":"\u8BF7\u786E\u4FDD\u8138\u90E8\u5149\u7EBF\u5747\u5300\u4E14\u5B8C\u6574\u53EF\u89C1\uFF0C\u5E76\u4FDD\u6301\u81EA\u7136\u8868\u60C5\u3002","home-no-selfies-suggestion-message":"\u770B\u8D77\u6765\u60A8\u5C1A\u672A\u6CE8\u518C\u81EA\u62CD\u3002\u7ACB\u5373\u62CD\u6444\u81EA\u62CD\u4EE5\u83B7\u53D6\u73CD\u8D35\u56DE\u5FC6\u3002","home-no-face-mask-message":"\u8BF7\u52FF\u4F69\u6234\u53E3\u7F69","home-selfie-maybe-later-btn":"\u7A0D\u540E","home-delete-stock-warning-message":"\u60A8\u9009\u62E9\u4E86\u6D3B\u52A8\u7D20\u6750\u56FE\u7247\u8981\u5220\u9664\u3002\u6B64\u56FE\u7247\u65E0\u6CD5\u4ECE\u60A8\u7684\u76F8\u518C\u5220\u9664\uFF0C\u5C06\u88AB\u8DF3\u8FC7\u3002","home-delete-confirm-message":"\u4ECE\u76F8\u518C\u5220\u9664\u56FE\u7247\u540E\u65E0\u6CD5\u590D\u539F\u3002\u786E\u5B9A\u8981\u7EE7\u7EED\u5417\uFF1F","home-delete-reason-not-wanted":"\u6211\u4E0D\u60F3\u8981\u8FD9\u4E9B\u56FE\u7247\u5728\u76F8\u518C\u4E2D","home-delete-reason-not-mine":"\u8FD9\u4E9B\u4E0D\u662F\u6211\u7684\u56FE\u7247","home-delete-confirm-btn":"\u662F\uFF0C\u5220\u9664","home-upload-unsupported-format-message":"\u4E0D\u652F\u6301\u7684\u56FE\u7247\u683C\u5F0F\u3002\u8BF7\u4F7F\u7528\u5176\u4ED6\u56FE\u7247\u6587\u4EF6\u3002","home-upload-generic-error-message":"\u4E0A\u4F20\u7167\u7247\u65F6\u53D1\u751F\u9519\u8BEF\u3002\u8BF7\u91CD\u8BD5\u6216\u8054\u7EDC\u652F\u6301\u3002","home-upload-limit-reached-message":"\u60A8\u5DF2\u8FBE\u7167\u7247\u4E0A\u4F20\u4E0A\u9650\u3002\u5982\u9700\u4E0A\u4F20\u66F4\u591A\u7167\u7247\uFF0C\u8BF7\u8054\u7EDC\u652F\u6301\u3002","home-upload-processing-error-message":"\u5904\u7406\u7167\u7247\u65F6\u53D1\u751F\u9519\u8BEF\u3002\u8BF7\u91CD\u8BD5\u6216\u8054\u7EDC\u652F\u6301\u3002","home-upload-processing-message":"\u60A8\u7684\u7167\u7247\u5C06\u4E8E\u4E00\u5206\u949F\u5185\u51FA\u73B0\u5728\u76F8\u518C\u4E2D\uFF01","home-upload-photo-message":"\u4ECE\u76F8\u518C\u4E0A\u4F20\u7167\u7247\u4EE5\u4F9B\u5217\u5370\uFF01","home-turn-me-into-tag-upload-message":"\u62CD\u6444\u81EA\u62CD\uFF0C\u6216\u4ECE\u76F8\u518C\u4E0A\u4F20\u4EBA\u50CF\u7167\u7247\u3002","home-turn-me-into-tag-processing-message":"\u6211\u4EEC\u6B63\u5728\u8F6C\u6362\u60A8\u7684\u56FE\u7247\uFF01\u8BF7\u7EA6\u4E00\u5206\u949F\u540E\u5237\u65B0\u6B64\u9875\u9762\u3002","home-download-waiting-message":"\u6B63\u5728\u4E0B\u8F7D\u6587\u4EF6\u3002<br/>\u8BF7\u7A0D\u5019\u3002","download-selection-too-large-message":"\u60A8\u9009\u62E9\u7684\u7167\u7247\u6216\u89C6\u9891\u8FC7\u591A\uFF0C\u65E0\u6CD5\u4E00\u6B21\u6027\u4E0B\u8F7D\u3002\u8BF7\u51CF\u5C11\u9009\u62E9\u6570\u91CF\u540E\u91CD\u8BD5\uFF0C\u6216\u9010\u4E2A\u4E0B\u8F7D\u3002","home-download-360-message":"\u8FD9\u662F\u4E92\u52A8\u5185\u5BB9\uFF0C\u5EFA\u8BAE\u5728\u76F8\u518C\u5185\u67E5\u770B\u3002\u60A8\u4ECD\u53EF\u4E0B\u8F7D\u539F\u59CB\u6587\u4EF6\u4EE5\u5728\u7EBF\u4E0A\u5206\u4EAB\uFF0C\u6216\u65E5\u540E\u5728\u652F\u6301 360 \u7403\u5F62\u683C\u5F0F\u7684\u5E94\u7528\u7A0B\u5E8F\u4E2D\u67E5\u770B\u3002","home-scanned-image-confirm-message":"\u5F88\u68D2\u7684\u7167\u7247\uFF01\u4E3A\u4E86\u5B89\u5168\u8BF7\u786E\u8BA4\uFF1A\u8FD9\u662F\u60A8\u7684\u56FE\u7247\u5417\uFF1F","home-media-share-title":"\u5A92\u4F53","webapp-share-title":"\u6765\u770B\u770B\u6211\u7684 Storibox \u76F8\u518C\uFF01","webapp-ogp-title":"\u6211\u7684 Storibox \u76F8\u518C","webapp-ogp-description":"\u67E5\u770B\u5E76\u5206\u4EAB\u6211\u5728 Storibox \u76F8\u518C\u4E2D\u7684\u7167\u7247\u4E0E\u89C6\u9891\u3002","home-share-files-unsupported-message":"\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u6587\u4EF6\u5206\u4EAB\u3002\u8BF7\u4F7F\u7528\u5176\u4ED6\u6D4F\u89C8\u5668\uFF0C\u6216\u76F4\u63A5\u4E0B\u8F7D\u6587\u4EF6\u3002","home-share-files-waiting-message":"\u6B63\u5728\u4E0B\u8F7D\u8981\u5206\u4EAB\u7684\u6587\u4EF6\u3002<br/>\u8BF7\u7A0D\u5019\u3002","title-select-a-combo":"\u9009\u62E9\u7EC4\u5408","title-select-a-la-carte":"\u5355\u70B9\u9879\u76EE","title-shopping-cart":"\u8D2D\u7269\u8F66","checkout-change-image-btn":"\u66F4\u6362\u56FE\u7247","checkout-empty-cart-message":"\u8D2D\u7269\u8F66\u662F\u7A7A\u7684","checkout-add-product-btn":"\u65B0\u589E\u5546\u54C1","checkout-subtotal-label":"\u5C0F\u8BA1:","checkout-taxes-label":"\u7A0E\u91D1 (0%)","checkout-total-label":"\u603B\u91D1\u989D:","checkout-promo-code-placeholder":"\u4F18\u60E0\u4EE3\u7801","checkout-add-on-btn":"+ \u52A0\u8D2D","checkout-invalid-promo-code-message":"\u65E0\u6548\u6216\u4E0D\u9002\u7528\u7684\u4F18\u60E0\u4EE3\u7801\uFF01","checkout-discount-label":"\u6298\u6263: {{title}}","checkout-delete-restriction-message":"\u5982\u8981\u8D2D\u4E70\u52A0\u8D2D\u9879\u76EE\uFF0C\u8D2D\u7269\u8F66\u4E2D\u5FC5\u987B\u81F3\u5C11\u4FDD\u7559\u4E00\u4E2A\u5957\u88C5\u3002\u82E5\u9700\u66F4\u6362\u5957\u88C5\uFF0C\u8BF7\u5148\u79FB\u9664\u8D2D\u7269\u8F66\u4E2D\u7684\u6240\u6709\u52A0\u8D2D\u9879\u76EE\u3002","checkout-digital-package-upsell-message":"\u8981\u5C06<br>\u6570\u4F4D\u5957\u88C5\u52A0\u5165<br>\u8D2D\u7269\u8F66\uFF0C\u5E76\u53D6\u5F97<br>\u6240\u6709\u6570\u4F4D\u5185\u5BB9\u7684\u8BBF\u95EE\u6743\u9650\u5417\uFF1F","checkout-tip-message":"\u8981\u6DFB\u52A0\u5C0F\u8D39\u5417\uFF1F","checkout-tip-description":"\u60A8\u7684\u5C0F\u8D39\u5C06\u5E2E\u52A9\u652F\u6301\u56E2\u961F\u3002","checkout-no-tip-btn":"\u4E0D\u7ED9\u5C0F\u8D39","photo-plus-maybe-later-btn":"\u7A0D\u540E","photo-plus-upgrade-btn":"\u662F\uFF0C\u7ACB\u5373\u5347\u7EA7","checkout-digital-package-duplicate-message":"\u60A8\u7684\u8D2D\u7269\u8F66\u4E2D\u5DF2\u5305\u542B\u6570\u4F4D\u8BBF\u95EE\u5957\u88C5\u3002<br>\u5728\u79FB\u9664\u6216\u8D2D\u4E70\u76EE\u524D\u5957\u88C5\u4E4B\u524D\uFF0C\u65E0\u6CD5\u65B0\u589E\u65B0\u5957\u88C5\u3002","title-change-image":"\u9009\u62E9\u7167\u7247","title-select-images":"\u9009\u62E9\u7167\u7247","title-registered-selfies":"\u5DF2\u6CE8\u518C\u7684\u4EBA\u8138","title-privacy":"\u6761\u6B3E\u4E0E\u7EC6\u5219","title-faq":"\u5E38\u89C1\u95EE\u9898","title-shoot":"\u62CD\u6444","title-remote-shoot":"\u8FDC\u7AEF\u62CD\u6444","title-thank-you":"\u8C22\u8C22","thank-you-header":"\u611F\u8C22\u60A8\u7684\u8D2D\u4E70\uFF01","thank-you-message":"\u8BF7\u70B9\u51FB\u201C\u8FD4\u56DE\u76F8\u518C\u201D\u6309\u94AE\u67E5\u770B\u60A8\u7684\u65B0\u7167\u7247\u3002","thank-you-go-to-album-btn":"\u8FD4\u56DE\u76F8\u518C","order-pickup":"\u8BF7\u5728\u6253\u5370\u7AD9\u9886\u53D6\u60A8\u7684\u7167\u7247\u3002","shoot-again-btn":"\u518D\u62CD\u4E00\u6B21","select-image-done-btn-name_final":"\u5B8C\u6210","select-image-done-btn-name_incomplete":"\u4E0B\u4E00\u6B65","select-image-done-btn-counter_finite":"({{amount}}/{{total}})","select-image-done-btn-counter_infinite":"({{amount}})","remote-shoot-btn":"\u62CD\u6444","remote-shoot-start-message":"\u8BF7\u770B\u8457\u955C\u5934\uFF0C\u51C6\u5099\u597D\u540E\u6309\u300C\u62CD\u6444\u300D","remote-shoot-countdown-message":"\u8BF7\u770B\u8457\u706F\u53F7","remote-shoot-rendering-message":"\u6B63\u5728\u5EFA\u7ACB\u60A8\u7684\u5185\u5BB9\u3002\u51E0\u79D2\u540E\u8BF7\u67E5\u770B\u76F8\u518C\uFF0C\u6B23\u8D4F\u5168\u65B0\u7CBE\u5F69\u89C6\u9891\uFF01"}');

});



parcelRegister("aeSym", function(module, exports) {

$parcel$export(module.exports, "getDefaultLanguageSettings", function () { return $7745874f24a31eec$export$77b5b16842cd2d0; });
$parcel$export(module.exports, "normalizeLanguageSettings", function () { return $7745874f24a31eec$export$44e85394f643620a; });
$parcel$export(module.exports, "resolveLanguageCode", function () { return $7745874f24a31eec$export$8745cb1162b05b83; });
$parcel$export(module.exports, "getEventLanguageSettings", function () { return $7745874f24a31eec$export$d8746ca2f3bb24c5; });
$parcel$export(module.exports, "getLanguageSwitcherModel", function () { return $7745874f24a31eec$export$817f59721bc4190e; });

var $8fp0t = parcelRequire("8fp0t");
const $7745874f24a31eec$var$DEFAULT_LANGUAGE_CODE = 'en';
const $7745874f24a31eec$var$SYSTEM_LANGUAGE_OPTIONS = (0, $8fp0t.languageOptions);
const $7745874f24a31eec$var$LANGUAGE_ALIASES = {
    zh: 'zht',
    'zh-hant': 'zht',
    'zh-tw': 'zht',
    'zh-hk': 'zht',
    'zh-mo': 'zht',
    'zh-hans': 'zhs',
    'zh-cn': 'zhs',
    'zh-sg': 'zhs',
    'zh-my': 'zhs'
};
function $7745874f24a31eec$export$3896e2ff75f74c92() {
    return $7745874f24a31eec$var$SYSTEM_LANGUAGE_OPTIONS.map((option)=>({
            ...option
        }));
}
function $7745874f24a31eec$export$77b5b16842cd2d0() {
    return {
        availableLanguages: [
            $7745874f24a31eec$var$DEFAULT_LANGUAGE_CODE
        ],
        defaultLanguage: $7745874f24a31eec$var$DEFAULT_LANGUAGE_CODE
    };
}
function $7745874f24a31eec$export$44e85394f643620a(rawSettings = {}) {
    const supportedCodes = new Set($7745874f24a31eec$var$SYSTEM_LANGUAGE_OPTIONS.map(({ code: code })=>code));
    const requestedCodes = Array.isArray(rawSettings?.availableLanguages) ? rawSettings.availableLanguages : [];
    const availableLanguages = [
        ...new Set(requestedCodes.map($7745874f24a31eec$export$8745cb1162b05b83).filter((code)=>supportedCodes.has(code)))
    ];
    const resolvedAvailableLanguages = availableLanguages.length > 0 ? availableLanguages : [
        $7745874f24a31eec$var$DEFAULT_LANGUAGE_CODE
    ];
    const resolvedDefaultLanguage = $7745874f24a31eec$export$8745cb1162b05b83(rawSettings?.defaultLanguage);
    const defaultLanguage = resolvedAvailableLanguages.includes(resolvedDefaultLanguage) ? resolvedDefaultLanguage : $7745874f24a31eec$var$DEFAULT_LANGUAGE_CODE;
    return {
        availableLanguages: resolvedAvailableLanguages,
        defaultLanguage: defaultLanguage
    };
}
function $7745874f24a31eec$export$d8746ca2f3bb24c5(opts = {}) {
    return $7745874f24a31eec$export$44e85394f643620a(opts?.languageSettings);
}
function $7745874f24a31eec$export$817f59721bc4190e(languageCodes = [], currentLanguage = $7745874f24a31eec$var$DEFAULT_LANGUAGE_CODE) {
    const allowedCodes = new Set(Array.isArray(languageCodes) ? languageCodes : []);
    const languages = $7745874f24a31eec$var$SYSTEM_LANGUAGE_OPTIONS.filter(({ code: code })=>allowedCodes.has(code)).map((language)=>({
            ...language
        }));
    const selectedLanguage = languages.find(({ code: code })=>code === $7745874f24a31eec$export$8745cb1162b05b83(currentLanguage)) || languages[0] || null;
    return {
        languages: languages,
        selectedLanguage: selectedLanguage,
        isVisible: languages.length > 1
    };
}
function $7745874f24a31eec$export$8745cb1162b05b83(languageCode = '') {
    if (typeof languageCode !== 'string') return languageCode;
    const normalizedCode = languageCode.trim().toLowerCase();
    if (!normalizedCode) return normalizedCode;
    if ($7745874f24a31eec$var$LANGUAGE_ALIASES[normalizedCode]) return $7745874f24a31eec$var$LANGUAGE_ALIASES[normalizedCode];
    const baseCode = normalizedCode.split('-')[0];
    return $7745874f24a31eec$var$LANGUAGE_ALIASES[baseCode] || baseCode;
}

});



parcelRegister("gb01V", function(module, exports) {

$parcel$export(module.exports, "ecomIsCollectionVisibleInPackageList", function () { return $bc6db264a4d29bf5$export$b16445aef1c835d1; });
$parcel$export(module.exports, "ecomGetCollectionOrProductVisibilityForWebapp", function () { return $bc6db264a4d29bf5$export$9a997c2913765c33; });
$parcel$export(module.exports, "ecomGetAddonCollectionForWebapp", function () { return $bc6db264a4d29bf5$export$c02ac486ed61539d; });
$parcel$export(module.exports, "ecomGetCollectionsById", function () { return $bc6db264a4d29bf5$export$df9d8dca01223942; });
$parcel$export(module.exports, "ecomGetCollectionsWithProductsByEventName", function () { return $bc6db264a4d29bf5$export$fab926130affe644; });
$parcel$export(module.exports, "ecomFindAndSetFullUnlockProduct", function () { return $bc6db264a4d29bf5$export$e21a08082fcd1e2d; });
$parcel$export(module.exports, "ecomGetAddonCollectionVariantArray", function () { return $bc6db264a4d29bf5$export$3af545805c904416; });
$parcel$export(module.exports, "ecomNormalizeProductVariantId", function () { return $bc6db264a4d29bf5$export$3942c515a4f05842; });
$parcel$export(module.exports, "ecomGetCollectionTagType", function () { return $bc6db264a4d29bf5$export$accca8c83aa8bacb; });
$parcel$export(module.exports, "ecomIsComboContainsRequiredOption", function () { return $bc6db264a4d29bf5$export$510edd081b81e37c; });
$parcel$export(module.exports, "ecomProductCountForPhotoSelection", function () { return $bc6db264a4d29bf5$export$9b7d948076c79727; });
$parcel$export(module.exports, "normalizeCollectionId", function () { return $bc6db264a4d29bf5$export$5f56868db4b5eed0; });
$parcel$export(module.exports, "ecomLoadTipProducts", function () { return $bc6db264a4d29bf5$export$71429af2d8fbf42a; });
$parcel$export(module.exports, "ecomHasTipProduct", function () { return $bc6db264a4d29bf5$export$2d8490e55e3f3575; });
$parcel$export(module.exports, "ecomBuildTipLineItem", function () { return $bc6db264a4d29bf5$export$e19a26eb83ec7c06; });
$parcel$export(module.exports, "ecomRenderTipCheckoutPopupHtml", function () { return $bc6db264a4d29bf5$export$25b97d90f4cce566; });
$parcel$export(module.exports, "ecomIsRequiredImageSelectionForProduct", function () { return $bc6db264a4d29bf5$export$587cecc3a3e721e; });
$parcel$export(module.exports, "ecomHasFullUnlockProduct", function () { return $bc6db264a4d29bf5$export$53c3fa392e8dac57; });
$parcel$export(module.exports, "ecomApplyDiscount", function () { return $bc6db264a4d29bf5$export$ed85147321d2ccf2; });
$parcel$export(module.exports, "ecomGetCart", function () { return $bc6db264a4d29bf5$export$ef703d1ea848fdb1; });
$parcel$export(module.exports, "ecomAddLineItems", function () { return $bc6db264a4d29bf5$export$5629af31f62510df; });
$parcel$export(module.exports, "ecomUpdateCartLineItems", function () { return $bc6db264a4d29bf5$export$f9c00bd36b317ace; });
$parcel$export(module.exports, "ecomIsValidForPrintAndUnlock", function () { return $bc6db264a4d29bf5$export$338d81c9a44f8ea5; });
$parcel$export(module.exports, "ecomCheckCollectionTagsAndImages", function () { return $bc6db264a4d29bf5$export$bab10e358f36a924; });
$parcel$export(module.exports, "ecomGetProductOptionType", function () { return $bc6db264a4d29bf5$export$8fc8893d5e903db4; });
$parcel$export(module.exports, "ecomGetAttendeeLastOrder", function () { return $bc6db264a4d29bf5$export$6ac754ee3717519b; });
$parcel$export(module.exports, "ecomGetProductAcceptDenyTags", function () { return $bc6db264a4d29bf5$export$3ef2821f44c6299; });
$parcel$export(module.exports, "loadEcommerceCheckoutSettings", function () { return (parcelRequire("3Hje3")).loadEcommerceCheckoutSettings; });
$parcel$export(module.exports, "applyEcommerceCheckoutSettingsToStorage", function () { return (parcelRequire("3Hje3")).applyEcommerceCheckoutSettingsToStorage; });
$parcel$export(module.exports, "ecomGetComboProductsIds", function () { return (parcelRequire("er4bn")).ecomGetComboProductsIds; });
$parcel$export(module.exports, "ecomGetCollComboVariant", function () { return (parcelRequire("er4bn")).ecomGetCollComboVariant; });
$parcel$export(module.exports, "ecomGetLocalisedObjectImage", function () { return (parcelRequire("er4bn")).ecomGetLocalisedObjectImage; });
$parcel$export(module.exports, "ecomGetProductTagType", function () { return (parcelRequire("4Da5X")).ecomGetProductTagType; });
$parcel$export(module.exports, "ecomCheckProductTagTypeAndImageTag", function () { return (parcelRequire("4Da5X")).ecomCheckProductTagTypeAndImageTag; });
$parcel$export(module.exports, "ecomCheckProductTagTypeForAllImages", function () { return (parcelRequire("4Da5X")).ecomCheckProductTagTypeForAllImages; });

var $fwAln = parcelRequire("fwAln");

var $er4bn = parcelRequire("er4bn");

var $4Da5X = parcelRequire("4Da5X");

var $4ah1P = parcelRequire("4ah1P");

var $7Ypd8 = parcelRequire("7Ypd8");
parcelRequire("hXoW9");
var $frM9m = parcelRequire("frM9m");

var $3Hje3 = parcelRequire("3Hje3");

var $dxUHY = parcelRequire("dxUHY");
function $bc6db264a4d29bf5$export$62b19f2f7c30f85a(checkingObj) {
    const visibilityJson = (0, $7Ypd8.tryJson)(checkingObj?.visibility_json, {});
    return visibilityJson.hide_from_packages === true || visibilityJson.hide_from_packages === 1 || checkingObj?.hide_from_packages === true || checkingObj?.hide_from_packages === 1;
}
function $bc6db264a4d29bf5$var$isTipCollectionFlag(value) {
    return value === true || value === 1 || value === '1';
}
function $bc6db264a4d29bf5$export$b16445aef1c835d1(checkingObj) {
    // Tip collections are checkout-only and must not appear in package grids.
    if ($bc6db264a4d29bf5$var$isTipCollectionFlag(checkingObj?.is_tip_collection)) return false;
    return !$bc6db264a4d29bf5$export$62b19f2f7c30f85a(checkingObj);
}
function $bc6db264a4d29bf5$export$1925d797187c0261(checkingObj, isVip) {
    const currKioskId = localStorage.getItem('kioskId')?.toLowerCase();
    const toHideKiosks = checkingObj.hide_from_kiosks || checkingObj.hideFromKiosks;
    const toShowOnlyKiosks = checkingObj.show_only_on_kiosks || checkingObj.showOnlyOnKiosks;
    const showToWip = checkingObj?.show_only_for_vip || checkingObj?.showOnlyForVip;
    const hideForWip = checkingObj?.hide_for_vip || checkingObj?.hideForVip;
    const visibilityJson = (0, $7Ypd8.tryJson)(checkingObj.visibility_json, {});
    if (visibilityJson?.kiosk === false) return false;
    const isVisibleForKiosk = ()=>{
        if (toShowOnlyKiosks) {
            const showKioskIds = toShowOnlyKiosks.split(',').map((item)=>item.trim());
            return showKioskIds.some((kioskId)=>kioskId.toLowerCase() === currKioskId);
        }
        if (toHideKiosks) {
            const hideKioskIds = toHideKiosks.split(',').map((item)=>item.trim());
            return !hideKioskIds.some((kioskId)=>kioskId.toLowerCase() === currKioskId);
        }
        return true;
    };
    const isVisibleForVIP = ()=>{
        if (showToWip && isVip === '0') return false;
        return !(hideForWip && isVip === '1');
    };
    return isVisibleForKiosk() && isVisibleForVIP();
}
function $bc6db264a4d29bf5$export$9a997c2913765c33(checkingObj, isVip) {
    const showToVip = checkingObj?.show_only_for_vip || checkingObj?.showOnlyForVip;
    const hideForVip = checkingObj?.hide_for_vip || checkingObj?.hideForVip;
    const visibilityJson = (0, $7Ypd8.tryJson)(checkingObj.visibility_json, {});
    let webappVisibility = checkingObj?.showOnWebapp;
    if (Object.prototype.hasOwnProperty.call(checkingObj || {}, 'show_on_webapp')) webappVisibility = checkingObj.show_on_webapp;
    if (Object.prototype.hasOwnProperty.call(visibilityJson, 'webapp')) webappVisibility = visibilityJson.webapp;
    if ((0, $7Ypd8.isFalsy)(webappVisibility)) return false;
    const isVisibleForVIP = ()=>{
        if (showToVip && isVip === '0') return false;
        return !(hideForVip && isVip === '1');
    };
    return isVisibleForVIP();
}
function $bc6db264a4d29bf5$export$ea95455cae150f8c(checkingObj, isVip, channel) {
    if (channel === 'webapp') return $bc6db264a4d29bf5$export$9a997c2913765c33(checkingObj, isVip);
    if (channel === 'kiosk') return $bc6db264a4d29bf5$export$1925d797187c0261(checkingObj, isVip);
    return false;
}
function $bc6db264a4d29bf5$export$c02ac486ed61539d(collectionList, isVip) {
    const addonCollection = collectionList?.find((collection)=>collection?.is_addon_collection);
    return addonCollection && $bc6db264a4d29bf5$export$9a997c2913765c33(addonCollection, isVip) ? addonCollection : null;
}
async function $bc6db264a4d29bf5$export$df9d8dca01223942({ collectionId: collectionId, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey, withProductData: withProductData = true }) {
    return (0, $fwAln.getCollectionsById)({
        id: collectionId,
        eventPrivateApiKey: eventPrivateApiKey,
        eventPublicApiKey: eventPublicApiKey,
        withProductData: withProductData
    });
}
async function $bc6db264a4d29bf5$export$fab926130affe644({ eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey, eventName: eventName }) {
    return (0, $fwAln.getCollectionsWithProductsByEventName)({
        eventPrivateApiKey: eventPrivateApiKey,
        eventPublicApiKey: eventPublicApiKey,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$dbb8a2f04947e2cf(eventName) {
    return (0, $fwAln.getCollectionsByEventName)(eventName);
}
async function $bc6db264a4d29bf5$export$3ac0b85e2bc7561d({ withCombos: withCombos = true, eventName: eventName }) {
    return (0, $fwAln.getProductsByEventName)({
        withCombos: withCombos,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$ac810dc016522637({ eventName: eventName }) {
    return (0, $fwAln.getShopLocationCodeList)({
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$97d2f58693c76fea({ productData: productData, eventName: eventName }) {
    return (0, $fwAln.createProduct)({
        productData: productData,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$b082cf8924550682({ productData: productData, eventName: eventName }) {
    return (0, $fwAln.editProduct)({
        productData: productData,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$dd9cc677db49c5af({ productData: productData, eventName: eventName }) {
    return (0, $fwAln.deleteProduct)({
        productData: productData,
        eventName: eventName
    });
}
function $bc6db264a4d29bf5$export$e21a08082fcd1e2d(internalCollection, externalCollection, isVip) {
    // Find the full unlock product in internal collection
    const fullUnlockProduct = internalCollection?.products?.find((product)=>product?.product_purpose === 'full_unlock');
    if (!fullUnlockProduct) return;
    // Find the corresponding external product
    const externalProduct = externalCollection?.products.edges.find((prod)=>prod.node.id === $bc6db264a4d29bf5$export$947231e7ac3fb978(fullUnlockProduct?.external_product_id));
    if (!externalProduct) return;
    // Get the external variant ID
    const externalVariantId = $bc6db264a4d29bf5$export$63034c6d37015df5(externalProduct, isVip);
    if (!externalVariantId) return;
    // Create and store the full unlock product with variant ID
    const newProduct = {
        ...fullUnlockProduct,
        variantId: externalVariantId
    };
    localStorage.setItem('fullUnlockProduct', JSON.stringify(newProduct));
}
async function $bc6db264a4d29bf5$export$3af545805c904416({ collectionId: collectionId, isVip: isVip, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    const res = await (0, $fwAln.getCollectionsById)({
        id: collectionId,
        eventPrivateApiKey: eventPrivateApiKey,
        eventPublicApiKey: eventPublicApiKey
    });
    const { occoCollectionData: occoCollectionData, collectionAndComboData: collectionAndComboData } = res?.status === 'ok' ? res.result : null;
    if (!occoCollectionData) throw new Error(`No collection found for ID ${collectionId}`);
    const variantArr = [];
    const { products: products } = occoCollectionData;
    const externalProducts = collectionAndComboData.collectionData.products.edges;
    for(let t = 0; t < products?.length; t += 1){
        const variant = products[t];
        const resVariant = (()=>{
            const product = externalProducts.find(({ node: node })=>node.id === $bc6db264a4d29bf5$export$947231e7ac3fb978(variant.external_product_id));
            if (!product) return null;
            const variantEdges = product.node.variants.edges;
            const v = variantEdges.find(({ node: node })=>(0, $er4bn.ecomIsNodeTitleHasCorrectMode)(node, isVip)) ?? variantEdges[0];
            return v ? {
                variantId: v.node.id,
                price: v.node.price,
                sku: v.node.sku || variant.sku || null
            } : null;
        })();
        if (resVariant) {
            variant.variantId = resVariant.variantId;
            variant.price = resVariant.price;
            variant.sku = resVariant.sku;
        }
        variantArr.push(variant);
    }
    return variantArr;
}
function $bc6db264a4d29bf5$export$63034c6d37015df5(externalProduct, isVip) {
    const variant = externalProduct.node.variants.edges.find((item)=>(0, $er4bn.ecomIsNodeTitleHasCorrectMode)(item?.node, isVip));
    return variant ? variant.node.id : null;
}
function $bc6db264a4d29bf5$export$3942c515a4f05842(id) {
    return id?.includes(`gid://shopify`) ? id : `gid://shopify/ProductVariant/${id}`;
}
function $bc6db264a4d29bf5$export$accca8c83aa8bacb(collection) {
    const collectionTagType = {
        collectionAcceptTags: [],
        collectionDenyTags: [],
        comboAcceptTags: [],
        comboDenyTags: []
    };
    const prodList = collection.products;
    for(let p = 0; p < prodList.length; p += 1){
        const prodTags = (0, $4Da5X.ecomGetProductTagType)(prodList[p]);
        if (prodTags.acceptTags.length > 0) collectionTagType.comboAcceptTags = collectionTagType.comboAcceptTags.concat(prodTags.acceptTags);
        if (prodTags.denyTags.length > 0) collectionTagType.comboDenyTags = collectionTagType.comboDenyTags.concat(prodTags.denyTags);
    }
    return collectionTagType;
}
function $bc6db264a4d29bf5$export$510edd081b81e37c(collection, option) {
    return collection.products.some((product)=>product.product_purpose === option);
}
function $bc6db264a4d29bf5$export$9b7d948076c79727(collection, option) {
    const { products: products } = collection;
    return products.reduce((count, product)=>{
        if (product.product_purpose === option) {
            const prodCount = (0, $er4bn.ecomGetProductCountInCollection)(collection, product.id);
            return count + (prodCount || 1);
        }
        return count;
    }, 0);
}
function $bc6db264a4d29bf5$export$7071711d58893d21(collectionList) {
    for(let i = 0; i < collectionList.length; i += 1){
        if (collectionList[i]?.is_addon_collection) return collectionList[i].id;
    }
    return -1;
}
function $bc6db264a4d29bf5$export$7a1db68d1a29bd9a(collectionList) {
    for(let i = 0; i < collectionList.length; i += 1){
        if ($bc6db264a4d29bf5$var$isTipCollectionFlag(collectionList[i]?.is_tip_collection)) return collectionList[i].id;
    }
    return -1;
}
function $bc6db264a4d29bf5$export$6b06283d69d8430b(collectionList, isVip, channel) {
    const tipCollection = collectionList?.find((collection)=>$bc6db264a4d29bf5$var$isTipCollectionFlag(collection?.is_tip_collection));
    return tipCollection && $bc6db264a4d29bf5$export$ea95455cae150f8c(tipCollection, isVip, channel) ? tipCollection : null;
}
function $bc6db264a4d29bf5$export$6d4a3c337ed1c1f8(occoCollections, externalCollections, isVip, { channel: channel } = {}) {
    const tipCollection = $bc6db264a4d29bf5$export$6b06283d69d8430b(occoCollections, isVip, channel);
    if (!tipCollection) return [];
    const tipExternalId = $bc6db264a4d29bf5$export$5f56868db4b5eed0(tipCollection.external_collection_id);
    const externalMatch = (externalCollections || []).find((item)=>{
        const collectionData = item?.collectionData || item;
        return $bc6db264a4d29bf5$export$5f56868db4b5eed0(collectionData?.id) === tipExternalId;
    });
    // Prefer tip-collection edges; fall back to any collection that contains the product.
    const tipEdges = (externalMatch?.collectionData || externalMatch)?.products?.edges || [];
    const allEdges = (externalCollections || []).flatMap((item)=>{
        const collectionData = item?.collectionData || item;
        return collectionData?.products?.edges || [];
    });
    const currency = tipCollection.currency || 'USD';
    return (tipCollection.products || []).filter((product)=>$bc6db264a4d29bf5$export$ea95455cae150f8c(product, isVip, channel)).reduce((tipProducts, product)=>{
        const productId = $bc6db264a4d29bf5$export$947231e7ac3fb978(product?.external_product_id);
        const externalProduct = tipEdges.find((p)=>p?.node?.id === productId) || allEdges.find((p)=>p?.node?.id === productId);
        const variantId = (externalProduct ? $bc6db264a4d29bf5$export$63034c6d37015df5(externalProduct, isVip) : null) || externalProduct?.node?.variants?.edges?.[0]?.node?.id || null;
        if (!variantId) return tipProducts;
        const amount = Number(isVip === '1' || isVip === true ? product.vip_price : product.non_vip_price) || 0;
        tipProducts.push({
            id: product.id,
            title: product.name,
            variantId: variantId,
            amount: amount,
            formattedPrice: (0, $er4bn.ecomFormatPrice)(amount, product.currency || currency),
            imageUrl: (0, $er4bn.ecomGetLocalisedObjectImage)(product) || ''
        });
        return tipProducts;
    }, []).sort((a, b)=>a.amount - b.amount);
}
async function $bc6db264a4d29bf5$export$71429af2d8fbf42a({ channel: channel } = {}) {
    const eventName = localStorage.getItem('eventName') || '';
    if (!eventName) return [];
    try {
        const res = await $bc6db264a4d29bf5$export$fab926130affe644({
            eventPrivateApiKey: localStorage.getItem('eventPrivateApiKey') || '',
            eventPublicApiKey: localStorage.getItem('eventPublicApiKey') || '',
            eventName: eventName
        });
        if (res?.status !== 'ok') return [];
        return $bc6db264a4d29bf5$export$6d4a3c337ed1c1f8(res.result?.occoCollectionData || [], res.result?.collectionData || [], localStorage.getItem('isVip'), {
            channel: channel
        });
    } catch (err) {
        console.error('Failed to load tip products:', err);
        return [];
    }
}
function $bc6db264a4d29bf5$export$2d8490e55e3f3575(checkout) {
    for (const lineItem of checkout?.lineItems || []){
        const variantArr = (0, $7Ypd8.tryJson)($bc6db264a4d29bf5$var$ecomGetCustomAttribute(lineItem, '_variantArr'), []);
        if (Array.isArray(variantArr) && variantArr.some((v)=>(v?.productPurpose || v?.product_purpose) === 'tip')) return true;
    }
    return false;
}
function $bc6db264a4d29bf5$export$e19a26eb83ec7c06(tipProduct, { eventName: eventName, attendeeUid: attendeeUid, kioskId: kioskId, uniqueField: uniqueField }) {
    const variant = {
        productTitle: tipProduct.title,
        pid: 0,
        eventName: eventName,
        id: tipProduct.id,
        attendeeUid: attendeeUid,
        action: 'tip',
        productPurpose: 'tip',
        uniqueField: uniqueField
    };
    if (kioskId) variant.kioskId = kioskId;
    return {
        variantId: tipProduct.variantId,
        quantity: 1,
        customAttributes: [
            {
                key: '_variantArr',
                value: JSON.stringify([
                    variant
                ])
            }
        ]
    };
}
function $bc6db264a4d29bf5$export$25b97d90f4cce566({ tipProducts: tipProducts, message: message, description: description, noTipLabel: noTipLabel }) {
    const buttons = (tipProducts || []).map((tip)=>{
        const tipId = (0, $7Ypd8.escapeHtml)(tip.id);
        const price = (0, $7Ypd8.escapeHtml)(tip.formattedPrice || '');
        const title = (0, $7Ypd8.escapeHtml)(tip.title || 'Tip');
        const imageUrl = tip.imageUrl ? (0, $7Ypd8.escapeHtml)(tip.imageUrl) : '';
        const imageHtml = imageUrl ? `<img class="tip-amount-btn__img" src="${imageUrl}" alt="${title}" />` : '';
        return `<button type="button" class="tip-amount-btn" data-tip-id="${tipId}">
          ${imageHtml}
          <span class="tip-amount-btn__price">${price}</span>
        </button>`;
    }).join('');
    const descriptionHtml = description ? `<p class="tip-checkout-popup__description">${(0, $7Ypd8.escapeHtml)(description)}</p>` : '';
    return `<div class="confirm-purchase-popup tip-checkout-popup">
    <h2 class="tip-checkout-popup__title">${(0, $7Ypd8.escapeHtml)(message)}</h2>
    ${descriptionHtml}
    <div class="tip-checkout-popup__amounts">${buttons}</div>
    <button id="noTipBtn" type="button" class="btn btn-outline tip-checkout-popup__skip" data-dismiss="modal">${(0, $7Ypd8.escapeHtml)(noTipLabel)}</button>
  </div>`;
}
function $bc6db264a4d29bf5$export$587cecc3a3e721e(product) {
    const requiredImageSelection = product?.productPurpose || product?.product_purpose;
    return requiredImageSelection === 'printable' || requiredImageSelection === 'partial_unlock_media';
}
function $bc6db264a4d29bf5$export$53c3fa392e8dac57(checkout) {
    let hasFullUnlock = false;
    const lineItems = checkout.lineItems || [];
    for(let k = 0; k < lineItems.length; k += 1){
        const lineItem = lineItems[k];
        const variantArr = JSON.parse($bc6db264a4d29bf5$var$ecomGetCustomAttribute(lineItem, '_variantArr'));
        for(let i = 0; i < variantArr.length; i += 1)if (variantArr[i].productPurpose === 'full_unlock') {
            hasFullUnlock = true;
            break;
        }
    }
    return hasFullUnlock;
}
function $bc6db264a4d29bf5$var$ecomGetCustomAttribute(lineItem, customAttName) {
    const lineItemArray = Array.isArray(lineItem) ? lineItem : [
        lineItem
    ];
    for(let i = 0; i < lineItemArray.length; i += 1){
        const item = lineItemArray[i];
        if (item.customAttributes && Array.isArray(item.customAttributes)) for(let j = 0; j < item.customAttributes.length; j += 1){
            const custAtt = item.customAttributes[j];
            if (custAtt.key === customAttName) return custAtt.value;
        }
    }
    return null;
}
function $bc6db264a4d29bf5$export$8aaf185ca5f7f3d5(variant, cart) {
    if (variant.product_purpose === 'full_unlock' && $bc6db264a4d29bf5$export$53c3fa392e8dac57(cart)) {
        const lsMessage = localStorage.getItem('shopDigitalProductDupMsg');
        const message = lsMessage || (0, $frM9m.t)('checkout-digital-package-duplicate-message');
        const content = `<div>
        <h6>${message} </h6><br> <br>
        <button id="buttonOK" type="button" class="btn btn-primary btn-lg"> OK </button></div>`;
        customPopUp.html(content);
        customPopUp.show();
        document.getElementById('buttonOK')?.addEventListener('click', ()=>{
            window.location.href = 'cart.html';
        }, {
            once: true
        });
        return true;
    }
    return false;
}
function $bc6db264a4d29bf5$export$36fab888a34be348(photoFullPath, tags) {
    const fileExtension = photoFullPath.split('.').pop().toLowerCase();
    return !!(/(jpg|jpeg|png)$/gi.test(fileExtension) || photoFullPath.includes('uokg5o') && tags.acceptTags.includes('uokg5o'));
}
function $bc6db264a4d29bf5$export$ed85147321d2ccf2({ cartId: cartId, discountCode: discountCode, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    return (0, $4ah1P.ecomApplyDiscount)({
        cartId: cartId,
        discountCode: discountCode,
        eventPrivateApiKey: eventPrivateApiKey,
        eventPublicApiKey: eventPublicApiKey
    });
}
function $bc6db264a4d29bf5$export$ef703d1ea848fdb1({ isFromWebapp: isFromWebapp, shippingAddress: shippingAddress, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    return (0, $4ah1P.ecomGetCart)({
        isFromWebapp: isFromWebapp,
        shippingAddress: shippingAddress,
        eventPrivateApiKey: eventPrivateApiKey,
        eventPublicApiKey: eventPublicApiKey
    });
}
function $bc6db264a4d29bf5$export$5629af31f62510df(cartId, lineItems) {
    return (0, $4ah1P.ecomAddLineItems)(cartId, lineItems);
}
function $bc6db264a4d29bf5$export$f9c00bd36b317ace({ cartId: cartId, lineItems: lineItems, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    return (0, $4ah1P.ecomUpdateCartLineItems)({
        cartId: cartId,
        lineItems: lineItems,
        eventPrivateApiKey: eventPrivateApiKey,
        eventPublicApiKey: eventPublicApiKey
    });
}
function $bc6db264a4d29bf5$export$947231e7ac3fb978(id) {
    return (0, $er4bn.normalizeProductId)(id);
}
function $bc6db264a4d29bf5$export$5f56868db4b5eed0(id) {
    return (0, $er4bn.normalizeCollectionId)(id);
}
function $bc6db264a4d29bf5$export$338d81c9a44f8ea5(photoFullPath, tags) {
    const fileExtension = photoFullPath.split('.').pop().toLowerCase();
    return !!(/(jpg|jpeg|png)$/gi.test(fileExtension) || localStorage.getItem('isUnlockMedia') === 'true' || photoFullPath.includes('uokg5o') && tags.acceptTags.includes('uokg5o'));
}
function $bc6db264a4d29bf5$export$bab10e358f36a924(collection, imgPaths) {
    let showCombo = true;
    for(let k = 0; k < collection.products.length; k += 1){
        const { acceptTags: acceptTags } = (0, $4Da5X.ecomGetProductTagType)(collection.products[k]);
        if (!(0, $4Da5X.ecomCheckProductTagTypeForAllImages)(imgPaths, {
            acceptTags: acceptTags
        })) {
            showCombo = false;
            break;
        }
    }
    return showCombo;
}
const $bc6db264a4d29bf5$export$81eb02a7647561ad = {
    NONE: 0,
    PRINTABLE: 1,
    PARTIAL_UNLOCK_MEDIA: 2,
    PRINTABLE_AND_PARTIAL_UNLOCK_MEDIA: 3
};
function $bc6db264a4d29bf5$export$8fc8893d5e903db4(collection) {
    const { products: products } = collection;
    if (!Array.isArray(products) || products.length === 0) return $bc6db264a4d29bf5$export$81eb02a7647561ad.NONE;
    let hasPrintable = false;
    let hasPartialUnlock = false;
    for (const product of products){
        const purpose = product?.product_purpose || product?.productPurpose;
        if (purpose === 'printable') hasPrintable = true;
        else if (purpose === 'partial_unlock_media') hasPartialUnlock = true;
        if (hasPrintable && hasPartialUnlock) return $bc6db264a4d29bf5$export$81eb02a7647561ad.PRINTABLE_AND_PARTIAL_UNLOCK_MEDIA;
    }
    if (hasPrintable) return $bc6db264a4d29bf5$export$81eb02a7647561ad.PRINTABLE;
    if (hasPartialUnlock) return $bc6db264a4d29bf5$export$81eb02a7647561ad.PARTIAL_UNLOCK_MEDIA;
    return $bc6db264a4d29bf5$export$81eb02a7647561ad.NONE;
}
function $bc6db264a4d29bf5$export$fe8173a6f4511573(collectionFullData) {
    const { occoCollectionData: occoCollectionData } = collectionFullData;
    const newCollection = occoCollectionData;
    const newExternalCollection = collectionFullData.collectionAndComboData.collectionData;
    const isVip = localStorage.getItem('isVip');
    const filteredOccoProducts = [];
    const filteredExternalProducts = [];
    if (occoCollectionData?.show_only_for_vip && isVip === '0' || occoCollectionData?.hide_for_vip && isVip === '1') return null;
    for(let i = 0; i < occoCollectionData.products.length; i += 1){
        const product = newCollection.products[i];
        const isVisibleToUser = !(product?.show_only_for_vip && isVip === '0' || product?.hide_for_vip && isVip === '1');
        if (isVisibleToUser) {
            filteredOccoProducts.push(product);
            const { edges: edges } = newExternalCollection.products;
            filteredExternalProducts.push($bc6db264a4d29bf5$var$getExternalProductsFromCollection(product.external_product_id, edges));
        }
    }
    if (filteredOccoProducts.length > 0) {
        newCollection.products = filteredOccoProducts;
        newExternalCollection.products.edges = filteredExternalProducts;
    } else return null;
    return {
        occoCollectionData: newCollection,
        collectionAndComboData: {
            collectionComboData: collectionFullData.collectionAndComboData.collectionComboData,
            collectionData: newExternalCollection
        }
    };
}
function $bc6db264a4d29bf5$var$getExternalProductsFromCollection(externalProductId, externalProductList) {
    const externalId = (0, $er4bn.normalizeProductId)(externalProductId);
    for(let i = 0; i < externalProductList.length; i += 1){
        if (externalProductList[i].node.id === externalId) return externalProductList[i];
    }
    return null;
}
async function $bc6db264a4d29bf5$export$466606a9b17b0d71({ collectionData: collectionData, eventName: eventName }) {
    return (0, $fwAln.createCollection)({
        collectionData: collectionData,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$951a68bdd8481567({ collectionData: collectionData, eventName: eventName }) {
    return (0, $fwAln.editCollection)({
        collectionData: collectionData,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$79affffb82eee6ff({ collectionData: collectionData, eventName: eventName }) {
    return (0, $fwAln.deleteCollection)({
        collectionData: collectionData,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$156a9fc09654a738({ settingsData: settingsData, eventName: eventName }) {
    return (0, $fwAln.addStoreSettings)({
        settingsData: settingsData,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$649dbdcecf2f58b3({ settingsData: settingsData, eventName: eventName }) {
    return (0, $fwAln.editStoreSettings)({
        settingsData: settingsData,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$4e3641ada1fa7329({ eventName: eventName, eventCode: eventCode }) {
    return (0, $fwAln.getStoreSettings)({
        eventName: eventName,
        eventCode: eventCode
    });
}
async function $bc6db264a4d29bf5$export$9efa836de663768({ settingsData: settingsData, eventName: eventName }) {
    return (0, $fwAln.deleteStoreSettings)({
        settingsData: settingsData,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$8f988928174dadc6({ locationData: locationData, eventName: eventName }) {
    return (0, $fwAln.addStoreLocation)({
        locationData: locationData,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$5c0f01e30d195d32({ locationData: locationData, eventName: eventName }) {
    return (0, $fwAln.editStoreLocation)({
        locationData: locationData,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$6c7eb9d493d01815({ eventName: eventName, eventCode: eventCode }) {
    return (0, $fwAln.getStoreLocation)({
        eventName: eventName,
        eventCode: eventCode
    });
}
async function $bc6db264a4d29bf5$export$d38d1d1be675baf7({ eventName: eventName, eventPublicApiKey: eventPublicApiKey }) {
    return (0, $fwAln.getStoreSettingsForKiosk)({
        eventName: eventName,
        eventPublicApiKey: eventPublicApiKey
    });
}
async function $bc6db264a4d29bf5$export$d7e6a512746836c5({ eventName: eventName, eventPublicApiKey: eventPublicApiKey }) {
    return (0, $fwAln.getStoreLocationForKiosk)({
        eventName: eventName,
        eventPublicApiKey: eventPublicApiKey
    });
}
async function $bc6db264a4d29bf5$export$ff600e1d0e98cad0({ locationData: locationData, eventName: eventName }) {
    return (0, $fwAln.deleteStoreLocation)({
        locationData: locationData,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$7f1f5df9e8fbd098({ orderId: orderId, eventPrivateApiKey: eventPrivateApiKey, eventName: eventName }) {
    const timeBasedKey = $bc6db264a4d29bf5$export$932b3a954cc6b0ad();
    return (0, $fwAln.printOrderPhotos)({
        orderId: orderId,
        timeBasedKey: timeBasedKey,
        eventPrivateApiKey: eventPrivateApiKey,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$896b91d172234fb4({ startDate: startDate, endDate: endDate, eventName: eventName }) {
    const result = await (0, $fwAln.getEventOrders)({
        startDate: startDate,
        endDate: endDate,
        eventName: eventName
    });
    if (result?.status === 'ok' && Array.isArray(result.result)) {
        const { orders: orders, skippedCount: skippedCount } = (0, $dxUHY.normalizeEventOrders)(result.result);
        return {
            ...result,
            result: orders,
            skippedOrderCount: skippedCount
        };
    }
    return result;
}
async function $bc6db264a4d29bf5$export$7ef73e51b3194229({ orderId: orderId, eventName: eventName }) {
    return (0, $fwAln.fulfillOrder)({
        orderId: orderId,
        eventName: eventName
    });
}
async function $bc6db264a4d29bf5$export$66c84d2cd2d127b4({ attendeeUid: attendeeUid, cartId: cartId, eventPrivateApiKey: eventPrivateApiKey }) {
    return (0, $fwAln.createDraftOrder)({
        attendeeUid: attendeeUid,
        cartId: cartId,
        eventPrivateApiKey: eventPrivateApiKey
    });
}
async function $bc6db264a4d29bf5$export$6ac754ee3717519b({ eventPublicApiKey: eventPublicApiKey, attendeeId: attendeeId }) {
    // Public last-order is already an allowlisted DTO (no id). Do not run it through
    // normalizeEventOrder — that helper is for the owner list and drops payloads without id.
    return (0, $fwAln.getAttendeeLastOrder)({
        eventPublicApiKey: eventPublicApiKey,
        attendeeId: attendeeId
    });
}
async function $bc6db264a4d29bf5$export$68865d086f42c453({ attendeeUid: attendeeUid, draftOrderId: draftOrderId, employeeSecretCode: employeeSecretCode, authRequired: authRequired, isByCash: isByCash, eventPrivateApiKey: eventPrivateApiKey }) {
    return (0, $fwAln.completeDraftOrder)({
        attendeeUid: attendeeUid,
        draftOrderId: draftOrderId,
        employeeSecretCode: employeeSecretCode,
        authRequired: authRequired,
        isByCash: isByCash,
        eventPrivateApiKey: eventPrivateApiKey
    });
}
async function $bc6db264a4d29bf5$export$63c75631ab04a352({ attendeeUid: attendeeUid, draftOrderId: draftOrderId, gateway: gateway, tag: tag, eventPrivateApiKey: eventPrivateApiKey }) {
    return (0, $fwAln.completeShopifyDraftOrderSelfCheckout)({
        attendeeUid: attendeeUid,
        draftOrderId: draftOrderId,
        gateway: gateway,
        tag: tag,
        eventPrivateApiKey: eventPrivateApiKey
    });
}
/**
 * Generate a time-based key that expires every 2 minutes
 * Returns the same key within a 2-minute window, generates a new one after expiration
 * @returns {string} - Time-based key
 */ const $bc6db264a4d29bf5$var$timeBasedKeyCache = {
    key: null,
    timestamp: null,
    expirationTime: 30000
};
function $bc6db264a4d29bf5$export$932b3a954cc6b0ad() {
    const now = Date.now();
    // Check if we have a valid cached key
    if ($bc6db264a4d29bf5$var$timeBasedKeyCache.key !== null && $bc6db264a4d29bf5$var$timeBasedKeyCache.timestamp !== null && now - $bc6db264a4d29bf5$var$timeBasedKeyCache.timestamp < $bc6db264a4d29bf5$var$timeBasedKeyCache.expirationTime) // Return cached key if still valid
    return $bc6db264a4d29bf5$var$timeBasedKeyCache.key;
    // Generate new key if expired or not set
    const newKey = $bc6db264a4d29bf5$var$generateRandomKey();
    $bc6db264a4d29bf5$var$timeBasedKeyCache.key = newKey;
    $bc6db264a4d29bf5$var$timeBasedKeyCache.timestamp = now;
    return newKey;
}
/**
 * Generate a random key string
 * @returns {string} - Random key
 */ function $bc6db264a4d29bf5$var$generateRandomKey() {
    const timestamp = Date.now();
    const randomStr = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    return `${timestamp}_${randomStr}`;
}
function $bc6db264a4d29bf5$export$3ef2821f44c6299(product) {
    const isUnlockMedia = product.product_purpose === 'partial_unlock_media' || product.productPurpose === 'partial_unlock_media';
    const requireTags = product.require_tags || product.requireTags || '';
    const denyTagsStr = product.deny_tags || product.denyTags || '';
    const acceptTags = requireTags?.length > 0 ? requireTags.split(',').map((tag)=>tag.trim()) : [];
    const denyTags = denyTagsStr?.length > 0 ? denyTagsStr.split(',').map((tag)=>tag.trim()) : [];
    return {
        acceptTags: acceptTags,
        denyTags: denyTags,
        isUnlockMedia: isUnlockMedia
    };
}

});
parcelRegister("fwAln", function(module, exports) {

$parcel$export(module.exports, "getCollectionsById", function () { return $b4d60950d58ff9ee$export$9c1fee7e66e40e74; });
$parcel$export(module.exports, "getCollectionsByEventName", function () { return $b4d60950d58ff9ee$export$a6997123664c949a; });
$parcel$export(module.exports, "getCollectionsWithProductsByEventName", function () { return $b4d60950d58ff9ee$export$1d0d39e973b30ba5; });
$parcel$export(module.exports, "createShoppingCard", function () { return $b4d60950d58ff9ee$export$cf1871a15fd5f30d; });
$parcel$export(module.exports, "addLineItemsToCart", function () { return $b4d60950d58ff9ee$export$3b42bbc90b2cb81c; });
$parcel$export(module.exports, "createDraftOrder", function () { return $b4d60950d58ff9ee$export$38a83e47ae9851b9; });
$parcel$export(module.exports, "getAttendeeLastOrder", function () { return $b4d60950d58ff9ee$export$3e73860553351b1b; });
$parcel$export(module.exports, "completeDraftOrder", function () { return $b4d60950d58ff9ee$export$7fdd4cc2851601c8; });
$parcel$export(module.exports, "completeShopifyDraftOrderSelfCheckout", function () { return $b4d60950d58ff9ee$export$f9ac2161b61066a7; });
$parcel$export(module.exports, "updateCartLineItems", function () { return $b4d60950d58ff9ee$export$ee75dda7ae522945; });
$parcel$export(module.exports, "updateCartShippingAddress", function () { return $b4d60950d58ff9ee$export$875a572c7098b896; });
$parcel$export(module.exports, "applyDiscountToCart", function () { return $b4d60950d58ff9ee$export$8e8192a1c7156016; });
$parcel$export(module.exports, "getShoppingCard", function () { return $b4d60950d58ff9ee$export$6081a4a410c0df57; });
$parcel$export(module.exports, "getProductsByEventName", function () { return $b4d60950d58ff9ee$export$b04ecb29a517f52e; });
$parcel$export(module.exports, "getShopLocationCodeList", function () { return $b4d60950d58ff9ee$export$c07484e1e20450cf; });
$parcel$export(module.exports, "createProduct", function () { return $b4d60950d58ff9ee$export$9c734a715e6666d0; });
$parcel$export(module.exports, "deleteProduct", function () { return $b4d60950d58ff9ee$export$297029b54a55ef2d; });
$parcel$export(module.exports, "editProduct", function () { return $b4d60950d58ff9ee$export$ffb156fa15e8d023; });
$parcel$export(module.exports, "createCollection", function () { return $b4d60950d58ff9ee$export$c74125a8e3af6bb2; });
$parcel$export(module.exports, "editCollection", function () { return $b4d60950d58ff9ee$export$2a5ab0bd8ac05e77; });
$parcel$export(module.exports, "deleteCollection", function () { return $b4d60950d58ff9ee$export$3d16e031f6551662; });
$parcel$export(module.exports, "printOrderPhotos", function () { return $b4d60950d58ff9ee$export$16934cd4463a7b7a; });
$parcel$export(module.exports, "getEventOrders", function () { return $b4d60950d58ff9ee$export$93206e4ef84c734c; });
$parcel$export(module.exports, "fulfillOrder", function () { return $b4d60950d58ff9ee$export$1cad8bfa5108220e; });
$parcel$export(module.exports, "addStoreSettings", function () { return $b4d60950d58ff9ee$export$e8995bef68f6a284; });
$parcel$export(module.exports, "editStoreSettings", function () { return $b4d60950d58ff9ee$export$178991be6bca13e1; });
$parcel$export(module.exports, "getStoreSettings", function () { return $b4d60950d58ff9ee$export$97a8fe0afcb70c04; });
$parcel$export(module.exports, "deleteStoreSettings", function () { return $b4d60950d58ff9ee$export$ca8ccce0f342968a; });
$parcel$export(module.exports, "addStoreLocation", function () { return $b4d60950d58ff9ee$export$7cb3ca3f8f924ba5; });
$parcel$export(module.exports, "editStoreLocation", function () { return $b4d60950d58ff9ee$export$a580abd31a761114; });
$parcel$export(module.exports, "getStoreLocation", function () { return $b4d60950d58ff9ee$export$db65c60f50035963; });
$parcel$export(module.exports, "getStoreSettingsForKiosk", function () { return $b4d60950d58ff9ee$export$932eb0e88f6b91f1; });
$parcel$export(module.exports, "getStoreLocationForKiosk", function () { return $b4d60950d58ff9ee$export$b2cd670d701df8f6; });
$parcel$export(module.exports, "deleteStoreLocation", function () { return $b4d60950d58ff9ee$export$6e340bc19c7291a3; });

var $k2vBO = parcelRequire("k2vBO");
const $b4d60950d58ff9ee$var$restApi = (0, $k2vBO.initRequest)("https://api-new.occo.io/v1");
async function $b4d60950d58ff9ee$export$9c1fee7e66e40e74({ id: id, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey, withProductData: withProductData = true }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/collections/get-by-id', {
        event_private_api_key: eventPrivateApiKey,
        event_public_api_key: eventPublicApiKey,
        id: id,
        withProductData: withProductData
    });
}
async function $b4d60950d58ff9ee$export$a6997123664c949a(eventName) {
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/collections/get-by-event-name', {
        eventName: eventName
    }, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$1d0d39e973b30ba5({ eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey, eventName: eventName }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/collections/get-by-event-name', {
        event_private_api_key: eventPrivateApiKey,
        event_public_api_key: eventPublicApiKey,
        eventName: eventName
    });
}
async function $b4d60950d58ff9ee$export$cf1871a15fd5f30d({ lineItems: lineItems = [], shippingAddress: shippingAddress = null, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/cart/create', {
        event_private_api_key: eventPrivateApiKey,
        event_public_api_key: eventPublicApiKey,
        line_items: lineItems,
        shipping_address: shippingAddress
    });
}
async function $b4d60950d58ff9ee$export$3b42bbc90b2cb81c({ cartId: cartId, lineItems: lineItems, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/cart/add-line-items', {
        event_private_api_key: eventPrivateApiKey,
        event_public_api_key: eventPublicApiKey,
        line_items: lineItems,
        cart_id: cartId
    });
}
async function $b4d60950d58ff9ee$export$38a83e47ae9851b9({ attendeeUid: attendeeUid, cartId: cartId, eventPrivateApiKey: eventPrivateApiKey }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/order/create-draft-order', {
        attendee_uid: attendeeUid,
        event_private_api_key: eventPrivateApiKey,
        cart_id: cartId
    });
}
async function $b4d60950d58ff9ee$export$3e73860553351b1b({ eventPublicApiKey: eventPublicApiKey, attendeeId: attendeeId }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/order/get-attendee-last-order', {
        event_public_api_key: eventPublicApiKey,
        attendee_id: attendeeId
    });
}
async function $b4d60950d58ff9ee$export$7fdd4cc2851601c8({ attendeeUid: attendeeUid, draftOrderId: draftOrderId, employeeSecretCode: employeeSecretCode, authRequired: authRequired, isByCash: isByCash, eventPrivateApiKey: eventPrivateApiKey }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/order/complete-draft-order', {
        attendee_uid: attendeeUid,
        event_private_api_key: eventPrivateApiKey,
        draft_order_id: draftOrderId,
        employee_secret_code: employeeSecretCode,
        auth_required: authRequired,
        is_by_cash: isByCash
    });
}
async function $b4d60950d58ff9ee$export$f9ac2161b61066a7({ attendeeUid: attendeeUid, draftOrderId: draftOrderId, gateway: gateway, tag: tag, eventPrivateApiKey: eventPrivateApiKey }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/order/complete-draft-order-self-checkout', {
        attendee_uid: attendeeUid,
        event_private_api_key: eventPrivateApiKey,
        draft_order_id: draftOrderId,
        gateway: gateway,
        tag: tag
    });
}
async function $b4d60950d58ff9ee$export$ee75dda7ae522945({ cartId: cartId, lineItems: lineItems, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/cart/update-line-items', {
        event_private_api_key: eventPrivateApiKey,
        event_public_api_key: eventPublicApiKey,
        line_items: lineItems,
        cart_id: cartId
    });
}
async function $b4d60950d58ff9ee$export$875a572c7098b896({ cartId: cartId, shippingAddress: shippingAddress, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/cart/update-address', {
        event_private_api_key: eventPrivateApiKey,
        event_public_api_key: eventPublicApiKey,
        cart_id: cartId,
        shipping_address: shippingAddress
    });
}
async function $b4d60950d58ff9ee$export$8e8192a1c7156016({ cartId: cartId, discountCode: discountCode, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/cart/apply-discount', {
        event_private_api_key: eventPrivateApiKey,
        event_public_api_key: eventPublicApiKey,
        cart_id: cartId,
        discount_code: discountCode
    });
}
async function $b4d60950d58ff9ee$export$6081a4a410c0df57({ cartId: cartId, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/cart/get-by-id', {
        event_private_api_key: eventPrivateApiKey,
        event_public_api_key: eventPublicApiKey,
        cart_id: cartId
    });
}
async function $b4d60950d58ff9ee$export$b04ecb29a517f52e({ withCombos: withCombos = true, eventName: eventName }) {
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/products/get-by-event-name', {
        eventName: eventName,
        withCombos: withCombos
    }, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$c07484e1e20450cf({ eventName: eventName }) {
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/products/shop-location-codes/list', {
        eventName: eventName
    }, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$9c734a715e6666d0({ productData: productData, eventName: eventName }) {
    const extendedProductData = {
        ...productData,
        eventName: eventName
    };
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/products/create', extendedProductData, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$297029b54a55ef2d({ productData: productData, eventName: eventName }) {
    const extendedProductData = {
        ...productData,
        eventName: eventName
    };
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/products/delete', extendedProductData, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$ffb156fa15e8d023({ productData: productData, eventName: eventName }) {
    const extendedProductData = {
        ...productData,
        eventName: eventName
    };
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/products/edit', extendedProductData, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$c74125a8e3af6bb2({ collectionData: collectionData, eventName: eventName }) {
    const extendedCollectionData = {
        ...collectionData,
        eventName: eventName
    };
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/collections/create', extendedCollectionData, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$2a5ab0bd8ac05e77({ collectionData: collectionData, eventName: eventName }) {
    const extendedCollectionData = {
        ...collectionData,
        eventName: eventName
    };
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/collections/edit', extendedCollectionData, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$3d16e031f6551662({ collectionData: collectionData, eventName: eventName }) {
    const extendedCollectionData = {
        ...collectionData,
        eventName: eventName
    };
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/collections/delete', extendedCollectionData, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$16934cd4463a7b7a({ orderId: orderId, timeBasedKey: timeBasedKey, eventPrivateApiKey: eventPrivateApiKey, eventName: eventName }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/web-hook/print-order-photos', {
        event_private_api_key: eventPrivateApiKey,
        callUniqueKey: `${timeBasedKey}${orderId}`,
        eventName: eventName,
        orderId: orderId
    }, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$93206e4ef84c734c({ startDate: startDate, endDate: endDate, eventName: eventName }) {
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/order/get-orders-by-event-and-date', {
        eventName: eventName,
        startDate: startDate instanceof Date ? startDate.toISOString() : startDate,
        endDate: endDate instanceof Date ? endDate.toISOString() : endDate
    }, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$1cad8bfa5108220e({ orderId: orderId, eventName: eventName }) {
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/order/fulfill-order', {
        orderId: orderId,
        eventName: eventName
    }, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$e8995bef68f6a284({ settingsData: settingsData, eventName: eventName }) {
    const extendedSettingsData = {
        ...settingsData,
        event_code: settingsData.event_code ?? eventName,
        eventName: eventName
    };
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/settings/create', extendedSettingsData, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$178991be6bca13e1({ settingsData: settingsData, eventName: eventName }) {
    const extendedSettingsData = {
        ...settingsData,
        event_code: settingsData.event_code ?? eventName,
        eventName: eventName
    };
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/settings/edit', extendedSettingsData, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$97a8fe0afcb70c04({ eventName: eventName, eventCode: eventCode }) {
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/settings/get-by-event-code', {
        event_code: eventCode ?? eventName,
        eventName: eventName
    }, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$ca8ccce0f342968a({ settingsData: settingsData, eventName: eventName }) {
    const extendedSettingsData = {
        ...settingsData,
        event_code: settingsData.event_code ?? eventName,
        eventName: eventName
    };
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/settings/delete', extendedSettingsData, {
        addAuth: true
    });
}
function $b4d60950d58ff9ee$var$buildStoreLocationDto(locationData, eventName, { includeId: includeId = false } = {}) {
    const payload = {
        event_code: locationData.event_code ?? eventName,
        location_name: locationData.location_name,
        location_external_id: locationData.location_external_id,
        address1: locationData.address1,
        address2: locationData.address2,
        country: locationData.country,
        state: locationData.state,
        city: locationData.city,
        zip: locationData.zip,
        company: locationData.company,
        phone: locationData.phone,
        first_name: locationData.first_name,
        last_name: locationData.last_name,
        eventName: eventName
    };
    if (includeId && locationData.id != null) payload.id = locationData.id;
    return payload;
}
async function $b4d60950d58ff9ee$export$7cb3ca3f8f924ba5({ locationData: locationData, eventName: eventName }) {
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/location/create', $b4d60950d58ff9ee$var$buildStoreLocationDto(locationData, eventName), {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$a580abd31a761114({ locationData: locationData, eventName: eventName }) {
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/location/edit', $b4d60950d58ff9ee$var$buildStoreLocationDto(locationData, eventName, {
        includeId: true
    }), {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$db65c60f50035963({ eventName: eventName, eventCode: eventCode }) {
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/location/get-by-event-code', {
        event_code: eventCode ?? eventName,
        eventName: eventName
    }, {
        addAuth: true
    });
}
async function $b4d60950d58ff9ee$export$932eb0e88f6b91f1({ eventName: eventName, eventPublicApiKey: eventPublicApiKey }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/settings/get-by-event-code', {
        event_code: eventName,
        event_public_api_key: eventPublicApiKey
    });
}
async function $b4d60950d58ff9ee$export$b2cd670d701df8f6({ eventName: eventName, eventPublicApiKey: eventPublicApiKey }) {
    return $b4d60950d58ff9ee$var$restApi.post('/ecommerce/location/get-by-event-code', {
        event_code: eventName,
        event_public_api_key: eventPublicApiKey
    });
}
async function $b4d60950d58ff9ee$export$6e340bc19c7291a3({ locationData: locationData, eventName: eventName }) {
    const extendedLocationData = {
        ...locationData,
        event_code: locationData.event_code ?? eventName,
        eventName: eventName
    };
    return $b4d60950d58ff9ee$var$restApi.post('/occo-owner/ecommerce/location/delete', extendedLocationData, {
        addAuth: true
    });
}

});

parcelRegister("er4bn", function(module, exports) {

$parcel$export(module.exports, "ecomIsNodeTitleHasCorrectMode", function () { return $a826d4dc37c35dba$export$a36ef6968303096d; });
$parcel$export(module.exports, "normalizeProductId", function () { return $a826d4dc37c35dba$export$947231e7ac3fb978; });
$parcel$export(module.exports, "normalizeCollectionId", function () { return $a826d4dc37c35dba$export$5f56868db4b5eed0; });
$parcel$export(module.exports, "ecomFormatPrice", function () { return $a826d4dc37c35dba$export$5a5d32ddfb85fbb2; });
$parcel$export(module.exports, "ecomGetLocalisedObjectImage", function () { return $a826d4dc37c35dba$export$1b46f909ece943e2; });
$parcel$export(module.exports, "ecomGetComboProductsIds", function () { return $a826d4dc37c35dba$export$ee9a84a05a7413f6; });
$parcel$export(module.exports, "ecomGetCollComboVariant", function () { return $a826d4dc37c35dba$export$98831540e3ce9c54; });
$parcel$export(module.exports, "ecomGetProductCountInCollection", function () { return $a826d4dc37c35dba$export$4a454716607f3bb8; });

var $cy5Ac = parcelRequire("cy5Ac");
function $a826d4dc37c35dba$export$a36ef6968303096d(node, isVip) {
    return $a826d4dc37c35dba$var$isNodeTitleHasCorrectMode(node, isVip);
}
function $a826d4dc37c35dba$var$isNodeTitleHasCorrectMode(node, isVip) {
    const mode = String(isVip ?? '').trim().toLowerCase();
    if (!mode) return false;
    const title = String(node?.title ?? '').trim().toLowerCase();
    if (!title) return false;
    if (title === 'default title' || title === 'unlock_media') return true;
    if (/^\d+$/.test(title)) return title === mode;
    // Accept common separators used in variant titles: slash, comma, pipe, or extra whitespace.
    const tokens = title.split(/[/|,]/g).map((token)=>token.trim()).filter(Boolean);
    return tokens.includes(mode);
}
function $a826d4dc37c35dba$export$947231e7ac3fb978(id) {
    return `gid://shopify/Product/${id}`;
}
function $a826d4dc37c35dba$export$5f56868db4b5eed0(id) {
    return `gid://shopify/Collection/${id}`;
}
function $a826d4dc37c35dba$export$728d5ed0ca3c7850(value, digits = 2) {
    return (Math.round(value * 100) / 100).toFixed(digits);
}
function $a826d4dc37c35dba$export$bc3ff8b6e30519ea(currencyCode) {
    if (currencyCode === 'USD') return '$';
    return currencyCode;
}
function $a826d4dc37c35dba$export$5a5d32ddfb85fbb2(amount = 0, currencyCode = 'USD') {
    return `${$a826d4dc37c35dba$export$bc3ff8b6e30519ea(currencyCode)}${$a826d4dc37c35dba$export$728d5ed0ca3c7850(amount)}`;
}
function $a826d4dc37c35dba$export$1b46f909ece943e2(obj) {
    const lang = $a826d4dc37c35dba$export$b972c1b8efd2416b(localStorage.getItem('i18nextLng'));
    const imageListJson = obj?.image_list_json || obj?.imageListJson;
    if (!imageListJson) return undefined;
    try {
        const imageList = JSON.parse(imageListJson);
        return imageList.find(({ lang: imageLang })=>imageLang === lang)?.url ?? imageList.find(({ lang: imageLang })=>imageLang === 'en')?.url;
    } catch  {
        return undefined;
    }
}
function $a826d4dc37c35dba$export$b972c1b8efd2416b(localeLang) {
    if (typeof localeLang !== 'string') return 'en';
    const parts = localeLang.split('-');
    return parts[0] || 'en';
}
function $a826d4dc37c35dba$export$7817469c34efe5d9(product) {
    return {
        id: product.id,
        productTitle: product.name,
        imgUrl: $a826d4dc37c35dba$export$1b46f909ece943e2(product),
        printPool: product.print_pull,
        productPurpose: product.product_purpose,
        partialUnlockTags: product.partial_unlock_tags,
        eventName: product.event_code,
        pipelineTag: product.pipeline_tag ?? product.pipelineTag,
        assetTag: product.asset_tag ?? product.assetTag
    };
}
function $a826d4dc37c35dba$var$getExternalProductsFromCollection(externalProductId, externalProductList) {
    const externalId = $a826d4dc37c35dba$export$947231e7ac3fb978(externalProductId);
    for(let i = 0; i < externalProductList.length; i += 1){
        if (externalProductList[i].node.id === externalId) return externalProductList[i];
    }
    return null;
}
function $a826d4dc37c35dba$var$getProductVariant(product, isVip) {
    const prodVariantList = product.variants?.edges.map((edge)=>edge.node) || [];
    if (prodVariantList.length < 1) return null;
    for(let k = 0; k < prodVariantList.length; k += 1){
        if ($a826d4dc37c35dba$var$isNodeTitleHasCorrectMode(prodVariantList[k], isVip)) return prodVariantList[k];
    }
    return null;
}
function $a826d4dc37c35dba$var$getExternalProductVariantNodeForCollection(productId, externalProductEdges, isVip) {
    const product = $a826d4dc37c35dba$var$getExternalProductsFromCollection(productId, externalProductEdges);
    const variantEdges = product?.node?.variants?.edges;
    if (!variantEdges) return null;
    for(let i = 0; i < variantEdges.length; i += 1){
        if ($a826d4dc37c35dba$var$isNodeTitleHasCorrectMode(variantEdges[i].node, isVip)) return variantEdges[i].node;
    }
    return null;
}
function $a826d4dc37c35dba$export$ee9a84a05a7413f6(collectionList) {
    return collectionList.reduce((comboIds, item)=>{
        try {
            const productJson = JSON.parse(item.collection_product_json);
            if (productJson?.comboExternalId) comboIds.push(productJson.comboExternalId);
            if (item.is_addon_collection === 1) {
                const products = item.products || [];
                products.forEach((prod)=>{
                    if (prod?.collection_id !== null) comboIds.push(prod.external_product_id);
                });
            }
        } catch (e) {
        /* ignore */ }
        return comboIds;
    }, []);
}
function $a826d4dc37c35dba$export$98831540e3ce9c54(collectionFullData, isVip) {
    const occoCollData = collectionFullData.occoCollectionData;
    const externalCollData = collectionFullData?.collectionAndComboData?.collectionData;
    const externalCollComboData = collectionFullData?.collectionAndComboData?.collectionComboData;
    const collectionProducts = JSON.parse(occoCollData.collection_product_json, {});
    const variantProdPack = $a826d4dc37c35dba$var$getProductVariant(externalCollComboData.product, isVip);
    const newProdCount = {};
    for(let i = 0; i < collectionProducts.collectionProductInfo.length; i += 1){
        const prodCountInfo = collectionProducts.collectionProductInfo[i];
        newProdCount[prodCountInfo.productId] = prodCountInfo.amount;
    }
    const variantArr = [];
    const { products: products } = occoCollData;
    const { edges: edges } = externalCollData.products;
    let prodGroup = 0;
    for(let t = 0; t < products.length; t += 1){
        const product = products[t];
        prodGroup += 1;
        const isResortFee = product.product_purpose === 'resort_fee';
        const isMediaSelectProduct = product?.productPurpose === 'printable' || product?.productPurpose === 'partial_unlock_media' || product?.product_purpose === 'printable' || product?.product_purpose === 'partial_unlock_media';
        const extVariantNode = $a826d4dc37c35dba$var$getExternalProductVariantNodeForCollection(product.external_product_id, edges, isVip);
        const variantId = extVariantNode?.id ?? null;
        const lineSku = extVariantNode?.sku || product.sku || null;
        const newVariant = $a826d4dc37c35dba$export$7817469c34efe5d9(product);
        if (newProdCount[product.id] && isMediaSelectProduct) for(let i = 0; i < newProdCount[product.id]; i += 1){
            const populatedVariant = {
                ...newVariant
            };
            populatedVariant.variantId = variantId;
            populatedVariant.sku = lineSku;
            populatedVariant.pid = `${prodGroup}_${i}`;
            populatedVariant.printPool = product.print_pull;
            populatedVariant.shippingPrintPool = product.shipping_print_pool;
            populatedVariant.requireTags = product.require_tags;
            populatedVariant.denyTags = product.deny_tags;
            variantArr.push(populatedVariant);
        }
        else {
            if (isResortFee) {
                const { price: price } = variantProdPack;
                const { currency: currency } = product;
                const percent = isVip === '1' ? product?.vip_price || 0.0 : product?.non_vip_price || 0.0;
                let fee = price * percent / 100;
                fee = Math.round(fee * 100) / 100;
                newVariant.productTitle = `${product.name} (${percent}% included) - ${(0, $cy5Ac.formatPrice)({
                    amount: fee,
                    currencyCode: currency
                })}`;
                newVariant.isResortFee = true;
            } else newVariant.productTitle = product.name;
            const count = isResortFee ? 1 : newProdCount[product.id] || 1;
            for(let i = 0; i < count; i += 1){
                newVariant.variantId = variantId;
                newVariant.sku = lineSku;
                newVariant.pid = `${prodGroup}_${i}`;
                newVariant.requireTags = product.require_tags;
                newVariant.denyTags = product.deny_tags;
                newVariant.partialUnlockTags = product.partial_unlock_tags;
                variantArr.push({
                    ...newVariant
                });
            }
        }
    }
    variantProdPack.variantArr = variantArr;
    return variantProdPack;
}
function $a826d4dc37c35dba$export$c304e770e81fb3ef(collectionPackage) {
    if (collectionPackage?.id?.includes('gid://')) return collectionPackage.id;
    return `gid://shopify/ProductVariant/${collectionPackage.id}`;
}
function $a826d4dc37c35dba$export$5819abebb0577415(collection, productMap) {
    const products = [];
    try {
        const prodList = JSON.parse(collection.collection_product_json);
        prodList.forEach(({ productId: productId })=>{
            const prodData = productMap.get(productId);
            if (prodData) products.push(prodData);
        });
    } catch (err) {
    /* ignore */ }
    return products;
}
function $a826d4dc37c35dba$export$4a454716607f3bb8(collection, productId) {
    const { collectionProductInfo: collectionProductInfo } = JSON.parse(collection.collection_product_json);
    let count = 0;
    for(let p = 0; p < collectionProductInfo.length; p += 1){
        const pid = collectionProductInfo[p];
        if (pid.productId === productId) count = pid.amount;
    }
    return count;
}

});
parcelRegister("cy5Ac", function(module, exports) {

$parcel$export(module.exports, "formatPrice", function () { return $922cfda6fda6d146$export$c86caf1be068fb8d; });
const $922cfda6fda6d146$var$currencySymbolMap = new Map();
// America
$922cfda6fda6d146$var$currencySymbolMap.set('USD', '$'); // US Dollar
$922cfda6fda6d146$var$currencySymbolMap.set('CRC', "\u20A1"); // Costa Rican Colón
$922cfda6fda6d146$var$currencySymbolMap.set('PYG', "\u20B2"); // Paraguayan Guarani
// Europe
$922cfda6fda6d146$var$currencySymbolMap.set('EUR', "\u20AC"); // Euro
$922cfda6fda6d146$var$currencySymbolMap.set('GBP', "\xa3"); // British Pound Sterling
$922cfda6fda6d146$var$currencySymbolMap.set('PLN', "z\u0142"); // Polish Zloty
$922cfda6fda6d146$var$currencySymbolMap.set('UAH', "\u20B4"); // Ukrainian Hryvnia
// Africa
$922cfda6fda6d146$var$currencySymbolMap.set('NGN', "\u20A6"); // Nigerian Naira
// Asia
$922cfda6fda6d146$var$currencySymbolMap.set('THB', "\u0E3F"); // Thai Baht
$922cfda6fda6d146$var$currencySymbolMap.set('PHP', "\u20B1"); // Philippine Peso
$922cfda6fda6d146$var$currencySymbolMap.set('VND', "\u20AB"); // Vietnamese Dong
$922cfda6fda6d146$var$currencySymbolMap.set('ILS', "\u20AA"); // Israeli New Sheqel
$922cfda6fda6d146$var$currencySymbolMap.set('INR', "\u20B9"); // Indian Rupee
$922cfda6fda6d146$var$currencySymbolMap.set('JPY', "\xa5"); // Japanese Yen
$922cfda6fda6d146$var$currencySymbolMap.set('KRW', "\u20A9"); // South Korean Won
$922cfda6fda6d146$var$currencySymbolMap.set('MYR', 'M$'); // Malaysian Ringgit
$922cfda6fda6d146$var$currencySymbolMap.set('QAR', 'QR'); // Qatari Rial
function $922cfda6fda6d146$export$3dc27271f5d5c629(currencyCode) {
    if (currencyCode === 'USD') return '$';
    return currencyCode;
}
function $922cfda6fda6d146$export$ef0e621e40e0bd28(currencyCode) {
    const currencySymbol = $922cfda6fda6d146$var$currencySymbolMap.get(currencyCode);
    return currencySymbol || currencyCode;
}
function $922cfda6fda6d146$var$formatDecimals(value, digits = 2) {
    return (Math.round(value * 100) / 100).toFixed(digits);
}
function $922cfda6fda6d146$export$c86caf1be068fb8d({ amount: amount = 0, currencyCode: currencyCode = 'USD' }) {
    return `${$922cfda6fda6d146$export$3dc27271f5d5c629(currencyCode)}${$922cfda6fda6d146$var$formatDecimals(amount)}`;
}
function $922cfda6fda6d146$export$39c5d188d626f1f1({ amount: amount = 0, currencyCode: currencyCode = 'USD' }) {
    return `${$922cfda6fda6d146$export$ef0e621e40e0bd28(currencyCode)}${$922cfda6fda6d146$var$formatDecimals(amount)}`;
}
function $922cfda6fda6d146$export$d3d2220b3b681caa(value) {
    if (value.length === 32) return value.replace(/-0+$/, '');
    return value;
}

});


parcelRegister("4Da5X", function(module, exports) {

$parcel$export(module.exports, "ecomGetProductTagType", function () { return $35f2a2991927f790$export$9c2bb0d853f40e72; });
$parcel$export(module.exports, "ecomCheckProductTagTypeAndImageTag", function () { return $35f2a2991927f790$export$87835224836de75e; });
$parcel$export(module.exports, "ecomCheckProductTagTypeForAllImages", function () { return $35f2a2991927f790$export$b1c903a690193084; });
function $35f2a2991927f790$export$a3878ae81adf338a(url) {
    if (!url) return url;
    return url.split('/').pop();
}
function $35f2a2991927f790$export$9c2bb0d853f40e72(product) {
    const isUnlockMedia = product.product_purpose === 'partial_unlock_media';
    const requireTag = product.require_tags || product.require_tag;
    const denyTag = product.deny_tags || product.deny_tag;
    const resProdTypes = {
        acceptTags: [],
        denyTags: [],
        isUnlockMedia: isUnlockMedia
    };
    if (requireTag) resProdTypes.acceptTags = requireTag.split(',').map((item)=>item.trim());
    if (denyTag) resProdTypes.denyTags = denyTag.split(',').map((item)=>item.trim());
    return resProdTypes;
}
function $35f2a2991927f790$export$87835224836de75e(imgUrl, prodTag) {
    if (!prodTag || !Array.isArray(prodTag.acceptTags) && !Array.isArray(prodTag.denyTags) || prodTag.acceptTags?.length === 0 && prodTag.denyTags?.length === 0) return true;
    const fileName = imgUrl ? $35f2a2991927f790$export$a3878ae81adf338a(imgUrl) : '';
    const { acceptTags: acceptTags = [], denyTags: denyTags = [] } = prodTag;
    const isPassedAccept = acceptTags.length === 0 || acceptTags.some((tag)=>fileName.includes(tag));
    const isPassedDeny = isPassedAccept && !denyTags.some((tag)=>fileName.includes(tag));
    return isPassedAccept && isPassedDeny;
}
function $35f2a2991927f790$export$b1c903a690193084(imgPaths, prodTags) {
    if (!prodTags || !prodTags?.acceptTags && !prodTags?.denyTags || prodTags?.acceptTags?.length === 0 && prodTags?.denyTags?.length === 0 || !imgPaths || imgPaths.length === 0) return true;
    let showProduct = false;
    for(let i = 0; i < imgPaths.length; i += 1)showProduct = showProduct || $35f2a2991927f790$export$87835224836de75e(imgPaths[i], prodTags);
    return showProduct;
}

});

parcelRegister("4ah1P", function(module, exports) {

$parcel$export(module.exports, "ecomGetCart", function () { return $30854e16407f757f$export$ef703d1ea848fdb1; });
$parcel$export(module.exports, "ecomAddLineItems", function () { return $30854e16407f757f$export$5629af31f62510df; });
$parcel$export(module.exports, "ecomUpdateCartLineItems", function () { return $30854e16407f757f$export$f9c00bd36b317ace; });
$parcel$export(module.exports, "ecomApplyDiscount", function () { return $30854e16407f757f$export$ed85147321d2ccf2; });

var $fwAln = parcelRequire("fwAln");
const $30854e16407f757f$var$shoppingCartIdKey = 'shoppingCartId';
function $30854e16407f757f$var$flattenCost(cart) {
    if (!cart?.cost) return cart;
    const { cost: cost, ...rest } = cart;
    return {
        ...rest,
        subtotalPrice: cost.subtotalPrice,
        totalPrice: cost.totalPrice,
        totalTax: cost.totalTax
    };
}
function $30854e16407f757f$var$flattenCartLines(cart) {
    if (!cart?.lines?.edges) return [];
    return cart.lines.edges.map((edge)=>{
        const { node: node } = edge;
        const merch = node.merchandise || {};
        return {
            id: node.id,
            quantity: node.quantity,
            merchandiseId: merch.id,
            title: merch.product.title,
            variant: merch,
            discountAllocations: node.discountAllocations,
            customAttributes: node.attributes
        };
    });
}
function $30854e16407f757f$var$calculateDiscountApplicationValueAmount(cart) {
    const values = cart.discountAllocations.filter((allocation)=>allocation.discountApplication).map((allocation)=>allocation.discountApplication.value);
    return values.every((value)=>value.amount) ? values.reduce((sum, value)=>sum + Number.parseFloat(value.amount), 0) : null;
}
function $30854e16407f757f$var$fillDiscountApplications(flatCart) {
    const discountApplications = [];
    if (flatCart?.discountAllocations?.[0]) {
        discountApplications[0] = {
            ...flatCart.discountAllocations[0].discountApplication,
            title: flatCart.discountCodes[0].code,
            allocatedAmount: flatCart.discountAllocations[0].discountedAmount
        };
        const discountApplicationValueAmount = $30854e16407f757f$var$calculateDiscountApplicationValueAmount(flatCart);
        if (discountApplicationValueAmount) discountApplications[0].value = {
            amount: discountApplicationValueAmount
        };
    }
    return discountApplications;
}
function $30854e16407f757f$var$getLocalShoppingCartId() {
    return localStorage.getItem($30854e16407f757f$var$shoppingCartIdKey);
}
function $30854e16407f757f$var$removeLocalShoppingCartId(cartId) {
    localStorage.removeItem($30854e16407f757f$var$shoppingCartIdKey);
}
function $30854e16407f757f$var$setLocalShoppingCartId(cartId) {
    localStorage.setItem($30854e16407f757f$var$shoppingCartIdKey, cartId);
}
function $30854e16407f757f$var$removeDraftOrderInfoFromLocalStorage() {
    localStorage.removeItem('draftOrderInfo');
}
function $30854e16407f757f$var$getLocalShippingAddress() {
    return localStorage.getItem('shippingAddress');
}
async function $30854e16407f757f$export$3b4e8c7834ff5431({ isFromWebapp: isFromWebapp, shippingAddress: shippingAddress, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    const cartId = $30854e16407f757f$var$getLocalShoppingCartId();
    const defaultShippingAddress = $30854e16407f757f$var$getLocalShippingAddress();
    const res = cartId ? await (0, $fwAln.getShoppingCard)({
        cartId: cartId,
        eventPrivateApiKey: eventPrivateApiKey,
        eventPublicApiKey: eventPublicApiKey
    }) : null;
    let cart = res?.status === 'ok' ? res.result : null;
    const cartShippingAddress = isFromWebapp && shippingAddress?.address1 ? shippingAddress : defaultShippingAddress;
    if (!cart) cart = await $30854e16407f757f$var$createAndStoreCart([], cartShippingAddress);
    else if (isFromWebapp && shippingAddress?.address1) cart = await (0, $fwAln.updateCartShippingAddress)({
        cartId: cart.id,
        shippingAddress: shippingAddress,
        eventPrivateApiKey: eventPrivateApiKey,
        eventPublicApiKey: eventPublicApiKey
    });
    const flatCart = $30854e16407f757f$var$flattenCost(cart);
    flatCart.lineItems = $30854e16407f757f$var$flattenCartLines(flatCart);
    flatCart.discountApplications = $30854e16407f757f$var$fillDiscountApplications(flatCart);
    return flatCart;
}
async function $30854e16407f757f$var$createAndStoreCart(lineItems = [], shippingAddress = null) {
    const res = await (0, $fwAln.createShoppingCard)({
        lineItems: lineItems,
        shippingAddress: shippingAddress,
        eventPrivateApiKey: localStorage.getItem('eventPrivateApiKey') || '',
        eventPublicApiKey: localStorage.getItem('eventPublicApiKey') || ''
    });
    const newCart = res.status === 'ok' ? res.result : null;
    if (newCart) {
        $30854e16407f757f$var$setLocalShoppingCartId(newCart.id);
        $30854e16407f757f$var$removeDraftOrderInfoFromLocalStorage();
    }
    return newCart;
}
async function $30854e16407f757f$export$ef703d1ea848fdb1({ isFromWebapp: isFromWebapp, shippingAddress: shippingAddress, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    const cart = await $30854e16407f757f$export$3b4e8c7834ff5431({
        isFromWebapp: isFromWebapp,
        shippingAddress: shippingAddress,
        eventPrivateApiKey: eventPrivateApiKey,
        eventPublicApiKey: eventPublicApiKey
    });
    return cart || null;
}
async function $30854e16407f757f$export$5629af31f62510df(cartId, lineItems) {
    const lines = (lineItems || []).map((item)=>({
            merchandiseId: item.variantId,
            quantity: item.quantity || 1,
            attributes: item.customAttributes || []
        }));
    const cart = await (0, $fwAln.addLineItemsToCart)({
        cartId: cartId,
        lineItems: lines,
        eventPrivateApiKey: localStorage.getItem('eventPrivateApiKey') || '',
        eventPublicApiKey: localStorage.getItem('eventPublicApiKey') || ''
    });
    if (cart.status === 'ok') return cart.result;
    return {};
}
async function $30854e16407f757f$export$f9c00bd36b317ace({ cartId: cartId, lineItems: lineItems, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    const res = await (0, $fwAln.updateCartLineItems)({
        cartId: cartId,
        lineItems: lineItems,
        eventPrivateApiKey: eventPrivateApiKey,
        eventPublicApiKey: eventPublicApiKey
    });
    const cart = res?.status === 'ok' ? res.result : null;
    $30854e16407f757f$var$removeDraftOrderInfoFromLocalStorage();
    return cart || {};
}
async function $30854e16407f757f$export$ed85147321d2ccf2({ cartId: cartId, discountCode: discountCode, eventPrivateApiKey: eventPrivateApiKey, eventPublicApiKey: eventPublicApiKey }) {
    const res = await (0, $fwAln.applyDiscountToCart)({
        cartId: cartId,
        discountCode: discountCode,
        eventPrivateApiKey: eventPrivateApiKey,
        eventPublicApiKey: eventPublicApiKey
    });
    const cart = res?.status === 'ok' ? res.result : null;
    $30854e16407f757f$var$removeDraftOrderInfoFromLocalStorage();
    return cart || {};
}
async function $30854e16407f757f$export$3545b11279542094() {
    $30854e16407f757f$var$removeDraftOrderInfoFromLocalStorage();
    $30854e16407f757f$var$removeLocalShoppingCartId();
    return $30854e16407f757f$var$createAndStoreCart([]);
}

});

parcelRegister("7Ypd8", function(module, exports) {

$parcel$export(module.exports, "tryJson", function () { return $5ce1b1552e2f0b03$export$812d0ff9b36a413b; });
$parcel$export(module.exports, "escapeHtml", function () { return $5ce1b1552e2f0b03$export$4cf11838cdc2a8a8; });
$parcel$export(module.exports, "isFalsy", function () { return $5ce1b1552e2f0b03$export$3f8b302b845e89ac; });
$parcel$export(module.exports, "latestStateRequestManager", function () { return $5ce1b1552e2f0b03$export$acd1523995ce209f; });
/**
 * Extracts attendee ID and unlock tag from a URL or plain attendee ID string
 *
 * Supports the following formats:
 * - https://storibox.com/?attId=ASMG-YKXL-PQZR-0001&u=mytag
 * - https://storibox.com/?attId=ASMG-YKXL-PQZR-0001
 * - ASMG-YKXL-PQZR-0001 (plain attendee ID)
 *
 * @param {string} url - URL with query parameters or plain attendee ID
 * @returns {Object} Object with attendeeId and unlockTag properties
 * @returns {string} returns.attendeeId - The extracted attendee ID
 * @returns {string|null} returns.unlockTag - The unlock tag if present, null otherwise
 */ function $5ce1b1552e2f0b03$export$3342980b67cf684b(url) {
    // Check if it's a URL with query parameters
    if (url.includes('?')) try {
        // Extract query string and parse parameters
        const queryString = url.substring(url.indexOf('?') + 1);
        const params = new URLSearchParams(queryString);
        const attendeeId = params.get('attId');
        const unlockTag = params.get('u');
        // If attId exists in URL, return it with the unlock tag (or null if not present)
        if (attendeeId) return {
            attendeeId: attendeeId,
            unlockTag: unlockTag
        };
    } catch (error) {
        console.error('Error parsing URL:', error);
    }
    // Just the attendee ID without URL (e.g., ASMG-YKXL-PQZR-0001)
    return {
        attendeeId: url,
        unlockTag: null
    };
}
function $5ce1b1552e2f0b03$export$812d0ff9b36a413b(str, defaultVal) {
    try {
        if (str == null || str === '') return defaultVal;
        const parsed = JSON.parse(str);
        return parsed == null ? defaultVal : parsed;
    } catch  {
        return defaultVal;
    }
}
function $5ce1b1552e2f0b03$export$4cf11838cdc2a8a8(value) {
    return String(value ?? '').replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#39;');
}
function $5ce1b1552e2f0b03$export$3f8b302b845e89ac(value) {
    return value === false || value === 0 || value === '0' || value === 'no';
}
/** Clears the debounce timer and resets timerId on the request state. */ function $5ce1b1552e2f0b03$var$clearTimer(requestState) {
    if (!requestState.timerId) return;
    clearTimeout(requestState.timerId);
    requestState.timerId = null;
}
function $5ce1b1552e2f0b03$export$acd1523995ce209f({ delayMs: delayMs, sendRequest: sendRequest, onError: onError }) {
    const requestStateByKey = new Map();
    /** Removes entry from map when no pending work and desired === server state. */ function cleanupIfIdle(key, requestState) {
        if (requestState.isSending || requestState.timerId) return;
        if (requestState.desiredState === requestState.serverState) requestStateByKey.delete(key);
    }
    /** Sends the current desired state to the server. Re-schedules if desired changed while sending. */ function flush(key) {
        const requestState = requestStateByKey.get(key);
        if (!requestState || requestState.isSending) return;
        $5ce1b1552e2f0b03$var$clearTimer(requestState);
        // Nothing to send – desired already matches server
        if (requestState.desiredState === requestState.serverState) {
            cleanupIfIdle(key, requestState);
            return;
        }
        const targetState = requestState.desiredState;
        requestState.isSending = true;
        sendRequest({
            key: key,
            state: targetState,
            payload: requestState.payload
        }, (err)=>{
            const latestRequestState = requestStateByKey.get(key);
            if (!latestRequestState) return;
            latestRequestState.isSending = false;
            if (err) {
                latestRequestState.desiredState = latestRequestState.serverState;
                if (latestRequestState.revertState) latestRequestState.revertState(latestRequestState.serverState);
                $5ce1b1552e2f0b03$var$clearTimer(latestRequestState);
                cleanupIfIdle(key, latestRequestState);
                if (onError) onError(err);
                return;
            }
            latestRequestState.serverState = targetState;
            // More changes happened while in-flight – schedule another flush
            if (latestRequestState.desiredState !== latestRequestState.serverState) {
                latestRequestState.timerId = setTimeout(()=>flush(key), delayMs);
                return;
            }
            cleanupIfIdle(key, latestRequestState);
        });
    }
    /**
   * Schedules a state change for the given key.
   * Debounces rapid calls; only the latest desiredState is sent.
   *
   * @param {string} key - Unique id for this state (e.g. resource id)
   * @param {*} serverState - Last confirmed server state
   * @param {*} desiredState - Target state to sync
   * @param {*} [payload] - Extra data passed to sendRequest
   * @param {Function} [revertState] - Called on error to revert UI to serverState
   */ function schedule({ key: key, serverState: serverState, desiredState: desiredState, payload: payload, revertState: revertState }) {
        let requestState = requestStateByKey.get(key);
        if (!requestState) {
            requestState = {
                serverState: serverState,
                desiredState: serverState,
                payload: null,
                revertState: null,
                timerId: null,
                isSending: false
            };
            requestStateByKey.set(key, requestState);
        }
        requestState.payload = payload;
        requestState.revertState = revertState;
        requestState.desiredState = desiredState;
        if (requestState.isSending) return; // Request in flight – flush callback will re-schedule if needed
        $5ce1b1552e2f0b03$var$clearTimer(requestState);
        requestState.timerId = setTimeout(()=>flush(key), delayMs);
    }
    return {
        schedule: schedule
    };
}

});

parcelRegister("3Hje3", function(module, exports) {

$parcel$export(module.exports, "loadEcommerceCheckoutSettings", function () { return $2b144d1257812e63$export$ca780cc6eb6403ff; });
$parcel$export(module.exports, "applyEcommerceCheckoutSettingsToStorage", function () { return $2b144d1257812e63$export$35e10661316470c3; });

var $fwAln = parcelRequire("fwAln");
function $2b144d1257812e63$export$6bf69a591fc39e86(response) {
    if (response?.status !== 'ok') return null;
    const { result: result } = response;
    if (!result || typeof result !== 'object') return null;
    if (Array.isArray(result)) return result[0] ?? null;
    return result;
}
function $2b144d1257812e63$export$742ee8331f4f577c(location) {
    if (!location) return {};
    return {
        shopifyLocationName: location.location_name ?? '',
        shopifyLocationExternalId: location.location_external_id ?? '',
        shopifyFirstName: location.first_name ?? '',
        shopifyLastName: location.last_name ?? '',
        shopifyAddress1: location.address1 ?? '',
        shopifyAddress2: location.address2 ?? '',
        shopifyCountry: location.country ?? '',
        shopifyState: location.state ?? '',
        shopifyCity: location.city ?? '',
        shopifyZip: location.zip ?? '',
        shopifyCompany: location.company ?? '',
        shopifyPhoneNumber: location.phone ?? ''
    };
}
function $2b144d1257812e63$export$c9eadd99a6ee685b(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
}
function $2b144d1257812e63$export$278c9b9dfef0d8df(value) {
    return $2b144d1257812e63$export$c9eadd99a6ee685b(value) ? 1 : 0;
}
function $2b144d1257812e63$export$953008d9b595883f(legacyShippingAddress) {
    if (legacyShippingAddress == null || legacyShippingAddress === 'null') return {};
    if (typeof legacyShippingAddress === 'string') {
        try {
            const parsed = JSON.parse(legacyShippingAddress);
            if (parsed && typeof parsed === 'object') return parsed.shopifyAddress1 != null ? parsed : $2b144d1257812e63$export$742ee8331f4f577c(parsed);
        } catch  {
            return {};
        }
        return {};
    }
    if (typeof legacyShippingAddress === 'object') return legacyShippingAddress.shopifyAddress1 != null ? legacyShippingAddress : $2b144d1257812e63$export$742ee8331f4f577c(legacyShippingAddress);
    return {};
}
function $2b144d1257812e63$var$readExistingEventOpts(storage) {
    try {
        const raw = storage.getItem('eventOpts');
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch  {
        return {};
    }
}
function $2b144d1257812e63$var$hasOwn(object, key) {
    return Object.hasOwn(object, key);
}
async function $2b144d1257812e63$export$ca780cc6eb6403ff({ eventName: eventName, eventPublicApiKey: eventPublicApiKey }) {
    const settings = {};
    if (!eventName || !eventPublicApiKey) return settings;
    try {
        const settingsResponse = await (0, $fwAln.getStoreSettingsForKiosk)({
            eventName: eventName,
            eventPublicApiKey: eventPublicApiKey
        });
        if (settingsResponse?.status === 'ok') {
            const storeSettings = $2b144d1257812e63$export$6bf69a591fc39e86(settingsResponse);
            settings.shopDomain = storeSettings?.shop_domain?.trim() || '';
            settings.shopToken = storeSettings?.shop_token?.trim() || '';
            settings.isUpsellProductsCheck = $2b144d1257812e63$export$278c9b9dfef0d8df(storeSettings?.is_upsell_products_check);
            settings.hideProductPrice = $2b144d1257812e63$export$278c9b9dfef0d8df(storeSettings?.hide_product_price);
            settings.enabledShopComboRequired = $2b144d1257812e63$export$c9eadd99a6ee685b(storeSettings?.enabled_shop_combo_required);
        }
    } catch (error) {
        console.warn('Failed to load ecommerce settings:', error);
    }
    try {
        const locationResponse = await (0, $fwAln.getStoreLocationForKiosk)({
            eventName: eventName,
            eventPublicApiKey: eventPublicApiKey
        });
        if (locationResponse?.status === 'ok') {
            const storeLocation = $2b144d1257812e63$export$6bf69a591fc39e86(locationResponse);
            settings.shippingAddress = $2b144d1257812e63$export$742ee8331f4f577c(storeLocation);
        }
    } catch (error) {
        console.warn('Failed to load ecommerce location:', error);
    }
    return settings;
}
function $2b144d1257812e63$export$35e10661316470c3(settings, storage = localStorage, baseOpts = null) {
    const existingOpts = baseOpts && typeof baseOpts === 'object' ? baseOpts : $2b144d1257812e63$var$readExistingEventOpts(storage);
    // Preserve non-ecommerce event opts; only overlay ecommerce_settings / location fields when provided.
    const mergedOpts = {
        ...existingOpts
    };
    if ($2b144d1257812e63$var$hasOwn(settings, 'shopDomain')) {
        mergedOpts.shopDomain = settings.shopDomain;
        mergedOpts.shopToken = settings.shopToken;
        mergedOpts.isUpsellProductsCheck = settings.isUpsellProductsCheck;
        mergedOpts.hideProductPrice = settings.hideProductPrice;
        mergedOpts.enabledShopComboRequired = settings.enabledShopComboRequired;
        storage.setItem('isUpsellProductsCheck', settings.isUpsellProductsCheck);
        storage.setItem('enabledShopComboRequired', settings.enabledShopComboRequired);
        if (settings.hideProductPrice) storage.setItem('hideProductPrice', settings.hideProductPrice);
        else storage.removeItem('hideProductPrice');
        if (settings.shopDomain) storage.setItem('shopDomain', settings.shopDomain);
        else storage.removeItem('shopDomain');
        if (settings.shopToken) storage.setItem('shopToken', settings.shopToken);
        else storage.removeItem('shopToken');
    }
    if ($2b144d1257812e63$var$hasOwn(settings, 'shippingAddress')) storage.setItem('shippingAddress', JSON.stringify(settings.shippingAddress ?? {}));
    storage.setItem('eventOpts', JSON.stringify(mergedOpts));
    return mergedOpts;
}

});

parcelRegister("dxUHY", function(module, exports) {

$parcel$export(module.exports, "normalizeEventOrders", function () { return $9dca5886a7bd336c$export$5493b9328052d0be; });
$parcel$export(module.exports, "isPickupOrder", function () { return $9dca5886a7bd336c$export$9a712899c2c93d86; });
$parcel$export(module.exports, "isPendingPickupOrder", function () { return $9dca5886a7bd336c$export$d027fb17d6978e21; });

var $7Ypd8 = parcelRequire("7Ypd8");
function $9dca5886a7bd336c$var$parseJsonField(value, defaultVal) {
    if (value == null) return defaultVal;
    if (typeof value !== 'string') return value;
    return (0, $7Ypd8.tryJson)(value, defaultVal);
}
function $9dca5886a7bd336c$var$resolveApiOrderId(order) {
    return order.id ?? null;
}
function $9dca5886a7bd336c$export$955491cc88ab25de(order) {
    if (!order) return null;
    const apiOrderId = $9dca5886a7bd336c$var$resolveApiOrderId(order);
    if (apiOrderId == null) return null;
    return {
        id: String(apiOrderId),
        name: order.name ?? null,
        totalPrice: Number(order.total_price ?? order.totalPrice ?? 0),
        subtotalPrice: Number(order.subtotal_price ?? order.subtotalPrice ?? 0),
        taxPrice: Number(order.tax_price ?? order.taxPrice ?? 0),
        totalDiscounts: Number(order.total_discounts ?? order.totalDiscounts ?? 0),
        taxesIncluded: order.taxes_included ?? order.taxesIncluded ?? false,
        paymentStatus: order.payment_status ?? order.paymentStatus ?? '',
        fulfillmentStatus: order.fulfillment_status ?? order.fulfillmentStatus ?? '',
        currency: order.currency ?? '',
        createdAt: order.created_at ?? order.createdAt ?? null,
        updatedAt: order.updated_at ?? order.updatedAt ?? null,
        eventCode: order.event_code ?? order.eventCode ?? null,
        ecommerceProvider: order.ecommerce_provider ?? order.ecommerceProvider ?? null,
        lineItems: $9dca5886a7bd336c$var$parseJsonField(order.line_items_json ?? order.lineItems, []),
        tags: $9dca5886a7bd336c$var$getOrderTags(order),
        customerInfo: $9dca5886a7bd336c$var$parseJsonField(order.customer_info_json ?? order.customerInfo, {}),
        shippingAddress: $9dca5886a7bd336c$var$parseJsonField(order.shipping_address ?? order.shippingAddress, null),
        pickupAddress: $9dca5886a7bd336c$var$parseJsonField(order.pickup_address ?? order.pickupAddress, null),
        discounts: $9dca5886a7bd336c$var$parseJsonField(order.discounts_json ?? order.discounts, []),
        taxLines: $9dca5886a7bd336c$var$parseJsonField(order.tax_lines_json ?? order.tax_lines ?? order.taxLines, [])
    };
}
function $9dca5886a7bd336c$export$5493b9328052d0be(orders) {
    if (!Array.isArray(orders)) return {
        orders: [],
        skippedCount: 0
    };
    const normalizedOrders = [];
    let skippedCount = 0;
    orders.forEach((order)=>{
        const normalizedOrder = $9dca5886a7bd336c$export$955491cc88ab25de(order);
        if (normalizedOrder) {
            normalizedOrders.push(normalizedOrder);
            return;
        }
        skippedCount += 1;
    });
    return {
        orders: normalizedOrders,
        skippedCount: skippedCount
    };
}
const $9dca5886a7bd336c$var$FULFILLED_STATUSES = new Set([
    'fulfilled',
    'completed'
]);
const $9dca5886a7bd336c$var$FULFILLABLE_STATUSES = new Set([
    'unfulfilled',
    'pending',
    ''
]);
function $9dca5886a7bd336c$export$4e3905a7b6f600ff(fulfillmentStatus) {
    return String(fulfillmentStatus || '').toLowerCase().trim();
}
function $9dca5886a7bd336c$export$6940b5842557bc3a(fulfillmentStatus) {
    return $9dca5886a7bd336c$var$FULFILLED_STATUSES.has($9dca5886a7bd336c$export$4e3905a7b6f600ff(fulfillmentStatus));
}
const $9dca5886a7bd336c$var$PICKUP_PRODUCT_PURPOSES = new Set([
    'printable'
]);
const $9dca5886a7bd336c$var$MOBILE_ITEM_TAG = 'mobile';
function $9dca5886a7bd336c$export$436fc3145e5a77f9(lineItem) {
    const attributes = lineItem?.customAttributes || lineItem?.properties;
    const variantAttr = attributes?.find((attr)=>attr.key === '_variantArr' || attr.name === '_variantArr');
    const parsed = $9dca5886a7bd336c$var$parseJsonField(variantAttr?.value, []);
    return Array.isArray(parsed) ? parsed : [];
}
function $9dca5886a7bd336c$var$getVariantProductPurpose(variant) {
    return variant?.productPurpose ?? variant?.product_purpose;
}
function $9dca5886a7bd336c$export$92a0420da114750f(lineItems) {
    if (!Array.isArray(lineItems)) return false;
    return lineItems.some((lineItem)=>$9dca5886a7bd336c$export$436fc3145e5a77f9(lineItem).some((variant)=>$9dca5886a7bd336c$var$PICKUP_PRODUCT_PURPOSES.has($9dca5886a7bd336c$var$getVariantProductPurpose(variant))));
}
function $9dca5886a7bd336c$var$normalizeOrderTags(tags) {
    if (Array.isArray(tags)) return tags;
    if (typeof tags === 'string') return tags.split(',').map((tag)=>tag.trim()).filter(Boolean);
    return [];
}
function $9dca5886a7bd336c$var$getOrderTags(order) {
    const rawTags = order.tags_json ?? order.tags;
    if (Array.isArray(rawTags)) return rawTags;
    const parsedTags = $9dca5886a7bd336c$var$parseJsonField(rawTags, rawTags);
    return $9dca5886a7bd336c$var$normalizeOrderTags(parsedTags);
}
function $9dca5886a7bd336c$var$hasMobileItemTag(order) {
    return $9dca5886a7bd336c$var$getOrderTags(order).some((tag)=>String(tag).trim().toLowerCase() === $9dca5886a7bd336c$var$MOBILE_ITEM_TAG);
}
function $9dca5886a7bd336c$var$getShippingAddress(order) {
    return order?.shippingAddress ?? order?.shipping_address ?? null;
}
function $9dca5886a7bd336c$var$getPickupAddress(order) {
    return order?.pickupAddress ?? order?.pickup_address ?? null;
}
const $9dca5886a7bd336c$var$ORDER_ADDRESS_LABELS = {
    shipping: 'Shipping address',
    pickup: 'Pickup address',
    none: 'Shipping/pickup address'
};
function $9dca5886a7bd336c$export$35a7387f2c68da6c(order) {
    const shippingAddress = $9dca5886a7bd336c$var$getShippingAddress(order);
    if (shippingAddress != null) return {
        label: $9dca5886a7bd336c$var$ORDER_ADDRESS_LABELS.shipping,
        address: shippingAddress
    };
    const pickupAddress = $9dca5886a7bd336c$var$getPickupAddress(order);
    if (pickupAddress != null) return {
        label: $9dca5886a7bd336c$var$ORDER_ADDRESS_LABELS.pickup,
        address: pickupAddress
    };
    return {
        label: $9dca5886a7bd336c$var$ORDER_ADDRESS_LABELS.none,
        address: null
    };
}
function $9dca5886a7bd336c$export$9a712899c2c93d86(order) {
    if (!order) return false;
    if (!$9dca5886a7bd336c$export$6940b5842557bc3a(order.fulfillmentStatus ?? order.fulfillment_status)) return false;
    return $9dca5886a7bd336c$var$getPickupAddress(order) != null && $9dca5886a7bd336c$var$hasMobileItemTag(order);
}
function $9dca5886a7bd336c$export$d027fb17d6978e21(order) {
    if (!order || $9dca5886a7bd336c$export$6940b5842557bc3a(order.fulfillmentStatus ?? order.fulfillment_status)) return false;
    return $9dca5886a7bd336c$var$getPickupAddress(order) != null && $9dca5886a7bd336c$var$hasMobileItemTag(order);
}
function $9dca5886a7bd336c$export$ba59d089000dc66(fulfillmentStatus) {
    return $9dca5886a7bd336c$var$FULFILLABLE_STATUSES.has($9dca5886a7bd336c$export$4e3905a7b6f600ff(fulfillmentStatus));
}
function $9dca5886a7bd336c$export$e3d597435c9c9d1d(fulfillmentStatus, filterValue) {
    if (filterValue === 'fulfilled') return $9dca5886a7bd336c$export$6940b5842557bc3a(fulfillmentStatus);
    if (filterValue === 'unfulfilled') return $9dca5886a7bd336c$export$ba59d089000dc66(fulfillmentStatus);
    if (filterValue === 'other') return !$9dca5886a7bd336c$export$6940b5842557bc3a(fulfillmentStatus) && !$9dca5886a7bd336c$export$ba59d089000dc66(fulfillmentStatus);
    return true;
}
function $9dca5886a7bd336c$export$4ecfe6e2c563d379(result) {
    if (result?.status !== 'ok') return {
        kind: 'error'
    };
    const payload = result?.result ?? {};
    if (payload.fulfilled === true) return {
        kind: 'fulfilled',
        fulfillmentStatus: payload.fulfillment_status || payload.fulfillmentStatus || 'fulfilled'
    };
    return {
        kind: 'not_fulfilled'
    };
}

});



var $48b1ef51c25b822d$exports = {};
$parcel$extendImportMap({
    "1fhCl": "browser-ponyfill.1186cd03.js"
});


//# sourceMappingURL=a-shoot.7f846466.js.map
